import * as e from "react";
import t, { createContext as n, useContext as r, useEffect as i, useState as a } from "react";
import { Fragment as o, jsxDEV as s } from "react/jsx-dev-runtime";
//#region ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
function c(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function l(e, t, n, r) {
	function i(e) {
		return e instanceof n ? e : new n(function(t) {
			t(e);
		});
	}
	return new (n ||= Promise)(function(n, a) {
		function o(e) {
			try {
				c(r.next(e));
			} catch (e) {
				a(e);
			}
		}
		function s(e) {
			try {
				c(r.throw(e));
			} catch (e) {
				a(e);
			}
		}
		function c(e) {
			e.done ? n(e.value) : i(e.value).then(o, s);
		}
		c((r = r.apply(e, t || [])).next());
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@supabase+functions-js@2.89.0/node_modules/@supabase/functions-js/dist/module/helper.js
var u = (e) => e ? (...t) => e(...t) : (...e) => fetch(...e), d = class extends Error {
	constructor(e, t = "FunctionsError", n) {
		super(e), this.name = t, this.context = n;
	}
}, f = class extends d {
	constructor(e) {
		super("Failed to send a request to the Edge Function", "FunctionsFetchError", e);
	}
}, p = class extends d {
	constructor(e) {
		super("Relay Error invoking the Edge Function", "FunctionsRelayError", e);
	}
}, m = class extends d {
	constructor(e) {
		super("Edge Function returned a non-2xx status code", "FunctionsHttpError", e);
	}
}, h;
(function(e) {
	e.Any = "any", e.ApNortheast1 = "ap-northeast-1", e.ApNortheast2 = "ap-northeast-2", e.ApSouth1 = "ap-south-1", e.ApSoutheast1 = "ap-southeast-1", e.ApSoutheast2 = "ap-southeast-2", e.CaCentral1 = "ca-central-1", e.EuCentral1 = "eu-central-1", e.EuWest1 = "eu-west-1", e.EuWest2 = "eu-west-2", e.EuWest3 = "eu-west-3", e.SaEast1 = "sa-east-1", e.UsEast1 = "us-east-1", e.UsWest1 = "us-west-1", e.UsWest2 = "us-west-2";
})(h ||= {});
//#endregion
//#region ../../node_modules/.pnpm/@supabase+functions-js@2.89.0/node_modules/@supabase/functions-js/dist/module/FunctionsClient.js
var g = class {
	constructor(e, { headers: t = {}, customFetch: n, region: r = h.Any } = {}) {
		this.url = e, this.headers = t, this.region = r, this.fetch = u(n);
	}
	setAuth(e) {
		this.headers.Authorization = `Bearer ${e}`;
	}
	invoke(e) {
		return l(this, arguments, void 0, function* (e, t = {}) {
			let n, r;
			try {
				let { headers: i, method: a, body: o, signal: s, timeout: c } = t, l = {}, { region: u } = t;
				u ||= this.region;
				let d = new URL(`${this.url}/${e}`);
				u && u !== "any" && (l["x-region"] = u, d.searchParams.set("forceFunctionRegion", u));
				let h;
				o && (i && !Object.prototype.hasOwnProperty.call(i, "Content-Type") || !i) ? typeof Blob < "u" && o instanceof Blob || o instanceof ArrayBuffer ? (l["Content-Type"] = "application/octet-stream", h = o) : typeof o == "string" ? (l["Content-Type"] = "text/plain", h = o) : typeof FormData < "u" && o instanceof FormData ? h = o : (l["Content-Type"] = "application/json", h = JSON.stringify(o)) : h = o;
				let g = s;
				c && (r = new AbortController(), n = setTimeout(() => r.abort(), c), s ? (g = r.signal, s.addEventListener("abort", () => r.abort())) : g = r.signal);
				let _ = yield this.fetch(d.toString(), {
					method: a || "POST",
					headers: Object.assign(Object.assign(Object.assign({}, l), this.headers), i),
					body: h,
					signal: g
				}).catch((e) => {
					throw new f(e);
				}), v = _.headers.get("x-relay-error");
				if (v && v === "true") throw new p(_);
				if (!_.ok) throw new m(_);
				let ee = (_.headers.get("Content-Type") ?? "text/plain").split(";")[0].trim(), te;
				return te = ee === "application/json" ? yield _.json() : ee === "application/octet-stream" || ee === "application/pdf" ? yield _.blob() : ee === "text/event-stream" ? _ : ee === "multipart/form-data" ? yield _.formData() : yield _.text(), {
					data: te,
					error: null,
					response: _
				};
			} catch (e) {
				return {
					data: null,
					error: e,
					response: e instanceof m || e instanceof p ? e.context : void 0
				};
			} finally {
				n && clearTimeout(n);
			}
		});
	}
}, _ = class extends Error {
	constructor(e) {
		super(e.message), this.name = "PostgrestError", this.details = e.details, this.hint = e.hint, this.code = e.code;
	}
}, v = class {
	constructor(e) {
		this.shouldThrowOnError = !1, this.method = e.method, this.url = e.url, this.headers = new Headers(e.headers), this.schema = e.schema, this.body = e.body, this.shouldThrowOnError = e.shouldThrowOnError ?? !1, this.signal = e.signal, this.isMaybeSingle = e.isMaybeSingle ?? !1, e.fetch ? this.fetch = e.fetch : this.fetch = fetch;
	}
	throwOnError() {
		return this.shouldThrowOnError = !0, this;
	}
	setHeader(e, t) {
		return this.headers = new Headers(this.headers), this.headers.set(e, t), this;
	}
	then(e, t) {
		var n = this;
		this.schema === void 0 || (["GET", "HEAD"].includes(this.method) ? this.headers.set("Accept-Profile", this.schema) : this.headers.set("Content-Profile", this.schema)), this.method !== "GET" && this.method !== "HEAD" && this.headers.set("Content-Type", "application/json");
		let r = this.fetch, i = r(this.url.toString(), {
			method: this.method,
			headers: this.headers,
			body: JSON.stringify(this.body),
			signal: this.signal
		}).then(async (e) => {
			let t = null, r = null, i = null, a = e.status, o = e.statusText;
			if (e.ok) {
				if (n.method !== "HEAD") {
					let t = await e.text();
					t === "" || (r = n.headers.get("Accept") === "text/csv" || n.headers.get("Accept") && n.headers.get("Accept")?.includes("application/vnd.pgrst.plan+text") ? t : JSON.parse(t));
				}
				let s = n.headers.get("Prefer")?.match(/count=(exact|planned|estimated)/), c = e.headers.get("content-range")?.split("/");
				s && c && c.length > 1 && (i = parseInt(c[1])), n.isMaybeSingle && n.method === "GET" && Array.isArray(r) && (r.length > 1 ? (t = {
					code: "PGRST116",
					details: `Results contain ${r.length} rows, application/vnd.pgrst.object+json requires 1 row`,
					hint: null,
					message: "JSON object requested, multiple (or no) rows returned"
				}, r = null, i = null, a = 406, o = "Not Acceptable") : r = r.length === 1 ? r[0] : null);
			} else {
				var s;
				let i = await e.text();
				try {
					t = JSON.parse(i), Array.isArray(t) && e.status === 404 && (r = [], t = null, a = 200, o = "OK");
				} catch {
					e.status === 404 && i === "" ? (a = 204, o = "No Content") : t = { message: i };
				}
				if (t && n.isMaybeSingle && !(t == null || (s = t.details) == null) && s.includes("0 rows") && (t = null, a = 200, o = "OK"), t && n.shouldThrowOnError) throw new _(t);
			}
			return {
				error: t,
				data: r,
				count: i,
				status: a,
				statusText: o
			};
		});
		return this.shouldThrowOnError || (i = i.catch((e) => {
			let t = "", n = e?.cause;
			if (n) {
				let r = n?.message ?? "", i = n?.code ?? "";
				t = `${e?.name ?? "FetchError"}: ${e?.message}`, t += `\n\nCaused by: ${n?.name ?? "Error"}: ${r}`, i && (t += ` (${i})`), n?.stack && (t += `\n${n.stack}`);
			} else t = e?.stack ?? "";
			return {
				error: {
					message: `${e?.name ?? "FetchError"}: ${e?.message}`,
					details: t,
					hint: "",
					code: ""
				},
				data: null,
				count: null,
				status: 0,
				statusText: ""
			};
		})), i.then(e, t);
	}
	returns() {
		/* istanbul ignore next */
		return this;
	}
	overrideTypes() {
		return this;
	}
}, ee = class extends v {
	select(e) {
		let t = !1, n = (e ?? "*").split("").map((e) => /\s/.test(e) && !t ? "" : (e === "\"" && (t = !t), e)).join("");
		return this.url.searchParams.set("select", n), this.headers.append("Prefer", "return=representation"), this;
	}
	order(e, { ascending: t = !0, nullsFirst: n, foreignTable: r, referencedTable: i = r } = {}) {
		let a = i ? `${i}.order` : "order", o = this.url.searchParams.get(a);
		return this.url.searchParams.set(a, `${o ? `${o},` : ""}${e}.${t ? "asc" : "desc"}${n === void 0 ? "" : n ? ".nullsfirst" : ".nullslast"}`), this;
	}
	limit(e, { foreignTable: t, referencedTable: n = t } = {}) {
		let r = n === void 0 ? "limit" : `${n}.limit`;
		return this.url.searchParams.set(r, `${e}`), this;
	}
	range(e, t, { foreignTable: n, referencedTable: r = n } = {}) {
		let i = r === void 0 ? "offset" : `${r}.offset`, a = r === void 0 ? "limit" : `${r}.limit`;
		return this.url.searchParams.set(i, `${e}`), this.url.searchParams.set(a, `${t - e + 1}`), this;
	}
	abortSignal(e) {
		return this.signal = e, this;
	}
	single() {
		return this.headers.set("Accept", "application/vnd.pgrst.object+json"), this;
	}
	maybeSingle() {
		return this.method === "GET" ? this.headers.set("Accept", "application/json") : this.headers.set("Accept", "application/vnd.pgrst.object+json"), this.isMaybeSingle = !0, this;
	}
	csv() {
		return this.headers.set("Accept", "text/csv"), this;
	}
	geojson() {
		return this.headers.set("Accept", "application/geo+json"), this;
	}
	explain({ analyze: e = !1, verbose: t = !1, settings: n = !1, buffers: r = !1, wal: i = !1, format: a = "text" } = {}) {
		let o = [
			e ? "analyze" : null,
			t ? "verbose" : null,
			n ? "settings" : null,
			r ? "buffers" : null,
			i ? "wal" : null
		].filter(Boolean).join("|"), s = this.headers.get("Accept") ?? "application/json";
		return this.headers.set("Accept", `application/vnd.pgrst.plan+${a}; for="${s}"; options=${o};`), this;
	}
	rollback() {
		return this.headers.append("Prefer", "tx=rollback"), this;
	}
	returns() {
		return this;
	}
	maxAffected(e) {
		return this.headers.append("Prefer", "handling=strict"), this.headers.append("Prefer", `max-affected=${e}`), this;
	}
}, te = /* @__PURE__ */ RegExp("[,()]"), ne = class extends ee {
	eq(e, t) {
		return this.url.searchParams.append(e, `eq.${t}`), this;
	}
	neq(e, t) {
		return this.url.searchParams.append(e, `neq.${t}`), this;
	}
	gt(e, t) {
		return this.url.searchParams.append(e, `gt.${t}`), this;
	}
	gte(e, t) {
		return this.url.searchParams.append(e, `gte.${t}`), this;
	}
	lt(e, t) {
		return this.url.searchParams.append(e, `lt.${t}`), this;
	}
	lte(e, t) {
		return this.url.searchParams.append(e, `lte.${t}`), this;
	}
	like(e, t) {
		return this.url.searchParams.append(e, `like.${t}`), this;
	}
	likeAllOf(e, t) {
		return this.url.searchParams.append(e, `like(all).{${t.join(",")}}`), this;
	}
	likeAnyOf(e, t) {
		return this.url.searchParams.append(e, `like(any).{${t.join(",")}}`), this;
	}
	ilike(e, t) {
		return this.url.searchParams.append(e, `ilike.${t}`), this;
	}
	ilikeAllOf(e, t) {
		return this.url.searchParams.append(e, `ilike(all).{${t.join(",")}}`), this;
	}
	ilikeAnyOf(e, t) {
		return this.url.searchParams.append(e, `ilike(any).{${t.join(",")}}`), this;
	}
	regexMatch(e, t) {
		return this.url.searchParams.append(e, `match.${t}`), this;
	}
	regexIMatch(e, t) {
		return this.url.searchParams.append(e, `imatch.${t}`), this;
	}
	is(e, t) {
		return this.url.searchParams.append(e, `is.${t}`), this;
	}
	isDistinct(e, t) {
		return this.url.searchParams.append(e, `isdistinct.${t}`), this;
	}
	in(e, t) {
		let n = Array.from(new Set(t)).map((e) => typeof e == "string" && te.test(e) ? `"${e}"` : `${e}`).join(",");
		return this.url.searchParams.append(e, `in.(${n})`), this;
	}
	notIn(e, t) {
		let n = Array.from(new Set(t)).map((e) => typeof e == "string" && te.test(e) ? `"${e}"` : `${e}`).join(",");
		return this.url.searchParams.append(e, `not.in.(${n})`), this;
	}
	contains(e, t) {
		return typeof t == "string" ? this.url.searchParams.append(e, `cs.${t}`) : Array.isArray(t) ? this.url.searchParams.append(e, `cs.{${t.join(",")}}`) : this.url.searchParams.append(e, `cs.${JSON.stringify(t)}`), this;
	}
	containedBy(e, t) {
		return typeof t == "string" ? this.url.searchParams.append(e, `cd.${t}`) : Array.isArray(t) ? this.url.searchParams.append(e, `cd.{${t.join(",")}}`) : this.url.searchParams.append(e, `cd.${JSON.stringify(t)}`), this;
	}
	rangeGt(e, t) {
		return this.url.searchParams.append(e, `sr.${t}`), this;
	}
	rangeGte(e, t) {
		return this.url.searchParams.append(e, `nxl.${t}`), this;
	}
	rangeLt(e, t) {
		return this.url.searchParams.append(e, `sl.${t}`), this;
	}
	rangeLte(e, t) {
		return this.url.searchParams.append(e, `nxr.${t}`), this;
	}
	rangeAdjacent(e, t) {
		return this.url.searchParams.append(e, `adj.${t}`), this;
	}
	overlaps(e, t) {
		return typeof t == "string" ? this.url.searchParams.append(e, `ov.${t}`) : this.url.searchParams.append(e, `ov.{${t.join(",")}}`), this;
	}
	textSearch(e, t, { config: n, type: r } = {}) {
		let i = "";
		r === "plain" ? i = "pl" : r === "phrase" ? i = "ph" : r === "websearch" && (i = "w");
		let a = n === void 0 ? "" : `(${n})`;
		return this.url.searchParams.append(e, `${i}fts${a}.${t}`), this;
	}
	match(e) {
		return Object.entries(e).forEach(([e, t]) => {
			this.url.searchParams.append(e, `eq.${t}`);
		}), this;
	}
	not(e, t, n) {
		return this.url.searchParams.append(e, `not.${t}.${n}`), this;
	}
	or(e, { foreignTable: t, referencedTable: n = t } = {}) {
		let r = n ? `${n}.or` : "or";
		return this.url.searchParams.append(r, `(${e})`), this;
	}
	filter(e, t, n) {
		return this.url.searchParams.append(e, `${t}.${n}`), this;
	}
}, re = class {
	constructor(e, { headers: t = {}, schema: n, fetch: r }) {
		this.url = e, this.headers = new Headers(t), this.schema = n, this.fetch = r;
	}
	select(e, t) {
		let { head: n = !1, count: r } = t ?? {}, i = n ? "HEAD" : "GET", a = !1, o = (e ?? "*").split("").map((e) => /\s/.test(e) && !a ? "" : (e === "\"" && (a = !a), e)).join("");
		return this.url.searchParams.set("select", o), r && this.headers.append("Prefer", `count=${r}`), new ne({
			method: i,
			url: this.url,
			headers: this.headers,
			schema: this.schema,
			fetch: this.fetch
		});
	}
	insert(e, { count: t, defaultToNull: n = !0 } = {}) {
		if (t && this.headers.append("Prefer", `count=${t}`), n || this.headers.append("Prefer", "missing=default"), Array.isArray(e)) {
			let t = e.reduce((e, t) => e.concat(Object.keys(t)), []);
			if (t.length > 0) {
				let e = [...new Set(t)].map((e) => `"${e}"`);
				this.url.searchParams.set("columns", e.join(","));
			}
		}
		return new ne({
			method: "POST",
			url: this.url,
			headers: this.headers,
			schema: this.schema,
			body: e,
			fetch: this.fetch ?? fetch
		});
	}
	upsert(e, { onConflict: t, ignoreDuplicates: n = !1, count: r, defaultToNull: i = !0 } = {}) {
		if (this.headers.append("Prefer", `resolution=${n ? "ignore" : "merge"}-duplicates`), t !== void 0 && this.url.searchParams.set("on_conflict", t), r && this.headers.append("Prefer", `count=${r}`), i || this.headers.append("Prefer", "missing=default"), Array.isArray(e)) {
			let t = e.reduce((e, t) => e.concat(Object.keys(t)), []);
			if (t.length > 0) {
				let e = [...new Set(t)].map((e) => `"${e}"`);
				this.url.searchParams.set("columns", e.join(","));
			}
		}
		return new ne({
			method: "POST",
			url: this.url,
			headers: this.headers,
			schema: this.schema,
			body: e,
			fetch: this.fetch ?? fetch
		});
	}
	update(e, { count: t } = {}) {
		return t && this.headers.append("Prefer", `count=${t}`), new ne({
			method: "PATCH",
			url: this.url,
			headers: this.headers,
			schema: this.schema,
			body: e,
			fetch: this.fetch ?? fetch
		});
	}
	delete({ count: e } = {}) {
		return e && this.headers.append("Prefer", `count=${e}`), new ne({
			method: "DELETE",
			url: this.url,
			headers: this.headers,
			schema: this.schema,
			fetch: this.fetch ?? fetch
		});
	}
}, ie = class e {
	constructor(e, { headers: t = {}, schema: n, fetch: r } = {}) {
		this.url = e, this.headers = new Headers(t), this.schemaName = n, this.fetch = r;
	}
	from(e) {
		if (!e || typeof e != "string" || e.trim() === "") throw Error("Invalid relation name: relation must be a non-empty string.");
		return new re(new URL(`${this.url}/${e}`), {
			headers: new Headers(this.headers),
			schema: this.schemaName,
			fetch: this.fetch
		});
	}
	schema(t) {
		return new e(this.url, {
			headers: this.headers,
			schema: t,
			fetch: this.fetch
		});
	}
	rpc(e, t = {}, { head: n = !1, get: r = !1, count: i } = {}) {
		let a, o = new URL(`${this.url}/rpc/${e}`), s;
		n || r ? (a = n ? "HEAD" : "GET", Object.entries(t).filter(([e, t]) => t !== void 0).map(([e, t]) => [e, Array.isArray(t) ? `{${t.join(",")}}` : `${t}`]).forEach(([e, t]) => {
			o.searchParams.append(e, t);
		})) : (a = "POST", s = t);
		let c = new Headers(this.headers);
		return i && c.set("Prefer", `count=${i}`), new ne({
			method: a,
			url: o,
			headers: c,
			schema: this.schemaName,
			body: s,
			fetch: this.fetch ?? fetch
		});
	}
}, ae = class {
	constructor() {}
	static detectEnvironment() {
		if (typeof WebSocket < "u") return {
			type: "native",
			constructor: WebSocket
		};
		if (typeof globalThis < "u" && globalThis.WebSocket !== void 0) return {
			type: "native",
			constructor: globalThis.WebSocket
		};
		if (typeof global < "u" && global.WebSocket !== void 0) return {
			type: "native",
			constructor: global.WebSocket
		};
		if (typeof globalThis < "u" && globalThis.WebSocketPair !== void 0 && globalThis.WebSocket === void 0) return {
			type: "cloudflare",
			error: "Cloudflare Workers detected. WebSocket clients are not supported in Cloudflare Workers.",
			workaround: "Use Cloudflare Workers WebSocket API for server-side WebSocket handling, or deploy to a different runtime."
		};
		if (typeof globalThis < "u" && globalThis.EdgeRuntime || typeof navigator < "u" && navigator.userAgent?.includes("Vercel-Edge")) return {
			type: "unsupported",
			error: "Edge runtime detected (Vercel Edge/Netlify Edge). WebSockets are not supported in edge functions.",
			workaround: "Use serverless functions or a different deployment target for WebSocket functionality."
		};
		if (typeof process < "u") {
			let e = process.versions;
			if (e && e.node) {
				let t = e.node, n = parseInt(t.replace(/^v/, "").split(".")[0]);
				return n >= 22 ? globalThis.WebSocket === void 0 ? {
					type: "unsupported",
					error: `Node.js ${n} detected but native WebSocket not found.`,
					workaround: "Provide a WebSocket implementation via the transport option."
				} : {
					type: "native",
					constructor: globalThis.WebSocket
				} : {
					type: "unsupported",
					error: `Node.js ${n} detected without native WebSocket support.`,
					workaround: "For Node.js < 22, install \"ws\" package and provide it via the transport option:\nimport ws from \"ws\"\nnew RealtimeClient(url, { transport: ws })"
				};
			}
		}
		return {
			type: "unsupported",
			error: "Unknown JavaScript runtime without WebSocket support.",
			workaround: "Ensure you're running in a supported environment (browser, Node.js, Deno) or provide a custom WebSocket implementation."
		};
	}
	static getWebSocketConstructor() {
		let e = this.detectEnvironment();
		if (e.constructor) return e.constructor;
		let t = e.error || "WebSocket not supported in this environment.";
		throw e.workaround && (t += `\n\nSuggested solution: ${e.workaround}`), Error(t);
	}
	static createWebSocket(e, t) {
		return new (this.getWebSocketConstructor())(e, t);
	}
	static isWebSocketSupported() {
		try {
			let e = this.detectEnvironment();
			return e.type === "native" || e.type === "ws";
		} catch {
			return !1;
		}
	}
}, y = "realtime-js/2.89.0", oe = "1.0.0", se = "2.0.0", ce = oe, le = 1e4, ue;
(function(e) {
	e[e.connecting = 0] = "connecting", e[e.open = 1] = "open", e[e.closing = 2] = "closing", e[e.closed = 3] = "closed";
})(ue ||= {});
var b;
(function(e) {
	e.closed = "closed", e.errored = "errored", e.joined = "joined", e.joining = "joining", e.leaving = "leaving";
})(b ||= {});
var de;
(function(e) {
	e.close = "phx_close", e.error = "phx_error", e.join = "phx_join", e.reply = "phx_reply", e.leave = "phx_leave", e.access_token = "access_token";
})(de ||= {});
var fe;
(function(e) {
	e.websocket = "websocket";
})(fe ||= {});
var pe;
(function(e) {
	e.Connecting = "connecting", e.Open = "open", e.Closing = "closing", e.Closed = "closed";
})(pe ||= {});
//#endregion
//#region ../../node_modules/.pnpm/@supabase+realtime-js@2.89.0/node_modules/@supabase/realtime-js/dist/module/lib/serializer.js
var me = class {
	constructor(e) {
		this.HEADER_LENGTH = 1, this.USER_BROADCAST_PUSH_META_LENGTH = 6, this.KINDS = {
			userBroadcastPush: 3,
			userBroadcast: 4
		}, this.BINARY_ENCODING = 0, this.JSON_ENCODING = 1, this.BROADCAST_EVENT = "broadcast", this.allowedMetadataKeys = [], this.allowedMetadataKeys = e ?? [];
	}
	encode(e, t) {
		if (e.event === this.BROADCAST_EVENT && !(e.payload instanceof ArrayBuffer) && typeof e.payload.event == "string") return t(this._binaryEncodeUserBroadcastPush(e));
		let n = [
			e.join_ref,
			e.ref,
			e.topic,
			e.event,
			e.payload
		];
		return t(JSON.stringify(n));
	}
	_binaryEncodeUserBroadcastPush(e) {
		return this._isArrayBuffer(e.payload?.payload) ? this._encodeBinaryUserBroadcastPush(e) : this._encodeJsonUserBroadcastPush(e);
	}
	_encodeBinaryUserBroadcastPush(e) {
		let t = e.payload?.payload ?? /* @__PURE__ */ new ArrayBuffer(0);
		return this._encodeUserBroadcastPush(e, this.BINARY_ENCODING, t);
	}
	_encodeJsonUserBroadcastPush(e) {
		let t = e.payload?.payload ?? {}, n = new TextEncoder().encode(JSON.stringify(t)).buffer;
		return this._encodeUserBroadcastPush(e, this.JSON_ENCODING, n);
	}
	_encodeUserBroadcastPush(e, t, n) {
		let r = e.topic, i = e.ref ?? "", a = e.join_ref ?? "", o = e.payload.event, s = this.allowedMetadataKeys ? this._pick(e.payload, this.allowedMetadataKeys) : {}, c = Object.keys(s).length === 0 ? "" : JSON.stringify(s);
		if (a.length > 255) throw Error(`joinRef length ${a.length} exceeds maximum of 255`);
		if (i.length > 255) throw Error(`ref length ${i.length} exceeds maximum of 255`);
		if (r.length > 255) throw Error(`topic length ${r.length} exceeds maximum of 255`);
		if (o.length > 255) throw Error(`userEvent length ${o.length} exceeds maximum of 255`);
		if (c.length > 255) throw Error(`metadata length ${c.length} exceeds maximum of 255`);
		let l = this.USER_BROADCAST_PUSH_META_LENGTH + a.length + i.length + r.length + o.length + c.length, u = new ArrayBuffer(this.HEADER_LENGTH + l), d = new DataView(u), f = 0;
		d.setUint8(f++, this.KINDS.userBroadcastPush), d.setUint8(f++, a.length), d.setUint8(f++, i.length), d.setUint8(f++, r.length), d.setUint8(f++, o.length), d.setUint8(f++, c.length), d.setUint8(f++, t), Array.from(a, (e) => d.setUint8(f++, e.charCodeAt(0))), Array.from(i, (e) => d.setUint8(f++, e.charCodeAt(0))), Array.from(r, (e) => d.setUint8(f++, e.charCodeAt(0))), Array.from(o, (e) => d.setUint8(f++, e.charCodeAt(0))), Array.from(c, (e) => d.setUint8(f++, e.charCodeAt(0)));
		var p = new Uint8Array(u.byteLength + n.byteLength);
		return p.set(new Uint8Array(u), 0), p.set(new Uint8Array(n), u.byteLength), p.buffer;
	}
	decode(e, t) {
		if (this._isArrayBuffer(e)) return t(this._binaryDecode(e));
		if (typeof e == "string") {
			let [n, r, i, a, o] = JSON.parse(e);
			return t({
				join_ref: n,
				ref: r,
				topic: i,
				event: a,
				payload: o
			});
		}
		return t({});
	}
	_binaryDecode(e) {
		let t = new DataView(e), n = t.getUint8(0), r = new TextDecoder();
		switch (n) {
			case this.KINDS.userBroadcast: return this._decodeUserBroadcast(e, t, r);
		}
	}
	_decodeUserBroadcast(e, t, n) {
		let r = t.getUint8(1), i = t.getUint8(2), a = t.getUint8(3), o = t.getUint8(4), s = this.HEADER_LENGTH + 4, c = n.decode(e.slice(s, s + r));
		s += r;
		let l = n.decode(e.slice(s, s + i));
		s += i;
		let u = n.decode(e.slice(s, s + a));
		s += a;
		let d = e.slice(s, e.byteLength), f = o === this.JSON_ENCODING ? JSON.parse(n.decode(d)) : d, p = {
			type: this.BROADCAST_EVENT,
			event: l,
			payload: f
		};
		return a > 0 && (p.meta = JSON.parse(u)), {
			join_ref: null,
			ref: null,
			topic: c,
			event: this.BROADCAST_EVENT,
			payload: p
		};
	}
	_isArrayBuffer(e) {
		return e instanceof ArrayBuffer || e?.constructor?.name === "ArrayBuffer";
	}
	_pick(e, t) {
		return !e || typeof e != "object" ? {} : Object.fromEntries(Object.entries(e).filter(([e]) => t.includes(e)));
	}
}, he = class {
	constructor(e, t) {
		this.callback = e, this.timerCalc = t, this.timer = void 0, this.tries = 0, this.callback = e, this.timerCalc = t;
	}
	reset() {
		this.tries = 0, clearTimeout(this.timer), this.timer = void 0;
	}
	scheduleTimeout() {
		clearTimeout(this.timer), this.timer = setTimeout(() => {
			this.tries += 1, this.callback();
		}, this.timerCalc(this.tries + 1));
	}
}, x;
(function(e) {
	e.abstime = "abstime", e.bool = "bool", e.date = "date", e.daterange = "daterange", e.float4 = "float4", e.float8 = "float8", e.int2 = "int2", e.int4 = "int4", e.int4range = "int4range", e.int8 = "int8", e.int8range = "int8range", e.json = "json", e.jsonb = "jsonb", e.money = "money", e.numeric = "numeric", e.oid = "oid", e.reltime = "reltime", e.text = "text", e.time = "time", e.timestamp = "timestamp", e.timestamptz = "timestamptz", e.timetz = "timetz", e.tsrange = "tsrange", e.tstzrange = "tstzrange";
})(x ||= {});
var ge = (e, t, n = {}) => {
	let r = n.skipTypes ?? [];
	return t ? Object.keys(t).reduce((n, i) => (n[i] = _e(i, e, t, r), n), {}) : {};
}, _e = (e, t, n, r) => {
	let i = t.find((t) => t.name === e)?.type, a = n[e];
	return i && !r.includes(i) ? ve(i, a) : ye(a);
}, ve = (e, t) => {
	if (e.charAt(0) === "_") return Ce(t, e.slice(1, e.length));
	switch (e) {
		case x.bool: return be(t);
		case x.float4:
		case x.float8:
		case x.int2:
		case x.int4:
		case x.int8:
		case x.numeric:
		case x.oid: return xe(t);
		case x.json:
		case x.jsonb: return Se(t);
		case x.timestamp: return we(t);
		case x.abstime:
		case x.date:
		case x.daterange:
		case x.int4range:
		case x.int8range:
		case x.money:
		case x.reltime:
		case x.text:
		case x.time:
		case x.timestamptz:
		case x.timetz:
		case x.tsrange:
		case x.tstzrange: return ye(t);
		default: return ye(t);
	}
}, ye = (e) => e, be = (e) => {
	switch (e) {
		case "t": return !0;
		case "f": return !1;
		default: return e;
	}
}, xe = (e) => {
	if (typeof e == "string") {
		let t = parseFloat(e);
		if (!Number.isNaN(t)) return t;
	}
	return e;
}, Se = (e) => {
	if (typeof e == "string") try {
		return JSON.parse(e);
	} catch {
		return e;
	}
	return e;
}, Ce = (e, t) => {
	if (typeof e != "string") return e;
	let n = e.length - 1, r = e[n];
	if (e[0] === "{" && r === "}") {
		let r, i = e.slice(1, n);
		try {
			r = JSON.parse("[" + i + "]");
		} catch {
			r = i ? i.split(",") : [];
		}
		return r.map((e) => ve(t, e));
	}
	return e;
}, we = (e) => typeof e == "string" ? e.replace(" ", "T") : e, Te = (e) => {
	let t = new URL(e);
	return t.protocol = t.protocol.replace(/^ws/i, "http"), t.pathname = t.pathname.replace(/\/+$/, "").replace(/\/socket\/websocket$/i, "").replace(/\/socket$/i, "").replace(/\/websocket$/i, ""), t.pathname === "" || t.pathname === "/" ? t.pathname = "/api/broadcast" : t.pathname += "/api/broadcast", t.href;
}, Ee = class {
	constructor(e, t, n = {}, r = le) {
		this.channel = e, this.event = t, this.payload = n, this.timeout = r, this.sent = !1, this.timeoutTimer = void 0, this.ref = "", this.receivedResp = null, this.recHooks = [], this.refEvent = null;
	}
	resend(e) {
		this.timeout = e, this._cancelRefEvent(), this.ref = "", this.refEvent = null, this.receivedResp = null, this.sent = !1, this.send();
	}
	send() {
		this._hasReceived("timeout") || (this.startTimeout(), this.sent = !0, this.channel.socket.push({
			topic: this.channel.topic,
			event: this.event,
			payload: this.payload,
			ref: this.ref,
			join_ref: this.channel._joinRef()
		}));
	}
	updatePayload(e) {
		this.payload = Object.assign(Object.assign({}, this.payload), e);
	}
	receive(e, t) {
		return this._hasReceived(e) && t(this.receivedResp?.response), this.recHooks.push({
			status: e,
			callback: t
		}), this;
	}
	startTimeout() {
		this.timeoutTimer ||= (this.ref = this.channel.socket._makeRef(), this.refEvent = this.channel._replyEventName(this.ref), this.channel._on(this.refEvent, {}, (e) => {
			this._cancelRefEvent(), this._cancelTimeout(), this.receivedResp = e, this._matchReceive(e);
		}), setTimeout(() => {
			this.trigger("timeout", {});
		}, this.timeout));
	}
	trigger(e, t) {
		this.refEvent && this.channel._trigger(this.refEvent, {
			status: e,
			response: t
		});
	}
	destroy() {
		this._cancelRefEvent(), this._cancelTimeout();
	}
	_cancelRefEvent() {
		this.refEvent && this.channel._off(this.refEvent, {});
	}
	_cancelTimeout() {
		clearTimeout(this.timeoutTimer), this.timeoutTimer = void 0;
	}
	_matchReceive({ status: e, response: t }) {
		this.recHooks.filter((t) => t.status === e).forEach((e) => e.callback(t));
	}
	_hasReceived(e) {
		return this.receivedResp && this.receivedResp.status === e;
	}
}, De;
(function(e) {
	e.SYNC = "sync", e.JOIN = "join", e.LEAVE = "leave";
})(De ||= {});
var Oe = class e {
	constructor(t, n) {
		this.channel = t, this.state = {}, this.pendingDiffs = [], this.joinRef = null, this.enabled = !1, this.caller = {
			onJoin: () => {},
			onLeave: () => {},
			onSync: () => {}
		};
		let r = n?.events || {
			state: "presence_state",
			diff: "presence_diff"
		};
		this.channel._on(r.state, {}, (t) => {
			let { onJoin: n, onLeave: r, onSync: i } = this.caller;
			this.joinRef = this.channel._joinRef(), this.state = e.syncState(this.state, t, n, r), this.pendingDiffs.forEach((t) => {
				this.state = e.syncDiff(this.state, t, n, r);
			}), this.pendingDiffs = [], i();
		}), this.channel._on(r.diff, {}, (t) => {
			let { onJoin: n, onLeave: r, onSync: i } = this.caller;
			this.inPendingSyncState() ? this.pendingDiffs.push(t) : (this.state = e.syncDiff(this.state, t, n, r), i());
		}), this.onJoin((e, t, n) => {
			this.channel._trigger("presence", {
				event: "join",
				key: e,
				currentPresences: t,
				newPresences: n
			});
		}), this.onLeave((e, t, n) => {
			this.channel._trigger("presence", {
				event: "leave",
				key: e,
				currentPresences: t,
				leftPresences: n
			});
		}), this.onSync(() => {
			this.channel._trigger("presence", { event: "sync" });
		});
	}
	static syncState(e, t, n, r) {
		let i = this.cloneDeep(e), a = this.transformState(t), o = {}, s = {};
		return this.map(i, (e, t) => {
			a[e] || (s[e] = t);
		}), this.map(a, (e, t) => {
			let n = i[e];
			if (n) {
				let r = t.map((e) => e.presence_ref), i = n.map((e) => e.presence_ref), a = t.filter((e) => i.indexOf(e.presence_ref) < 0), c = n.filter((e) => r.indexOf(e.presence_ref) < 0);
				a.length > 0 && (o[e] = a), c.length > 0 && (s[e] = c);
			} else o[e] = t;
		}), this.syncDiff(i, {
			joins: o,
			leaves: s
		}, n, r);
	}
	static syncDiff(e, t, n, r) {
		let { joins: i, leaves: a } = {
			joins: this.transformState(t.joins),
			leaves: this.transformState(t.leaves)
		};
		return n ||= () => {}, r ||= () => {}, this.map(i, (t, r) => {
			let i = e[t] ?? [];
			if (e[t] = this.cloneDeep(r), i.length > 0) {
				let n = e[t].map((e) => e.presence_ref), r = i.filter((e) => n.indexOf(e.presence_ref) < 0);
				e[t].unshift(...r);
			}
			n(t, i, r);
		}), this.map(a, (t, n) => {
			let i = e[t];
			if (!i) return;
			let a = n.map((e) => e.presence_ref);
			i = i.filter((e) => a.indexOf(e.presence_ref) < 0), e[t] = i, r(t, i, n), i.length === 0 && delete e[t];
		}), e;
	}
	static map(e, t) {
		return Object.getOwnPropertyNames(e).map((n) => t(n, e[n]));
	}
	static transformState(e) {
		return e = this.cloneDeep(e), Object.getOwnPropertyNames(e).reduce((t, n) => {
			let r = e[n];
			return "metas" in r ? t[n] = r.metas.map((e) => (e.presence_ref = e.phx_ref, delete e.phx_ref, delete e.phx_ref_prev, e)) : t[n] = r, t;
		}, {});
	}
	static cloneDeep(e) {
		return JSON.parse(JSON.stringify(e));
	}
	onJoin(e) {
		this.caller.onJoin = e;
	}
	onLeave(e) {
		this.caller.onLeave = e;
	}
	onSync(e) {
		this.caller.onSync = e;
	}
	inPendingSyncState() {
		return !this.joinRef || this.joinRef !== this.channel._joinRef();
	}
}, ke;
(function(e) {
	e.ALL = "*", e.INSERT = "INSERT", e.UPDATE = "UPDATE", e.DELETE = "DELETE";
})(ke ||= {});
var Ae;
(function(e) {
	e.BROADCAST = "broadcast", e.PRESENCE = "presence", e.POSTGRES_CHANGES = "postgres_changes", e.SYSTEM = "system";
})(Ae ||= {});
var je;
(function(e) {
	e.SUBSCRIBED = "SUBSCRIBED", e.TIMED_OUT = "TIMED_OUT", e.CLOSED = "CLOSED", e.CHANNEL_ERROR = "CHANNEL_ERROR";
})(je ||= {});
var Me = class e {
	constructor(e, t = { config: {} }, n) {
		if (this.topic = e, this.params = t, this.socket = n, this.bindings = {}, this.state = b.closed, this.joinedOnce = !1, this.pushBuffer = [], this.subTopic = e.replace(/^realtime:/i, ""), this.params.config = Object.assign({
			broadcast: {
				ack: !1,
				self: !1
			},
			presence: {
				key: "",
				enabled: !1
			},
			private: !1
		}, t.config), this.timeout = this.socket.timeout, this.joinPush = new Ee(this, de.join, this.params, this.timeout), this.rejoinTimer = new he(() => this._rejoinUntilConnected(), this.socket.reconnectAfterMs), this.joinPush.receive("ok", () => {
			this.state = b.joined, this.rejoinTimer.reset(), this.pushBuffer.forEach((e) => e.send()), this.pushBuffer = [];
		}), this._onClose(() => {
			this.rejoinTimer.reset(), this.socket.log("channel", `close ${this.topic} ${this._joinRef()}`), this.state = b.closed, this.socket._remove(this);
		}), this._onError((e) => {
			this._isLeaving() || this._isClosed() || (this.socket.log("channel", `error ${this.topic}`, e), this.state = b.errored, this.rejoinTimer.scheduleTimeout());
		}), this.joinPush.receive("timeout", () => {
			this._isJoining() && (this.socket.log("channel", `timeout ${this.topic}`, this.joinPush.timeout), this.state = b.errored, this.rejoinTimer.scheduleTimeout());
		}), this.joinPush.receive("error", (e) => {
			this._isLeaving() || this._isClosed() || (this.socket.log("channel", `error ${this.topic}`, e), this.state = b.errored, this.rejoinTimer.scheduleTimeout());
		}), this._on(de.reply, {}, (e, t) => {
			this._trigger(this._replyEventName(t), e);
		}), this.presence = new Oe(this), this.broadcastEndpointURL = Te(this.socket.endPoint), this.private = this.params.config.private || !1, !this.private && this.params.config?.broadcast?.replay) throw `tried to use replay on public channel '${this.topic}'. It must be a private channel.`;
	}
	subscribe(t, n = this.timeout) {
		if (this.socket.isConnected() || this.socket.connect(), this.state == b.closed) {
			let { config: { broadcast: r, presence: i, private: a } } = this.params, o = this.bindings.postgres_changes?.map((e) => e.filter) ?? [], s = !!this.bindings[Ae.PRESENCE] && this.bindings[Ae.PRESENCE].length > 0 || this.params.config.presence?.enabled === !0, c = {}, l = {
				broadcast: r,
				presence: Object.assign(Object.assign({}, i), { enabled: s }),
				postgres_changes: o,
				private: a
			};
			this.socket.accessTokenValue && (c.access_token = this.socket.accessTokenValue), this._onError((e) => t?.(je.CHANNEL_ERROR, e)), this._onClose(() => t?.(je.CLOSED)), this.updateJoinPayload(Object.assign({ config: l }, c)), this.joinedOnce = !0, this._rejoin(n), this.joinPush.receive("ok", async ({ postgres_changes: n }) => {
				if (this.socket._isManualToken() || this.socket.setAuth(), n === void 0) {
					t?.(je.SUBSCRIBED);
					return;
				} else {
					let r = this.bindings.postgres_changes, i = r?.length ?? 0, a = [];
					for (let o = 0; o < i; o++) {
						let i = r[o], { filter: { event: s, schema: c, table: l, filter: u } } = i, d = n && n[o];
						if (d && d.event === s && e.isFilterValueEqual(d.schema, c) && e.isFilterValueEqual(d.table, l) && e.isFilterValueEqual(d.filter, u)) a.push(Object.assign(Object.assign({}, i), { id: d.id }));
						else {
							this.unsubscribe(), this.state = b.errored, t?.(je.CHANNEL_ERROR, /* @__PURE__ */ Error("mismatch between server and client bindings for postgres changes"));
							return;
						}
					}
					this.bindings.postgres_changes = a, t && t(je.SUBSCRIBED);
					return;
				}
			}).receive("error", (e) => {
				this.state = b.errored, t?.(je.CHANNEL_ERROR, Error(JSON.stringify(Object.values(e).join(", ") || "error")));
			}).receive("timeout", () => {
				t?.(je.TIMED_OUT);
			});
		}
		return this;
	}
	presenceState() {
		return this.presence.state;
	}
	async track(e, t = {}) {
		return await this.send({
			type: "presence",
			event: "track",
			payload: e
		}, t.timeout || this.timeout);
	}
	async untrack(e = {}) {
		return await this.send({
			type: "presence",
			event: "untrack"
		}, e);
	}
	on(e, t, n) {
		return this.state === b.joined && e === Ae.PRESENCE && (this.socket.log("channel", `resubscribe to ${this.topic} due to change in presence callbacks on joined channel`), this.unsubscribe().then(async () => await this.subscribe())), this._on(e, t, n);
	}
	async httpSend(e, t, n = {}) {
		if (t == null) return Promise.reject("Payload is required for httpSend()");
		let r = {
			apikey: this.socket.apiKey ? this.socket.apiKey : "",
			"Content-Type": "application/json"
		};
		this.socket.accessTokenValue && (r.Authorization = `Bearer ${this.socket.accessTokenValue}`);
		let i = {
			method: "POST",
			headers: r,
			body: JSON.stringify({ messages: [{
				topic: this.subTopic,
				event: e,
				payload: t,
				private: this.private
			}] })
		}, a = await this._fetchWithTimeout(this.broadcastEndpointURL, i, n.timeout ?? this.timeout);
		if (a.status === 202) return { success: !0 };
		let o = a.statusText;
		try {
			let e = await a.json();
			o = e.error || e.message || o;
		} catch {}
		return Promise.reject(Error(o));
	}
	async send(e, t = {}) {
		if (!this._canPush() && e.type === "broadcast") {
			console.warn("Realtime send() is automatically falling back to REST API. This behavior will be deprecated in the future. Please use httpSend() explicitly for REST delivery.");
			let { event: n, payload: r } = e, i = {
				apikey: this.socket.apiKey ? this.socket.apiKey : "",
				"Content-Type": "application/json"
			};
			this.socket.accessTokenValue && (i.Authorization = `Bearer ${this.socket.accessTokenValue}`);
			let a = {
				method: "POST",
				headers: i,
				body: JSON.stringify({ messages: [{
					topic: this.subTopic,
					event: n,
					payload: r,
					private: this.private
				}] })
			};
			try {
				let e = await this._fetchWithTimeout(this.broadcastEndpointURL, a, t.timeout ?? this.timeout);
				return await e.body?.cancel(), e.ok ? "ok" : "error";
			} catch (e) {
				return e.name === "AbortError" ? "timed out" : "error";
			}
		} else return new Promise((n) => {
			let r = this._push(e.type, e, t.timeout || this.timeout);
			e.type === "broadcast" && !this.params?.config?.broadcast?.ack && n("ok"), r.receive("ok", () => n("ok")), r.receive("error", () => n("error")), r.receive("timeout", () => n("timed out"));
		});
	}
	updateJoinPayload(e) {
		this.joinPush.updatePayload(e);
	}
	unsubscribe(e = this.timeout) {
		this.state = b.leaving;
		let t = () => {
			this.socket.log("channel", `leave ${this.topic}`), this._trigger(de.close, "leave", this._joinRef());
		};
		this.joinPush.destroy();
		let n = null;
		return new Promise((r) => {
			n = new Ee(this, de.leave, {}, e), n.receive("ok", () => {
				t(), r("ok");
			}).receive("timeout", () => {
				t(), r("timed out");
			}).receive("error", () => {
				r("error");
			}), n.send(), this._canPush() || n.trigger("ok", {});
		}).finally(() => {
			n?.destroy();
		});
	}
	teardown() {
		this.pushBuffer.forEach((e) => e.destroy()), this.pushBuffer = [], this.rejoinTimer.reset(), this.joinPush.destroy(), this.state = b.closed, this.bindings = {};
	}
	async _fetchWithTimeout(e, t, n) {
		let r = new AbortController(), i = setTimeout(() => r.abort(), n), a = await this.socket.fetch(e, Object.assign(Object.assign({}, t), { signal: r.signal }));
		return clearTimeout(i), a;
	}
	_push(e, t, n = this.timeout) {
		if (!this.joinedOnce) throw `tried to push '${e}' to '${this.topic}' before joining. Use channel.subscribe() before pushing events`;
		let r = new Ee(this, e, t, n);
		return this._canPush() ? r.send() : this._addToPushBuffer(r), r;
	}
	_addToPushBuffer(e) {
		if (e.startTimeout(), this.pushBuffer.push(e), this.pushBuffer.length > 100) {
			let e = this.pushBuffer.shift();
			e && (e.destroy(), this.socket.log("channel", `discarded push due to buffer overflow: ${e.event}`, e.payload));
		}
	}
	_onMessage(e, t, n) {
		return t;
	}
	_isMember(e) {
		return this.topic === e;
	}
	_joinRef() {
		return this.joinPush.ref;
	}
	_trigger(e, t, n) {
		var r, i;
		let a = e.toLocaleLowerCase(), { close: o, error: s, leave: c, join: l } = de;
		if (n && [
			o,
			s,
			c,
			l
		].indexOf(a) >= 0 && n !== this._joinRef()) return;
		let u = this._onMessage(a, t, n);
		if (t && !u) throw "channel onMessage callbacks must return the payload, modified or unmodified";
		[
			"insert",
			"update",
			"delete"
		].includes(a) ? (r = this.bindings.postgres_changes) == null || r.filter((e) => e.filter?.event === "*" || (e.filter?.event)?.toLocaleLowerCase() === a).map((e) => e.callback(u, n)) : (i = this.bindings[a]) == null || i.filter((e) => {
			if ([
				"broadcast",
				"presence",
				"postgres_changes"
			].includes(a)) if ("id" in e) {
				let n = e.id, r = e.filter?.event;
				return n && t.ids?.includes(n) && (r === "*" || r?.toLocaleLowerCase() === t.data?.type.toLocaleLowerCase());
			} else {
				let n = (e?.filter?.event)?.toLocaleLowerCase();
				return n === "*" || n === (t?.event)?.toLocaleLowerCase();
			}
			else return e.type.toLocaleLowerCase() === a;
		}).map((e) => {
			if (typeof u == "object" && "ids" in u) {
				let e = u.data, { schema: t, table: n, commit_timestamp: r, type: i, errors: a } = e, o = {
					schema: t,
					table: n,
					commit_timestamp: r,
					eventType: i,
					new: {},
					old: {},
					errors: a
				};
				u = Object.assign(Object.assign({}, o), this._getPayloadRecords(e));
			}
			e.callback(u, n);
		});
	}
	_isClosed() {
		return this.state === b.closed;
	}
	_isJoined() {
		return this.state === b.joined;
	}
	_isJoining() {
		return this.state === b.joining;
	}
	_isLeaving() {
		return this.state === b.leaving;
	}
	_replyEventName(e) {
		return `chan_reply_${e}`;
	}
	_on(e, t, n) {
		let r = e.toLocaleLowerCase(), i = {
			type: r,
			filter: t,
			callback: n
		};
		return this.bindings[r] ? this.bindings[r].push(i) : this.bindings[r] = [i], this;
	}
	_off(t, n) {
		let r = t.toLocaleLowerCase();
		return this.bindings[r] && (this.bindings[r] = this.bindings[r].filter((t) => !(t.type?.toLocaleLowerCase() === r && e.isEqual(t.filter, n)))), this;
	}
	static isEqual(e, t) {
		if (Object.keys(e).length !== Object.keys(t).length) return !1;
		for (let n in e) if (e[n] !== t[n]) return !1;
		return !0;
	}
	static isFilterValueEqual(e, t) {
		return (e ?? void 0) === (t ?? void 0);
	}
	_rejoinUntilConnected() {
		this.rejoinTimer.scheduleTimeout(), this.socket.isConnected() && this._rejoin();
	}
	_onClose(e) {
		this._on(de.close, {}, e);
	}
	_onError(e) {
		this._on(de.error, {}, (t) => e(t));
	}
	_canPush() {
		return this.socket.isConnected() && this._isJoined();
	}
	_rejoin(e = this.timeout) {
		this._isLeaving() || (this.socket._leaveOpenTopic(this.topic), this.state = b.joining, this.joinPush.resend(e));
	}
	_getPayloadRecords(e) {
		let t = {
			new: {},
			old: {}
		};
		return (e.type === "INSERT" || e.type === "UPDATE") && (t.new = ge(e.columns, e.record)), (e.type === "UPDATE" || e.type === "DELETE") && (t.old = ge(e.columns, e.old_record)), t;
	}
}, Ne = () => {}, Pe = {
	HEARTBEAT_INTERVAL: 25e3,
	RECONNECT_DELAY: 10,
	HEARTBEAT_TIMEOUT_FALLBACK: 100
}, Fe = [
	1e3,
	2e3,
	5e3,
	1e4
], Ie = 1e4, Le = "\n  addEventListener(\"message\", (e) => {\n    if (e.data.event === \"start\") {\n      setInterval(() => postMessage({ event: \"keepAlive\" }), e.data.interval);\n    }\n  });", Re = class {
	constructor(e, t) {
		if (this.accessTokenValue = null, this.apiKey = null, this._manuallySetToken = !1, this.channels = [], this.endPoint = "", this.httpEndpoint = "", this.headers = {}, this.params = {}, this.timeout = le, this.transport = null, this.heartbeatIntervalMs = Pe.HEARTBEAT_INTERVAL, this.heartbeatTimer = void 0, this.pendingHeartbeatRef = null, this.heartbeatCallback = Ne, this.ref = 0, this.reconnectTimer = null, this.vsn = ce, this.logger = Ne, this.conn = null, this.sendBuffer = [], this.serializer = new me(), this.stateChangeCallbacks = {
			open: [],
			close: [],
			error: [],
			message: []
		}, this.accessToken = null, this._connectionState = "disconnected", this._wasManualDisconnect = !1, this._authPromise = null, this._resolveFetch = (e) => e ? (...t) => e(...t) : (...e) => fetch(...e), !t?.params?.apikey) throw Error("API key is required to connect to Realtime");
		this.apiKey = t.params.apikey, this.endPoint = `${e}/${fe.websocket}`, this.httpEndpoint = Te(e), this._initializeOptions(t), this._setupReconnectionTimer(), this.fetch = this._resolveFetch(t?.fetch);
	}
	connect() {
		if (!(this.isConnecting() || this.isDisconnecting() || this.conn !== null && this.isConnected())) {
			if (this._setConnectionState("connecting"), this.accessToken && !this._authPromise && this._setAuthSafely("connect"), this.transport) this.conn = new this.transport(this.endpointURL());
			else try {
				this.conn = ae.createWebSocket(this.endpointURL());
			} catch (e) {
				this._setConnectionState("disconnected");
				let t = e.message;
				throw t.includes("Node.js") ? Error(`${t}\n\nTo use Realtime in Node.js, you need to provide a WebSocket implementation:

Option 1: Use Node.js 22+ which has native WebSocket support
Option 2: Install and provide the "ws" package:

  npm install ws

  import ws from "ws"
  const client = new RealtimeClient(url, {
    ...options,
    transport: ws
  })`) : Error(`WebSocket not available: ${t}`);
			}
			this._setupConnectionHandlers();
		}
	}
	endpointURL() {
		return this._appendParams(this.endPoint, Object.assign({}, this.params, { vsn: this.vsn }));
	}
	disconnect(e, t) {
		if (!this.isDisconnecting()) if (this._setConnectionState("disconnecting", !0), this.conn) {
			let n = setTimeout(() => {
				this._setConnectionState("disconnected");
			}, 100);
			this.conn.onclose = () => {
				clearTimeout(n), this._setConnectionState("disconnected");
			}, typeof this.conn.close == "function" && (e ? this.conn.close(e, t ?? "") : this.conn.close()), this._teardownConnection();
		} else this._setConnectionState("disconnected");
	}
	getChannels() {
		return this.channels;
	}
	async removeChannel(e) {
		let t = await e.unsubscribe();
		return this.channels.length === 0 && this.disconnect(), t;
	}
	async removeAllChannels() {
		let e = await Promise.all(this.channels.map((e) => e.unsubscribe()));
		return this.channels = [], this.disconnect(), e;
	}
	log(e, t, n) {
		this.logger(e, t, n);
	}
	connectionState() {
		switch (this.conn && this.conn.readyState) {
			case ue.connecting: return pe.Connecting;
			case ue.open: return pe.Open;
			case ue.closing: return pe.Closing;
			default: return pe.Closed;
		}
	}
	isConnected() {
		return this.connectionState() === pe.Open;
	}
	isConnecting() {
		return this._connectionState === "connecting";
	}
	isDisconnecting() {
		return this._connectionState === "disconnecting";
	}
	channel(e, t = { config: {} }) {
		let n = `realtime:${e}`, r = this.getChannels().find((e) => e.topic === n);
		if (r) return r;
		{
			let n = new Me(`realtime:${e}`, t, this);
			return this.channels.push(n), n;
		}
	}
	push(e) {
		let { topic: t, event: n, payload: r, ref: i } = e, a = () => {
			this.encode(e, (e) => {
				var t;
				(t = this.conn) == null || t.send(e);
			});
		};
		this.log("push", `${t} ${n} (${i})`, r), this.isConnected() ? a() : this.sendBuffer.push(a);
	}
	async setAuth(e = null) {
		this._authPromise = this._performAuth(e);
		try {
			await this._authPromise;
		} finally {
			this._authPromise = null;
		}
	}
	_isManualToken() {
		return this._manuallySetToken;
	}
	async sendHeartbeat() {
		var e;
		if (!this.isConnected()) {
			try {
				this.heartbeatCallback("disconnected");
			} catch (e) {
				this.log("error", "error in heartbeat callback", e);
			}
			return;
		}
		if (this.pendingHeartbeatRef) {
			this.pendingHeartbeatRef = null, this.log("transport", "heartbeat timeout. Attempting to re-establish connection");
			try {
				this.heartbeatCallback("timeout");
			} catch (e) {
				this.log("error", "error in heartbeat callback", e);
			}
			this._wasManualDisconnect = !1, (e = this.conn) == null || e.close(1e3, "heartbeat timeout"), setTimeout(() => {
				var e;
				this.isConnected() || (e = this.reconnectTimer) == null || e.scheduleTimeout();
			}, Pe.HEARTBEAT_TIMEOUT_FALLBACK);
			return;
		}
		this.pendingHeartbeatRef = this._makeRef(), this.push({
			topic: "phoenix",
			event: "heartbeat",
			payload: {},
			ref: this.pendingHeartbeatRef
		});
		try {
			this.heartbeatCallback("sent");
		} catch (e) {
			this.log("error", "error in heartbeat callback", e);
		}
		this._setAuthSafely("heartbeat");
	}
	onHeartbeat(e) {
		this.heartbeatCallback = e;
	}
	flushSendBuffer() {
		this.isConnected() && this.sendBuffer.length > 0 && (this.sendBuffer.forEach((e) => e()), this.sendBuffer = []);
	}
	_makeRef() {
		let e = this.ref + 1;
		return e === this.ref ? this.ref = 0 : this.ref = e, this.ref.toString();
	}
	_leaveOpenTopic(e) {
		let t = this.channels.find((t) => t.topic === e && (t._isJoined() || t._isJoining()));
		t && (this.log("transport", `leaving duplicate topic "${e}"`), t.unsubscribe());
	}
	_remove(e) {
		this.channels = this.channels.filter((t) => t.topic !== e.topic);
	}
	_onConnMessage(e) {
		this.decode(e.data, (e) => {
			if (e.topic === "phoenix" && e.event === "phx_reply") try {
				this.heartbeatCallback(e.payload.status === "ok" ? "ok" : "error");
			} catch (e) {
				this.log("error", "error in heartbeat callback", e);
			}
			e.ref && e.ref === this.pendingHeartbeatRef && (this.pendingHeartbeatRef = null);
			let { topic: t, event: n, payload: r, ref: i } = e, a = i ? `(${i})` : "", o = r.status || "";
			this.log("receive", `${o} ${t} ${n} ${a}`.trim(), r), this.channels.filter((e) => e._isMember(t)).forEach((e) => e._trigger(n, r, i)), this._triggerStateCallbacks("message", e);
		});
	}
	_clearTimer(e) {
		var t;
		e === "heartbeat" && this.heartbeatTimer ? (clearInterval(this.heartbeatTimer), this.heartbeatTimer = void 0) : e === "reconnect" && ((t = this.reconnectTimer) == null || t.reset());
	}
	_clearAllTimers() {
		this._clearTimer("heartbeat"), this._clearTimer("reconnect");
	}
	_setupConnectionHandlers() {
		this.conn && ("binaryType" in this.conn && (this.conn.binaryType = "arraybuffer"), this.conn.onopen = () => this._onConnOpen(), this.conn.onerror = (e) => this._onConnError(e), this.conn.onmessage = (e) => this._onConnMessage(e), this.conn.onclose = (e) => this._onConnClose(e), this.conn.readyState === ue.open && this._onConnOpen());
	}
	_teardownConnection() {
		if (this.conn) {
			if (this.conn.readyState === ue.open || this.conn.readyState === ue.connecting) try {
				this.conn.close();
			} catch (e) {
				this.log("error", "Error closing connection", e);
			}
			this.conn.onopen = null, this.conn.onerror = null, this.conn.onmessage = null, this.conn.onclose = null, this.conn = null;
		}
		this._clearAllTimers(), this._terminateWorker(), this.channels.forEach((e) => e.teardown());
	}
	_onConnOpen() {
		this._setConnectionState("connected"), this.log("transport", `connected to ${this.endpointURL()}`), (this._authPromise || (this.accessToken && !this.accessTokenValue ? this.setAuth() : Promise.resolve())).then(() => {
			this.flushSendBuffer();
		}).catch((e) => {
			this.log("error", "error waiting for auth on connect", e), this.flushSendBuffer();
		}), this._clearTimer("reconnect"), this.worker ? this.workerRef || this._startWorkerHeartbeat() : this._startHeartbeat(), this._triggerStateCallbacks("open");
	}
	_startHeartbeat() {
		this.heartbeatTimer && clearInterval(this.heartbeatTimer), this.heartbeatTimer = setInterval(() => this.sendHeartbeat(), this.heartbeatIntervalMs);
	}
	_startWorkerHeartbeat() {
		this.workerUrl ? this.log("worker", `starting worker for from ${this.workerUrl}`) : this.log("worker", "starting default worker");
		let e = this._workerObjectUrl(this.workerUrl);
		this.workerRef = new Worker(e), this.workerRef.onerror = (e) => {
			this.log("worker", "worker error", e.message), this._terminateWorker();
		}, this.workerRef.onmessage = (e) => {
			e.data.event === "keepAlive" && this.sendHeartbeat();
		}, this.workerRef.postMessage({
			event: "start",
			interval: this.heartbeatIntervalMs
		});
	}
	_terminateWorker() {
		this.workerRef &&= (this.log("worker", "terminating worker"), this.workerRef.terminate(), void 0);
	}
	_onConnClose(e) {
		var t;
		this._setConnectionState("disconnected"), this.log("transport", "close", e), this._triggerChanError(), this._clearTimer("heartbeat"), this._wasManualDisconnect || (t = this.reconnectTimer) == null || t.scheduleTimeout(), this._triggerStateCallbacks("close", e);
	}
	_onConnError(e) {
		this._setConnectionState("disconnected"), this.log("transport", `${e}`), this._triggerChanError(), this._triggerStateCallbacks("error", e);
	}
	_triggerChanError() {
		this.channels.forEach((e) => e._trigger(de.error));
	}
	_appendParams(e, t) {
		return Object.keys(t).length === 0 ? e : `${e}${e.match(/\?/) ? "&" : "?"}${new URLSearchParams(t)}`;
	}
	_workerObjectUrl(e) {
		let t;
		if (e) t = e;
		else {
			let e = new Blob([Le], { type: "application/javascript" });
			t = URL.createObjectURL(e);
		}
		return t;
	}
	_setConnectionState(e, t = !1) {
		this._connectionState = e, e === "connecting" ? this._wasManualDisconnect = !1 : e === "disconnecting" && (this._wasManualDisconnect = t);
	}
	async _performAuth(e = null) {
		let t, n = !1;
		if (e) t = e, n = !0;
		else if (this.accessToken) try {
			t = await this.accessToken();
		} catch (e) {
			this.log("error", "Error fetching access token from callback", e), t = this.accessTokenValue;
		}
		else t = this.accessTokenValue;
		n ? this._manuallySetToken = !0 : this.accessToken && (this._manuallySetToken = !1), this.accessTokenValue != t && (this.accessTokenValue = t, this.channels.forEach((e) => {
			let n = {
				access_token: t,
				version: y
			};
			t && e.updateJoinPayload(n), e.joinedOnce && e._isJoined() && e._push(de.access_token, { access_token: t });
		}));
	}
	async _waitForAuthIfNeeded() {
		this._authPromise && await this._authPromise;
	}
	_setAuthSafely(e = "general") {
		this._isManualToken() || this.setAuth().catch((t) => {
			this.log("error", `Error setting auth in ${e}`, t);
		});
	}
	_triggerStateCallbacks(e, t) {
		try {
			this.stateChangeCallbacks[e].forEach((n) => {
				try {
					n(t);
				} catch (t) {
					this.log("error", `error in ${e} callback`, t);
				}
			});
		} catch (t) {
			this.log("error", `error triggering ${e} callbacks`, t);
		}
	}
	_setupReconnectionTimer() {
		this.reconnectTimer = new he(async () => {
			setTimeout(async () => {
				await this._waitForAuthIfNeeded(), this.isConnected() || this.connect();
			}, Pe.RECONNECT_DELAY);
		}, this.reconnectAfterMs);
	}
	_initializeOptions(e) {
		switch (this.transport = e?.transport ?? null, this.timeout = e?.timeout ?? le, this.heartbeatIntervalMs = e?.heartbeatIntervalMs ?? Pe.HEARTBEAT_INTERVAL, this.worker = e?.worker ?? !1, this.accessToken = e?.accessToken ?? null, this.heartbeatCallback = e?.heartbeatCallback ?? Ne, this.vsn = e?.vsn ?? ce, e?.params && (this.params = e.params), e?.logger && (this.logger = e.logger), (e?.logLevel || e?.log_level) && (this.logLevel = e.logLevel || e.log_level, this.params = Object.assign(Object.assign({}, this.params), { log_level: this.logLevel })), this.reconnectAfterMs = e?.reconnectAfterMs ?? ((e) => Fe[e - 1] || Ie), this.vsn) {
			case oe:
				this.encode = e?.encode ?? ((e, t) => t(JSON.stringify(e))), this.decode = e?.decode ?? ((e, t) => t(JSON.parse(e)));
				break;
			case se:
				this.encode = e?.encode ?? this.serializer.encode.bind(this.serializer), this.decode = e?.decode ?? this.serializer.decode.bind(this.serializer);
				break;
			default: throw Error(`Unsupported serializer version: ${this.vsn}`);
		}
		if (this.worker) {
			if (typeof window < "u" && !window.Worker) throw Error("Web Worker is not supported");
			this.workerUrl = e?.workerUrl;
		}
	}
}, ze = class extends Error {
	constructor(e, t) {
		super(e), this.name = "IcebergError", this.status = t.status, this.icebergType = t.icebergType, this.icebergCode = t.icebergCode, this.details = t.details, this.isCommitStateUnknown = t.icebergType === "CommitStateUnknownException" || [
			500,
			502,
			504
		].includes(t.status) && t.icebergType?.includes("CommitState") === !0;
	}
	isNotFound() {
		return this.status === 404;
	}
	isConflict() {
		return this.status === 409;
	}
	isAuthenticationTimeout() {
		return this.status === 419;
	}
};
function Be(e, t, n) {
	let r = new URL(t, e);
	if (n) for (let [e, t] of Object.entries(n)) t !== void 0 && r.searchParams.set(e, t);
	return r.toString();
}
async function Ve(e) {
	return !e || e.type === "none" ? {} : e.type === "bearer" ? { Authorization: `Bearer ${e.token}` } : e.type === "header" ? { [e.name]: e.value } : e.type === "custom" ? await e.getHeaders() : {};
}
function He(e) {
	let t = e.fetchImpl ?? globalThis.fetch;
	return { async request({ method: n, path: r, query: i, body: a, headers: o }) {
		let s = Be(e.baseUrl, r, i), c = await Ve(e.auth), l = await t(s, {
			method: n,
			headers: {
				...a ? { "Content-Type": "application/json" } : {},
				...c,
				...o
			},
			body: a ? JSON.stringify(a) : void 0
		}), u = await l.text(), d = (l.headers.get("content-type") || "").includes("application/json"), f = d && u ? JSON.parse(u) : u;
		if (!l.ok) {
			let e = d ? f : void 0, t = e?.error;
			throw new ze(t?.message ?? `Request failed with status ${l.status}`, {
				status: l.status,
				icebergType: t?.type,
				icebergCode: t?.code,
				details: e
			});
		}
		return {
			status: l.status,
			headers: l.headers,
			data: f
		};
	} };
}
function Ue(e) {
	return e.join("");
}
var We = class {
	constructor(e, t = "") {
		this.client = e, this.prefix = t;
	}
	async listNamespaces(e) {
		let t = e ? { parent: Ue(e.namespace) } : void 0;
		return (await this.client.request({
			method: "GET",
			path: `${this.prefix}/namespaces`,
			query: t
		})).data.namespaces.map((e) => ({ namespace: e }));
	}
	async createNamespace(e, t) {
		let n = {
			namespace: e.namespace,
			properties: t?.properties
		};
		return (await this.client.request({
			method: "POST",
			path: `${this.prefix}/namespaces`,
			body: n
		})).data;
	}
	async dropNamespace(e) {
		await this.client.request({
			method: "DELETE",
			path: `${this.prefix}/namespaces/${Ue(e.namespace)}`
		});
	}
	async loadNamespaceMetadata(e) {
		return { properties: (await this.client.request({
			method: "GET",
			path: `${this.prefix}/namespaces/${Ue(e.namespace)}`
		})).data.properties };
	}
	async namespaceExists(e) {
		try {
			return await this.client.request({
				method: "HEAD",
				path: `${this.prefix}/namespaces/${Ue(e.namespace)}`
			}), !0;
		} catch (e) {
			if (e instanceof ze && e.status === 404) return !1;
			throw e;
		}
	}
	async createNamespaceIfNotExists(e, t) {
		try {
			return await this.createNamespace(e, t);
		} catch (e) {
			if (e instanceof ze && e.status === 409) return;
			throw e;
		}
	}
};
function Ge(e) {
	return e.join("");
}
var Ke = class {
	constructor(e, t = "", n) {
		this.client = e, this.prefix = t, this.accessDelegation = n;
	}
	async listTables(e) {
		return (await this.client.request({
			method: "GET",
			path: `${this.prefix}/namespaces/${Ge(e.namespace)}/tables`
		})).data.identifiers;
	}
	async createTable(e, t) {
		let n = {};
		return this.accessDelegation && (n["X-Iceberg-Access-Delegation"] = this.accessDelegation), (await this.client.request({
			method: "POST",
			path: `${this.prefix}/namespaces/${Ge(e.namespace)}/tables`,
			body: t,
			headers: n
		})).data.metadata;
	}
	async updateTable(e, t) {
		let n = await this.client.request({
			method: "POST",
			path: `${this.prefix}/namespaces/${Ge(e.namespace)}/tables/${e.name}`,
			body: t
		});
		return {
			"metadata-location": n.data["metadata-location"],
			metadata: n.data.metadata
		};
	}
	async dropTable(e, t) {
		await this.client.request({
			method: "DELETE",
			path: `${this.prefix}/namespaces/${Ge(e.namespace)}/tables/${e.name}`,
			query: { purgeRequested: String(t?.purge ?? !1) }
		});
	}
	async loadTable(e) {
		let t = {};
		return this.accessDelegation && (t["X-Iceberg-Access-Delegation"] = this.accessDelegation), (await this.client.request({
			method: "GET",
			path: `${this.prefix}/namespaces/${Ge(e.namespace)}/tables/${e.name}`,
			headers: t
		})).data.metadata;
	}
	async tableExists(e) {
		let t = {};
		this.accessDelegation && (t["X-Iceberg-Access-Delegation"] = this.accessDelegation);
		try {
			return await this.client.request({
				method: "HEAD",
				path: `${this.prefix}/namespaces/${Ge(e.namespace)}/tables/${e.name}`,
				headers: t
			}), !0;
		} catch (e) {
			if (e instanceof ze && e.status === 404) return !1;
			throw e;
		}
	}
	async createTableIfNotExists(e, t) {
		try {
			return await this.createTable(e, t);
		} catch (n) {
			if (n instanceof ze && n.status === 409) return await this.loadTable({
				namespace: e.namespace,
				name: t.name
			});
			throw n;
		}
	}
}, qe = class {
	constructor(e) {
		let t = "v1";
		e.catalogName && (t += `/${e.catalogName}`), this.client = He({
			baseUrl: e.baseUrl.endsWith("/") ? e.baseUrl : `${e.baseUrl}/`,
			auth: e.auth,
			fetchImpl: e.fetch
		}), this.accessDelegation = e.accessDelegation?.join(","), this.namespaceOps = new We(this.client, t), this.tableOps = new Ke(this.client, t, this.accessDelegation);
	}
	async listNamespaces(e) {
		return this.namespaceOps.listNamespaces(e);
	}
	async createNamespace(e, t) {
		return this.namespaceOps.createNamespace(e, t);
	}
	async dropNamespace(e) {
		await this.namespaceOps.dropNamespace(e);
	}
	async loadNamespaceMetadata(e) {
		return this.namespaceOps.loadNamespaceMetadata(e);
	}
	async listTables(e) {
		return this.tableOps.listTables(e);
	}
	async createTable(e, t) {
		return this.tableOps.createTable(e, t);
	}
	async updateTable(e, t) {
		return this.tableOps.updateTable(e, t);
	}
	async dropTable(e, t) {
		await this.tableOps.dropTable(e, t);
	}
	async loadTable(e) {
		return this.tableOps.loadTable(e);
	}
	async namespaceExists(e) {
		return this.namespaceOps.namespaceExists(e);
	}
	async tableExists(e) {
		return this.tableOps.tableExists(e);
	}
	async createNamespaceIfNotExists(e, t) {
		return this.namespaceOps.createNamespaceIfNotExists(e, t);
	}
	async createTableIfNotExists(e, t) {
		return this.tableOps.createTableIfNotExists(e, t);
	}
}, Je = class extends Error {
	constructor(e) {
		super(e), this.__isStorageError = !0, this.name = "StorageError";
	}
};
function S(e) {
	return typeof e == "object" && !!e && "__isStorageError" in e;
}
var Ye = class extends Je {
	constructor(e, t, n) {
		super(e), this.name = "StorageApiError", this.status = t, this.statusCode = n;
	}
	toJSON() {
		return {
			name: this.name,
			message: this.message,
			status: this.status,
			statusCode: this.statusCode
		};
	}
}, Xe = class extends Je {
	constructor(e, t) {
		super(e), this.name = "StorageUnknownError", this.originalError = t;
	}
}, Ze = (e) => e ? (...t) => e(...t) : (...e) => fetch(...e), Qe = () => Response, $e = (e) => {
	if (Array.isArray(e)) return e.map((e) => $e(e));
	if (typeof e == "function" || e !== Object(e)) return e;
	let t = {};
	return Object.entries(e).forEach(([e, n]) => {
		let r = e.replace(/([-_][a-z])/gi, (e) => e.toUpperCase().replace(/[-_]/g, ""));
		t[r] = $e(n);
	}), t;
}, et = (e) => {
	if (typeof e != "object" || !e) return !1;
	let t = Object.getPrototypeOf(e);
	return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, tt = (e) => !e || typeof e != "string" || e.length === 0 || e.length > 100 || e.trim() !== e || e.includes("/") || e.includes("\\") ? !1 : /^[\w!.\*'() &$@=;:+,?-]+$/.test(e);
function nt(e) {
	"@babel/helpers - typeof";
	return nt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, nt(e);
}
function rt(e, t) {
	if (nt(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (nt(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function it(e) {
	var t = rt(e, "string");
	return nt(t) == "symbol" ? t : t + "";
}
function at(e, t, n) {
	return (t = it(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function ot(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function C(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? ot(Object(n), !0).forEach(function(t) {
			at(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ot(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var st = (e) => e.msg || e.message || e.error_description || (typeof e.error == "string" ? e.error : e.error?.message) || JSON.stringify(e), ct = async (e, t, n) => {
	e instanceof await Qe() && !n?.noResolveJson ? e.json().then((n) => {
		let r = e.status || 500, i = n?.statusCode || r + "";
		t(new Ye(st(n), r, i));
	}).catch((e) => {
		t(new Xe(st(e), e));
	}) : t(new Xe(st(e), e));
}, lt = (e, t, n, r) => {
	let i = {
		method: e,
		headers: t?.headers || {}
	};
	return e === "GET" || !r ? i : (et(r) ? (i.headers = C({ "Content-Type": "application/json" }, t?.headers), i.body = JSON.stringify(r)) : i.body = r, t?.duplex && (i.duplex = t.duplex), C(C({}, i), n));
};
async function ut(e, t, n, r, i, a) {
	return new Promise((o, s) => {
		e(n, lt(t, r, i, a)).then((e) => {
			if (!e.ok) throw e;
			return r?.noResolveJson ? e : e.json();
		}).then((e) => o(e)).catch((e) => ct(e, s, r));
	});
}
async function dt(e, t, n, r) {
	return ut(e, "GET", t, n, r);
}
async function ft(e, t, n, r, i) {
	return ut(e, "POST", t, r, i, n);
}
async function pt(e, t, n, r, i) {
	return ut(e, "PUT", t, r, i, n);
}
async function mt(e, t, n, r) {
	return ut(e, "HEAD", t, C(C({}, n), {}, { noResolveJson: !0 }), r);
}
async function ht(e, t, n, r, i) {
	return ut(e, "DELETE", t, r, i, n);
}
var gt = class {
	constructor(e, t) {
		this.downloadFn = e, this.shouldThrowOnError = t;
	}
	then(e, t) {
		return this.execute().then(e, t);
	}
	async execute() {
		var e = this;
		try {
			return {
				data: (await e.downloadFn()).body,
				error: null
			};
		} catch (t) {
			if (e.shouldThrowOnError) throw t;
			if (S(t)) return {
				data: null,
				error: t
			};
			throw t;
		}
	}
}, _t = Symbol.toStringTag, vt = class {
	constructor(e, t) {
		this.downloadFn = e, this.shouldThrowOnError = t, this[_t] = "BlobDownloadBuilder", this.promise = null;
	}
	asStream() {
		return new gt(this.downloadFn, this.shouldThrowOnError);
	}
	then(e, t) {
		return this.getPromise().then(e, t);
	}
	catch(e) {
		return this.getPromise().catch(e);
	}
	finally(e) {
		return this.getPromise().finally(e);
	}
	getPromise() {
		return this.promise ||= this.execute(), this.promise;
	}
	async execute() {
		var e = this;
		try {
			return {
				data: await (await e.downloadFn()).blob(),
				error: null
			};
		} catch (t) {
			if (e.shouldThrowOnError) throw t;
			if (S(t)) return {
				data: null,
				error: t
			};
			throw t;
		}
	}
}, yt = {
	limit: 100,
	offset: 0,
	sortBy: {
		column: "name",
		order: "asc"
	}
}, bt = {
	cacheControl: "3600",
	contentType: "text/plain;charset=UTF-8",
	upsert: !1
}, xt = class {
	constructor(e, t = {}, n, r) {
		this.shouldThrowOnError = !1, this.url = e, this.headers = t, this.bucketId = n, this.fetch = Ze(r);
	}
	throwOnError() {
		return this.shouldThrowOnError = !0, this;
	}
	async uploadOrUpdate(e, t, n, r) {
		var i = this;
		try {
			let a, o = C(C({}, bt), r), s = C(C({}, i.headers), e === "POST" && { "x-upsert": String(o.upsert) }), c = o.metadata;
			typeof Blob < "u" && n instanceof Blob ? (a = new FormData(), a.append("cacheControl", o.cacheControl), c && a.append("metadata", i.encodeMetadata(c)), a.append("", n)) : typeof FormData < "u" && n instanceof FormData ? (a = n, a.has("cacheControl") || a.append("cacheControl", o.cacheControl), c && !a.has("metadata") && a.append("metadata", i.encodeMetadata(c))) : (a = n, s["cache-control"] = `max-age=${o.cacheControl}`, s["content-type"] = o.contentType, c && (s["x-metadata"] = i.toBase64(i.encodeMetadata(c))), (typeof ReadableStream < "u" && a instanceof ReadableStream || a && typeof a == "object" && "pipe" in a && typeof a.pipe == "function") && !o.duplex && (o.duplex = "half")), r?.headers && (s = C(C({}, s), r.headers));
			let l = i._removeEmptyFolders(t), u = i._getFinalPath(l), d = await (e == "PUT" ? pt : ft)(i.fetch, `${i.url}/object/${u}`, a, C({ headers: s }, o?.duplex ? { duplex: o.duplex } : {}));
			return {
				data: {
					path: l,
					id: d.Id,
					fullPath: d.Key
				},
				error: null
			};
		} catch (e) {
			if (i.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async upload(e, t, n) {
		return this.uploadOrUpdate("POST", e, t, n);
	}
	async uploadToSignedUrl(e, t, n, r) {
		var i = this;
		let a = i._removeEmptyFolders(e), o = i._getFinalPath(a), s = new URL(i.url + `/object/upload/sign/${o}`);
		s.searchParams.set("token", t);
		try {
			let e, t = C({ upsert: bt.upsert }, r), o = C(C({}, i.headers), { "x-upsert": String(t.upsert) });
			return typeof Blob < "u" && n instanceof Blob ? (e = new FormData(), e.append("cacheControl", t.cacheControl), e.append("", n)) : typeof FormData < "u" && n instanceof FormData ? (e = n, e.append("cacheControl", t.cacheControl)) : (e = n, o["cache-control"] = `max-age=${t.cacheControl}`, o["content-type"] = t.contentType), {
				data: {
					path: a,
					fullPath: (await pt(i.fetch, s.toString(), e, { headers: o })).Key
				},
				error: null
			};
		} catch (e) {
			if (i.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async createSignedUploadUrl(e, t) {
		var n = this;
		try {
			let r = n._getFinalPath(e), i = C({}, n.headers);
			t?.upsert && (i["x-upsert"] = "true");
			let a = await ft(n.fetch, `${n.url}/object/upload/sign/${r}`, {}, { headers: i }), o = new URL(n.url + a.url), s = o.searchParams.get("token");
			if (!s) throw new Je("No token returned by API");
			return {
				data: {
					signedUrl: o.toString(),
					path: e,
					token: s
				},
				error: null
			};
		} catch (e) {
			if (n.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async update(e, t, n) {
		return this.uploadOrUpdate("PUT", e, t, n);
	}
	async move(e, t, n) {
		var r = this;
		try {
			return {
				data: await ft(r.fetch, `${r.url}/object/move`, {
					bucketId: r.bucketId,
					sourceKey: e,
					destinationKey: t,
					destinationBucket: n?.destinationBucket
				}, { headers: r.headers }),
				error: null
			};
		} catch (e) {
			if (r.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async copy(e, t, n) {
		var r = this;
		try {
			return {
				data: { path: (await ft(r.fetch, `${r.url}/object/copy`, {
					bucketId: r.bucketId,
					sourceKey: e,
					destinationKey: t,
					destinationBucket: n?.destinationBucket
				}, { headers: r.headers })).Key },
				error: null
			};
		} catch (e) {
			if (r.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async createSignedUrl(e, t, n) {
		var r = this;
		try {
			let i = r._getFinalPath(e), a = await ft(r.fetch, `${r.url}/object/sign/${i}`, C({ expiresIn: t }, n?.transform ? { transform: n.transform } : {}), { headers: r.headers }), o = n?.download ? `&download=${n.download === !0 ? "" : n.download}` : "";
			return a = { signedUrl: encodeURI(`${r.url}${a.signedURL}${o}`) }, {
				data: a,
				error: null
			};
		} catch (e) {
			if (r.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async createSignedUrls(e, t, n) {
		var r = this;
		try {
			let i = await ft(r.fetch, `${r.url}/object/sign/${r.bucketId}`, {
				expiresIn: t,
				paths: e
			}, { headers: r.headers }), a = n?.download ? `&download=${n.download === !0 ? "" : n.download}` : "";
			return {
				data: i.map((e) => C(C({}, e), {}, { signedUrl: e.signedURL ? encodeURI(`${r.url}${e.signedURL}${a}`) : null })),
				error: null
			};
		} catch (e) {
			if (r.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	download(e, t) {
		let n = t?.transform === void 0 ? "object" : "render/image/authenticated", r = this.transformOptsToQueryString(t?.transform || {}), i = r ? `?${r}` : "", a = this._getFinalPath(e);
		return new vt(() => dt(this.fetch, `${this.url}/${n}/${a}${i}`, {
			headers: this.headers,
			noResolveJson: !0
		}), this.shouldThrowOnError);
	}
	async info(e) {
		var t = this;
		let n = t._getFinalPath(e);
		try {
			return {
				data: $e(await dt(t.fetch, `${t.url}/object/info/${n}`, { headers: t.headers })),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async exists(e) {
		var t = this;
		let n = t._getFinalPath(e);
		try {
			return await mt(t.fetch, `${t.url}/object/${n}`, { headers: t.headers }), {
				data: !0,
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (S(e) && e instanceof Xe) {
				let t = e.originalError;
				if ([400, 404].includes(t?.status)) return {
					data: !1,
					error: e
				};
			}
			throw e;
		}
	}
	getPublicUrl(e, t) {
		let n = this._getFinalPath(e), r = [], i = t?.download ? `download=${t.download === !0 ? "" : t.download}` : "";
		i !== "" && r.push(i);
		let a = t?.transform === void 0 ? "object" : "render/image", o = this.transformOptsToQueryString(t?.transform || {});
		o !== "" && r.push(o);
		let s = r.join("&");
		return s !== "" && (s = `?${s}`), { data: { publicUrl: encodeURI(`${this.url}/${a}/public/${n}${s}`) } };
	}
	async remove(e) {
		var t = this;
		try {
			return {
				data: await ht(t.fetch, `${t.url}/object/${t.bucketId}`, { prefixes: e }, { headers: t.headers }),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async list(e, t, n) {
		var r = this;
		try {
			let i = C(C(C({}, yt), t), {}, { prefix: e || "" });
			return {
				data: await ft(r.fetch, `${r.url}/object/list/${r.bucketId}`, i, { headers: r.headers }, n),
				error: null
			};
		} catch (e) {
			if (r.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async listV2(e, t) {
		var n = this;
		try {
			let r = C({}, e);
			return {
				data: await ft(n.fetch, `${n.url}/object/list-v2/${n.bucketId}`, r, { headers: n.headers }, t),
				error: null
			};
		} catch (e) {
			if (n.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	encodeMetadata(e) {
		return JSON.stringify(e);
	}
	toBase64(e) {
		return typeof Buffer < "u" ? Buffer.from(e).toString("base64") : btoa(e);
	}
	_getFinalPath(e) {
		return `${this.bucketId}/${e.replace(/^\/+/, "")}`;
	}
	_removeEmptyFolders(e) {
		return e.replace(/^\/|\/$/g, "").replace(/\/+/g, "/");
	}
	transformOptsToQueryString(e) {
		let t = [];
		return e.width && t.push(`width=${e.width}`), e.height && t.push(`height=${e.height}`), e.resize && t.push(`resize=${e.resize}`), e.format && t.push(`format=${e.format}`), e.quality && t.push(`quality=${e.quality}`), t.join("&");
	}
}, St = "2.89.0", Ct = { "X-Client-Info": `storage-js/${St}` }, wt = class {
	constructor(e, t = {}, n, r) {
		this.shouldThrowOnError = !1;
		let i = new URL(e);
		r?.useNewHostname && /supabase\.(co|in|red)$/.test(i.hostname) && !i.hostname.includes("storage.supabase.") && (i.hostname = i.hostname.replace("supabase.", "storage.supabase.")), this.url = i.href.replace(/\/$/, ""), this.headers = C(C({}, Ct), t), this.fetch = Ze(n);
	}
	throwOnError() {
		return this.shouldThrowOnError = !0, this;
	}
	async listBuckets(e) {
		var t = this;
		try {
			let n = t.listBucketOptionsToQueryString(e);
			return {
				data: await dt(t.fetch, `${t.url}/bucket${n}`, { headers: t.headers }),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async getBucket(e) {
		var t = this;
		try {
			return {
				data: await dt(t.fetch, `${t.url}/bucket/${e}`, { headers: t.headers }),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async createBucket(e, t = { public: !1 }) {
		var n = this;
		try {
			return {
				data: await ft(n.fetch, `${n.url}/bucket`, {
					id: e,
					name: e,
					type: t.type,
					public: t.public,
					file_size_limit: t.fileSizeLimit,
					allowed_mime_types: t.allowedMimeTypes
				}, { headers: n.headers }),
				error: null
			};
		} catch (e) {
			if (n.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async updateBucket(e, t) {
		var n = this;
		try {
			return {
				data: await pt(n.fetch, `${n.url}/bucket/${e}`, {
					id: e,
					name: e,
					public: t.public,
					file_size_limit: t.fileSizeLimit,
					allowed_mime_types: t.allowedMimeTypes
				}, { headers: n.headers }),
				error: null
			};
		} catch (e) {
			if (n.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async emptyBucket(e) {
		var t = this;
		try {
			return {
				data: await ft(t.fetch, `${t.url}/bucket/${e}/empty`, {}, { headers: t.headers }),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async deleteBucket(e) {
		var t = this;
		try {
			return {
				data: await ht(t.fetch, `${t.url}/bucket/${e}`, {}, { headers: t.headers }),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	listBucketOptionsToQueryString(e) {
		let t = {};
		return e && ("limit" in e && (t.limit = String(e.limit)), "offset" in e && (t.offset = String(e.offset)), e.search && (t.search = e.search), e.sortColumn && (t.sortColumn = e.sortColumn), e.sortOrder && (t.sortOrder = e.sortOrder)), Object.keys(t).length > 0 ? "?" + new URLSearchParams(t).toString() : "";
	}
}, Tt = class {
	constructor(e, t = {}, n) {
		this.shouldThrowOnError = !1, this.url = e.replace(/\/$/, ""), this.headers = C(C({}, Ct), t), this.fetch = Ze(n);
	}
	throwOnError() {
		return this.shouldThrowOnError = !0, this;
	}
	async createBucket(e) {
		var t = this;
		try {
			return {
				data: await ft(t.fetch, `${t.url}/bucket`, { name: e }, { headers: t.headers }),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async listBuckets(e) {
		var t = this;
		try {
			let n = new URLSearchParams();
			e?.limit !== void 0 && n.set("limit", e.limit.toString()), e?.offset !== void 0 && n.set("offset", e.offset.toString()), e?.sortColumn && n.set("sortColumn", e.sortColumn), e?.sortOrder && n.set("sortOrder", e.sortOrder), e?.search && n.set("search", e.search);
			let r = n.toString(), i = r ? `${t.url}/bucket?${r}` : `${t.url}/bucket`;
			return {
				data: await dt(t.fetch, i, { headers: t.headers }),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async deleteBucket(e) {
		var t = this;
		try {
			return {
				data: await ht(t.fetch, `${t.url}/bucket/${e}`, {}, { headers: t.headers }),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (S(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	from(e) {
		var t = this;
		if (!tt(e)) throw new Je("Invalid bucket name: File, folder, and bucket names must follow AWS object key naming guidelines and should avoid the use of any other characters.");
		let n = new qe({
			baseUrl: this.url,
			catalogName: e,
			auth: {
				type: "custom",
				getHeaders: async () => t.headers
			},
			fetch: this.fetch
		}), r = this.shouldThrowOnError;
		return new Proxy(n, { get(e, t) {
			let n = e[t];
			return typeof n == "function" ? async (...t) => {
				try {
					return {
						data: await n.apply(e, t),
						error: null
					};
				} catch (e) {
					if (r) throw e;
					return {
						data: null,
						error: e
					};
				}
			} : n;
		} });
	}
}, Et = {
	"X-Client-Info": `storage-js/${St}`,
	"Content-Type": "application/json"
}, Dt = class extends Error {
	constructor(e) {
		super(e), this.__isStorageVectorsError = !0, this.name = "StorageVectorsError";
	}
};
function Ot(e) {
	return typeof e == "object" && !!e && "__isStorageVectorsError" in e;
}
var kt = class extends Dt {
	constructor(e, t, n) {
		super(e), this.name = "StorageVectorsApiError", this.status = t, this.statusCode = n;
	}
	toJSON() {
		return {
			name: this.name,
			message: this.message,
			status: this.status,
			statusCode: this.statusCode
		};
	}
}, At = class extends Dt {
	constructor(e, t) {
		super(e), this.name = "StorageVectorsUnknownError", this.originalError = t;
	}
}, jt = (e) => e ? (...t) => e(...t) : (...e) => fetch(...e), Mt = (e) => {
	if (typeof e != "object" || !e) return !1;
	let t = Object.getPrototypeOf(e);
	return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Nt = (e) => e.msg || e.message || e.error_description || e.error || JSON.stringify(e), Pt = async (e, t, n) => {
	if (e && typeof e == "object" && "status" in e && "ok" in e && typeof e.status == "number" && !n?.noResolveJson) {
		let n = e.status || 500, r = e;
		if (typeof r.json == "function") r.json().then((e) => {
			let r = e?.statusCode || e?.code || n + "";
			t(new kt(Nt(e), n, r));
		}).catch(() => {
			let e = n + "";
			t(new kt(r.statusText || `HTTP ${n} error`, n, e));
		});
		else {
			let e = n + "";
			t(new kt(r.statusText || `HTTP ${n} error`, n, e));
		}
	} else t(new At(Nt(e), e));
}, Ft = (e, t, n, r) => {
	let i = {
		method: e,
		headers: t?.headers || {}
	};
	return e === "GET" || !r ? i : (Mt(r) ? (i.headers = C({ "Content-Type": "application/json" }, t?.headers), i.body = JSON.stringify(r)) : i.body = r, C(C({}, i), n));
};
async function It(e, t, n, r, i, a) {
	return new Promise((o, s) => {
		e(n, Ft(t, r, i, a)).then((e) => {
			if (!e.ok) throw e;
			if (r?.noResolveJson) return e;
			let t = e.headers.get("content-type");
			return !t || !t.includes("application/json") ? {} : e.json();
		}).then((e) => o(e)).catch((e) => Pt(e, s, r));
	});
}
async function Lt(e, t, n, r, i) {
	return It(e, "POST", t, r, i, n);
}
var Rt = class {
	constructor(e, t = {}, n) {
		this.shouldThrowOnError = !1, this.url = e.replace(/\/$/, ""), this.headers = C(C({}, Et), t), this.fetch = jt(n);
	}
	throwOnError() {
		return this.shouldThrowOnError = !0, this;
	}
	async createIndex(e) {
		var t = this;
		try {
			return {
				data: await Lt(t.fetch, `${t.url}/CreateIndex`, e, { headers: t.headers }) || {},
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (Ot(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async getIndex(e, t) {
		var n = this;
		try {
			return {
				data: await Lt(n.fetch, `${n.url}/GetIndex`, {
					vectorBucketName: e,
					indexName: t
				}, { headers: n.headers }),
				error: null
			};
		} catch (e) {
			if (n.shouldThrowOnError) throw e;
			if (Ot(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async listIndexes(e) {
		var t = this;
		try {
			return {
				data: await Lt(t.fetch, `${t.url}/ListIndexes`, e, { headers: t.headers }),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (Ot(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async deleteIndex(e, t) {
		var n = this;
		try {
			return {
				data: await Lt(n.fetch, `${n.url}/DeleteIndex`, {
					vectorBucketName: e,
					indexName: t
				}, { headers: n.headers }) || {},
				error: null
			};
		} catch (e) {
			if (n.shouldThrowOnError) throw e;
			if (Ot(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
}, zt = class {
	constructor(e, t = {}, n) {
		this.shouldThrowOnError = !1, this.url = e.replace(/\/$/, ""), this.headers = C(C({}, Et), t), this.fetch = jt(n);
	}
	throwOnError() {
		return this.shouldThrowOnError = !0, this;
	}
	async putVectors(e) {
		var t = this;
		try {
			if (e.vectors.length < 1 || e.vectors.length > 500) throw Error("Vector batch size must be between 1 and 500 items");
			return {
				data: await Lt(t.fetch, `${t.url}/PutVectors`, e, { headers: t.headers }) || {},
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (Ot(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async getVectors(e) {
		var t = this;
		try {
			return {
				data: await Lt(t.fetch, `${t.url}/GetVectors`, e, { headers: t.headers }),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (Ot(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async listVectors(e) {
		var t = this;
		try {
			if (e.segmentCount !== void 0) {
				if (e.segmentCount < 1 || e.segmentCount > 16) throw Error("segmentCount must be between 1 and 16");
				if (e.segmentIndex !== void 0 && (e.segmentIndex < 0 || e.segmentIndex >= e.segmentCount)) throw Error(`segmentIndex must be between 0 and ${e.segmentCount - 1}`);
			}
			return {
				data: await Lt(t.fetch, `${t.url}/ListVectors`, e, { headers: t.headers }),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (Ot(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async queryVectors(e) {
		var t = this;
		try {
			return {
				data: await Lt(t.fetch, `${t.url}/QueryVectors`, e, { headers: t.headers }),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (Ot(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async deleteVectors(e) {
		var t = this;
		try {
			if (e.keys.length < 1 || e.keys.length > 500) throw Error("Keys batch size must be between 1 and 500 items");
			return {
				data: await Lt(t.fetch, `${t.url}/DeleteVectors`, e, { headers: t.headers }) || {},
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (Ot(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
}, Bt = class {
	constructor(e, t = {}, n) {
		this.shouldThrowOnError = !1, this.url = e.replace(/\/$/, ""), this.headers = C(C({}, Et), t), this.fetch = jt(n);
	}
	throwOnError() {
		return this.shouldThrowOnError = !0, this;
	}
	async createBucket(e) {
		var t = this;
		try {
			return {
				data: await Lt(t.fetch, `${t.url}/CreateVectorBucket`, { vectorBucketName: e }, { headers: t.headers }) || {},
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (Ot(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async getBucket(e) {
		var t = this;
		try {
			return {
				data: await Lt(t.fetch, `${t.url}/GetVectorBucket`, { vectorBucketName: e }, { headers: t.headers }),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (Ot(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async listBuckets(e = {}) {
		var t = this;
		try {
			return {
				data: await Lt(t.fetch, `${t.url}/ListVectorBuckets`, e, { headers: t.headers }),
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (Ot(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async deleteBucket(e) {
		var t = this;
		try {
			return {
				data: await Lt(t.fetch, `${t.url}/DeleteVectorBucket`, { vectorBucketName: e }, { headers: t.headers }) || {},
				error: null
			};
		} catch (e) {
			if (t.shouldThrowOnError) throw e;
			if (Ot(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
}, Vt = class extends Bt {
	constructor(e, t = {}) {
		super(e, t.headers || {}, t.fetch);
	}
	from(e) {
		return new Ht(this.url, this.headers, e, this.fetch);
	}
	async createBucket(e) {
		var t = () => super.createBucket, n = this;
		return t().call(n, e);
	}
	async getBucket(e) {
		var t = () => super.getBucket, n = this;
		return t().call(n, e);
	}
	async listBuckets(e = {}) {
		var t = () => super.listBuckets, n = this;
		return t().call(n, e);
	}
	async deleteBucket(e) {
		var t = () => super.deleteBucket, n = this;
		return t().call(n, e);
	}
}, Ht = class extends Rt {
	constructor(e, t, n, r) {
		super(e, t, r), this.vectorBucketName = n;
	}
	async createIndex(e) {
		var t = () => super.createIndex, n = this;
		return t().call(n, C(C({}, e), {}, { vectorBucketName: n.vectorBucketName }));
	}
	async listIndexes(e = {}) {
		var t = () => super.listIndexes, n = this;
		return t().call(n, C(C({}, e), {}, { vectorBucketName: n.vectorBucketName }));
	}
	async getIndex(e) {
		var t = () => super.getIndex, n = this;
		return t().call(n, n.vectorBucketName, e);
	}
	async deleteIndex(e) {
		var t = () => super.deleteIndex, n = this;
		return t().call(n, n.vectorBucketName, e);
	}
	index(e) {
		return new Ut(this.url, this.headers, this.vectorBucketName, e, this.fetch);
	}
}, Ut = class extends zt {
	constructor(e, t, n, r, i) {
		super(e, t, i), this.vectorBucketName = n, this.indexName = r;
	}
	async putVectors(e) {
		var t = () => super.putVectors, n = this;
		return t().call(n, C(C({}, e), {}, {
			vectorBucketName: n.vectorBucketName,
			indexName: n.indexName
		}));
	}
	async getVectors(e) {
		var t = () => super.getVectors, n = this;
		return t().call(n, C(C({}, e), {}, {
			vectorBucketName: n.vectorBucketName,
			indexName: n.indexName
		}));
	}
	async listVectors(e = {}) {
		var t = () => super.listVectors, n = this;
		return t().call(n, C(C({}, e), {}, {
			vectorBucketName: n.vectorBucketName,
			indexName: n.indexName
		}));
	}
	async queryVectors(e) {
		var t = () => super.queryVectors, n = this;
		return t().call(n, C(C({}, e), {}, {
			vectorBucketName: n.vectorBucketName,
			indexName: n.indexName
		}));
	}
	async deleteVectors(e) {
		var t = () => super.deleteVectors, n = this;
		return t().call(n, C(C({}, e), {}, {
			vectorBucketName: n.vectorBucketName,
			indexName: n.indexName
		}));
	}
}, Wt = class extends wt {
	constructor(e, t = {}, n, r) {
		super(e, t, n, r);
	}
	from(e) {
		return new xt(this.url, this.headers, e, this.fetch);
	}
	get vectors() {
		return new Vt(this.url + "/vector", {
			headers: this.headers,
			fetch: this.fetch
		});
	}
	get analytics() {
		return new Tt(this.url + "/iceberg", this.headers, this.fetch);
	}
}, Gt = "2.89.0", Kt = 30 * 1e3, qt = 3 * Kt, Jt = "http://localhost:9999", Yt = "supabase.auth.token", Xt = { "X-Client-Info": `gotrue-js/${Gt}` }, Zt = "X-Supabase-Api-Version", Qt = { "2024-01-01": {
	timestamp: Date.parse("2024-01-01T00:00:00.0Z"),
	name: "2024-01-01"
} }, $t = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}$|[a-z0-9_-]{2}$)$/i, en = class extends Error {
	constructor(e, t, n) {
		super(e), this.__isAuthError = !0, this.name = "AuthError", this.status = t, this.code = n;
	}
};
function w(e) {
	return typeof e == "object" && !!e && "__isAuthError" in e;
}
var tn = class extends en {
	constructor(e, t, n) {
		super(e, t, n), this.name = "AuthApiError", this.status = t, this.code = n;
	}
};
function nn(e) {
	return w(e) && e.name === "AuthApiError";
}
var rn = class extends en {
	constructor(e, t) {
		super(e), this.name = "AuthUnknownError", this.originalError = t;
	}
}, an = class extends en {
	constructor(e, t, n, r) {
		super(e, n, r), this.name = t, this.status = n;
	}
}, on = class extends an {
	constructor() {
		super("Auth session missing!", "AuthSessionMissingError", 400, void 0);
	}
};
function sn(e) {
	return w(e) && e.name === "AuthSessionMissingError";
}
var cn = class extends an {
	constructor() {
		super("Auth session or user missing", "AuthInvalidTokenResponseError", 500, void 0);
	}
}, ln = class extends an {
	constructor(e) {
		super(e, "AuthInvalidCredentialsError", 400, void 0);
	}
}, un = class extends an {
	constructor(e, t = null) {
		super(e, "AuthImplicitGrantRedirectError", 500, void 0), this.details = null, this.details = t;
	}
	toJSON() {
		return {
			name: this.name,
			message: this.message,
			status: this.status,
			details: this.details
		};
	}
};
function dn(e) {
	return w(e) && e.name === "AuthImplicitGrantRedirectError";
}
var fn = class extends an {
	constructor(e, t = null) {
		super(e, "AuthPKCEGrantCodeExchangeError", 500, void 0), this.details = null, this.details = t;
	}
	toJSON() {
		return {
			name: this.name,
			message: this.message,
			status: this.status,
			details: this.details
		};
	}
}, pn = class extends an {
	constructor() {
		super("PKCE code verifier not found in storage. This can happen if the auth flow was initiated in a different browser or device, or if the storage was cleared. For SSR frameworks (Next.js, SvelteKit, etc.), use @supabase/ssr on both the server and client to store the code verifier in cookies.", "AuthPKCECodeVerifierMissingError", 400, "pkce_code_verifier_not_found");
	}
}, mn = class extends an {
	constructor(e, t) {
		super(e, "AuthRetryableFetchError", t, void 0);
	}
};
function hn(e) {
	return w(e) && e.name === "AuthRetryableFetchError";
}
var gn = class extends an {
	constructor(e, t, n) {
		super(e, "AuthWeakPasswordError", t, "weak_password"), this.reasons = n;
	}
}, _n = class extends an {
	constructor(e) {
		super(e, "AuthInvalidJwtError", 400, "invalid_jwt");
	}
}, vn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_".split(""), yn = " 	\n\r=".split(""), bn = (() => {
	let e = Array(128);
	for (let t = 0; t < e.length; t += 1) e[t] = -1;
	for (let t = 0; t < yn.length; t += 1) e[yn[t].charCodeAt(0)] = -2;
	for (let t = 0; t < vn.length; t += 1) e[vn[t].charCodeAt(0)] = t;
	return e;
})();
function xn(e, t, n) {
	if (e !== null) for (t.queue = t.queue << 8 | e, t.queuedBits += 8; t.queuedBits >= 6;) n(vn[t.queue >> t.queuedBits - 6 & 63]), t.queuedBits -= 6;
	else if (t.queuedBits > 0) for (t.queue <<= 6 - t.queuedBits, t.queuedBits = 6; t.queuedBits >= 6;) n(vn[t.queue >> t.queuedBits - 6 & 63]), t.queuedBits -= 6;
}
function Sn(e, t, n) {
	let r = bn[e];
	if (r > -1) for (t.queue = t.queue << 6 | r, t.queuedBits += 6; t.queuedBits >= 8;) n(t.queue >> t.queuedBits - 8 & 255), t.queuedBits -= 8;
	else if (r === -2) return;
	else throw Error(`Invalid Base64-URL character "${String.fromCharCode(e)}"`);
}
function Cn(e) {
	let t = [], n = (e) => {
		t.push(String.fromCodePoint(e));
	}, r = {
		utf8seq: 0,
		codepoint: 0
	}, i = {
		queue: 0,
		queuedBits: 0
	}, a = (e) => {
		En(e, r, n);
	};
	for (let t = 0; t < e.length; t += 1) Sn(e.charCodeAt(t), i, a);
	return t.join("");
}
function wn(e, t) {
	if (e <= 127) {
		t(e);
		return;
	} else if (e <= 2047) {
		t(192 | e >> 6), t(128 | e & 63);
		return;
	} else if (e <= 65535) {
		t(224 | e >> 12), t(128 | e >> 6 & 63), t(128 | e & 63);
		return;
	} else if (e <= 1114111) {
		t(240 | e >> 18), t(128 | e >> 12 & 63), t(128 | e >> 6 & 63), t(128 | e & 63);
		return;
	}
	throw Error(`Unrecognized Unicode codepoint: ${e.toString(16)}`);
}
function Tn(e, t) {
	for (let n = 0; n < e.length; n += 1) {
		let r = e.charCodeAt(n);
		if (r > 55295 && r <= 56319) {
			let t = (r - 55296) * 1024 & 65535;
			r = (e.charCodeAt(n + 1) - 56320 & 65535 | t) + 65536, n += 1;
		}
		wn(r, t);
	}
}
function En(e, t, n) {
	if (t.utf8seq === 0) {
		if (e <= 127) {
			n(e);
			return;
		}
		for (let n = 1; n < 6; n += 1) if (!(e >> 7 - n & 1)) {
			t.utf8seq = n;
			break;
		}
		if (t.utf8seq === 2) t.codepoint = e & 31;
		else if (t.utf8seq === 3) t.codepoint = e & 15;
		else if (t.utf8seq === 4) t.codepoint = e & 7;
		else throw Error("Invalid UTF-8 sequence");
		--t.utf8seq;
	} else if (t.utf8seq > 0) {
		if (e <= 127) throw Error("Invalid UTF-8 sequence");
		t.codepoint = t.codepoint << 6 | e & 63, --t.utf8seq, t.utf8seq === 0 && n(t.codepoint);
	}
}
function Dn(e) {
	let t = [], n = {
		queue: 0,
		queuedBits: 0
	}, r = (e) => {
		t.push(e);
	};
	for (let t = 0; t < e.length; t += 1) Sn(e.charCodeAt(t), n, r);
	return new Uint8Array(t);
}
function On(e) {
	let t = [];
	return Tn(e, (e) => t.push(e)), new Uint8Array(t);
}
function kn(e) {
	let t = [], n = {
		queue: 0,
		queuedBits: 0
	}, r = (e) => {
		t.push(e);
	};
	return e.forEach((e) => xn(e, n, r)), xn(null, n, r), t.join("");
}
//#endregion
//#region ../../node_modules/.pnpm/@supabase+auth-js@2.89.0/node_modules/@supabase/auth-js/dist/module/lib/helpers.js
function An(e) {
	return Math.round(Date.now() / 1e3) + e;
}
function jn() {
	return Symbol("auth-callback");
}
var T = () => typeof window < "u" && typeof document < "u", Mn = {
	tested: !1,
	writable: !1
}, Nn = () => {
	if (!T()) return !1;
	try {
		if (typeof globalThis.localStorage != "object") return !1;
	} catch {
		return !1;
	}
	if (Mn.tested) return Mn.writable;
	let e = `lswt-${Math.random()}${Math.random()}`;
	try {
		globalThis.localStorage.setItem(e, e), globalThis.localStorage.removeItem(e), Mn.tested = !0, Mn.writable = !0;
	} catch {
		Mn.tested = !0, Mn.writable = !1;
	}
	return Mn.writable;
};
function Pn(e) {
	let t = {}, n = new URL(e);
	if (n.hash && n.hash[0] === "#") try {
		new URLSearchParams(n.hash.substring(1)).forEach((e, n) => {
			t[n] = e;
		});
	} catch {}
	return n.searchParams.forEach((e, n) => {
		t[n] = e;
	}), t;
}
var Fn = (e) => e ? (...t) => e(...t) : (...e) => fetch(...e), In = (e) => typeof e == "object" && !!e && "status" in e && "ok" in e && "json" in e && typeof e.json == "function", Ln = async (e, t, n) => {
	await e.setItem(t, JSON.stringify(n));
}, Rn = async (e, t) => {
	let n = await e.getItem(t);
	if (!n) return null;
	try {
		return JSON.parse(n);
	} catch {
		return n;
	}
}, E = async (e, t) => {
	await e.removeItem(t);
}, zn = class e {
	constructor() {
		this.promise = new e.promiseConstructor((e, t) => {
			this.resolve = e, this.reject = t;
		});
	}
};
zn.promiseConstructor = Promise;
function Bn(e) {
	let t = e.split(".");
	if (t.length !== 3) throw new _n("Invalid JWT structure");
	for (let e = 0; e < t.length; e++) if (!$t.test(t[e])) throw new _n("JWT not in base64url format");
	return {
		header: JSON.parse(Cn(t[0])),
		payload: JSON.parse(Cn(t[1])),
		signature: Dn(t[2]),
		raw: {
			header: t[0],
			payload: t[1]
		}
	};
}
async function Vn(e) {
	return await new Promise((t) => {
		setTimeout(() => t(null), e);
	});
}
function Hn(e, t) {
	return new Promise((n, r) => {
		(async () => {
			for (let i = 0; i < Infinity; i++) try {
				let r = await e(i);
				if (!t(i, null, r)) {
					n(r);
					return;
				}
			} catch (e) {
				if (!t(i, e)) {
					r(e);
					return;
				}
			}
		})();
	});
}
function Un(e) {
	return ("0" + e.toString(16)).substr(-2);
}
function Wn() {
	let e = new Uint32Array(56);
	if (typeof crypto > "u") {
		let e = "";
		for (let t = 0; t < 56; t++) e += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~".charAt(Math.floor(Math.random() * 66));
		return e;
	}
	return crypto.getRandomValues(e), Array.from(e, Un).join("");
}
async function Gn(e) {
	let t = new TextEncoder().encode(e), n = await crypto.subtle.digest("SHA-256", t), r = new Uint8Array(n);
	return Array.from(r).map((e) => String.fromCharCode(e)).join("");
}
async function Kn(e) {
	if (!(typeof crypto < "u" && crypto.subtle !== void 0 && typeof TextEncoder < "u")) return console.warn("WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256."), e;
	let t = await Gn(e);
	return btoa(t).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
async function qn(e, t, n = !1) {
	let r = Wn(), i = r;
	n && (i += "/PASSWORD_RECOVERY"), await Ln(e, `${t}-code-verifier`, i);
	let a = await Kn(r);
	return [a, r === a ? "plain" : "s256"];
}
var Jn = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function Yn(e) {
	let t = e.headers.get(Zt);
	if (!t || !t.match(Jn)) return null;
	try {
		return /* @__PURE__ */ new Date(`${t}T00:00:00.0Z`);
	} catch {
		return null;
	}
}
function Xn(e) {
	if (!e) throw Error("Missing exp claim");
	if (e <= Math.floor(Date.now() / 1e3)) throw Error("JWT has expired");
}
function Zn(e) {
	switch (e) {
		case "RS256": return {
			name: "RSASSA-PKCS1-v1_5",
			hash: { name: "SHA-256" }
		};
		case "ES256": return {
			name: "ECDSA",
			namedCurve: "P-256",
			hash: { name: "SHA-256" }
		};
		default: throw Error("Invalid alg claim");
	}
}
var Qn = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
function $n(e) {
	if (!Qn.test(e)) throw Error("@supabase/auth-js: Expected parameter to be UUID but is not");
}
function er() {
	return new Proxy({}, {
		get: (e, t) => {
			if (t === "__isUserNotAvailableProxy") return !0;
			if (typeof t == "symbol") {
				let e = t.toString();
				if (e === "Symbol(Symbol.toPrimitive)" || e === "Symbol(Symbol.toStringTag)" || e === "Symbol(util.inspect.custom)") return;
			}
			throw Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Accessing the "${t}" property of the session object is not supported. Please use getUser() instead.`);
		},
		set: (e, t) => {
			throw Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Setting the "${t}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
		},
		deleteProperty: (e, t) => {
			throw Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Deleting the "${t}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
		}
	});
}
function tr(e, t) {
	return new Proxy(e, { get: (e, n, r) => {
		if (n === "__isInsecureUserWarningProxy") return !0;
		if (typeof n == "symbol") {
			let t = n.toString();
			if (t === "Symbol(Symbol.toPrimitive)" || t === "Symbol(Symbol.toStringTag)" || t === "Symbol(util.inspect.custom)" || t === "Symbol(nodejs.util.inspect.custom)") return Reflect.get(e, n, r);
		}
		return !t.value && typeof n == "string" && (console.warn("Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server."), t.value = !0), Reflect.get(e, n, r);
	} });
}
function nr(e) {
	return JSON.parse(JSON.stringify(e));
}
//#endregion
//#region ../../node_modules/.pnpm/@supabase+auth-js@2.89.0/node_modules/@supabase/auth-js/dist/module/lib/fetch.js
var rr = (e) => e.msg || e.message || e.error_description || e.error || JSON.stringify(e), ir = [
	502,
	503,
	504
];
async function ar(e) {
	if (!In(e)) throw new mn(rr(e), 0);
	if (ir.includes(e.status)) throw new mn(rr(e), e.status);
	let t;
	try {
		t = await e.json();
	} catch (e) {
		throw new rn(rr(e), e);
	}
	let n, r = Yn(e);
	if (r && r.getTime() >= Qt["2024-01-01"].timestamp && typeof t == "object" && t && typeof t.code == "string" ? n = t.code : typeof t == "object" && t && typeof t.error_code == "string" && (n = t.error_code), !n) {
		if (typeof t == "object" && t && typeof t.weak_password == "object" && t.weak_password && Array.isArray(t.weak_password.reasons) && t.weak_password.reasons.length && t.weak_password.reasons.reduce((e, t) => e && typeof t == "string", !0)) throw new gn(rr(t), e.status, t.weak_password.reasons);
	} else if (n === "weak_password") throw new gn(rr(t), e.status, t.weak_password?.reasons || []);
	else if (n === "session_not_found") throw new on();
	throw new tn(rr(t), e.status || 500, n);
}
var or = (e, t, n, r) => {
	let i = {
		method: e,
		headers: t?.headers || {}
	};
	return e === "GET" ? i : (i.headers = Object.assign({ "Content-Type": "application/json;charset=UTF-8" }, t?.headers), i.body = JSON.stringify(r), Object.assign(Object.assign({}, i), n));
};
async function D(e, t, n, r) {
	let i = Object.assign({}, r?.headers);
	i["X-Supabase-Api-Version"] || (i[Zt] = Qt["2024-01-01"].name), r?.jwt && (i.Authorization = `Bearer ${r.jwt}`);
	let a = r?.query ?? {};
	r?.redirectTo && (a.redirect_to = r.redirectTo);
	let o = await sr(e, t, n + (Object.keys(a).length ? "?" + new URLSearchParams(a).toString() : ""), {
		headers: i,
		noResolveJson: r?.noResolveJson
	}, {}, r?.body);
	return r?.xform ? r?.xform(o) : {
		data: Object.assign({}, o),
		error: null
	};
}
async function sr(e, t, n, r, i, a) {
	let o = or(t, r, i, a), s;
	try {
		s = await e(n, Object.assign({}, o));
	} catch (e) {
		throw console.error(e), new mn(rr(e), 0);
	}
	if (s.ok || await ar(s), r?.noResolveJson) return s;
	try {
		return await s.json();
	} catch (e) {
		await ar(e);
	}
}
function cr(e) {
	let t = null;
	mr(e) && (t = Object.assign({}, e), e.expires_at || (t.expires_at = An(e.expires_in)));
	let n = e.user ?? e;
	return {
		data: {
			session: t,
			user: n
		},
		error: null
	};
}
function lr(e) {
	let t = cr(e);
	return !t.error && e.weak_password && typeof e.weak_password == "object" && Array.isArray(e.weak_password.reasons) && e.weak_password.reasons.length && e.weak_password.message && typeof e.weak_password.message == "string" && e.weak_password.reasons.reduce((e, t) => e && typeof t == "string", !0) && (t.data.weak_password = e.weak_password), t;
}
function ur(e) {
	return {
		data: { user: e.user ?? e },
		error: null
	};
}
function dr(e) {
	return {
		data: e,
		error: null
	};
}
function fr(e) {
	let { action_link: t, email_otp: n, hashed_token: r, redirect_to: i, verification_type: a } = e, o = c(e, [
		"action_link",
		"email_otp",
		"hashed_token",
		"redirect_to",
		"verification_type"
	]);
	return {
		data: {
			properties: {
				action_link: t,
				email_otp: n,
				hashed_token: r,
				redirect_to: i,
				verification_type: a
			},
			user: Object.assign({}, o)
		},
		error: null
	};
}
function pr(e) {
	return e;
}
function mr(e) {
	return e.access_token && e.refresh_token && e.expires_in;
}
//#endregion
//#region ../../node_modules/.pnpm/@supabase+auth-js@2.89.0/node_modules/@supabase/auth-js/dist/module/lib/types.js
var hr = [
	"global",
	"local",
	"others"
], gr = class {
	constructor({ url: e = "", headers: t = {}, fetch: n }) {
		this.url = e, this.headers = t, this.fetch = Fn(n), this.mfa = {
			listFactors: this._listFactors.bind(this),
			deleteFactor: this._deleteFactor.bind(this)
		}, this.oauth = {
			listClients: this._listOAuthClients.bind(this),
			createClient: this._createOAuthClient.bind(this),
			getClient: this._getOAuthClient.bind(this),
			updateClient: this._updateOAuthClient.bind(this),
			deleteClient: this._deleteOAuthClient.bind(this),
			regenerateClientSecret: this._regenerateOAuthClientSecret.bind(this)
		};
	}
	async signOut(e, t = hr[0]) {
		if (hr.indexOf(t) < 0) throw Error(`@supabase/auth-js: Parameter scope must be one of ${hr.join(", ")}`);
		try {
			return await D(this.fetch, "POST", `${this.url}/logout?scope=${t}`, {
				headers: this.headers,
				jwt: e,
				noResolveJson: !0
			}), {
				data: null,
				error: null
			};
		} catch (e) {
			if (w(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async inviteUserByEmail(e, t = {}) {
		try {
			return await D(this.fetch, "POST", `${this.url}/invite`, {
				body: {
					email: e,
					data: t.data
				},
				headers: this.headers,
				redirectTo: t.redirectTo,
				xform: ur
			});
		} catch (e) {
			if (w(e)) return {
				data: { user: null },
				error: e
			};
			throw e;
		}
	}
	async generateLink(e) {
		try {
			let { options: t } = e, n = c(e, ["options"]), r = Object.assign(Object.assign({}, n), t);
			return "newEmail" in n && (r.new_email = n?.newEmail, delete r.newEmail), await D(this.fetch, "POST", `${this.url}/admin/generate_link`, {
				body: r,
				headers: this.headers,
				xform: fr,
				redirectTo: t?.redirectTo
			});
		} catch (e) {
			if (w(e)) return {
				data: {
					properties: null,
					user: null
				},
				error: e
			};
			throw e;
		}
	}
	async createUser(e) {
		try {
			return await D(this.fetch, "POST", `${this.url}/admin/users`, {
				body: e,
				headers: this.headers,
				xform: ur
			});
		} catch (e) {
			if (w(e)) return {
				data: { user: null },
				error: e
			};
			throw e;
		}
	}
	async listUsers(e) {
		try {
			let t = {
				nextPage: null,
				lastPage: 0,
				total: 0
			}, n = await D(this.fetch, "GET", `${this.url}/admin/users`, {
				headers: this.headers,
				noResolveJson: !0,
				query: {
					page: (e?.page)?.toString() ?? "",
					per_page: (e?.perPage)?.toString() ?? ""
				},
				xform: pr
			});
			if (n.error) throw n.error;
			let r = await n.json(), i = n.headers.get("x-total-count") ?? 0, a = n.headers.get("link")?.split(",") ?? [];
			return a.length > 0 && (a.forEach((e) => {
				let n = parseInt(e.split(";")[0].split("=")[1].substring(0, 1)), r = JSON.parse(e.split(";")[1].split("=")[1]);
				t[`${r}Page`] = n;
			}), t.total = parseInt(i)), {
				data: Object.assign(Object.assign({}, r), t),
				error: null
			};
		} catch (e) {
			if (w(e)) return {
				data: { users: [] },
				error: e
			};
			throw e;
		}
	}
	async getUserById(e) {
		$n(e);
		try {
			return await D(this.fetch, "GET", `${this.url}/admin/users/${e}`, {
				headers: this.headers,
				xform: ur
			});
		} catch (e) {
			if (w(e)) return {
				data: { user: null },
				error: e
			};
			throw e;
		}
	}
	async updateUserById(e, t) {
		$n(e);
		try {
			return await D(this.fetch, "PUT", `${this.url}/admin/users/${e}`, {
				body: t,
				headers: this.headers,
				xform: ur
			});
		} catch (e) {
			if (w(e)) return {
				data: { user: null },
				error: e
			};
			throw e;
		}
	}
	async deleteUser(e, t = !1) {
		$n(e);
		try {
			return await D(this.fetch, "DELETE", `${this.url}/admin/users/${e}`, {
				headers: this.headers,
				body: { should_soft_delete: t },
				xform: ur
			});
		} catch (e) {
			if (w(e)) return {
				data: { user: null },
				error: e
			};
			throw e;
		}
	}
	async _listFactors(e) {
		$n(e.userId);
		try {
			let { data: t, error: n } = await D(this.fetch, "GET", `${this.url}/admin/users/${e.userId}/factors`, {
				headers: this.headers,
				xform: (e) => ({
					data: { factors: e },
					error: null
				})
			});
			return {
				data: t,
				error: n
			};
		} catch (e) {
			if (w(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async _deleteFactor(e) {
		$n(e.userId), $n(e.id);
		try {
			return {
				data: await D(this.fetch, "DELETE", `${this.url}/admin/users/${e.userId}/factors/${e.id}`, { headers: this.headers }),
				error: null
			};
		} catch (e) {
			if (w(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async _listOAuthClients(e) {
		try {
			let t = {
				nextPage: null,
				lastPage: 0,
				total: 0
			}, n = await D(this.fetch, "GET", `${this.url}/admin/oauth/clients`, {
				headers: this.headers,
				noResolveJson: !0,
				query: {
					page: (e?.page)?.toString() ?? "",
					per_page: (e?.perPage)?.toString() ?? ""
				},
				xform: pr
			});
			if (n.error) throw n.error;
			let r = await n.json(), i = n.headers.get("x-total-count") ?? 0, a = n.headers.get("link")?.split(",") ?? [];
			return a.length > 0 && (a.forEach((e) => {
				let n = parseInt(e.split(";")[0].split("=")[1].substring(0, 1)), r = JSON.parse(e.split(";")[1].split("=")[1]);
				t[`${r}Page`] = n;
			}), t.total = parseInt(i)), {
				data: Object.assign(Object.assign({}, r), t),
				error: null
			};
		} catch (e) {
			if (w(e)) return {
				data: { clients: [] },
				error: e
			};
			throw e;
		}
	}
	async _createOAuthClient(e) {
		try {
			return await D(this.fetch, "POST", `${this.url}/admin/oauth/clients`, {
				body: e,
				headers: this.headers,
				xform: (e) => ({
					data: e,
					error: null
				})
			});
		} catch (e) {
			if (w(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async _getOAuthClient(e) {
		try {
			return await D(this.fetch, "GET", `${this.url}/admin/oauth/clients/${e}`, {
				headers: this.headers,
				xform: (e) => ({
					data: e,
					error: null
				})
			});
		} catch (e) {
			if (w(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async _updateOAuthClient(e, t) {
		try {
			return await D(this.fetch, "PUT", `${this.url}/admin/oauth/clients/${e}`, {
				body: t,
				headers: this.headers,
				xform: (e) => ({
					data: e,
					error: null
				})
			});
		} catch (e) {
			if (w(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async _deleteOAuthClient(e) {
		try {
			return await D(this.fetch, "DELETE", `${this.url}/admin/oauth/clients/${e}`, {
				headers: this.headers,
				noResolveJson: !0
			}), {
				data: null,
				error: null
			};
		} catch (e) {
			if (w(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
	async _regenerateOAuthClientSecret(e) {
		try {
			return await D(this.fetch, "POST", `${this.url}/admin/oauth/clients/${e}/regenerate_secret`, {
				headers: this.headers,
				xform: (e) => ({
					data: e,
					error: null
				})
			});
		} catch (e) {
			if (w(e)) return {
				data: null,
				error: e
			};
			throw e;
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/@supabase+auth-js@2.89.0/node_modules/@supabase/auth-js/dist/module/lib/local-storage.js
function _r(e = {}) {
	return {
		getItem: (t) => e[t] || null,
		setItem: (t, n) => {
			e[t] = n;
		},
		removeItem: (t) => {
			delete e[t];
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@supabase+auth-js@2.89.0/node_modules/@supabase/auth-js/dist/module/lib/locks.js
var vr = { debug: !!(globalThis && Nn() && globalThis.localStorage && globalThis.localStorage.getItem("supabase.gotrue-js.locks.debug") === "true") }, yr = class extends Error {
	constructor(e) {
		super(e), this.isAcquireTimeout = !0;
	}
}, br = class extends yr {};
async function xr(e, t, n) {
	vr.debug && console.log("@supabase/gotrue-js: navigatorLock: acquire lock", e, t);
	let r = new globalThis.AbortController();
	return t > 0 && setTimeout(() => {
		r.abort(), vr.debug && console.log("@supabase/gotrue-js: navigatorLock acquire timed out", e);
	}, t), await Promise.resolve().then(() => globalThis.navigator.locks.request(e, t === 0 ? {
		mode: "exclusive",
		ifAvailable: !0
	} : {
		mode: "exclusive",
		signal: r.signal
	}, async (r) => {
		if (r) {
			vr.debug && console.log("@supabase/gotrue-js: navigatorLock: acquired", e, r.name);
			try {
				return await n();
			} finally {
				vr.debug && console.log("@supabase/gotrue-js: navigatorLock: released", e, r.name);
			}
		} else if (t === 0) throw vr.debug && console.log("@supabase/gotrue-js: navigatorLock: not immediately available", e), new br(`Acquiring an exclusive Navigator LockManager lock "${e}" immediately failed`);
		else {
			if (vr.debug) try {
				let e = await globalThis.navigator.locks.query();
				console.log("@supabase/gotrue-js: Navigator LockManager state", JSON.stringify(e, null, "  "));
			} catch (e) {
				console.warn("@supabase/gotrue-js: Error when querying Navigator LockManager state", e);
			}
			return console.warn("@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request"), await n();
		}
	}));
}
//#endregion
//#region ../../node_modules/.pnpm/@supabase+auth-js@2.89.0/node_modules/@supabase/auth-js/dist/module/lib/polyfills.js
function Sr() {
	if (typeof globalThis != "object") try {
		Object.defineProperty(Object.prototype, "__magic__", {
			get: function() {
				return this;
			},
			configurable: !0
		}), __magic__.globalThis = __magic__, delete Object.prototype.__magic__;
	} catch {
		typeof self < "u" && (self.globalThis = self);
	}
}
//#endregion
//#region ../../node_modules/.pnpm/@supabase+auth-js@2.89.0/node_modules/@supabase/auth-js/dist/module/lib/web3/ethereum.js
function Cr(e) {
	if (!/^0x[a-fA-F0-9]{40}$/.test(e)) throw Error(`@supabase/auth-js: Address "${e}" is invalid.`);
	return e.toLowerCase();
}
function wr(e) {
	return parseInt(e, 16);
}
function Tr(e) {
	let t = new TextEncoder().encode(e);
	return "0x" + Array.from(t, (e) => e.toString(16).padStart(2, "0")).join("");
}
function Er(e) {
	let { chainId: t, domain: n, expirationTime: r, issuedAt: i = /* @__PURE__ */ new Date(), nonce: a, notBefore: o, requestId: s, resources: c, scheme: l, uri: u, version: d } = e;
	if (!Number.isInteger(t)) throw Error(`@supabase/auth-js: Invalid SIWE message field "chainId". Chain ID must be a EIP-155 chain ID. Provided value: ${t}`);
	if (!n) throw Error("@supabase/auth-js: Invalid SIWE message field \"domain\". Domain must be provided.");
	if (a && a.length < 8) throw Error(`@supabase/auth-js: Invalid SIWE message field "nonce". Nonce must be at least 8 characters. Provided value: ${a}`);
	if (!u) throw Error("@supabase/auth-js: Invalid SIWE message field \"uri\". URI must be provided.");
	if (d !== "1") throw Error(`@supabase/auth-js: Invalid SIWE message field "version". Version must be '1'. Provided value: ${d}`);
	if (e.statement?.includes("\n")) throw Error(`@supabase/auth-js: Invalid SIWE message field "statement". Statement must not include '\\n'. Provided value: ${e.statement}`);
	let f = Cr(e.address), p = `${l ? `${l}://${n}` : n} wants you to sign in with your Ethereum account:\n${f}\n\n${e.statement ? `${e.statement}\n` : ""}`, m = `URI: ${u}\nVersion: ${d}\nChain ID: ${t}${a ? `\nNonce: ${a}` : ""}\nIssued At: ${i.toISOString()}`;
	if (r && (m += `\nExpiration Time: ${r.toISOString()}`), o && (m += `\nNot Before: ${o.toISOString()}`), s && (m += `\nRequest ID: ${s}`), c) {
		let e = "\nResources:";
		for (let t of c) {
			if (!t || typeof t != "string") throw Error(`@supabase/auth-js: Invalid SIWE message field "resources". Every resource must be a valid string. Provided value: ${t}`);
			e += `\n- ${t}`;
		}
		m += e;
	}
	return `${p}\n${m}`;
}
//#endregion
//#region ../../node_modules/.pnpm/@supabase+auth-js@2.89.0/node_modules/@supabase/auth-js/dist/module/lib/webauthn.errors.js
var O = class extends Error {
	constructor({ message: e, code: t, cause: n, name: r }) {
		super(e, { cause: n }), this.__isWebAuthnError = !0, this.name = r ?? (n instanceof Error ? n.name : void 0) ?? "Unknown Error", this.code = t;
	}
}, Dr = class extends O {
	constructor(e, t) {
		super({
			code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
			cause: t,
			message: e
		}), this.name = "WebAuthnUnknownError", this.originalError = t;
	}
};
function Or({ error: e, options: t }) {
	let { publicKey: n } = t;
	if (!n) throw Error("options was missing required publicKey property");
	if (e.name === "AbortError") {
		if (t.signal instanceof AbortSignal) return new O({
			message: "Registration ceremony was sent an abort signal",
			code: "ERROR_CEREMONY_ABORTED",
			cause: e
		});
	} else if (e.name === "ConstraintError") {
		if (n.authenticatorSelection?.requireResidentKey === !0) return new O({
			message: "Discoverable credentials were required but no available authenticator supported it",
			code: "ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT",
			cause: e
		});
		if (t.mediation === "conditional" && n.authenticatorSelection?.userVerification === "required") return new O({
			message: "User verification was required during automatic registration but it could not be performed",
			code: "ERROR_AUTO_REGISTER_USER_VERIFICATION_FAILURE",
			cause: e
		});
		if (n.authenticatorSelection?.userVerification === "required") return new O({
			message: "User verification was required but no available authenticator supported it",
			code: "ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT",
			cause: e
		});
	} else if (e.name === "InvalidStateError") return new O({
		message: "The authenticator was previously registered",
		code: "ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED",
		cause: e
	});
	else if (e.name === "NotAllowedError") return new O({
		message: e.message,
		code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
		cause: e
	});
	else if (e.name === "NotSupportedError") return n.pubKeyCredParams.filter((e) => e.type === "public-key").length === 0 ? new O({
		message: "No entry in pubKeyCredParams was of type \"public-key\"",
		code: "ERROR_MALFORMED_PUBKEYCREDPARAMS",
		cause: e
	}) : new O({
		message: "No available authenticator supported any of the specified pubKeyCredParams algorithms",
		code: "ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG",
		cause: e
	});
	else if (e.name === "SecurityError") {
		let t = window.location.hostname;
		if (!Fr(t)) return new O({
			message: `${window.location.hostname} is an invalid domain`,
			code: "ERROR_INVALID_DOMAIN",
			cause: e
		});
		if (n.rp.id !== t) return new O({
			message: `The RP ID "${n.rp.id}" is invalid for this domain`,
			code: "ERROR_INVALID_RP_ID",
			cause: e
		});
	} else if (e.name === "TypeError") {
		if (n.user.id.byteLength < 1 || n.user.id.byteLength > 64) return new O({
			message: "User ID was not between 1 and 64 characters",
			code: "ERROR_INVALID_USER_ID_LENGTH",
			cause: e
		});
	} else if (e.name === "UnknownError") return new O({
		message: "The authenticator was unable to process the specified options, or could not create a new credential",
		code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
		cause: e
	});
	return new O({
		message: "a Non-Webauthn related error has occurred",
		code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
		cause: e
	});
}
function kr({ error: e, options: t }) {
	let { publicKey: n } = t;
	if (!n) throw Error("options was missing required publicKey property");
	if (e.name === "AbortError") {
		if (t.signal instanceof AbortSignal) return new O({
			message: "Authentication ceremony was sent an abort signal",
			code: "ERROR_CEREMONY_ABORTED",
			cause: e
		});
	} else if (e.name === "NotAllowedError") return new O({
		message: e.message,
		code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
		cause: e
	});
	else if (e.name === "SecurityError") {
		let t = window.location.hostname;
		if (!Fr(t)) return new O({
			message: `${window.location.hostname} is an invalid domain`,
			code: "ERROR_INVALID_DOMAIN",
			cause: e
		});
		if (n.rpId !== t) return new O({
			message: `The RP ID "${n.rpId}" is invalid for this domain`,
			code: "ERROR_INVALID_RP_ID",
			cause: e
		});
	} else if (e.name === "UnknownError") return new O({
		message: "The authenticator was unable to process the specified options, or could not create a new assertion signature",
		code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
		cause: e
	});
	return new O({
		message: "a Non-Webauthn related error has occurred",
		code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
		cause: e
	});
}
var Ar = new class {
	createNewAbortSignal() {
		if (this.controller) {
			let e = /* @__PURE__ */ Error("Cancelling existing WebAuthn API call for new one");
			e.name = "AbortError", this.controller.abort(e);
		}
		let e = new AbortController();
		return this.controller = e, e.signal;
	}
	cancelCeremony() {
		if (this.controller) {
			let e = /* @__PURE__ */ Error("Manually cancelling existing WebAuthn API call");
			e.name = "AbortError", this.controller.abort(e), this.controller = void 0;
		}
	}
}();
function jr(e) {
	if (!e) throw Error("Credential creation options are required");
	if (typeof PublicKeyCredential < "u" && "parseCreationOptionsFromJSON" in PublicKeyCredential && typeof PublicKeyCredential.parseCreationOptionsFromJSON == "function") return PublicKeyCredential.parseCreationOptionsFromJSON(e);
	let { challenge: t, user: n, excludeCredentials: r } = e, i = c(e, [
		"challenge",
		"user",
		"excludeCredentials"
	]), a = Dn(t).buffer, o = Object.assign(Object.assign({}, n), { id: Dn(n.id).buffer }), s = Object.assign(Object.assign({}, i), {
		challenge: a,
		user: o
	});
	if (r && r.length > 0) {
		s.excludeCredentials = Array(r.length);
		for (let e = 0; e < r.length; e++) {
			let t = r[e];
			s.excludeCredentials[e] = Object.assign(Object.assign({}, t), {
				id: Dn(t.id).buffer,
				type: t.type || "public-key",
				transports: t.transports
			});
		}
	}
	return s;
}
function Mr(e) {
	if (!e) throw Error("Credential request options are required");
	if (typeof PublicKeyCredential < "u" && "parseRequestOptionsFromJSON" in PublicKeyCredential && typeof PublicKeyCredential.parseRequestOptionsFromJSON == "function") return PublicKeyCredential.parseRequestOptionsFromJSON(e);
	let { challenge: t, allowCredentials: n } = e, r = c(e, ["challenge", "allowCredentials"]), i = Dn(t).buffer, a = Object.assign(Object.assign({}, r), { challenge: i });
	if (n && n.length > 0) {
		a.allowCredentials = Array(n.length);
		for (let e = 0; e < n.length; e++) {
			let t = n[e];
			a.allowCredentials[e] = Object.assign(Object.assign({}, t), {
				id: Dn(t.id).buffer,
				type: t.type || "public-key",
				transports: t.transports
			});
		}
	}
	return a;
}
function Nr(e) {
	if ("toJSON" in e && typeof e.toJSON == "function") return e.toJSON();
	let t = e;
	return {
		id: e.id,
		rawId: e.id,
		response: {
			attestationObject: kn(new Uint8Array(e.response.attestationObject)),
			clientDataJSON: kn(new Uint8Array(e.response.clientDataJSON))
		},
		type: "public-key",
		clientExtensionResults: e.getClientExtensionResults(),
		authenticatorAttachment: t.authenticatorAttachment ?? void 0
	};
}
function Pr(e) {
	if ("toJSON" in e && typeof e.toJSON == "function") return e.toJSON();
	let t = e, n = e.getClientExtensionResults(), r = e.response;
	return {
		id: e.id,
		rawId: e.id,
		response: {
			authenticatorData: kn(new Uint8Array(r.authenticatorData)),
			clientDataJSON: kn(new Uint8Array(r.clientDataJSON)),
			signature: kn(new Uint8Array(r.signature)),
			userHandle: r.userHandle ? kn(new Uint8Array(r.userHandle)) : void 0
		},
		type: "public-key",
		clientExtensionResults: n,
		authenticatorAttachment: t.authenticatorAttachment ?? void 0
	};
}
function Fr(e) {
	return e === "localhost" || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(e);
}
function Ir() {
	return !!(T() && "PublicKeyCredential" in window && window.PublicKeyCredential && "credentials" in navigator && typeof (navigator == null ? void 0 : navigator.credentials)?.create == "function" && typeof (navigator == null ? void 0 : navigator.credentials)?.get == "function");
}
async function Lr(e) {
	try {
		let t = await navigator.credentials.create(e);
		return t ? t instanceof PublicKeyCredential ? {
			data: t,
			error: null
		} : {
			data: null,
			error: new Dr("Browser returned unexpected credential type", t)
		} : {
			data: null,
			error: new Dr("Empty credential response", t)
		};
	} catch (t) {
		return {
			data: null,
			error: Or({
				error: t,
				options: e
			})
		};
	}
}
async function Rr(e) {
	try {
		let t = await navigator.credentials.get(e);
		return t ? t instanceof PublicKeyCredential ? {
			data: t,
			error: null
		} : {
			data: null,
			error: new Dr("Browser returned unexpected credential type", t)
		} : {
			data: null,
			error: new Dr("Empty credential response", t)
		};
	} catch (t) {
		return {
			data: null,
			error: kr({
				error: t,
				options: e
			})
		};
	}
}
var zr = {
	hints: ["security-key"],
	authenticatorSelection: {
		authenticatorAttachment: "cross-platform",
		requireResidentKey: !1,
		userVerification: "preferred",
		residentKey: "discouraged"
	},
	attestation: "direct"
}, Br = {
	userVerification: "preferred",
	hints: ["security-key"],
	attestation: "direct"
};
function Vr(...e) {
	let t = (e) => typeof e == "object" && !!e && !Array.isArray(e), n = (e) => e instanceof ArrayBuffer || ArrayBuffer.isView(e), r = {};
	for (let i of e) if (i) for (let e in i) {
		let a = i[e];
		if (a !== void 0) if (Array.isArray(a)) r[e] = a;
		else if (n(a)) r[e] = a;
		else if (t(a)) {
			let n = r[e];
			t(n) ? r[e] = Vr(n, a) : r[e] = Vr(a);
		} else r[e] = a;
	}
	return r;
}
function Hr(e, t) {
	return Vr(zr, e, t || {});
}
function Ur(e, t) {
	return Vr(Br, e, t || {});
}
var Wr = class {
	constructor(e) {
		this.client = e, this.enroll = this._enroll.bind(this), this.challenge = this._challenge.bind(this), this.verify = this._verify.bind(this), this.authenticate = this._authenticate.bind(this), this.register = this._register.bind(this);
	}
	async _enroll(e) {
		return this.client.mfa.enroll(Object.assign(Object.assign({}, e), { factorType: "webauthn" }));
	}
	async _challenge({ factorId: e, webauthn: t, friendlyName: n, signal: r }, i) {
		try {
			let { data: a, error: o } = await this.client.mfa.challenge({
				factorId: e,
				webauthn: t
			});
			if (!a) return {
				data: null,
				error: o
			};
			let s = r ?? Ar.createNewAbortSignal();
			if (a.webauthn.type === "create") {
				let { user: e } = a.webauthn.credential_options.publicKey;
				e.name ||= `${e.id}:${n}`, e.displayName ||= e.name;
			}
			switch (a.webauthn.type) {
				case "create": {
					let { data: t, error: n } = await Lr({
						publicKey: Hr(a.webauthn.credential_options.publicKey, i?.create),
						signal: s
					});
					return t ? {
						data: {
							factorId: e,
							challengeId: a.id,
							webauthn: {
								type: a.webauthn.type,
								credential_response: t
							}
						},
						error: null
					} : {
						data: null,
						error: n
					};
				}
				case "request": {
					let t = Ur(a.webauthn.credential_options.publicKey, i?.request), { data: n, error: r } = await Rr(Object.assign(Object.assign({}, a.webauthn.credential_options), {
						publicKey: t,
						signal: s
					}));
					return n ? {
						data: {
							factorId: e,
							challengeId: a.id,
							webauthn: {
								type: a.webauthn.type,
								credential_response: n
							}
						},
						error: null
					} : {
						data: null,
						error: r
					};
				}
			}
		} catch (e) {
			return w(e) ? {
				data: null,
				error: e
			} : {
				data: null,
				error: new rn("Unexpected error in challenge", e)
			};
		}
	}
	async _verify({ challengeId: e, factorId: t, webauthn: n }) {
		return this.client.mfa.verify({
			factorId: t,
			challengeId: e,
			webauthn: n
		});
	}
	async _authenticate({ factorId: e, webauthn: { rpId: t = typeof window < "u" ? window.location.hostname : void 0, rpOrigins: n = typeof window < "u" ? [window.location.origin] : void 0, signal: r } = {} }, i) {
		if (!t) return {
			data: null,
			error: new en("rpId is required for WebAuthn authentication")
		};
		try {
			if (!Ir()) return {
				data: null,
				error: new rn("Browser does not support WebAuthn", null)
			};
			let { data: a, error: o } = await this.challenge({
				factorId: e,
				webauthn: {
					rpId: t,
					rpOrigins: n
				},
				signal: r
			}, { request: i });
			if (!a) return {
				data: null,
				error: o
			};
			let { webauthn: s } = a;
			return this._verify({
				factorId: e,
				challengeId: a.challengeId,
				webauthn: {
					type: s.type,
					rpId: t,
					rpOrigins: n,
					credential_response: s.credential_response
				}
			});
		} catch (e) {
			return w(e) ? {
				data: null,
				error: e
			} : {
				data: null,
				error: new rn("Unexpected error in authenticate", e)
			};
		}
	}
	async _register({ friendlyName: e, webauthn: { rpId: t = typeof window < "u" ? window.location.hostname : void 0, rpOrigins: n = typeof window < "u" ? [window.location.origin] : void 0, signal: r } = {} }, i) {
		if (!t) return {
			data: null,
			error: new en("rpId is required for WebAuthn registration")
		};
		try {
			if (!Ir()) return {
				data: null,
				error: new rn("Browser does not support WebAuthn", null)
			};
			let { data: a, error: o } = await this._enroll({ friendlyName: e });
			if (!a) return await this.client.mfa.listFactors().then((t) => t.data?.all.find((t) => t.factor_type === "webauthn" && t.friendly_name === e && t.status !== "unverified")).then((e) => e ? this.client.mfa.unenroll({ factorId: e?.id }) : void 0), {
				data: null,
				error: o
			};
			let { data: s, error: c } = await this._challenge({
				factorId: a.id,
				friendlyName: a.friendly_name,
				webauthn: {
					rpId: t,
					rpOrigins: n
				},
				signal: r
			}, { create: i });
			return s ? this._verify({
				factorId: a.id,
				challengeId: s.challengeId,
				webauthn: {
					rpId: t,
					rpOrigins: n,
					type: s.webauthn.type,
					credential_response: s.webauthn.credential_response
				}
			}) : {
				data: null,
				error: c
			};
		} catch (e) {
			return w(e) ? {
				data: null,
				error: e
			} : {
				data: null,
				error: new rn("Unexpected error in register", e)
			};
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/@supabase+auth-js@2.89.0/node_modules/@supabase/auth-js/dist/module/GoTrueClient.js
Sr();
var Gr = {
	url: Jt,
	storageKey: Yt,
	autoRefreshToken: !0,
	persistSession: !0,
	detectSessionInUrl: !0,
	headers: Xt,
	flowType: "implicit",
	debug: !1,
	hasCustomAuthorizationHeader: !1,
	throwOnError: !1
};
async function Kr(e, t, n) {
	return await n();
}
var qr = {}, Jr = class e {
	get jwks() {
		return qr[this.storageKey]?.jwks ?? { keys: [] };
	}
	set jwks(e) {
		qr[this.storageKey] = Object.assign(Object.assign({}, qr[this.storageKey]), { jwks: e });
	}
	get jwks_cached_at() {
		return qr[this.storageKey]?.cachedAt ?? -(2 ** 53 - 1);
	}
	set jwks_cached_at(e) {
		qr[this.storageKey] = Object.assign(Object.assign({}, qr[this.storageKey]), { cachedAt: e });
	}
	constructor(t) {
		var n;
		this.userStorage = null, this.memoryStorage = null, this.stateChangeEmitters = /* @__PURE__ */ new Map(), this.autoRefreshTicker = null, this.visibilityChangedCallback = null, this.refreshingDeferred = null, this.initializePromise = null, this.detectSessionInUrl = !0, this.hasCustomAuthorizationHeader = !1, this.suppressGetSessionWarning = !1, this.lockAcquired = !1, this.pendingInLock = [], this.broadcastChannel = null, this.logger = console.log;
		let r = Object.assign(Object.assign({}, Gr), t);
		if (this.storageKey = r.storageKey, this.instanceID = e.nextInstanceID[this.storageKey] ?? 0, e.nextInstanceID[this.storageKey] = this.instanceID + 1, this.logDebugMessages = !!r.debug, typeof r.debug == "function" && (this.logger = r.debug), this.instanceID > 0 && T()) {
			let e = `${this._logPrefix()} Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.`;
			console.warn(e), this.logDebugMessages && console.trace(e);
		}
		if (this.persistSession = r.persistSession, this.autoRefreshToken = r.autoRefreshToken, this.admin = new gr({
			url: r.url,
			headers: r.headers,
			fetch: r.fetch
		}), this.url = r.url, this.headers = r.headers, this.fetch = Fn(r.fetch), this.lock = r.lock || Kr, this.detectSessionInUrl = r.detectSessionInUrl, this.flowType = r.flowType, this.hasCustomAuthorizationHeader = r.hasCustomAuthorizationHeader, this.throwOnError = r.throwOnError, r.lock ? this.lock = r.lock : this.persistSession && T() && (globalThis == null ? void 0 : globalThis.navigator)?.locks ? this.lock = xr : this.lock = Kr, this.jwks || (this.jwks = { keys: [] }, this.jwks_cached_at = -(2 ** 53 - 1)), this.mfa = {
			verify: this._verify.bind(this),
			enroll: this._enroll.bind(this),
			unenroll: this._unenroll.bind(this),
			challenge: this._challenge.bind(this),
			listFactors: this._listFactors.bind(this),
			challengeAndVerify: this._challengeAndVerify.bind(this),
			getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this),
			webauthn: new Wr(this)
		}, this.oauth = {
			getAuthorizationDetails: this._getAuthorizationDetails.bind(this),
			approveAuthorization: this._approveAuthorization.bind(this),
			denyAuthorization: this._denyAuthorization.bind(this),
			listGrants: this._listOAuthGrants.bind(this),
			revokeGrant: this._revokeOAuthGrant.bind(this)
		}, this.persistSession ? (r.storage ? this.storage = r.storage : Nn() ? this.storage = globalThis.localStorage : (this.memoryStorage = {}, this.storage = _r(this.memoryStorage)), r.userStorage && (this.userStorage = r.userStorage)) : (this.memoryStorage = {}, this.storage = _r(this.memoryStorage)), T() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
			try {
				this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
			} catch (e) {
				console.error("Failed to create a new BroadcastChannel, multi-tab state changes will not be available", e);
			}
			(n = this.broadcastChannel) == null || n.addEventListener("message", async (e) => {
				this._debug("received broadcast notification from other tab or client", e), await this._notifyAllSubscribers(e.data.event, e.data.session, !1);
			});
		}
		this.initialize();
	}
	isThrowOnErrorEnabled() {
		return this.throwOnError;
	}
	_returnResult(e) {
		if (this.throwOnError && e && e.error) throw e.error;
		return e;
	}
	_logPrefix() {
		return `GoTrueClient@${this.storageKey}:${this.instanceID} (${Gt}) ${(/* @__PURE__ */ new Date()).toISOString()}`;
	}
	_debug(...e) {
		return this.logDebugMessages && this.logger(this._logPrefix(), ...e), this;
	}
	async initialize() {
		return this.initializePromise ||= (async () => await this._acquireLock(-1, async () => await this._initialize()))(), await this.initializePromise;
	}
	async _initialize() {
		try {
			let e = {}, t = "none";
			if (T() && (e = Pn(window.location.href), this._isImplicitGrantCallback(e) ? t = "implicit" : await this._isPKCECallback(e) && (t = "pkce")), T() && this.detectSessionInUrl && t !== "none") {
				let { data: n, error: r } = await this._getSessionFromURL(e, t);
				if (r) {
					if (this._debug("#_initialize()", "error detecting session from URL", r), dn(r)) {
						let e = r.details?.code;
						if (e === "identity_already_exists" || e === "identity_not_found" || e === "single_identity_not_deletable") return { error: r };
					}
					return await this._removeSession(), { error: r };
				}
				let { session: i, redirectType: a } = n;
				return this._debug("#_initialize()", "detected session in URL", i, "redirect type", a), await this._saveSession(i), setTimeout(async () => {
					a === "recovery" ? await this._notifyAllSubscribers("PASSWORD_RECOVERY", i) : await this._notifyAllSubscribers("SIGNED_IN", i);
				}, 0), { error: null };
			}
			return await this._recoverAndRefresh(), { error: null };
		} catch (e) {
			return w(e) ? this._returnResult({ error: e }) : this._returnResult({ error: new rn("Unexpected error during initialization", e) });
		} finally {
			await this._handleVisibilityChange(), this._debug("#_initialize()", "end");
		}
	}
	async signInAnonymously(e) {
		try {
			let { data: t, error: n } = await D(this.fetch, "POST", `${this.url}/signup`, {
				headers: this.headers,
				body: {
					data: e?.options?.data ?? {},
					gotrue_meta_security: { captcha_token: e?.options?.captchaToken }
				},
				xform: cr
			});
			if (n || !t) return this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: n
			});
			let r = t.session, i = t.user;
			return t.session && (await this._saveSession(t.session), await this._notifyAllSubscribers("SIGNED_IN", r)), this._returnResult({
				data: {
					user: i,
					session: r
				},
				error: null
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: e
			});
			throw e;
		}
	}
	async signUp(e) {
		try {
			let t;
			if ("email" in e) {
				let { email: n, password: r, options: i } = e, a = null, o = null;
				this.flowType === "pkce" && ([a, o] = await qn(this.storage, this.storageKey)), t = await D(this.fetch, "POST", `${this.url}/signup`, {
					headers: this.headers,
					redirectTo: i?.emailRedirectTo,
					body: {
						email: n,
						password: r,
						data: i?.data ?? {},
						gotrue_meta_security: { captcha_token: i?.captchaToken },
						code_challenge: a,
						code_challenge_method: o
					},
					xform: cr
				});
			} else if ("phone" in e) {
				let { phone: n, password: r, options: i } = e;
				t = await D(this.fetch, "POST", `${this.url}/signup`, {
					headers: this.headers,
					body: {
						phone: n,
						password: r,
						data: i?.data ?? {},
						channel: i?.channel ?? "sms",
						gotrue_meta_security: { captcha_token: i?.captchaToken }
					},
					xform: cr
				});
			} else throw new ln("You must provide either an email or phone number and a password");
			let { data: n, error: r } = t;
			if (r || !n) return await E(this.storage, `${this.storageKey}-code-verifier`), this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: r
			});
			let i = n.session, a = n.user;
			return n.session && (await this._saveSession(n.session), await this._notifyAllSubscribers("SIGNED_IN", i)), this._returnResult({
				data: {
					user: a,
					session: i
				},
				error: null
			});
		} catch (e) {
			if (await E(this.storage, `${this.storageKey}-code-verifier`), w(e)) return this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: e
			});
			throw e;
		}
	}
	async signInWithPassword(e) {
		try {
			let t;
			if ("email" in e) {
				let { email: n, password: r, options: i } = e;
				t = await D(this.fetch, "POST", `${this.url}/token?grant_type=password`, {
					headers: this.headers,
					body: {
						email: n,
						password: r,
						gotrue_meta_security: { captcha_token: i?.captchaToken }
					},
					xform: lr
				});
			} else if ("phone" in e) {
				let { phone: n, password: r, options: i } = e;
				t = await D(this.fetch, "POST", `${this.url}/token?grant_type=password`, {
					headers: this.headers,
					body: {
						phone: n,
						password: r,
						gotrue_meta_security: { captcha_token: i?.captchaToken }
					},
					xform: lr
				});
			} else throw new ln("You must provide either an email or phone number and a password");
			let { data: n, error: r } = t;
			if (r) return this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: r
			});
			if (!n || !n.session || !n.user) {
				let e = new cn();
				return this._returnResult({
					data: {
						user: null,
						session: null
					},
					error: e
				});
			}
			return n.session && (await this._saveSession(n.session), await this._notifyAllSubscribers("SIGNED_IN", n.session)), this._returnResult({
				data: Object.assign({
					user: n.user,
					session: n.session
				}, n.weak_password ? { weakPassword: n.weak_password } : null),
				error: r
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: e
			});
			throw e;
		}
	}
	async signInWithOAuth(e) {
		return await this._handleProviderSignIn(e.provider, {
			redirectTo: e.options?.redirectTo,
			scopes: e.options?.scopes,
			queryParams: e.options?.queryParams,
			skipBrowserRedirect: e.options?.skipBrowserRedirect
		});
	}
	async exchangeCodeForSession(e) {
		return await this.initializePromise, this._acquireLock(-1, async () => this._exchangeCodeForSession(e));
	}
	async signInWithWeb3(e) {
		let { chain: t } = e;
		switch (t) {
			case "ethereum": return await this.signInWithEthereum(e);
			case "solana": return await this.signInWithSolana(e);
			default: throw Error(`@supabase/auth-js: Unsupported chain "${t}"`);
		}
	}
	async signInWithEthereum(e) {
		let t, n;
		if ("message" in e) t = e.message, n = e.signature;
		else {
			let { chain: r, wallet: i, statement: a, options: o } = e, s;
			if (!T()) {
				if (typeof i != "object" || !o?.url) throw Error("@supabase/auth-js: Both wallet and url must be specified in non-browser environments.");
				s = i;
			} else if (typeof i == "object") s = i;
			else {
				let e = window;
				if ("ethereum" in e && typeof e.ethereum == "object" && "request" in e.ethereum && typeof e.ethereum.request == "function") s = e.ethereum;
				else throw Error("@supabase/auth-js: No compatible Ethereum wallet interface on the window object (window.ethereum) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'ethereum', wallet: resolvedUserWallet }) instead.");
			}
			let c = new URL(o?.url ?? window.location.href), l = await s.request({ method: "eth_requestAccounts" }).then((e) => e).catch(() => {
				throw Error("@supabase/auth-js: Wallet method eth_requestAccounts is missing or invalid");
			});
			if (!l || l.length === 0) throw Error("@supabase/auth-js: No accounts available. Please ensure the wallet is connected.");
			let u = Cr(l[0]), d = o?.signInWithEthereum?.chainId;
			d ||= wr(await s.request({ method: "eth_chainId" })), t = Er({
				domain: c.host,
				address: u,
				statement: a,
				uri: c.href,
				version: "1",
				chainId: d,
				nonce: o?.signInWithEthereum?.nonce,
				issuedAt: o?.signInWithEthereum?.issuedAt ?? /* @__PURE__ */ new Date(),
				expirationTime: o?.signInWithEthereum?.expirationTime,
				notBefore: o?.signInWithEthereum?.notBefore,
				requestId: o?.signInWithEthereum?.requestId,
				resources: o?.signInWithEthereum?.resources
			}), n = await s.request({
				method: "personal_sign",
				params: [Tr(t), u]
			});
		}
		try {
			let { data: r, error: i } = await D(this.fetch, "POST", `${this.url}/token?grant_type=web3`, {
				headers: this.headers,
				body: Object.assign({
					chain: "ethereum",
					message: t,
					signature: n
				}, e.options?.captchaToken ? { gotrue_meta_security: { captcha_token: e.options?.captchaToken } } : null),
				xform: cr
			});
			if (i) throw i;
			if (!r || !r.session || !r.user) {
				let e = new cn();
				return this._returnResult({
					data: {
						user: null,
						session: null
					},
					error: e
				});
			}
			return r.session && (await this._saveSession(r.session), await this._notifyAllSubscribers("SIGNED_IN", r.session)), this._returnResult({
				data: Object.assign({}, r),
				error: i
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: e
			});
			throw e;
		}
	}
	async signInWithSolana(e) {
		let t, n;
		if ("message" in e) t = e.message, n = e.signature;
		else {
			let { chain: r, wallet: i, statement: a, options: o } = e, s;
			if (!T()) {
				if (typeof i != "object" || !o?.url) throw Error("@supabase/auth-js: Both wallet and url must be specified in non-browser environments.");
				s = i;
			} else if (typeof i == "object") s = i;
			else {
				let e = window;
				if ("solana" in e && typeof e.solana == "object" && ("signIn" in e.solana && typeof e.solana.signIn == "function" || "signMessage" in e.solana && typeof e.solana.signMessage == "function")) s = e.solana;
				else throw Error("@supabase/auth-js: No compatible Solana wallet interface on the window object (window.solana) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'solana', wallet: resolvedUserWallet }) instead.");
			}
			let c = new URL(o?.url ?? window.location.href);
			if ("signIn" in s && s.signIn) {
				let e = await s.signIn(Object.assign(Object.assign(Object.assign({ issuedAt: (/* @__PURE__ */ new Date()).toISOString() }, o?.signInWithSolana), {
					version: "1",
					domain: c.host,
					uri: c.href
				}), a ? { statement: a } : null)), r;
				if (Array.isArray(e) && e[0] && typeof e[0] == "object") r = e[0];
				else if (e && typeof e == "object" && "signedMessage" in e && "signature" in e) r = e;
				else throw Error("@supabase/auth-js: Wallet method signIn() returned unrecognized value");
				if ("signedMessage" in r && "signature" in r && (typeof r.signedMessage == "string" || r.signedMessage instanceof Uint8Array) && r.signature instanceof Uint8Array) t = typeof r.signedMessage == "string" ? r.signedMessage : new TextDecoder().decode(r.signedMessage), n = r.signature;
				else throw Error("@supabase/auth-js: Wallet method signIn() API returned object without signedMessage and signature fields");
			} else {
				if (!("signMessage" in s) || typeof s.signMessage != "function" || !("publicKey" in s) || typeof s != "object" || !s.publicKey || !("toBase58" in s.publicKey) || typeof s.publicKey.toBase58 != "function") throw Error("@supabase/auth-js: Wallet does not have a compatible signMessage() and publicKey.toBase58() API");
				t = [
					`${c.host} wants you to sign in with your Solana account:`,
					s.publicKey.toBase58(),
					...a ? [
						"",
						a,
						""
					] : [""],
					"Version: 1",
					`URI: ${c.href}`,
					`Issued At: ${o?.signInWithSolana?.issuedAt ?? (/* @__PURE__ */ new Date()).toISOString()}`,
					...o?.signInWithSolana?.notBefore ? [`Not Before: ${o.signInWithSolana.notBefore}`] : [],
					...o?.signInWithSolana?.expirationTime ? [`Expiration Time: ${o.signInWithSolana.expirationTime}`] : [],
					...o?.signInWithSolana?.chainId ? [`Chain ID: ${o.signInWithSolana.chainId}`] : [],
					...o?.signInWithSolana?.nonce ? [`Nonce: ${o.signInWithSolana.nonce}`] : [],
					...o?.signInWithSolana?.requestId ? [`Request ID: ${o.signInWithSolana.requestId}`] : [],
					...o?.signInWithSolana?.resources?.length ? ["Resources", ...o.signInWithSolana.resources.map((e) => `- ${e}`)] : []
				].join("\n");
				let e = await s.signMessage(new TextEncoder().encode(t), "utf8");
				if (!e || !(e instanceof Uint8Array)) throw Error("@supabase/auth-js: Wallet signMessage() API returned an recognized value");
				n = e;
			}
		}
		try {
			let { data: r, error: i } = await D(this.fetch, "POST", `${this.url}/token?grant_type=web3`, {
				headers: this.headers,
				body: Object.assign({
					chain: "solana",
					message: t,
					signature: kn(n)
				}, e.options?.captchaToken ? { gotrue_meta_security: { captcha_token: e.options?.captchaToken } } : null),
				xform: cr
			});
			if (i) throw i;
			if (!r || !r.session || !r.user) {
				let e = new cn();
				return this._returnResult({
					data: {
						user: null,
						session: null
					},
					error: e
				});
			}
			return r.session && (await this._saveSession(r.session), await this._notifyAllSubscribers("SIGNED_IN", r.session)), this._returnResult({
				data: Object.assign({}, r),
				error: i
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: e
			});
			throw e;
		}
	}
	async _exchangeCodeForSession(e) {
		let [t, n] = (await Rn(this.storage, `${this.storageKey}-code-verifier`) ?? "").split("/");
		try {
			if (!t && this.flowType === "pkce") throw new pn();
			let { data: r, error: i } = await D(this.fetch, "POST", `${this.url}/token?grant_type=pkce`, {
				headers: this.headers,
				body: {
					auth_code: e,
					code_verifier: t
				},
				xform: cr
			});
			if (await E(this.storage, `${this.storageKey}-code-verifier`), i) throw i;
			if (!r || !r.session || !r.user) {
				let e = new cn();
				return this._returnResult({
					data: {
						user: null,
						session: null,
						redirectType: null
					},
					error: e
				});
			}
			return r.session && (await this._saveSession(r.session), await this._notifyAllSubscribers("SIGNED_IN", r.session)), this._returnResult({
				data: Object.assign(Object.assign({}, r), { redirectType: n ?? null }),
				error: i
			});
		} catch (e) {
			if (await E(this.storage, `${this.storageKey}-code-verifier`), w(e)) return this._returnResult({
				data: {
					user: null,
					session: null,
					redirectType: null
				},
				error: e
			});
			throw e;
		}
	}
	async signInWithIdToken(e) {
		try {
			let { options: t, provider: n, token: r, access_token: i, nonce: a } = e, { data: o, error: s } = await D(this.fetch, "POST", `${this.url}/token?grant_type=id_token`, {
				headers: this.headers,
				body: {
					provider: n,
					id_token: r,
					access_token: i,
					nonce: a,
					gotrue_meta_security: { captcha_token: t?.captchaToken }
				},
				xform: cr
			});
			if (s) return this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: s
			});
			if (!o || !o.session || !o.user) {
				let e = new cn();
				return this._returnResult({
					data: {
						user: null,
						session: null
					},
					error: e
				});
			}
			return o.session && (await this._saveSession(o.session), await this._notifyAllSubscribers("SIGNED_IN", o.session)), this._returnResult({
				data: o,
				error: s
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: e
			});
			throw e;
		}
	}
	async signInWithOtp(e) {
		try {
			if ("email" in e) {
				let { email: t, options: n } = e, r = null, i = null;
				this.flowType === "pkce" && ([r, i] = await qn(this.storage, this.storageKey));
				let { error: a } = await D(this.fetch, "POST", `${this.url}/otp`, {
					headers: this.headers,
					body: {
						email: t,
						data: n?.data ?? {},
						create_user: n?.shouldCreateUser ?? !0,
						gotrue_meta_security: { captcha_token: n?.captchaToken },
						code_challenge: r,
						code_challenge_method: i
					},
					redirectTo: n?.emailRedirectTo
				});
				return this._returnResult({
					data: {
						user: null,
						session: null
					},
					error: a
				});
			}
			if ("phone" in e) {
				let { phone: t, options: n } = e, { data: r, error: i } = await D(this.fetch, "POST", `${this.url}/otp`, {
					headers: this.headers,
					body: {
						phone: t,
						data: n?.data ?? {},
						create_user: n?.shouldCreateUser ?? !0,
						gotrue_meta_security: { captcha_token: n?.captchaToken },
						channel: n?.channel ?? "sms"
					}
				});
				return this._returnResult({
					data: {
						user: null,
						session: null,
						messageId: r?.message_id
					},
					error: i
				});
			}
			throw new ln("You must provide either an email or phone number.");
		} catch (e) {
			if (await E(this.storage, `${this.storageKey}-code-verifier`), w(e)) return this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: e
			});
			throw e;
		}
	}
	async verifyOtp(e) {
		try {
			let t, n;
			"options" in e && (t = e.options?.redirectTo, n = e.options?.captchaToken);
			let { data: r, error: i } = await D(this.fetch, "POST", `${this.url}/verify`, {
				headers: this.headers,
				body: Object.assign(Object.assign({}, e), { gotrue_meta_security: { captcha_token: n } }),
				redirectTo: t,
				xform: cr
			});
			if (i) throw i;
			if (!r) throw /* @__PURE__ */ Error("An error occurred on token verification.");
			let a = r.session, o = r.user;
			return a?.access_token && (await this._saveSession(a), await this._notifyAllSubscribers(e.type == "recovery" ? "PASSWORD_RECOVERY" : "SIGNED_IN", a)), this._returnResult({
				data: {
					user: o,
					session: a
				},
				error: null
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: e
			});
			throw e;
		}
	}
	async signInWithSSO(e) {
		try {
			let t = null, n = null;
			this.flowType === "pkce" && ([t, n] = await qn(this.storage, this.storageKey));
			let r = await D(this.fetch, "POST", `${this.url}/sso`, {
				body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, "providerId" in e ? { provider_id: e.providerId } : null), "domain" in e ? { domain: e.domain } : null), { redirect_to: e.options?.redirectTo ?? void 0 }), e?.options?.captchaToken ? { gotrue_meta_security: { captcha_token: e.options.captchaToken } } : null), {
					skip_http_redirect: !0,
					code_challenge: t,
					code_challenge_method: n
				}),
				headers: this.headers,
				xform: dr
			});
			return r.data?.url && T() && !e.options?.skipBrowserRedirect && window.location.assign(r.data.url), this._returnResult(r);
		} catch (e) {
			if (await E(this.storage, `${this.storageKey}-code-verifier`), w(e)) return this._returnResult({
				data: null,
				error: e
			});
			throw e;
		}
	}
	async reauthenticate() {
		return await this.initializePromise, await this._acquireLock(-1, async () => await this._reauthenticate());
	}
	async _reauthenticate() {
		try {
			return await this._useSession(async (e) => {
				let { data: { session: t }, error: n } = e;
				if (n) throw n;
				if (!t) throw new on();
				let { error: r } = await D(this.fetch, "GET", `${this.url}/reauthenticate`, {
					headers: this.headers,
					jwt: t.access_token
				});
				return this._returnResult({
					data: {
						user: null,
						session: null
					},
					error: r
				});
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: e
			});
			throw e;
		}
	}
	async resend(e) {
		try {
			let t = `${this.url}/resend`;
			if ("email" in e) {
				let { email: n, type: r, options: i } = e, { error: a } = await D(this.fetch, "POST", t, {
					headers: this.headers,
					body: {
						email: n,
						type: r,
						gotrue_meta_security: { captcha_token: i?.captchaToken }
					},
					redirectTo: i?.emailRedirectTo
				});
				return this._returnResult({
					data: {
						user: null,
						session: null
					},
					error: a
				});
			} else if ("phone" in e) {
				let { phone: n, type: r, options: i } = e, { data: a, error: o } = await D(this.fetch, "POST", t, {
					headers: this.headers,
					body: {
						phone: n,
						type: r,
						gotrue_meta_security: { captcha_token: i?.captchaToken }
					}
				});
				return this._returnResult({
					data: {
						user: null,
						session: null,
						messageId: a?.message_id
					},
					error: o
				});
			}
			throw new ln("You must provide either an email or phone number and a type");
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: e
			});
			throw e;
		}
	}
	async getSession() {
		return await this.initializePromise, await this._acquireLock(-1, async () => this._useSession(async (e) => e));
	}
	async _acquireLock(e, t) {
		this._debug("#_acquireLock", "begin", e);
		try {
			if (this.lockAcquired) {
				let e = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve(), n = (async () => (await e, await t()))();
				return this.pendingInLock.push((async () => {
					try {
						await n;
					} catch {}
				})()), n;
			}
			return await this.lock(`lock:${this.storageKey}`, e, async () => {
				this._debug("#_acquireLock", "lock acquired for storage key", this.storageKey);
				try {
					this.lockAcquired = !0;
					let e = t();
					for (this.pendingInLock.push((async () => {
						try {
							await e;
						} catch {}
					})()), await e; this.pendingInLock.length;) {
						let e = [...this.pendingInLock];
						await Promise.all(e), this.pendingInLock.splice(0, e.length);
					}
					return await e;
				} finally {
					this._debug("#_acquireLock", "lock released for storage key", this.storageKey), this.lockAcquired = !1;
				}
			});
		} finally {
			this._debug("#_acquireLock", "end");
		}
	}
	async _useSession(e) {
		this._debug("#_useSession", "begin");
		try {
			return await e(await this.__loadSession());
		} finally {
			this._debug("#_useSession", "end");
		}
	}
	async __loadSession() {
		this._debug("#__loadSession()", "begin"), this.lockAcquired || this._debug("#__loadSession()", "used outside of an acquired lock!", (/* @__PURE__ */ Error()).stack);
		try {
			let e = null, t = await Rn(this.storage, this.storageKey);
			if (this._debug("#getSession()", "session from storage", t), t !== null && (this._isValidSession(t) ? e = t : (this._debug("#getSession()", "session from storage is not valid"), await this._removeSession())), !e) return {
				data: { session: null },
				error: null
			};
			let n = e.expires_at ? e.expires_at * 1e3 - Date.now() < qt : !1;
			if (this._debug("#__loadSession()", `session has${n ? "" : " not"} expired`, "expires_at", e.expires_at), !n) {
				if (this.userStorage) {
					let t = await Rn(this.userStorage, this.storageKey + "-user");
					t?.user ? e.user = t.user : e.user = er();
				}
				if (this.storage.isServer && e.user && !e.user.__isUserNotAvailableProxy) {
					let t = { value: this.suppressGetSessionWarning };
					e.user = tr(e.user, t), t.value && (this.suppressGetSessionWarning = !0);
				}
				return {
					data: { session: e },
					error: null
				};
			}
			let { data: r, error: i } = await this._callRefreshToken(e.refresh_token);
			return i ? this._returnResult({
				data: { session: null },
				error: i
			}) : this._returnResult({
				data: { session: r },
				error: null
			});
		} finally {
			this._debug("#__loadSession()", "end");
		}
	}
	async getUser(e) {
		if (e) return await this._getUser(e);
		await this.initializePromise;
		let t = await this._acquireLock(-1, async () => await this._getUser());
		return t.data.user && (this.suppressGetSessionWarning = !0), t;
	}
	async _getUser(e) {
		try {
			return e ? await D(this.fetch, "GET", `${this.url}/user`, {
				headers: this.headers,
				jwt: e,
				xform: ur
			}) : await this._useSession(async (e) => {
				let { data: t, error: n } = e;
				if (n) throw n;
				return !t.session?.access_token && !this.hasCustomAuthorizationHeader ? {
					data: { user: null },
					error: new on()
				} : await D(this.fetch, "GET", `${this.url}/user`, {
					headers: this.headers,
					jwt: t.session?.access_token ?? void 0,
					xform: ur
				});
			});
		} catch (e) {
			if (w(e)) return sn(e) && (await this._removeSession(), await E(this.storage, `${this.storageKey}-code-verifier`)), this._returnResult({
				data: { user: null },
				error: e
			});
			throw e;
		}
	}
	async updateUser(e, t = {}) {
		return await this.initializePromise, await this._acquireLock(-1, async () => await this._updateUser(e, t));
	}
	async _updateUser(e, t = {}) {
		try {
			return await this._useSession(async (n) => {
				let { data: r, error: i } = n;
				if (i) throw i;
				if (!r.session) throw new on();
				let a = r.session, o = null, s = null;
				this.flowType === "pkce" && e.email != null && ([o, s] = await qn(this.storage, this.storageKey));
				let { data: c, error: l } = await D(this.fetch, "PUT", `${this.url}/user`, {
					headers: this.headers,
					redirectTo: t?.emailRedirectTo,
					body: Object.assign(Object.assign({}, e), {
						code_challenge: o,
						code_challenge_method: s
					}),
					jwt: a.access_token,
					xform: ur
				});
				if (l) throw l;
				return a.user = c.user, await this._saveSession(a), await this._notifyAllSubscribers("USER_UPDATED", a), this._returnResult({
					data: { user: a.user },
					error: null
				});
			});
		} catch (e) {
			if (await E(this.storage, `${this.storageKey}-code-verifier`), w(e)) return this._returnResult({
				data: { user: null },
				error: e
			});
			throw e;
		}
	}
	async setSession(e) {
		return await this.initializePromise, await this._acquireLock(-1, async () => await this._setSession(e));
	}
	async _setSession(e) {
		try {
			if (!e.access_token || !e.refresh_token) throw new on();
			let t = Date.now() / 1e3, n = t, r = !0, i = null, { payload: a } = Bn(e.access_token);
			if (a.exp && (n = a.exp, r = n <= t), r) {
				let { data: t, error: n } = await this._callRefreshToken(e.refresh_token);
				if (n) return this._returnResult({
					data: {
						user: null,
						session: null
					},
					error: n
				});
				if (!t) return {
					data: {
						user: null,
						session: null
					},
					error: null
				};
				i = t;
			} else {
				let { data: r, error: a } = await this._getUser(e.access_token);
				if (a) throw a;
				i = {
					access_token: e.access_token,
					refresh_token: e.refresh_token,
					user: r.user,
					token_type: "bearer",
					expires_in: n - t,
					expires_at: n
				}, await this._saveSession(i), await this._notifyAllSubscribers("SIGNED_IN", i);
			}
			return this._returnResult({
				data: {
					user: i.user,
					session: i
				},
				error: null
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: {
					session: null,
					user: null
				},
				error: e
			});
			throw e;
		}
	}
	async refreshSession(e) {
		return await this.initializePromise, await this._acquireLock(-1, async () => await this._refreshSession(e));
	}
	async _refreshSession(e) {
		try {
			return await this._useSession(async (t) => {
				if (!e) {
					let { data: n, error: r } = t;
					if (r) throw r;
					e = n.session ?? void 0;
				}
				if (!e?.refresh_token) throw new on();
				let { data: n, error: r } = await this._callRefreshToken(e.refresh_token);
				return r ? this._returnResult({
					data: {
						user: null,
						session: null
					},
					error: r
				}) : n ? this._returnResult({
					data: {
						user: n.user,
						session: n
					},
					error: null
				}) : this._returnResult({
					data: {
						user: null,
						session: null
					},
					error: null
				});
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: {
					user: null,
					session: null
				},
				error: e
			});
			throw e;
		}
	}
	async _getSessionFromURL(e, t) {
		try {
			if (!T()) throw new un("No browser detected.");
			if (e.error || e.error_description || e.error_code) throw new un(e.error_description || "Error in URL with unspecified error_description", {
				error: e.error || "unspecified_error",
				code: e.error_code || "unspecified_code"
			});
			switch (t) {
				case "implicit":
					if (this.flowType === "pkce") throw new fn("Not a valid PKCE flow url.");
					break;
				case "pkce":
					if (this.flowType === "implicit") throw new un("Not a valid implicit grant flow url.");
					break;
				default:
			}
			if (t === "pkce") {
				if (this._debug("#_initialize()", "begin", "is PKCE flow", !0), !e.code) throw new fn("No code detected.");
				let { data: t, error: n } = await this._exchangeCodeForSession(e.code);
				if (n) throw n;
				let r = new URL(window.location.href);
				return r.searchParams.delete("code"), window.history.replaceState(window.history.state, "", r.toString()), {
					data: {
						session: t.session,
						redirectType: null
					},
					error: null
				};
			}
			let { provider_token: n, provider_refresh_token: r, access_token: i, refresh_token: a, expires_in: o, expires_at: s, token_type: c } = e;
			if (!i || !o || !a || !c) throw new un("No session defined in URL");
			let l = Math.round(Date.now() / 1e3), u = parseInt(o), d = l + u;
			s && (d = parseInt(s));
			let f = d - l;
			f * 1e3 <= 3e4 && console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${f}s, should have been closer to ${u}s`);
			let p = d - u;
			l - p >= 120 ? console.warn("@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale", p, d, l) : l - p < 0 && console.warn("@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew", p, d, l);
			let { data: m, error: h } = await this._getUser(i);
			if (h) throw h;
			let g = {
				provider_token: n,
				provider_refresh_token: r,
				access_token: i,
				expires_in: u,
				expires_at: d,
				refresh_token: a,
				token_type: c,
				user: m.user
			};
			return window.location.hash = "", this._debug("#_getSessionFromURL()", "clearing window.location.hash"), this._returnResult({
				data: {
					session: g,
					redirectType: e.type
				},
				error: null
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: {
					session: null,
					redirectType: null
				},
				error: e
			});
			throw e;
		}
	}
	_isImplicitGrantCallback(e) {
		return typeof this.detectSessionInUrl == "function" ? this.detectSessionInUrl(new URL(window.location.href), e) : !!(e.access_token || e.error_description);
	}
	async _isPKCECallback(e) {
		let t = await Rn(this.storage, `${this.storageKey}-code-verifier`);
		return !!(e.code && t);
	}
	async signOut(e = { scope: "global" }) {
		return await this.initializePromise, await this._acquireLock(-1, async () => await this._signOut(e));
	}
	async _signOut({ scope: e } = { scope: "global" }) {
		return await this._useSession(async (t) => {
			let { data: n, error: r } = t;
			if (r) return this._returnResult({ error: r });
			let i = n.session?.access_token;
			if (i) {
				let { error: t } = await this.admin.signOut(i, e);
				if (t && !(nn(t) && (t.status === 404 || t.status === 401 || t.status === 403))) return this._returnResult({ error: t });
			}
			return e !== "others" && (await this._removeSession(), await E(this.storage, `${this.storageKey}-code-verifier`)), this._returnResult({ error: null });
		});
	}
	onAuthStateChange(e) {
		let t = jn(), n = {
			id: t,
			callback: e,
			unsubscribe: () => {
				this._debug("#unsubscribe()", "state change callback with id removed", t), this.stateChangeEmitters.delete(t);
			}
		};
		return this._debug("#onAuthStateChange()", "registered callback with id", t), this.stateChangeEmitters.set(t, n), (async () => {
			await this.initializePromise, await this._acquireLock(-1, async () => {
				this._emitInitialSession(t);
			});
		})(), { data: { subscription: n } };
	}
	async _emitInitialSession(e) {
		return await this._useSession(async (t) => {
			try {
				let { data: { session: n }, error: r } = t;
				if (r) throw r;
				await this.stateChangeEmitters.get(e)?.callback("INITIAL_SESSION", n), this._debug("INITIAL_SESSION", "callback id", e, "session", n);
			} catch (t) {
				await this.stateChangeEmitters.get(e)?.callback("INITIAL_SESSION", null), this._debug("INITIAL_SESSION", "callback id", e, "error", t), console.error(t);
			}
		});
	}
	async resetPasswordForEmail(e, t = {}) {
		let n = null, r = null;
		this.flowType === "pkce" && ([n, r] = await qn(this.storage, this.storageKey, !0));
		try {
			return await D(this.fetch, "POST", `${this.url}/recover`, {
				body: {
					email: e,
					code_challenge: n,
					code_challenge_method: r,
					gotrue_meta_security: { captcha_token: t.captchaToken }
				},
				headers: this.headers,
				redirectTo: t.redirectTo
			});
		} catch (e) {
			if (await E(this.storage, `${this.storageKey}-code-verifier`), w(e)) return this._returnResult({
				data: null,
				error: e
			});
			throw e;
		}
	}
	async getUserIdentities() {
		try {
			let { data: e, error: t } = await this.getUser();
			if (t) throw t;
			return this._returnResult({
				data: { identities: e.user.identities ?? [] },
				error: null
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: null,
				error: e
			});
			throw e;
		}
	}
	async linkIdentity(e) {
		return "token" in e ? this.linkIdentityIdToken(e) : this.linkIdentityOAuth(e);
	}
	async linkIdentityOAuth(e) {
		try {
			let { data: t, error: n } = await this._useSession(async (t) => {
				let { data: n, error: r } = t;
				if (r) throw r;
				let i = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, e.provider, {
					redirectTo: e.options?.redirectTo,
					scopes: e.options?.scopes,
					queryParams: e.options?.queryParams,
					skipBrowserRedirect: !0
				});
				return await D(this.fetch, "GET", i, {
					headers: this.headers,
					jwt: n.session?.access_token ?? void 0
				});
			});
			if (n) throw n;
			return T() && !e.options?.skipBrowserRedirect && window.location.assign(t?.url), this._returnResult({
				data: {
					provider: e.provider,
					url: t?.url
				},
				error: null
			});
		} catch (t) {
			if (w(t)) return this._returnResult({
				data: {
					provider: e.provider,
					url: null
				},
				error: t
			});
			throw t;
		}
	}
	async linkIdentityIdToken(e) {
		return await this._useSession(async (t) => {
			try {
				let { error: n, data: { session: r } } = t;
				if (n) throw n;
				let { options: i, provider: a, token: o, access_token: s, nonce: c } = e, { data: l, error: u } = await D(this.fetch, "POST", `${this.url}/token?grant_type=id_token`, {
					headers: this.headers,
					jwt: r?.access_token ?? void 0,
					body: {
						provider: a,
						id_token: o,
						access_token: s,
						nonce: c,
						link_identity: !0,
						gotrue_meta_security: { captcha_token: i?.captchaToken }
					},
					xform: cr
				});
				return u ? this._returnResult({
					data: {
						user: null,
						session: null
					},
					error: u
				}) : !l || !l.session || !l.user ? this._returnResult({
					data: {
						user: null,
						session: null
					},
					error: new cn()
				}) : (l.session && (await this._saveSession(l.session), await this._notifyAllSubscribers("USER_UPDATED", l.session)), this._returnResult({
					data: l,
					error: u
				}));
			} catch (e) {
				if (await E(this.storage, `${this.storageKey}-code-verifier`), w(e)) return this._returnResult({
					data: {
						user: null,
						session: null
					},
					error: e
				});
				throw e;
			}
		});
	}
	async unlinkIdentity(e) {
		try {
			return await this._useSession(async (t) => {
				let { data: n, error: r } = t;
				if (r) throw r;
				return await D(this.fetch, "DELETE", `${this.url}/user/identities/${e.identity_id}`, {
					headers: this.headers,
					jwt: n.session?.access_token ?? void 0
				});
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: null,
				error: e
			});
			throw e;
		}
	}
	async _refreshAccessToken(e) {
		let t = `#_refreshAccessToken(${e.substring(0, 5)}...)`;
		this._debug(t, "begin");
		try {
			let n = Date.now();
			return await Hn(async (n) => (n > 0 && await Vn(200 * 2 ** (n - 1)), this._debug(t, "refreshing attempt", n), await D(this.fetch, "POST", `${this.url}/token?grant_type=refresh_token`, {
				body: { refresh_token: e },
				headers: this.headers,
				xform: cr
			})), (e, t) => {
				let r = 200 * 2 ** e;
				return t && hn(t) && Date.now() + r - n < 3e4;
			});
		} catch (e) {
			if (this._debug(t, "error", e), w(e)) return this._returnResult({
				data: {
					session: null,
					user: null
				},
				error: e
			});
			throw e;
		} finally {
			this._debug(t, "end");
		}
	}
	_isValidSession(e) {
		return typeof e == "object" && !!e && "access_token" in e && "refresh_token" in e && "expires_at" in e;
	}
	async _handleProviderSignIn(e, t) {
		let n = await this._getUrlForProvider(`${this.url}/authorize`, e, {
			redirectTo: t.redirectTo,
			scopes: t.scopes,
			queryParams: t.queryParams
		});
		return this._debug("#_handleProviderSignIn()", "provider", e, "options", t, "url", n), T() && !t.skipBrowserRedirect && window.location.assign(n), {
			data: {
				provider: e,
				url: n
			},
			error: null
		};
	}
	async _recoverAndRefresh() {
		let e = "#_recoverAndRefresh()";
		this._debug(e, "begin");
		try {
			let t = await Rn(this.storage, this.storageKey);
			if (t && this.userStorage) {
				let e = await Rn(this.userStorage, this.storageKey + "-user");
				!this.storage.isServer && Object.is(this.storage, this.userStorage) && !e && (e = { user: t.user }, await Ln(this.userStorage, this.storageKey + "-user", e)), t.user = e?.user ?? er();
			} else if (t && !t.user && !t.user) {
				let e = await Rn(this.storage, this.storageKey + "-user");
				e && e?.user ? (t.user = e.user, await E(this.storage, this.storageKey + "-user"), await Ln(this.storage, this.storageKey, t)) : t.user = er();
			}
			if (this._debug(e, "session from storage", t), !this._isValidSession(t)) {
				this._debug(e, "session is not valid"), t !== null && await this._removeSession();
				return;
			}
			let n = (t.expires_at ?? Infinity) * 1e3 - Date.now() < qt;
			if (this._debug(e, `session has${n ? "" : " not"} expired with margin of ${qt}s`), n) {
				if (this.autoRefreshToken && t.refresh_token) {
					let { error: n } = await this._callRefreshToken(t.refresh_token);
					n && (console.error(n), hn(n) || (this._debug(e, "refresh failed with a non-retryable error, removing the session", n), await this._removeSession()));
				}
			} else if (t.user && t.user.__isUserNotAvailableProxy === !0) try {
				let { data: n, error: r } = await this._getUser(t.access_token);
				!r && n?.user ? (t.user = n.user, await this._saveSession(t), await this._notifyAllSubscribers("SIGNED_IN", t)) : this._debug(e, "could not get user data, skipping SIGNED_IN notification");
			} catch (t) {
				console.error("Error getting user data:", t), this._debug(e, "error getting user data, skipping SIGNED_IN notification", t);
			}
			else await this._notifyAllSubscribers("SIGNED_IN", t);
		} catch (t) {
			this._debug(e, "error", t), console.error(t);
			return;
		} finally {
			this._debug(e, "end");
		}
	}
	async _callRefreshToken(e) {
		var t, n;
		if (!e) throw new on();
		if (this.refreshingDeferred) return this.refreshingDeferred.promise;
		let r = `#_callRefreshToken(${e.substring(0, 5)}...)`;
		this._debug(r, "begin");
		try {
			this.refreshingDeferred = new zn();
			let { data: t, error: n } = await this._refreshAccessToken(e);
			if (n) throw n;
			if (!t.session) throw new on();
			await this._saveSession(t.session), await this._notifyAllSubscribers("TOKEN_REFRESHED", t.session);
			let r = {
				data: t.session,
				error: null
			};
			return this.refreshingDeferred.resolve(r), r;
		} catch (e) {
			if (this._debug(r, "error", e), w(e)) {
				let n = {
					data: null,
					error: e
				};
				return hn(e) || await this._removeSession(), (t = this.refreshingDeferred) == null || t.resolve(n), n;
			}
			throw (n = this.refreshingDeferred) == null || n.reject(e), e;
		} finally {
			this.refreshingDeferred = null, this._debug(r, "end");
		}
	}
	async _notifyAllSubscribers(e, t, n = !0) {
		let r = `#_notifyAllSubscribers(${e})`;
		this._debug(r, "begin", t, `broadcast = ${n}`);
		try {
			this.broadcastChannel && n && this.broadcastChannel.postMessage({
				event: e,
				session: t
			});
			let r = [], i = Array.from(this.stateChangeEmitters.values()).map(async (n) => {
				try {
					await n.callback(e, t);
				} catch (e) {
					r.push(e);
				}
			});
			if (await Promise.all(i), r.length > 0) {
				for (let e = 0; e < r.length; e += 1) console.error(r[e]);
				throw r[0];
			}
		} finally {
			this._debug(r, "end");
		}
	}
	async _saveSession(e) {
		this._debug("#_saveSession()", e), this.suppressGetSessionWarning = !0, await E(this.storage, `${this.storageKey}-code-verifier`);
		let t = Object.assign({}, e), n = t.user && t.user.__isUserNotAvailableProxy === !0;
		if (this.userStorage) {
			!n && t.user && await Ln(this.userStorage, this.storageKey + "-user", { user: t.user });
			let e = Object.assign({}, t);
			delete e.user;
			let r = nr(e);
			await Ln(this.storage, this.storageKey, r);
		} else {
			let e = nr(t);
			await Ln(this.storage, this.storageKey, e);
		}
	}
	async _removeSession() {
		this._debug("#_removeSession()"), this.suppressGetSessionWarning = !1, await E(this.storage, this.storageKey), await E(this.storage, this.storageKey + "-code-verifier"), await E(this.storage, this.storageKey + "-user"), this.userStorage && await E(this.userStorage, this.storageKey + "-user"), await this._notifyAllSubscribers("SIGNED_OUT", null);
	}
	_removeVisibilityChangedCallback() {
		this._debug("#_removeVisibilityChangedCallback()");
		let e = this.visibilityChangedCallback;
		this.visibilityChangedCallback = null;
		try {
			e && T() && window != null && window.removeEventListener && window.removeEventListener("visibilitychange", e);
		} catch (e) {
			console.error("removing visibilitychange callback failed", e);
		}
	}
	async _startAutoRefresh() {
		await this._stopAutoRefresh(), this._debug("#_startAutoRefresh()");
		let e = setInterval(() => this._autoRefreshTokenTick(), Kt);
		this.autoRefreshTicker = e, e && typeof e == "object" && typeof e.unref == "function" ? e.unref() : typeof Deno < "u" && typeof Deno.unrefTimer == "function" && Deno.unrefTimer(e), setTimeout(async () => {
			await this.initializePromise, await this._autoRefreshTokenTick();
		}, 0);
	}
	async _stopAutoRefresh() {
		this._debug("#_stopAutoRefresh()");
		let e = this.autoRefreshTicker;
		this.autoRefreshTicker = null, e && clearInterval(e);
	}
	async startAutoRefresh() {
		this._removeVisibilityChangedCallback(), await this._startAutoRefresh();
	}
	async stopAutoRefresh() {
		this._removeVisibilityChangedCallback(), await this._stopAutoRefresh();
	}
	async _autoRefreshTokenTick() {
		this._debug("#_autoRefreshTokenTick()", "begin");
		try {
			await this._acquireLock(0, async () => {
				try {
					let e = Date.now();
					try {
						return await this._useSession(async (t) => {
							let { data: { session: n } } = t;
							if (!n || !n.refresh_token || !n.expires_at) {
								this._debug("#_autoRefreshTokenTick()", "no session");
								return;
							}
							let r = Math.floor((n.expires_at * 1e3 - e) / Kt);
							this._debug("#_autoRefreshTokenTick()", `access token expires in ${r} ticks, a tick lasts ${Kt}ms, refresh threshold is 3 ticks`), r <= 3 && await this._callRefreshToken(n.refresh_token);
						});
					} catch (e) {
						console.error("Auto refresh tick failed with error. This is likely a transient error.", e);
					}
				} finally {
					this._debug("#_autoRefreshTokenTick()", "end");
				}
			});
		} catch (e) {
			if (e.isAcquireTimeout || e instanceof yr) this._debug("auto refresh token tick lock not available");
			else throw e;
		}
	}
	async _handleVisibilityChange() {
		if (this._debug("#_handleVisibilityChange()"), !T() || !(window != null && window.addEventListener)) return this.autoRefreshToken && this.startAutoRefresh(), !1;
		try {
			this.visibilityChangedCallback = async () => await this._onVisibilityChanged(!1), window == null || window.addEventListener("visibilitychange", this.visibilityChangedCallback), await this._onVisibilityChanged(!0);
		} catch (e) {
			console.error("_handleVisibilityChange", e);
		}
	}
	async _onVisibilityChanged(e) {
		let t = `#_onVisibilityChanged(${e})`;
		this._debug(t, "visibilityState", document.visibilityState), document.visibilityState === "visible" ? (this.autoRefreshToken && this._startAutoRefresh(), e || (await this.initializePromise, await this._acquireLock(-1, async () => {
			if (document.visibilityState !== "visible") {
				this._debug(t, "acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting");
				return;
			}
			await this._recoverAndRefresh();
		}))) : document.visibilityState === "hidden" && this.autoRefreshToken && this._stopAutoRefresh();
	}
	async _getUrlForProvider(e, t, n) {
		let r = [`provider=${encodeURIComponent(t)}`];
		if (n?.redirectTo && r.push(`redirect_to=${encodeURIComponent(n.redirectTo)}`), n?.scopes && r.push(`scopes=${encodeURIComponent(n.scopes)}`), this.flowType === "pkce") {
			let [e, t] = await qn(this.storage, this.storageKey), n = new URLSearchParams({
				code_challenge: `${encodeURIComponent(e)}`,
				code_challenge_method: `${encodeURIComponent(t)}`
			});
			r.push(n.toString());
		}
		if (n?.queryParams) {
			let e = new URLSearchParams(n.queryParams);
			r.push(e.toString());
		}
		return n?.skipBrowserRedirect && r.push(`skip_http_redirect=${n.skipBrowserRedirect}`), `${e}?${r.join("&")}`;
	}
	async _unenroll(e) {
		try {
			return await this._useSession(async (t) => {
				let { data: n, error: r } = t;
				return r ? this._returnResult({
					data: null,
					error: r
				}) : await D(this.fetch, "DELETE", `${this.url}/factors/${e.factorId}`, {
					headers: this.headers,
					jwt: n?.session?.access_token
				});
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: null,
				error: e
			});
			throw e;
		}
	}
	async _enroll(e) {
		try {
			return await this._useSession(async (t) => {
				let { data: n, error: r } = t;
				if (r) return this._returnResult({
					data: null,
					error: r
				});
				let i = Object.assign({
					friendly_name: e.friendlyName,
					factor_type: e.factorType
				}, e.factorType === "phone" ? { phone: e.phone } : e.factorType === "totp" ? { issuer: e.issuer } : {}), { data: a, error: o } = await D(this.fetch, "POST", `${this.url}/factors`, {
					body: i,
					headers: this.headers,
					jwt: n?.session?.access_token
				});
				return o ? this._returnResult({
					data: null,
					error: o
				}) : (e.factorType === "totp" && a.type === "totp" && a?.totp?.qr_code && (a.totp.qr_code = `data:image/svg+xml;utf-8,${a.totp.qr_code}`), this._returnResult({
					data: a,
					error: null
				}));
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: null,
				error: e
			});
			throw e;
		}
	}
	async _verify(e) {
		return this._acquireLock(-1, async () => {
			try {
				return await this._useSession(async (t) => {
					let { data: n, error: r } = t;
					if (r) return this._returnResult({
						data: null,
						error: r
					});
					let i = Object.assign({ challenge_id: e.challengeId }, "webauthn" in e ? { webauthn: Object.assign(Object.assign({}, e.webauthn), { credential_response: e.webauthn.type === "create" ? Nr(e.webauthn.credential_response) : Pr(e.webauthn.credential_response) }) } : { code: e.code }), { data: a, error: o } = await D(this.fetch, "POST", `${this.url}/factors/${e.factorId}/verify`, {
						body: i,
						headers: this.headers,
						jwt: n?.session?.access_token
					});
					return o ? this._returnResult({
						data: null,
						error: o
					}) : (await this._saveSession(Object.assign({ expires_at: Math.round(Date.now() / 1e3) + a.expires_in }, a)), await this._notifyAllSubscribers("MFA_CHALLENGE_VERIFIED", a), this._returnResult({
						data: a,
						error: o
					}));
				});
			} catch (e) {
				if (w(e)) return this._returnResult({
					data: null,
					error: e
				});
				throw e;
			}
		});
	}
	async _challenge(e) {
		return this._acquireLock(-1, async () => {
			try {
				return await this._useSession(async (t) => {
					let { data: n, error: r } = t;
					if (r) return this._returnResult({
						data: null,
						error: r
					});
					let i = await D(this.fetch, "POST", `${this.url}/factors/${e.factorId}/challenge`, {
						body: e,
						headers: this.headers,
						jwt: n?.session?.access_token
					});
					if (i.error) return i;
					let { data: a } = i;
					if (a.type !== "webauthn") return {
						data: a,
						error: null
					};
					switch (a.webauthn.type) {
						case "create": return {
							data: Object.assign(Object.assign({}, a), { webauthn: Object.assign(Object.assign({}, a.webauthn), { credential_options: Object.assign(Object.assign({}, a.webauthn.credential_options), { publicKey: jr(a.webauthn.credential_options.publicKey) }) }) }),
							error: null
						};
						case "request": return {
							data: Object.assign(Object.assign({}, a), { webauthn: Object.assign(Object.assign({}, a.webauthn), { credential_options: Object.assign(Object.assign({}, a.webauthn.credential_options), { publicKey: Mr(a.webauthn.credential_options.publicKey) }) }) }),
							error: null
						};
					}
				});
			} catch (e) {
				if (w(e)) return this._returnResult({
					data: null,
					error: e
				});
				throw e;
			}
		});
	}
	async _challengeAndVerify(e) {
		let { data: t, error: n } = await this._challenge({ factorId: e.factorId });
		return n ? this._returnResult({
			data: null,
			error: n
		}) : await this._verify({
			factorId: e.factorId,
			challengeId: t.id,
			code: e.code
		});
	}
	async _listFactors() {
		let { data: { user: e }, error: t } = await this.getUser();
		if (t) return {
			data: null,
			error: t
		};
		let n = {
			all: [],
			phone: [],
			totp: [],
			webauthn: []
		};
		for (let t of e?.factors ?? []) n.all.push(t), t.status === "verified" && n[t.factor_type].push(t);
		return {
			data: n,
			error: null
		};
	}
	async _getAuthenticatorAssuranceLevel() {
		let { data: { session: e }, error: t } = await this.getSession();
		if (t) return this._returnResult({
			data: null,
			error: t
		});
		if (!e) return {
			data: {
				currentLevel: null,
				nextLevel: null,
				currentAuthenticationMethods: []
			},
			error: null
		};
		let { payload: n } = Bn(e.access_token), r = null;
		n.aal && (r = n.aal);
		let i = r;
		(e.user.factors?.filter((e) => e.status === "verified") ?? []).length > 0 && (i = "aal2");
		let a = n.amr || [];
		return {
			data: {
				currentLevel: r,
				nextLevel: i,
				currentAuthenticationMethods: a
			},
			error: null
		};
	}
	async _getAuthorizationDetails(e) {
		try {
			return await this._useSession(async (t) => {
				let { data: { session: n }, error: r } = t;
				return r ? this._returnResult({
					data: null,
					error: r
				}) : n ? await D(this.fetch, "GET", `${this.url}/oauth/authorizations/${e}`, {
					headers: this.headers,
					jwt: n.access_token,
					xform: (e) => ({
						data: e,
						error: null
					})
				}) : this._returnResult({
					data: null,
					error: new on()
				});
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: null,
				error: e
			});
			throw e;
		}
	}
	async _approveAuthorization(e, t) {
		try {
			return await this._useSession(async (n) => {
				let { data: { session: r }, error: i } = n;
				if (i) return this._returnResult({
					data: null,
					error: i
				});
				if (!r) return this._returnResult({
					data: null,
					error: new on()
				});
				let a = await D(this.fetch, "POST", `${this.url}/oauth/authorizations/${e}/consent`, {
					headers: this.headers,
					jwt: r.access_token,
					body: { action: "approve" },
					xform: (e) => ({
						data: e,
						error: null
					})
				});
				return a.data && a.data.redirect_url && T() && !t?.skipBrowserRedirect && window.location.assign(a.data.redirect_url), a;
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: null,
				error: e
			});
			throw e;
		}
	}
	async _denyAuthorization(e, t) {
		try {
			return await this._useSession(async (n) => {
				let { data: { session: r }, error: i } = n;
				if (i) return this._returnResult({
					data: null,
					error: i
				});
				if (!r) return this._returnResult({
					data: null,
					error: new on()
				});
				let a = await D(this.fetch, "POST", `${this.url}/oauth/authorizations/${e}/consent`, {
					headers: this.headers,
					jwt: r.access_token,
					body: { action: "deny" },
					xform: (e) => ({
						data: e,
						error: null
					})
				});
				return a.data && a.data.redirect_url && T() && !t?.skipBrowserRedirect && window.location.assign(a.data.redirect_url), a;
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: null,
				error: e
			});
			throw e;
		}
	}
	async _listOAuthGrants() {
		try {
			return await this._useSession(async (e) => {
				let { data: { session: t }, error: n } = e;
				return n ? this._returnResult({
					data: null,
					error: n
				}) : t ? await D(this.fetch, "GET", `${this.url}/user/oauth/grants`, {
					headers: this.headers,
					jwt: t.access_token,
					xform: (e) => ({
						data: e,
						error: null
					})
				}) : this._returnResult({
					data: null,
					error: new on()
				});
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: null,
				error: e
			});
			throw e;
		}
	}
	async _revokeOAuthGrant(e) {
		try {
			return await this._useSession(async (t) => {
				let { data: { session: n }, error: r } = t;
				return r ? this._returnResult({
					data: null,
					error: r
				}) : n ? (await D(this.fetch, "DELETE", `${this.url}/user/oauth/grants`, {
					headers: this.headers,
					jwt: n.access_token,
					query: { client_id: e.clientId },
					noResolveJson: !0
				}), {
					data: {},
					error: null
				}) : this._returnResult({
					data: null,
					error: new on()
				});
			});
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: null,
				error: e
			});
			throw e;
		}
	}
	async fetchJwk(e, t = { keys: [] }) {
		let n = t.keys.find((t) => t.kid === e);
		if (n) return n;
		let r = Date.now();
		if (n = this.jwks.keys.find((t) => t.kid === e), n && this.jwks_cached_at + 6e5 > r) return n;
		let { data: i, error: a } = await D(this.fetch, "GET", `${this.url}/.well-known/jwks.json`, { headers: this.headers });
		if (a) throw a;
		return !i.keys || i.keys.length === 0 || (this.jwks = i, this.jwks_cached_at = r, n = i.keys.find((t) => t.kid === e), !n) ? null : n;
	}
	async getClaims(e, t = {}) {
		try {
			let n = e;
			if (!n) {
				let { data: e, error: t } = await this.getSession();
				if (t || !e.session) return this._returnResult({
					data: null,
					error: t
				});
				n = e.session.access_token;
			}
			let { header: r, payload: i, signature: a, raw: { header: o, payload: s } } = Bn(n);
			t?.allowExpired || Xn(i.exp);
			let c = !r.alg || r.alg.startsWith("HS") || !r.kid || !("crypto" in globalThis && "subtle" in globalThis.crypto) ? null : await this.fetchJwk(r.kid, t?.keys ? { keys: t.keys } : t?.jwks);
			if (!c) {
				let { error: e } = await this.getUser(n);
				if (e) throw e;
				return {
					data: {
						claims: i,
						header: r,
						signature: a
					},
					error: null
				};
			}
			let l = Zn(r.alg), u = await crypto.subtle.importKey("jwk", c, l, !0, ["verify"]);
			if (!await crypto.subtle.verify(l, u, a, On(`${o}.${s}`))) throw new _n("Invalid JWT signature");
			return {
				data: {
					claims: i,
					header: r,
					signature: a
				},
				error: null
			};
		} catch (e) {
			if (w(e)) return this._returnResult({
				data: null,
				error: e
			});
			throw e;
		}
	}
};
Jr.nextInstanceID = {};
//#endregion
//#region ../../node_modules/.pnpm/@supabase+auth-js@2.89.0/node_modules/@supabase/auth-js/dist/module/AuthClient.js
var Yr = Jr, Xr = "2.89.0", Zr = "";
Zr = typeof Deno < "u" ? "deno" : typeof document < "u" ? "web" : typeof navigator < "u" && navigator.product === "ReactNative" ? "react-native" : "node";
var Qr = { headers: { "X-Client-Info": `supabase-js-${Zr}/${Xr}` } }, $r = { schema: "public" }, ei = {
	autoRefreshToken: !0,
	persistSession: !0,
	detectSessionInUrl: !0,
	flowType: "implicit"
}, ti = {};
function ni(e) {
	"@babel/helpers - typeof";
	return ni = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, ni(e);
}
function ri(e, t) {
	if (ni(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (ni(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function ii(e) {
	var t = ri(e, "string");
	return ni(t) == "symbol" ? t : t + "";
}
function ai(e, t, n) {
	return (t = ii(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function oi(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function k(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? oi(Object(n), !0).forEach(function(t) {
			ai(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : oi(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var si = (e) => e ? (...t) => e(...t) : (...e) => fetch(...e), ci = () => Headers, li = (e, t, n) => {
	let r = si(n), i = ci();
	return async (n, a) => {
		let o = await t() ?? e, s = new i(a?.headers);
		return s.has("apikey") || s.set("apikey", e), s.has("Authorization") || s.set("Authorization", `Bearer ${o}`), r(n, k(k({}, a), {}, { headers: s }));
	};
};
function ui(e) {
	return e.endsWith("/") ? e : e + "/";
}
function di(e, t) {
	let { db: n, auth: r, realtime: i, global: a } = e, { db: o, auth: s, realtime: c, global: l } = t, u = {
		db: k(k({}, o), n),
		auth: k(k({}, s), r),
		realtime: k(k({}, c), i),
		storage: {},
		global: k(k(k({}, l), a), {}, { headers: k(k({}, l?.headers ?? {}), a?.headers ?? {}) }),
		accessToken: async () => ""
	};
	return e.accessToken ? u.accessToken = e.accessToken : delete u.accessToken, u;
}
function fi(e) {
	let t = e?.trim();
	if (!t) throw Error("supabaseUrl is required.");
	if (!t.match(/^https?:\/\//i)) throw Error("Invalid supabaseUrl: Must be a valid HTTP or HTTPS URL.");
	try {
		return new URL(ui(t));
	} catch {
		throw Error("Invalid supabaseUrl: Provided URL is malformed.");
	}
}
var pi = class extends Yr {
	constructor(e) {
		super(e);
	}
}, mi = class {
	constructor(e, t, n) {
		this.supabaseUrl = e, this.supabaseKey = t;
		let r = fi(e);
		if (!t) throw Error("supabaseKey is required.");
		this.realtimeUrl = new URL("realtime/v1", r), this.realtimeUrl.protocol = this.realtimeUrl.protocol.replace("http", "ws"), this.authUrl = new URL("auth/v1", r), this.storageUrl = new URL("storage/v1", r), this.functionsUrl = new URL("functions/v1", r);
		let i = `sb-${r.hostname.split(".")[0]}-auth-token`, a = {
			db: $r,
			realtime: ti,
			auth: k(k({}, ei), {}, { storageKey: i }),
			global: Qr
		}, o = di(n ?? {}, a);
		this.storageKey = o.auth.storageKey ?? "", this.headers = o.global.headers ?? {}, o.accessToken ? (this.accessToken = o.accessToken, this.auth = new Proxy({}, { get: (e, t) => {
			throw Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(t)} is not possible`);
		} })) : this.auth = this._initSupabaseAuthClient(o.auth ?? {}, this.headers, o.global.fetch), this.fetch = li(t, this._getAccessToken.bind(this), o.global.fetch), this.realtime = this._initRealtimeClient(k({
			headers: this.headers,
			accessToken: this._getAccessToken.bind(this)
		}, o.realtime)), this.accessToken && this.accessToken().then((e) => this.realtime.setAuth(e)).catch((e) => console.warn("Failed to set initial Realtime auth token:", e)), this.rest = new ie(new URL("rest/v1", r).href, {
			headers: this.headers,
			schema: o.db.schema,
			fetch: this.fetch
		}), this.storage = new Wt(this.storageUrl.href, this.headers, this.fetch, n?.storage), o.accessToken || this._listenForAuthEvents();
	}
	get functions() {
		return new g(this.functionsUrl.href, {
			headers: this.headers,
			customFetch: this.fetch
		});
	}
	from(e) {
		return this.rest.from(e);
	}
	schema(e) {
		return this.rest.schema(e);
	}
	rpc(e, t = {}, n = {
		head: !1,
		get: !1,
		count: void 0
	}) {
		return this.rest.rpc(e, t, n);
	}
	channel(e, t = { config: {} }) {
		return this.realtime.channel(e, t);
	}
	getChannels() {
		return this.realtime.getChannels();
	}
	removeChannel(e) {
		return this.realtime.removeChannel(e);
	}
	removeAllChannels() {
		return this.realtime.removeAllChannels();
	}
	async _getAccessToken() {
		var e = this;
		if (e.accessToken) return await e.accessToken();
		let { data: t } = await e.auth.getSession();
		return t.session?.access_token ?? e.supabaseKey;
	}
	_initSupabaseAuthClient({ autoRefreshToken: e, persistSession: t, detectSessionInUrl: n, storage: r, userStorage: i, storageKey: a, flowType: o, lock: s, debug: c, throwOnError: l }, u, d) {
		let f = {
			Authorization: `Bearer ${this.supabaseKey}`,
			apikey: `${this.supabaseKey}`
		};
		return new pi({
			url: this.authUrl.href,
			headers: k(k({}, f), u),
			storageKey: a,
			autoRefreshToken: e,
			persistSession: t,
			detectSessionInUrl: n,
			storage: r,
			userStorage: i,
			flowType: o,
			lock: s,
			debug: c,
			throwOnError: l,
			fetch: d,
			hasCustomAuthorizationHeader: Object.keys(this.headers).some((e) => e.toLowerCase() === "authorization")
		});
	}
	_initRealtimeClient(e) {
		return new Re(this.realtimeUrl.href, k(k({}, e), {}, { params: k(k({}, { apikey: this.supabaseKey }), e?.params) }));
	}
	_listenForAuthEvents() {
		return this.auth.onAuthStateChange((e, t) => {
			this._handleTokenChanged(e, "CLIENT", t?.access_token);
		});
	}
	_handleTokenChanged(e, t, n) {
		(e === "TOKEN_REFRESHED" || e === "SIGNED_IN") && this.changedAccessToken !== n ? (this.changedAccessToken = n, this.realtime.setAuth(n)) : e === "SIGNED_OUT" && (this.realtime.setAuth(), t == "STORAGE" && this.auth.signOut(), this.changedAccessToken = void 0);
	}
}, hi = (e, t, n) => new mi(e, t, n);
function gi() {
	if (typeof window < "u" || typeof process > "u") return !1;
	let e = process.version;
	if (e == null) return !1;
	let t = e.match(/^v(\d+)\./);
	return t ? parseInt(t[1], 10) <= 18 : !1;
}
gi() && console.warn("⚠️  Node.js 18 and below are deprecated and will no longer be supported in future versions of @supabase/supabase-js. Please upgrade to Node.js 20 or later. For more information, visit: https://github.com/orgs/supabase/discussions/37217");
//#endregion
//#region src/env-provider.tsx
var _i = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-common/src/env-provider.tsx", vi = {
	REACT_APP_API_ENDPOINT: null,
	REACT_APP_URI_CLIENT_APP: null,
	REACT_APP_ENV: null,
	REACT_APP_SUPABASE_URL: null,
	REACT_APP_SUPABASE_ANON_KEY: null,
	REACT_APP_HERE_MAPS_API_KEY: null,
	REACT_APP_MAP_TILES_BASE_URL: null
}, yi = t.createContext(null);
function bi({ env: e, children: n }) {
	return t.useMemo(() => {
		console.log("🚀 - env-provider.tsx:20 - env:", e);
	}, []), t.useEffect(() => {
		Object.keys(vi).forEach((t) => {
			t in e || console.error(`Required configuration ${t} not set`);
		});
	}, [e]), /* @__PURE__ */ s(yi.Provider, {
		value: e,
		children: n
	}, void 0, !1, {
		fileName: _i,
		lineNumber: 31,
		columnNumber: 10
	}, this);
}
function xi(e) {
	let t = Si(e);
	if (!t) throw console.error(`Key: ${e} in environment not set`), Error(`Key: ${e} in environment not set`);
	return t;
}
function Si(e) {
	return r(yi)?.[e] ?? null;
}
var Ci = () => xi("REACT_APP_URI_CLIENT_APP"), wi = () => {
	let e = Ci().replace(/\/$/, "");
	return (t) => e + "/" + t.replace(/^\//, "");
}, Ti = () => xi("REACT_APP_ENV").match(/.*dev.*/i), Ei = () => xi("REACT_APP_ENV").toLowerCase().match(/production/i), Di = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-common/src/supabase-provider.tsx", Oi = t.createContext(null);
function ki() {
	let e = t.useContext(Oi);
	if (!e) throw Error("SupabaseProvider not found");
	return e;
}
var Ai = null;
function ji({ children: e }) {
	let n = xi("REACT_APP_SUPABASE_URL"), r = xi("REACT_APP_SUPABASE_ANON_KEY"), i = t.useMemo(() => Ai || (Ai = hi(n, r), Ai), [n, r]);
	return /* @__PURE__ */ s(Oi.Provider, {
		value: i,
		children: e
	}, void 0, !1, {
		fileName: Di,
		lineNumber: 40,
		columnNumber: 5
	}, this);
}
function Mi() {
	let e = ki(), [n, r] = t.useState(null), [i, a] = t.useState(!0);
	return t.useEffect(() => {
		e?.auth?.getSession?.().then((e) => {
			a(!1), r(e.data?.session?.user ?? null);
		});
	}, []), {
		loading: i,
		user: n
	};
}
function Ni() {
	let { user: e, loading: t } = Mi();
	return {
		id: e?.id,
		loading: t
	};
}
//#endregion
//#region src/auth-context.tsx
var Pi = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-common/src/auth-context.tsx", Fi = n(null), Ii = ({ children: e }) => {
	let t = ki(), [n, r] = a(null), [o, c] = a(null), [l, u] = a(!0);
	i(() => {
		(async () => {
			try {
				let { data: e } = await t.auth.getSession();
				e.session && (r(e.session.user), c(e.session.access_token));
			} catch (e) {
				console.error("Error getting initial session:", e);
			} finally {
				u(!1);
			}
		})();
		let { data: e } = t.auth.onAuthStateChange((e, t) => {
			t ? (r(t.user), c(t.access_token)) : (r(null), c(null)), u(!1);
		});
		return () => {
			e?.subscription?.unsubscribe();
		};
	}, [t]);
	let d = {
		user: n,
		jwt: o,
		signIn: async (e, n) => {
			let { data: r, error: i } = await t.auth.signInWithPassword({
				email: e,
				password: n
			});
			if (i) throw i;
			return { session: r.session };
		},
		signUp: async (e, n) => {
			let { data: r, error: i } = await t.auth.signUp({
				email: e,
				password: n
			});
			if (i) throw i;
			return { session: r.session };
		},
		signOut: async () => {
			let { error: e } = await t.auth.signOut();
			if (e) throw e;
		},
		loading: l
	};
	return /* @__PURE__ */ s(Fi.Provider, {
		value: d,
		children: e
	}, void 0, !1, {
		fileName: Pi,
		lineNumber: 121,
		columnNumber: 10
	}, void 0);
}, Li = () => {
	let e = r(Fi);
	if (!e) throw Error("useAuth must be used within an AuthProvider");
	return e;
};
//#endregion
//#region src/auth-hooks.ts
function Ri({ onError: t, supabase: n, onSuccess: r }) {
	return e.useCallback(async (e, i) => {
		let { error: a, data: o } = await n.auth.signInWithPassword({
			email: e,
			password: i
		});
		return console.log("🚀 - file: login.lazy.tsx:33 - signIn - data:", o), a ? t(a) : r(e);
	}, [t, r]);
}
function zi({ onError: t, onSuccess: n, supabase: r, emailRedirectTo: i, shouldCreateUser: a }) {
	return e.useCallback(async (e) => {
		console.log("🚀 - auth-hooks.ts:43 - useSignInWithOtpInitiate - string:", e);
		let { error: o, data: s, ...c } = await r.auth.signInWithOtp({
			email: e,
			options: {
				emailRedirectTo: i,
				shouldCreateUser: a
			}
		});
		return console.log("🚀 - file: login.lazy.tsx:33 - signIn - data:", s, o, c), o ? t(o) : n(e);
	}, [t, n]);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/constants.js
var Bi = 365.2425, Vi = 3600 * 24;
Vi * 7, Vi * Bi / 12 * 3;
var Hi = Symbol.for("constructDateFrom");
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/constructFrom.js
function Ui(e, t) {
	return typeof e == "function" ? e(t) : e && typeof e == "object" && Hi in e ? e[Hi](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/toDate.js
function Wi(e, t) {
	return Ui(t || e, e);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/addDays.js
function Gi(e, t, n) {
	let r = Wi(e, n?.in);
	return isNaN(t) ? Ui(n?.in || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/addMonths.js
function Ki(e, t, n) {
	let r = Wi(e, n?.in);
	if (isNaN(t)) return Ui(n?.in || e, NaN);
	if (!t) return r;
	let i = r.getDate(), a = Ui(n?.in || e, r.getTime());
	return a.setMonth(r.getMonth() + t + 1, 0), i >= a.getDate() ? a : (r.setFullYear(a.getFullYear(), a.getMonth(), i), r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/add.js
function qi(e, t, n) {
	let { years: r = 0, months: i = 0, weeks: a = 0, days: o = 0, hours: s = 0, minutes: c = 0, seconds: l = 0 } = t, u = Wi(e, n?.in), d = i || r ? Ki(u, i + r * 12) : u, f = o || a ? Gi(d, o + a * 7) : d, p = (l + (c + s * 60) * 60) * 1e3;
	return Ui(n?.in || e, +f + p);
}
//#endregion
//#region ../../node_modules/.pnpm/@ark+util@0.56.0/node_modules/@ark/util/out/arrays.js
var Ji = (e) => Array.isArray(e) ? e : [e], Yi = (e, t) => {
	let n = [[], []];
	for (let r of e) t(r) ? n[0].push(r) : n[1].push(r);
	return n;
}, Xi = Array, Zi = (e, t) => e.includes(t), Qi = (e, t = 0) => [...Array(e)].map((e, n) => n + t), A = (e, t, n) => e === void 0 ? t === void 0 ? [] : Array.isArray(t) ? t : [t] : (n?.prepend ? Array.isArray(t) ? e.unshift(...t) : e.unshift(t) : Array.isArray(t) ? e.push(...t) : e.push(t), e), $i = (e, t) => t == null ? e ?? [] : e == null ? Ji(t) : e.concat(t), ea = (...e) => e.reduce($i, []), ta = (e, t, n) => {
	if (e === void 0) return Array.isArray(t) ? t : [t];
	let r = n?.isEqual ?? ((e, t) => e === t);
	for (let n of Ji(t)) e.some((e) => r(e, n)) || e.push(n);
	return e;
}, na = (e, t) => e.reduce((e, n) => {
	let r = n[t];
	return e[r] = A(e[r], n), e;
}, {}), ra = (e, t, n) => e.length === t.length && e.every(n?.isEqual ? (e, r) => n.isEqual(e, t[r]) : (e, n) => e === t[n]), ia = (e, t) => aa(e) === t, aa = (e) => {
	let t = typeof e;
	return t === "object" ? e === null ? "null" : "object" : t === "function" ? "object" : t;
}, oa = {
	boolean: "boolean",
	null: "null",
	undefined: "undefined",
	bigint: "a bigint",
	number: "a number",
	object: "an object",
	string: "a string",
	symbol: "a symbol"
}, sa = {
	...oa,
	function: "a function"
}, ca = class extends Error {}, j = (e) => la(e, ca), la = (e, t = Error) => {
	throw new t(e);
}, ua = class extends Error {
	name = "ParseError";
}, M = (e) => la(e, ua), da = (e) => ` ${e}`, N = (e, t) => {
	let n = {}, r = Array.isArray(e), i = !1;
	for (let [a, o] of Object.entries(e).entries()) {
		let e = r ? t(a, o[1]) : t(...o, a);
		i ||= typeof e[0] == "number";
		let s = Array.isArray(e[0]) || e.length === 0 ? e : [e];
		for (let [e, t] of s) typeof e == "object" ? n[e.group] = A(n[e.group], t) : n[e] = t;
	}
	return i ? Object.values(n) : n;
}, fa = Object.entries, pa = (e, t) => e in t, ma = (e, t) => t in e, ha = class {
	constructor(e) {
		Object.assign(this, e);
	}
}, ga = class {}, _a = class extends ga {}, va = (e, t) => {
	let n = {}, r = {}, i;
	for (i in e) i in t ? n[i] = e[i] : r[i] = e[i];
	return [n, r];
}, ya = (e, t) => va(e, t)[1], ba = (e) => Object.keys(e).length === 0, xa = (e) => [...Object.entries(e), ...Object.getOwnPropertySymbols(e).map((t) => [t, e[t]])], Sa = (e, t) => Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)), Ca = (e) => {
	let t = Object.keys(e).sort(), n = {};
	for (let r = 0; r < t.length; r++) n[t[r]] = e[t[r]];
	return n;
}, wa = da("unset​"), Ta = (e) => Object.values(e).filter((t) => typeof t == "number" ? !0 : typeof e[t] != "number"), Ea = {
	Array,
	Boolean,
	Date,
	Error,
	Function,
	Map,
	Number,
	Promise,
	RegExp,
	Set,
	String,
	WeakMap,
	WeakSet
}, Da = globalThis.File ?? Blob, Oa = {
	ArrayBuffer,
	Blob,
	File: Da,
	FormData,
	Headers,
	Request,
	Response,
	URL
}, ka = {
	Int8Array,
	Uint8Array,
	Uint8ClampedArray,
	Int16Array,
	Uint16Array,
	Int32Array,
	Uint32Array,
	Float32Array,
	Float64Array,
	BigInt64Array,
	BigUint64Array
}, Aa = {
	...Ea,
	...Oa,
	...ka,
	String,
	Number,
	Boolean
}, ja = (e) => {
	let t = Object.getPrototypeOf(e);
	for (; t?.constructor && (!pa(t.constructor.name, Aa) || !(e instanceof Aa[t.constructor.name]));) t = Object.getPrototypeOf(t);
	let n = t?.constructor?.name;
	if (!(n === void 0 || n === "Object")) return n;
}, Ma = (e) => typeof e == "object" && e ? ja(e) ?? "object" : aa(e), P = Array.isArray, Na = {
	Array: "an array",
	Function: "a function",
	Date: "a Date",
	RegExp: "a RegExp",
	Error: "an Error",
	Map: "a Map",
	Set: "a Set",
	String: "a String object",
	Number: "a Number object",
	Boolean: "a Boolean object",
	Promise: "a Promise",
	WeakMap: "a WeakMap",
	WeakSet: "a WeakSet"
}, Pa = {
	ArrayBuffer: "an ArrayBuffer instance",
	Blob: "a Blob instance",
	File: "a File instance",
	FormData: "a FormData instance",
	Headers: "a Headers instance",
	Request: "a Request instance",
	Response: "a Response instance",
	URL: "a URL instance"
}, Fa = {
	Int8Array: "an Int8Array",
	Uint8Array: "a Uint8Array",
	Uint8ClampedArray: "a Uint8ClampedArray",
	Int16Array: "an Int16Array",
	Uint16Array: "a Uint16Array",
	Int32Array: "an Int32Array",
	Uint32Array: "a Uint32Array",
	Float32Array: "a Float32Array",
	Float64Array: "a Float64Array",
	BigInt64Array: "a BigInt64Array",
	BigUint64Array: "a BigUint64Array"
}, Ia = {
	...Na,
	...Pa,
	...Fa
}, La = (e) => {
	let t = Object(e).name ?? null;
	return t && pa(t, Aa) && Aa[t] === e ? t : null;
}, Ra = (e, t) => {
	let n = e.prototype;
	for (; n !== null;) {
		if (n === t.prototype) return !0;
		n = Object.getPrototypeOf(n);
	}
	return !1;
}, za = (e) => Ba(e, /* @__PURE__ */ new Map()), Ba = (e, t) => {
	if (typeof e != "object" || !e) return e;
	if (t?.has(e)) return t.get(e);
	let n = La(e.constructor);
	if (n === "Date") return new Date(e.getTime());
	if (n && n !== "Array") return e;
	let r = Array.isArray(e) ? e.slice() : Object.create(Object.getPrototypeOf(e)), i = Object.getOwnPropertyDescriptors(e);
	if (t) {
		t.set(e, r);
		for (let e in i) {
			let n = i[e];
			"get" in n || "set" in n || (n.value = Ba(n.value, t));
		}
	}
	return Object.defineProperties(r, i), r;
}, Va = (e) => {
	let t = wa;
	return () => t === wa ? t = e() : t;
}, Ha = (e) => typeof e == "function" && e.length === 0, Ua = class extends Function {
	constructor(...e) {
		let t = e.slice(0, -1), n = e[e.length - 1];
		try {
			super(...t, n);
		} catch (t) {
			return j(`Encountered an unexpected error while compiling your definition:
                Message: ${t} 
                Source: (${e.slice(0, -1)}) => {
                    ${e[e.length - 1]}
                }`);
		}
	}
}, Wa = class {
	constructor(e, ...[t]) {
		return Object.assign(Object.setPrototypeOf(e.bind(t?.bind ?? this), this.constructor.prototype), t?.attach);
	}
}, Ga = Va(() => {
	try {
		return Function("return false")();
	} catch {
		return !0;
	}
});
//#endregion
//#region ../../node_modules/.pnpm/@ark+util@0.56.0/node_modules/@ark/util/out/hkt.js
da("brand"), da("arkInferred"), da("args");
var Ka = class {
	constructor() {}
}, qa = {
	fileName: () => {
		try {
			return (((/* @__PURE__ */ Error()).stack?.split("\n")[2]?.trim() || "").match(/\(?(.+?)(?::\d+:\d+)?\)?$/)?.[1] || "unknown").replace(/^file:\/\//, "");
		} catch {
			return "unknown";
		}
	},
	env: globalThis.process?.env ?? {}
}, Ja = (e) => e[0].toUpperCase() + e.slice(1), Ya = (e) => e[0].toLowerCase() + e.slice(1), Xa = (e) => new RegExp(Za(e), typeof e == "string" ? "" : e.flags), Za = (e) => `^(?:${typeof e == "string" ? e : e.source})$`, Qa = {
	negativeLookahead: (e) => `(?!${e})`,
	nonCapturingGroup: (e) => `(?:${e})`
}, $a = {
	" ": 1,
	"\n": 1,
	"	": 1
}, eo = "^-0\\.?0*$", to = "[1-9]\\d*", no = "\\.\\d+", ro = "\\.\\d*[1-9]", io = (e) => Xa(Qa.negativeLookahead(eo) + Qa.nonCapturingGroup("-?" + Qa.nonCapturingGroup(Qa.nonCapturingGroup("0|" + to) + Qa.nonCapturingGroup(e.decimalPattern) + "?") + (e.allowDecimalOnly ? "|" + e.decimalPattern : "") + "?")), ao = io({
	decimalPattern: ro,
	allowDecimalOnly: !1
}), oo = ao.test.bind(ao), so = io({
	decimalPattern: no,
	allowDecimalOnly: !0
});
so.test.bind(so);
var co = /^-?\d*\.?\d*$/, lo = (e) => e.length !== 0 && co.test(e), uo = Xa(Qa.negativeLookahead("^-0$") + "-?" + Qa.nonCapturingGroup(Qa.nonCapturingGroup("0|" + to))), fo = uo.test.bind(uo), po = /^-?\d+$/, mo = po.test.bind(po), ho = {
	number: "a number",
	bigint: "a bigint",
	integer: "an integer"
}, go = (e, t) => `'${e}' was parsed as ${ho[t]} but could not be narrowed to a literal value. Avoid unnecessary leading or trailing zeros and other abnormal notation`, _o = (e, t) => t === "number" ? oo(e) : fo(e), vo = (e, t) => t === "number" ? Number(e) : Number.parseInt(e), yo = (e, t) => t === "number" ? lo(e) : mo(e), bo = (e, t) => Co(e, "number", t), xo = (e, t) => Co(e, "number", {
	...t,
	strict: !0
}), So = (e, t) => Co(e, "integer", t), Co = (e, t, n) => {
	let r = vo(e, t);
	return !Number.isNaN(r) && yo(e, t) ? n?.strict ? _o(e, t) ? r : M(go(e, t)) : r : n?.errorOnFail ? M(n?.errorOnFail === !0 ? `Failed to parse ${ho[t]} from '${e}'` : n?.errorOnFail) : void 0;
}, wo = (e) => {
	if (e[e.length - 1] !== "n") return;
	let t = e.slice(0, -1), n;
	try {
		n = BigInt(t);
	} catch {
		return;
	}
	if (uo.test(t)) return n;
	if (po.test(t)) return M(go(e, "bigint"));
}, To = {
	version: "0.56.0",
	filename: qa.fileName(),
	FileConstructor: Da
}, Eo = /* @__PURE__ */ new Map(), Do = Object.create(null), Oo = (e) => {
	let t = Eo.get(e);
	if (t) return t;
	let n = Ao(e);
	return Do[n] ? n = `${n}${Do[n]++}` : Do[n] = 1, To[n] = e, Eo.set(e, n), n;
}, ko = (e) => /^[$A-Z_a-z][\w$]*$/.test(e), Ao = (e) => {
	switch (typeof e) {
		case "object": {
			if (e === null) break;
			let t = ja(e) ?? "object";
			return t[0].toLowerCase() + t.slice(1);
		}
		case "function": return ko(e.name) ? e.name : "fn";
		case "symbol": return e.description && ko(e.description) ? e.description : "symbol";
	}
	return j(`Unexpected attempt to register serializable value of type ${aa(e)}`);
}, jo = (e) => typeof e == "string" ? JSON.stringify(e) : typeof e == "bigint" ? `${e}n` : `${e}`, Mo = (e, t = {}) => Fo(e, {
	onUndefined: "$ark.undefined",
	onBigInt: (e) => `$ark.bigint-${e}`,
	...t
}, []), F = (e, t) => {
	switch (aa(e)) {
		case "object":
			let n = e, r = n.constructor?.name ?? "Object";
			return r === "Object" || r === "Array" ? t?.quoteKeys === !1 ? No(n, t?.indent ?? 0, "") : JSON.stringify(Fo(n, Po, []), null, t?.indent) : No(n, t?.indent ?? 0, "");
		case "symbol": return Po.onSymbol(e);
		default: return jo(e);
	}
}, No = (e, t, n) => {
	if (typeof e == "function") return Po.onFunction(e);
	if (typeof e != "object" || !e) return jo(e);
	let r = n + " ".repeat(t);
	if (Array.isArray(e)) {
		if (e.length === 0) return "[]";
		let i = e.map((e) => No(e, t, r)).join(",\n" + r);
		return t ? `[\n${r}${i}\n${n}]` : `[${i}]`;
	}
	let i = e.constructor?.name ?? "Object";
	if (i === "Object") {
		let i = xa(e).map(([e, n]) => `${r}${typeof e == "symbol" ? Po.onSymbol(e) : ko(e) ? e : JSON.stringify(e)}: ${No(n, t, r)}`);
		return i.length === 0 ? "{}" : t ? `{\n${i.join(",\n")}\n${n}}` : `{${i.join(", ")}}`;
	}
	return e instanceof Date ? Io(e) : "expression" in e && typeof e.expression == "string" ? e.expression : i;
}, Po = {
	onCycle: () => "(cycle)",
	onSymbol: (e) => `Symbol(${Oo(e)})`,
	onFunction: (e) => `Function(${Oo(e)})`
}, Fo = (e, t, n) => {
	switch (aa(e)) {
		case "object": {
			let r = e;
			if ("toJSON" in r && typeof r.toJSON == "function") return r.toJSON();
			if (typeof r == "function") return Po.onFunction(r);
			if (n.includes(r)) return "(cycle)";
			let i = [...n, r];
			if (Array.isArray(r)) return r.map((e) => Fo(e, t, i));
			if (r instanceof Date) return r.toDateString();
			let a = {};
			for (let e in r) a[e] = Fo(r[e], t, i);
			for (let e of Object.getOwnPropertySymbols(r)) a[t.onSymbol?.(e) ?? e.toString()] = Fo(r[e], t, i);
			return a;
		}
		case "symbol": return Po.onSymbol(e);
		case "bigint": return t.onBigInt?.(e) ?? `${e}n`;
		case "undefined": return t.onUndefined ?? "undefined";
		case "string": return e.replace(/\\/g, "\\\\");
		default: return e;
	}
}, Io = (e) => {
	let t = e.getFullYear(), n = e.getMonth(), r = e.getDate(), i = e.getHours(), a = e.getMinutes(), o = e.getSeconds(), s = e.getMilliseconds();
	if (n === 0 && r === 1 && i === 0 && a === 0 && o === 0 && s === 0) return `${t}`;
	let c = `${Lo[n]} ${r}, ${t}`;
	if (i === 0 && a === 0 && o === 0 && s === 0) return c;
	let l = e.toLocaleTimeString(), u = l.endsWith(" AM") || l.endsWith(" PM") ? l.slice(-3) : "";
	return u && (l = l.slice(0, -u.length)), s ? l += `.${zo(s, 3)}` : Ro.test(l) && (l = l.slice(0, -3)), `${l + u}, ${c}`;
}, Lo = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December"
], Ro = /:\d\d:00$/, zo = (e, t) => String(e).padStart(t, "0"), Bo = (e, t, ...[n]) => {
	let r = n?.stringifySymbol ?? F, i = e;
	switch (typeof t) {
		case "string":
			i = ko(t) ? e === "" ? t : `${e}.${t}` : `${e}[${JSON.stringify(t)}]`;
			break;
		case "number":
			i = `${e}[${t}]`;
			break;
		case "symbol":
			i = `${e}[${r(t)}]`;
			break;
		default: n?.stringifyNonKey ? i = `${e}[${n.stringifyNonKey(t)}]` : M(`${F(t)} must be a PropertyKey or stringifyNonKey must be passed to options`);
	}
	return i;
}, Vo = (e, ...t) => e.reduce((e, n) => Bo(e, n, ...t), ""), Ho = class extends Xi {
	cache = {};
	constructor(...e) {
		super(), this.push(...e);
	}
	toJSON() {
		if (this.cache.json) return this.cache.json;
		this.cache.json = [];
		for (let e = 0; e < this.length; e++) this.cache.json.push(typeof this[e] == "symbol" ? F(this[e]) : this[e]);
		return this.cache.json;
	}
	stringify() {
		return this.cache.stringify ? this.cache.stringify : this.cache.stringify = Vo(this);
	}
	stringifyAncestors() {
		if (this.cache.stringifyAncestors) return this.cache.stringifyAncestors;
		let e = "", t = [e];
		for (let n of this) e = Bo(e, n), t.push(e);
		return this.cache.stringifyAncestors = t;
	}
}, Uo = class {
	chars;
	i;
	def;
	constructor(e) {
		this.def = e, this.chars = [...e], this.i = 0;
	}
	shift() {
		return this.chars[this.i++] ?? "";
	}
	get lookahead() {
		return this.chars[this.i] ?? "";
	}
	get nextLookahead() {
		return this.chars[this.i + 1] ?? "";
	}
	get length() {
		return this.chars.length;
	}
	shiftUntil(e) {
		let t = "";
		for (; this.lookahead && !e(this, t);) t += this.shift();
		return t;
	}
	shiftUntilEscapable(e) {
		let t = "";
		for (; this.lookahead;) if (this.lookahead === "\\") this.shift(), e(this, t) || this.lookahead === "\\" ? t += this.shift() : t += `\\${this.shift()}`;
		else if (e(this, t)) break;
		else t += this.shift();
		return t;
	}
	shiftUntilLookahead(e) {
		return typeof e == "string" ? this.shiftUntil((t) => t.lookahead === e) : this.shiftUntil((t) => t.lookahead in e);
	}
	shiftUntilNonWhitespace() {
		return this.shiftUntil(() => !(this.lookahead in $a));
	}
	jumpToIndex(e) {
		this.i = e < 0 ? this.length + e : e;
	}
	jumpForward(e) {
		this.i += e;
	}
	get location() {
		return this.i;
	}
	get unscanned() {
		return this.chars.slice(this.i, this.length).join("");
	}
	get scanned() {
		return this.chars.slice(0, this.i).join("");
	}
	sliceChars(e, t) {
		return this.chars.slice(e, t).join("");
	}
	lookaheadIs(e) {
		return this.lookahead === e;
	}
	lookaheadIsIn(e) {
		return this.lookahead in e;
	}
}, Wo = (e, t) => `Unmatched ${e}${t === "" ? "" : ` before ${t}`}`, Go = (e) => `Missing ${e}`;
da("implementedTraits"), Symbol.hasInstance;
for (var Ko = "$ark", qo = 2; Ko in globalThis;) Ko = `$ark${qo++}`;
var Jo = Ko;
globalThis[Jo] = To;
var I = To, Yo = (e) => `${Jo}.${e}`, Xo = (e) => Yo(Oo(e)), Zo = class extends _a {
	argNames;
	body = "";
	constructor(...e) {
		super(), this.argNames = e;
		for (let t of e) {
			if (t in this) throw Error(`Arg name '${t}' would overwrite an existing property on FunctionBody`);
			this[t] = t;
		}
	}
	indentation = 0;
	indent() {
		return this.indentation += 4, this;
	}
	dedent() {
		return this.indentation -= 4, this;
	}
	prop(e, t = !1) {
		return $o(e, t);
	}
	index(e, t = !1) {
		return ts(`${e}`, t);
	}
	line(e) {
		return this.body += `${" ".repeat(this.indentation)}${e}\n`, this;
	}
	const(e, t) {
		return this.line(`const ${e} = ${t}`), this;
	}
	let(e, t) {
		return this.line(`let ${e} = ${t}`);
	}
	set(e, t) {
		return this.line(`${e} = ${t}`);
	}
	if(e, t) {
		return this.block(`if (${e})`, t);
	}
	elseIf(e, t) {
		return this.block(`else if (${e})`, t);
	}
	else(e) {
		return this.block("else", e);
	}
	for(e, t, n = 0) {
		return this.block(`for (let i = ${n}; ${e}; i++)`, t);
	}
	forIn(e, t) {
		return this.block(`for (const k in ${e})`, t);
	}
	block(e, t, n = "") {
		return this.line(`${e} {`), this.indent(), t(this), this.dedent(), this.line(`}${n}`);
	}
	return(e = "") {
		return this.line(`return ${e}`);
	}
	write(e = "anonymous", t = 0) {
		return `${e}(${this.argNames.join(", ")}) { ${t ? this.body.split("\n").map((e) => " ".repeat(t) + `${e}`).join("\n") : this.body} }`;
	}
	compile() {
		return new Ua(...this.argNames, this.body);
	}
}, Qo = (e) => ia(e, "object") || typeof e == "symbol" ? Xo(e) : jo(e), $o = (e, t = !1) => typeof e == "string" && ko(e) ? `${t ? "?" : ""}.${e}` : ts(es(e), t), es = (e) => typeof e == "symbol" ? Xo(e) : JSON.stringify(e), ts = (e, t = !1) => `${t ? "?." : ""}[${e}]`, ns = class extends Zo {
	traversalKind;
	optimistic;
	constructor(e) {
		super("data", "ctx"), this.traversalKind = e.kind, this.optimistic = e.optimistic === !0;
	}
	invoke(e, t) {
		let n = t?.arg ?? this.data, r = typeof e == "string" ? !0 : this.requiresContextFor(e), i = typeof e == "string" ? e : e.id;
		return r ? `${this.referenceToId(i, t)}(${n}, ${this.ctx})` : `${this.referenceToId(i, t)}(${n})`;
	}
	referenceToId(e, t) {
		let n = `this.${e}${t?.kind ?? this.traversalKind}`;
		return t?.bind ? `${n}.bind(${t?.bind})` : n;
	}
	requiresContextFor(e) {
		return this.traversalKind === "Apply" || e.allowsRequiresContext;
	}
	initializeErrorCount() {
		return this.const("errorCount", "ctx.currentErrorCount");
	}
	returnIfFail() {
		return this.if("ctx.currentErrorCount > errorCount", () => this.return());
	}
	returnIfFailFast() {
		return this.if("ctx.failFast && ctx.currentErrorCount > errorCount", () => this.return());
	}
	traverseKey(e, t, n) {
		let r = this.requiresContextFor(n);
		return r && this.line(`${this.ctx}.path.push(${e})`), this.check(n, { arg: t }), r && this.line(`${this.ctx}.path.pop()`), this;
	}
	check(e, t) {
		return this.traversalKind === "Allows" ? this.if(`!${this.invoke(e, t)}`, () => this.return(!1)) : this.line(this.invoke(e, t));
	}
}, rs = (e) => N(e, (e, t) => [e, P(t) ? [...t] : t]), is = da("arkKind"), L = (e, t) => e?.[is] === t, as = (e) => L(e, "root") || L(e, "constraint"), os = [
	"unit",
	"proto",
	"domain"
], ss = [
	"required",
	"optional",
	"index",
	"sequence"
], cs = [
	"pattern",
	"divisor",
	"exactLength",
	"max",
	"min",
	"maxLength",
	"minLength",
	"before",
	"after"
], ls = [
	...cs,
	"structure",
	"predicate"
], us = [...ls, ...ss], ds = [
	"alias",
	"union",
	"morph",
	"unit",
	"intersection",
	"proto",
	"domain"
], fs = [...ds, ...us], ps = N(us, (e, t) => [t, 1]), ms = N([...ss, "undeclared"], (e, t) => [t, 1]), hs = N(fs, (e, t) => [t, e]), gs = (e) => typeof e == "string" && e in hs, _s = (e) => hs[e], vs = (e) => ds.slice(_s(e) + 1);
[...vs("union")], [...vs("morph")];
var ys = (e) => typeof e == "string" || typeof e == "boolean" || e === null ? e : typeof e == "number" ? Number.isNaN(e) ? "NaN" : e === Infinity ? "Infinity" : e === -Infinity ? "-Infinity" : e : Qo(e), bs = (e) => {
	let t = "{ ";
	for (let [n, r] of Object.entries(e)) t += `${n}: ${Qo(r)}, `;
	return t + " }";
}, R = (e) => {
	let t = e;
	return t.hasAssociatedError && (t.defaults.expected ??= (e) => "description" in e ? e.description : t.defaults.description(e), t.defaults.actual ??= (e) => F(e), t.defaults.problem ??= (e) => `must be ${e.expected}${e.actual ? ` (was ${e.actual})` : ""}`, t.defaults.message ??= (e) => {
		if (e.path.length === 0) return e.problem;
		let t = `${e.propString} ${e.problem}`;
		return t[0] === "[" ? `value at ${t}` : t;
	}), t;
}, z = {
	Error: class extends Error {
		name = "ToJsonSchemaError";
		code;
		context;
		constructor(e, t) {
			super(F(t, {
				quoteKeys: !1,
				indent: 4
			})), this.code = e, this.context = t;
		}
		hasCode(e) {
			return this.code === e;
		}
	},
	throw: (...e) => {
		throw new z.Error(...e);
	},
	throwInternalOperandError: (e, t) => j(`Unexpected JSON Schema input for ${e}: ${F(t)}`),
	defaultConfig: {
		target: "draft-2020-12",
		dialect: "https://json-schema.org/draft/2020-12/schema",
		useRefs: !1,
		fallback: {
			arrayObject: (e) => z.throw("arrayObject", e),
			arrayPostfix: (e) => z.throw("arrayPostfix", e),
			defaultValue: (e) => z.throw("defaultValue", e),
			domain: (e) => z.throw("domain", e),
			morph: (e) => z.throw("morph", e),
			patternIntersection: (e) => z.throw("patternIntersection", e),
			predicate: (e) => z.throw("predicate", e),
			proto: (e) => z.throw("proto", e),
			symbolKey: (e) => z.throw("symbolKey", e),
			unit: (e) => z.throw("unit", e),
			date: (e) => z.throw("date", e)
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/@ark+schema@0.56.0/node_modules/@ark/schema/out/config.js
I.config ??= {};
var xs = (e, t) => {
	if (!t) return e;
	let n = { ...e }, r;
	for (r in t) {
		let i = { ...e.keywords };
		if (r === "keywords") {
			for (let e in t[r]) {
				let n = t.keywords[e];
				n !== void 0 && (i[e] = typeof n == "string" ? { description: n } : n);
			}
			n.keywords = i;
		} else r === "toJsonSchema" ? n[r] = Cs(e.toJsonSchema, t.toJsonSchema) : gs(r) ? n[r] = {
			...e[r],
			...t[r]
		} : n[r] = t[r];
	}
	return n;
}, Ss = {
	"draft-2020-12": "https://json-schema.org/draft/2020-12/schema",
	"draft-07": "http://json-schema.org/draft-07/schema#"
}, Cs = ((e, t) => {
	if (!e) return ws(t ?? {}, void 0);
	if (!t) return e;
	let n = { ...e }, r;
	for (r in t) r === "fallback" ? n.fallback = Ts(e.fallback, t.fallback) : n[r] = t[r];
	return ws(n, t);
}), ws = (e, t) => t?.dialect === void 0 ? t?.target === void 0 ? e : {
	...e,
	dialect: Ss[t.target]
} : e, Ts = (e, t) => {
	e = Es(e), t = Es(t);
	let n = {}, r;
	for (r in z.defaultConfig.fallback) n[r] = t[r] ?? t.default ?? e[r] ?? e.default ?? z.defaultConfig.fallback[r];
	return n;
}, Es = (e) => typeof e == "function" ? { default: e } : e ?? {}, Ds = class e extends _a {
	[is] = "error";
	path;
	data;
	nodeConfig;
	input;
	ctx;
	constructor({ prefixPath: e, relativePath: t, ...n }, r) {
		super(), this.input = n, this.ctx = r, Sa(this, n);
		let i = r.data;
		n.code === "union" && (n.errors = n.errors.flatMap((n) => {
			let r = n.hasCode("union") ? n.errors : [n];
			return !e && !t ? r : r.map((n) => n.transform((n) => ({
				...n,
				path: ea(e, n.path, t)
			})));
		})), this.nodeConfig = r.config[this.code];
		let a = [...n.path ?? r.path];
		t && a.push(...t), e && a.unshift(...e), this.path = new Ho(...a), this.data = "data" in n ? n.data : i;
	}
	transform(t) {
		return new e(t({
			data: this.data,
			path: this.path,
			...this.input
		}), this.ctx);
	}
	hasCode(e) {
		return this.code === e;
	}
	get propString() {
		return Vo(this.path);
	}
	get expected() {
		if (this.input.expected) return this.input.expected;
		let e = this.meta?.expected ?? this.nodeConfig.expected;
		return typeof e == "function" ? e(this.input) : e;
	}
	get actual() {
		if (this.input.actual) return this.input.actual;
		let e = this.meta?.actual ?? this.nodeConfig.actual;
		return typeof e == "function" ? e(this.data) : e;
	}
	get problem() {
		if (this.input.problem) return this.input.problem;
		let e = this.meta?.problem ?? this.nodeConfig.problem;
		return typeof e == "function" ? e(this) : e;
	}
	get message() {
		if (this.input.message) return this.input.message;
		let e = this.meta?.message ?? this.nodeConfig.message;
		return typeof e == "function" ? e(this) : e;
	}
	get flat() {
		return this.hasCode("intersection") ? [...this.errors] : [this];
	}
	toJSON() {
		return {
			data: this.data,
			path: this.path,
			...this.input,
			expected: this.expected,
			actual: this.actual,
			problem: this.problem,
			message: this.message
		};
	}
	toString() {
		return this.message;
	}
	throw() {
		throw this;
	}
}, Os = class e extends Xi {
	[is] = "errors";
	ctx;
	constructor(e) {
		super(), this.ctx = e;
	}
	byPath = Object.create(null);
	get flatByPath() {
		return N(this.byPath, (e, t) => [e, t.flat]);
	}
	get flatProblemsByPath() {
		return N(this.byPath, (e, t) => [e, t.flat.map((e) => e.problem)]);
	}
	byAncestorPath = Object.create(null);
	count = 0;
	mutable = this;
	throw() {
		throw this.toTraversalError();
	}
	toTraversalError() {
		return new ks(this);
	}
	add(e) {
		let t = this.byPath[e.propString];
		if (t) {
			if (e === t || t.hasCode("union") && t.errors.length === 0) return;
			let n = e.hasCode("union") && e.errors.length === 0 ? e : new Ds({
				code: "intersection",
				errors: t.hasCode("intersection") ? [...t.errors, e] : [t, e]
			}, this.ctx), r = this.indexOf(t);
			this.mutable[r === -1 ? this.length : r] = n, this.byPath[e.propString] = n, this.addAncestorPaths(e);
		} else this.byPath[e.propString] = e, this.addAncestorPaths(e), this.mutable.push(e);
		this.count++;
	}
	transform(t) {
		let n = new e(this.ctx);
		for (let e of this) n.add(t(e));
		return n;
	}
	merge(e) {
		for (let t of e) this.add(new Ds({
			...t,
			path: [...this.ctx.path, ...t.path]
		}, this.ctx));
	}
	affectsPath(e) {
		return this.length === 0 ? !1 : e.stringifyAncestors().some((e) => e in this.byPath) || e.stringify() in this.byAncestorPath;
	}
	get summary() {
		return this.toString();
	}
	get issues() {
		return this;
	}
	toJSON() {
		return [...this.map((e) => e.toJSON())];
	}
	toString() {
		return this.join("\n");
	}
	addAncestorPaths(e) {
		for (let t of e.path.stringifyAncestors()) this.byAncestorPath[t] = A(this.byAncestorPath[t], e);
	}
}, ks = class extends Error {
	name = "TraversalError";
	constructor(e) {
		e.length === 1 ? super(e.summary) : super("\n" + e.map((e) => `  • ${As(e)}`).join("\n")), Object.defineProperty(this, "arkErrors", {
			value: e,
			enumerable: !1
		});
	}
}, As = (e) => e.toString().split("\n").join("\n  "), js = class {
	path = [];
	errors = new Os(this);
	root;
	config;
	queuedMorphs = [];
	branches = [];
	seen = {};
	constructor(e, t) {
		this.root = e, this.config = t;
	}
	get data() {
		let e = this.root;
		for (let t of this.path) e = e?.[t];
		return e;
	}
	get propString() {
		return Vo(this.path);
	}
	reject(e) {
		return this.error(e), !1;
	}
	mustBe(e) {
		return this.error(e), !1;
	}
	error(e) {
		let t = typeof e == "object" ? e.code ? e : {
			...e,
			code: "predicate"
		} : {
			code: "predicate",
			expected: e
		};
		return this.errorFromContext(t);
	}
	hasError() {
		return this.currentErrorCount !== 0;
	}
	get currentBranch() {
		return this.branches[this.branches.length - 1];
	}
	queueMorphs(e) {
		let t = {
			path: new Ho(...this.path),
			morphs: e
		};
		this.currentBranch ? this.currentBranch.queuedMorphs.push(t) : this.queuedMorphs.push(t);
	}
	finalize(e) {
		return this.queuedMorphs.length && (typeof this.root == "object" && this.root !== null && this.config.clone && (this.root = this.config.clone(this.root)), this.applyQueuedMorphs()), this.hasError() ? e ? e(this.errors) : this.errors : this.root;
	}
	get currentErrorCount() {
		return this.currentBranch ? this.currentBranch.error ? 1 : 0 : this.errors.count;
	}
	get failFast() {
		return this.branches.length !== 0;
	}
	pushBranch() {
		this.branches.push({
			error: void 0,
			queuedMorphs: []
		});
	}
	popBranch() {
		return this.branches.pop();
	}
	get external() {
		return this;
	}
	errorFromNodeContext(e) {
		return this.errorFromContext(e);
	}
	errorFromContext(e) {
		let t = new Ds(e, this);
		return this.currentBranch ? this.currentBranch.error = t : this.errors.add(t), t;
	}
	applyQueuedMorphs() {
		for (; this.queuedMorphs.length;) {
			let e = this.queuedMorphs;
			this.queuedMorphs = [];
			for (let { path: t, morphs: n } of e) this.errors.affectsPath(t) || this.applyMorphsAtPath(t, n);
		}
	}
	applyMorphsAtPath(e, t) {
		let n = e[e.length - 1], r;
		if (n !== void 0) {
			r = this.root;
			for (let t = 0; t < e.length - 1; t++) r = r[e[t]];
		}
		for (let i of t) {
			this.path = [...e];
			let t = as(i), a = i(r === void 0 ? this.root : r[n], this);
			if (a instanceof Ds) {
				this.errors.includes(a) || this.errors.add(a);
				break;
			}
			if (a instanceof Os) {
				t || this.errors.merge(a), this.queuedMorphs = [];
				break;
			}
			r === void 0 ? this.root = a : r[n] = a, this.applyQueuedMorphs();
		}
	}
}, Ms = (e, t, n) => {
	if (!n) return t();
	n.path.push(e);
	let r = t();
	return n.path.pop(), r;
}, Ns = class extends Wa {
	attachments;
	$;
	onFail;
	includesTransform;
	includesContextualPredicate;
	isCyclic;
	allowsRequiresContext;
	rootApplyStrategy;
	contextFreeMorph;
	rootApply;
	referencesById;
	shallowReferences;
	flatRefs;
	flatMorphs;
	allows;
	get shallowMorphs() {
		return [];
	}
	constructor(e, t) {
		super((e, t, n = this.onFail) => t ? (this.traverseApply(e, t), t.hasError() ? t.errors : t.data) : this.rootApply(e, n), { attach: e }), this.attachments = e, this.$ = t, this.onFail = this.meta.onFail ?? this.$.resolvedConfig.onFail, this.includesTransform = this.hasKind("morph") || this.hasKind("structure") && this.structuralMorph !== void 0 || this.hasKind("sequence") && this.inner.defaultables !== void 0, this.includesContextualPredicate = this.hasKind("predicate") && this.inner.predicate.length !== 1, this.isCyclic = this.kind === "alias", this.referencesById = { [this.id]: this }, this.shallowReferences = this.hasKind("structure") ? [this, ...this.children] : this.children.reduce((e, t) => Hs(e, t.shallowReferences), [this]);
		let n = this.isStructural();
		this.flatRefs = [], this.flatMorphs = [];
		for (let e = 0; e < this.children.length; e++) {
			if (this.includesTransform ||= this.children[e].includesTransform, this.includesContextualPredicate ||= this.children[e].includesContextualPredicate, this.isCyclic ||= this.children[e].isCyclic, !n) {
				let t = this.children[e].flatRefs;
				for (let e = 0; e < t.length; e++) {
					let n = t[e];
					if (!this.flatRefs.some((e) => Bs(e, n))) {
						this.flatRefs.push(n);
						for (let e of n.node.branches) (e.hasKind("morph") || e.hasKind("intersection") && e.structure?.structuralMorph !== void 0) && this.flatMorphs.push({
							path: n.path,
							propString: n.propString,
							node: e
						});
					}
				}
			}
			Object.assign(this.referencesById, this.children[e].referencesById);
		}
		this.flatRefs.sort((e, t) => e.path.length > t.path.length ? 1 : e.path.length < t.path.length ? -1 : e.propString > t.propString ? 1 : e.propString < t.propString || e.node.expression < t.node.expression ? -1 : 1), this.allowsRequiresContext = this.includesContextualPredicate || this.isCyclic, this.rootApplyStrategy = !this.allowsRequiresContext && this.flatMorphs.length === 0 ? this.shallowMorphs.length === 0 ? "allows" : this.shallowMorphs.every((e) => e.length === 1 || e.name === "$arkStructuralMorph") ? this.hasKind("union") ? this.branches.some((e) => e.shallowMorphs.length > 1) ? "contextual" : "branchedOptimistic" : this.shallowMorphs.length > 1 ? "contextual" : "optimistic" : "contextual" : "contextual", this.rootApply = this.createRootApply(), this.allows = this.allowsRequiresContext ? (e) => this.traverseAllows(e, new js(e, this.$.resolvedConfig)) : (e) => this.traverseAllows(e);
	}
	createRootApply() {
		switch (this.rootApplyStrategy) {
			case "allows": return (e, t) => {
				if (this.allows(e)) return e;
				let n = new js(e, this.$.resolvedConfig);
				return this.traverseApply(e, n), n.finalize(t);
			};
			case "contextual": return (e, t) => {
				let n = new js(e, this.$.resolvedConfig);
				return this.traverseApply(e, n), n.finalize(t);
			};
			case "optimistic":
				this.contextFreeMorph = this.shallowMorphs[0];
				let e = this.$.resolvedConfig.clone;
				return (t, n) => {
					if (this.allows(t)) return this.contextFreeMorph(e && (typeof t == "object" && t || typeof t == "function") ? e(t) : t);
					let r = new js(t, this.$.resolvedConfig);
					return this.traverseApply(t, r), r.finalize(n);
				};
			case "branchedOptimistic": return this.createBranchedOptimisticRootApply();
			default: return this.rootApplyStrategy, j(`Unexpected rootApplyStrategy ${this.rootApplyStrategy}`);
		}
	}
	compiledMeta = Rs(this.metaJson);
	cacheGetter(e, t) {
		return Object.defineProperty(this, e, { value: t }), t;
	}
	get description() {
		return this.cacheGetter("description", this.meta?.description ?? this.$.resolvedConfig[this.kind].description(this));
	}
	get references() {
		return Object.values(this.referencesById);
	}
	precedence = _s(this.kind);
	precompilation;
	assert = (e, t) => this(e, t, (e) => e.throw());
	traverse(e, t) {
		return this(e, t, null);
	}
	get in() {
		return this.cacheGetter("in", this.rawIn.isRoot() ? this.$.finalize(this.rawIn) : this.rawIn);
	}
	get rawIn() {
		return this.cacheGetter("rawIn", this.getIo("in"));
	}
	get out() {
		return this.cacheGetter("out", this.rawOut.isRoot() ? this.$.finalize(this.rawOut) : this.rawOut);
	}
	get rawOut() {
		return this.cacheGetter("rawOut", this.getIo("out"));
	}
	getIo(e) {
		if (!this.includesTransform) return this;
		let t = {};
		for (let [n, r] of this.innerEntries) {
			let i = this.impl.keys[n];
			if (i.reduceIo) i.reduceIo(e, t, r);
			else if (i.child) {
				let i = r;
				t[n] = P(i) ? i.map((t) => e === "in" ? t.rawIn : t.rawOut) : e === "in" ? i.rawIn : i.rawOut;
			} else t[n] = r;
		}
		return this.$.node(this.kind, t);
	}
	toJSON() {
		return this.json;
	}
	toString() {
		return `Type<${this.expression}>`;
	}
	equals(e) {
		let t = as(e) ? e : this.$.parseDefinition(e);
		return this.innerHash === t.innerHash;
	}
	ifEquals(e) {
		return this.equals(e) ? this : void 0;
	}
	hasKind(e) {
		return this.kind === e;
	}
	assertHasKind(e) {
		return this.kind !== e && la(`${this.kind} node was not of asserted kind ${e}`), this;
	}
	hasKindIn(...e) {
		return e.includes(this.kind);
	}
	assertHasKindIn(...e) {
		return Zi(e, this.kind) || la(`${this.kind} node was not one of asserted kinds ${e}`), this;
	}
	isBasis() {
		return Zi(os, this.kind);
	}
	isConstraint() {
		return Zi(us, this.kind);
	}
	isStructural() {
		return Zi(ss, this.kind);
	}
	isRefinement() {
		return Zi(ls, this.kind);
	}
	isRoot() {
		return Zi(ds, this.kind);
	}
	isUnknown() {
		return this.hasKind("intersection") && this.children.length === 0;
	}
	isNever() {
		return this.hasKind("union") && this.children.length === 0;
	}
	hasUnit(e) {
		return this.hasKind("unit") && this.allows(e);
	}
	hasOpenIntersection() {
		return this.impl.intersectionIsOpen;
	}
	get nestableExpression() {
		return this.expression;
	}
	select(e) {
		let t = Ps.normalize(e);
		return this._select(t);
	}
	_select(e) {
		let t = Ps.applyBoundary[e.boundary ?? "references"](this);
		return e.kind && (t = t.filter((t) => t.kind === e.kind)), e.where && (t = t.filter(e.where)), Ps.applyMethod[e.method ?? "filter"](t, this, e);
	}
	transform(e, t) {
		return this._transform(e, this._createTransformContext(t));
	}
	_createTransformContext(e) {
		return {
			root: this,
			selected: void 0,
			seen: {},
			path: [],
			parseOptions: { prereduced: e?.prereduced ?? !1 },
			undeclaredKeyHandling: void 0,
			...e
		};
	}
	_transform(e, t) {
		let n = t.bindScope ?? this.$;
		if (t.seen[this.id]) return this.$.lazilyResolve(t.seen[this.id]);
		if (t.shouldTransform?.(this, t) === !1) return this;
		let r;
		t.seen[this.id] = () => r, this.hasKind("structure") && this.undeclared !== t.undeclaredKeyHandling && (t = {
			...t,
			undeclaredKeyHandling: this.undeclared
		});
		let i = N(this.inner, (n, r) => {
			if (!this.impl.keys[n].child) return [n, r];
			let i = r;
			if (!P(i)) {
				let r = i._transform(e, t);
				return r ? [n, r] : [];
			}
			if (i.length === 0) return [n, r];
			let a = i.flatMap((n) => n._transform(e, t) ?? []);
			return a.length ? [n, a] : [];
		});
		delete t.seen[this.id];
		let a = Object.assign(i, { meta: this.meta }), o = t.selected && !t.selected.includes(this) ? a : e(this.kind, a, t);
		if (o === null) return null;
		if (as(o)) return r = o;
		let s = Object.keys(o);
		return (s.length === 0 || s.length === 1 && s[0] === "meta") && !ba(this.inner) ? null : (this.kind === "required" || this.kind === "optional" || this.kind === "index") && !("value" in o) ? t.undeclaredKeyHandling ? {
			...o,
			value: I.intrinsic.unknown
		} : null : (this.kind === "morph" && (o.in ??= I.intrinsic.unknown), r = n.node(this.kind, o, t.parseOptions));
	}
	configureReferences(e, t = "references") {
		let n = Ps.normalize(t), r = typeof e == "string" ? (t, n) => ({
			...n,
			meta: {
				...n.meta,
				description: e
			}
		}) : typeof e == "function" ? (t, n) => ({
			...n,
			meta: e(n.meta)
		}) : (t, n) => ({
			...n,
			meta: {
				...n.meta,
				...e
			}
		});
		if (n.boundary === "self") return this.$.node(this.kind, r(this.kind, {
			...this.inner,
			meta: this.meta
		}));
		let i = this._select(n), a = i && Ji(i), o = n.boundary === "child" ? (e, t) => t.root.children.includes(e) : n.boundary === "shallow" ? (e) => e.kind !== "structure" : () => !0;
		return this.$.finalize(this.transform(r, {
			shouldTransform: o,
			selected: a
		}));
	}
}, Ps = {
	applyBoundary: {
		self: (e) => [e],
		child: (e) => [...e.children],
		shallow: (e) => [...e.shallowReferences],
		references: (e) => [...e.references]
	},
	applyMethod: {
		filter: (e) => e,
		assertFilter: (e, t, n) => (e.length === 0 && la(Fs(t, n)), e),
		find: (e) => e[0],
		assertFind: (e, t, n) => (e.length === 0 && la(Fs(t, n)), e[0])
	},
	normalize: (e) => typeof e == "function" ? {
		boundary: "references",
		method: "filter",
		where: e
	} : typeof e == "string" ? pa(e, Ps.applyBoundary) ? {
		method: "filter",
		boundary: e
	} : {
		boundary: "references",
		method: "filter",
		kind: e
	} : {
		boundary: "references",
		method: "filter",
		...e
	}
}, Fs = (e, t) => `${e} had no references matching ${F(t)}.`, Is = (e) => Vo(e, { stringifyNonKey: (e) => e.expression }), Ls = /"(\$ark\.[^"]+)"/g, Rs = (e) => JSON.stringify(e).replace(Ls, "$1"), zs = (e, t) => ({
	path: e,
	node: t,
	propString: Is(e)
}), Bs = (e, t) => e.propString === t.propString && e.node.equals(t.node), Vs = (e, t) => ta(e, t, { isEqual: Bs }), Hs = (e, t) => ta(e, t, { isEqual: (e, t) => e.equals(t) }), B = class e extends Array {
	static init(t, n, r, i) {
		return new e({
			kind: t,
			l: n,
			r,
			path: i?.path ?? [],
			optional: i?.optional ?? !1
		});
	}
	add(e, t, n, r) {
		return this.push({
			kind: e,
			l: t,
			r: n,
			path: r?.path ?? [],
			optional: r?.optional ?? !1
		}), this;
	}
	get summary() {
		return this.describeReasons();
	}
	describeReasons() {
		if (this.length === 1) {
			let { path: e, l: t, r: n } = this[0], r = Vo(e);
			return Gs(`Intersection${r && ` at ${r}`} of ${Us(t, n)}`);
		}
		return `The following intersections result in unsatisfiable types:\n• ${this.map(({ path: e, l: t, r: n }) => `${e}: ${Us(t, n)}`).join("\n• ")}`;
	}
	throw() {
		return M(this.describeReasons());
	}
	invert() {
		let t = this.map((e) => ({
			...e,
			l: e.r,
			r: e.l
		}));
		return t instanceof e ? t : new e(...t);
	}
	withPrefixKey(e, t) {
		return this.map((n) => ({
			...n,
			path: [e, ...n.path],
			optional: n.optional || t === "optional"
		}));
	}
	toNeverIfDisjoint() {
		return I.intrinsic.never;
	}
}, Us = (e, t) => `${Ws(e)} and ${Ws(t)}`, Ws = (e) => as(e) ? e.expression : P(e) ? e.map(Ws).join(" | ") || "never" : String(e), Gs = (e) => `${e} results in an unsatisfiable type`, Ks = {}, qs = (e, t, n) => V(e, t, {
	$: n,
	invert: !1,
	pipe: !1
}), Js = (e, t, n) => V(e, t, {
	$: n,
	invert: !1,
	pipe: !0
}), V = ((e, t, n) => {
	let r = n.pipe ? "|>" : "&", i = `${e.hash}${r}${t.hash}`;
	if (Ks[i] !== void 0) return Ks[i];
	if (!n.pipe) {
		let n = `${t.hash}${r}${e.hash}`;
		if (Ks[n] !== void 0) {
			let e = Ks[n], t = e instanceof B ? e.invert() : e;
			return Ks[i] = t, t;
		}
	}
	let a = !n.pipe || !e.includesTransform && !t.includesTransform;
	if (a && e.equals(t)) return e;
	let o = a ? Ys(e, t, n) : e.hasKindIn(...ds) ? Xs(e, t, n) : Ys(e, t, n);
	return as(o) && (e.equals(o) ? o = e : t.equals(o) && (o = t)), Ks[i] = o, o;
}), Ys = (e, t, n) => {
	let r = e.precedence < t.precedence ? e.kind : t.kind, i = e.impl.intersections[t.kind] ?? t.impl.intersections[e.kind];
	if (i === void 0) return null;
	if (r === e.kind) return i(e, t, n);
	{
		let r = i(t, e, {
			...n,
			invert: !n.invert
		});
		return r instanceof B && (r = r.invert()), r;
	}
}, Xs = (e, t, n) => e.includesTransform || t.includesTransform ? n.invert ? Zs(t, e, n) : Zs(e, t, n) : Ys(e, t, n), Zs = (e, t, n) => e.distribute((e) => Qs(e, t, n), (r) => {
	let i = r.filter(as);
	if (i.length === 0) return B.init("union", e.branches, t.branches);
	if (i.length < e.branches.length || !e.branches.every((e, t) => e.rawIn.equals(i[t].rawIn))) return n.$.parseSchema(i);
	if (i.length === 1) return i[0];
	let a = { branches: i };
	return n.$.parseSchema(a);
}), Qs = (e, t, n) => {
	if (e.hasKind("morph")) {
		let r = [...e.morphs];
		if (e.lastMorphIfNode) {
			let i = V(e.lastMorphIfNode, t, n);
			if (i instanceof B) return i;
			r[r.length - 1] = i;
		} else r.push(t);
		return n.$.node("morph", {
			morphs: r,
			in: e.inner.in
		});
	}
	if (t.hasKind("morph")) {
		let r = V(e, t.rawIn, n);
		return r instanceof B ? r : n.$.node("morph", {
			morphs: [t],
			in: r
		});
	}
	return n.$.node("morph", {
		morphs: [t],
		in: e
	});
}, $s = class extends Ns {
	constructor(e, t) {
		super(e, t), Object.defineProperty(this, is, {
			value: "constraint",
			enumerable: !1
		});
	}
	impliedSiblings;
	intersect(e) {
		return qs(this, e, this.$);
	}
}, ec = class extends $s {
	traverseApply = (e, t) => {
		this.traverseAllows(e, t) || t.errorFromNodeContext(this.errorContext);
	};
	compile(e) {
		e.traversalKind === "Allows" ? e.return(this.compiledCondition) : e.if(this.compiledNegation, () => e.line(`ctx.errorFromNodeContext(${this.compiledErrorContext})`));
	}
	get errorContext() {
		return {
			code: this.kind,
			description: this.description,
			meta: this.meta,
			...this.inner
		};
	}
	get compiledErrorContext() {
		return bs(this.errorContext);
	}
}, tc = (e) => (t, n) => {
	if (P(t)) {
		if (t.length === 0) return;
		let r = t.map((t) => n.$.node(e, t));
		return e === "predicate" ? r : r.sort((e, t) => e.hash < t.hash ? -1 : 1);
	}
	let r = n.$.node(e, t);
	return r.hasOpenIntersection() ? [r] : r;
}, nc = (e) => {
	let t = e.r.shift();
	if (!t) {
		let t = e.l.length === 0 && e.kind === "structure" ? I.intrinsic.unknown.internal : e.ctx.$.node(e.kind, Object.assign(e.baseInner, ic(e.l)), { prereduced: !0 });
		for (let n of e.roots) {
			if (t instanceof B) return t;
			t = V(n, t, e.ctx);
		}
		return t;
	}
	let n = !1;
	for (let r = 0; r < e.l.length; r++) {
		let i = V(e.l[r], t, e.ctx);
		if (i !== null) {
			if (i instanceof B) return i;
			if (i.isRoot()) return e.roots.push(i), e.l.splice(r), nc(e);
			if (!n) e.l[r] = i, n = !0;
			else if (!e.l.includes(i)) return j(`Unexpectedly encountered multiple distinct intersection results for refinement ${t}`);
		}
	}
	if (n || e.l.push(t), e.kind === "intersection" && t.impliedSiblings) for (let n of t.impliedSiblings) ta(e.r, n);
	return nc(e);
}, rc = (e) => Object.entries(e).flatMap(([e, t]) => e in ps ? t : []).sort((e, t) => e.precedence < t.precedence ? -1 : e.precedence > t.precedence ? 1 : e.kind === "predicate" && t.kind === "predicate" ? 0 : e.hash < t.hash ? -1 : 1), ic = (e) => {
	let t = {};
	for (let n of e) if (n.hasOpenIntersection()) t[n.kind] = A(t[n.kind], n);
	else {
		if (t[n.kind]) return j(`Unexpected intersection of closed refinements of kind ${n.kind}`);
		t[n.kind] = n;
	}
	return t;
}, ac = (...e) => M(oc(...e)), oc = (e, t, n) => {
	let r = n.hasKind("morph") ? "a morph" : n.isUnknown() ? "unknown" : n.exclude(t).defaultShortDescription;
	return `${Ja(e)} operand must be ${t.description} (was ${r})`;
}, sc = (e, t, n) => new lc(e, t, n, n, null), cc = class extends Wa {}, lc = class extends Wa {
	[is] = "generic";
	paramDefs;
	bodyDef;
	$;
	arg$;
	baseInstantiation;
	hkt;
	description;
	constructor(e, t, n, r, i) {
		super((...e) => {
			let n = N(this.names, (t, n) => {
				let r = this.arg$.parse(e[t]);
				return r.extends(this.constraints[t]) || M(uc(n, this.constraints[t].expression, r.expression)), [n, r];
			});
			if (this.defIsLazy()) {
				let e = this.bodyDef(n);
				return this.$.parse(e);
			}
			return this.$.parse(t, { args: n });
		}), this.paramDefs = e, this.bodyDef = t, this.$ = n, this.arg$ = r, this.hkt = i, this.description = i ? new i().description ?? `a generic type for ${i.constructor.name}` : "a generic type", this.baseInstantiation = this(...this.constraints);
	}
	defIsLazy() {
		return this.bodyDef instanceof cc;
	}
	cacheGetter(e, t) {
		return Object.defineProperty(this, e, { value: t }), t;
	}
	get json() {
		return this.cacheGetter("json", {
			params: this.params.map((e) => e[1].isUnknown() ? e[0] : [e[0], e[1].json]),
			body: Mo(this.bodyDef)
		});
	}
	get params() {
		return this.cacheGetter("params", this.paramDefs.map((e) => typeof e == "string" ? [e, I.intrinsic.unknown] : [e[0], this.$.parse(e[1])]));
	}
	get names() {
		return this.cacheGetter("names", this.params.map((e) => e[0]));
	}
	get constraints() {
		return this.cacheGetter("constraints", this.params.map((e) => e[1]));
	}
	get internal() {
		return this;
	}
	get referencesById() {
		return this.baseInstantiation.internal.referencesById;
	}
	get references() {
		return this.baseInstantiation.internal.references;
	}
}, uc = (e, t, n) => `${e} must be assignable to ${t} (was ${n})`, dc = {
	implementation: R({
		kind: "predicate",
		hasAssociatedError: !0,
		collapsibleKey: "predicate",
		keys: { predicate: {} },
		normalize: (e) => typeof e == "function" ? { predicate: e } : e,
		defaults: { description: (e) => `valid according to ${e.predicate.name || "an anonymous predicate"}` },
		intersectionIsOpen: !0,
		intersections: { predicate: () => null }
	}),
	Node: class extends $s {
		serializedPredicate = Xo(this.predicate);
		compiledCondition = `${this.serializedPredicate}(data, ctx)`;
		compiledNegation = `!${this.compiledCondition}`;
		impliedBasis = null;
		expression = this.serializedPredicate;
		traverseAllows = this.predicate;
		errorContext = {
			code: "predicate",
			description: this.description,
			meta: this.meta
		};
		compiledErrorContext = bs(this.errorContext);
		traverseApply = (e, t) => {
			let n = t.currentErrorCount;
			!this.predicate(e, t.external) && t.currentErrorCount === n && t.errorFromNodeContext(this.errorContext);
		};
		compile(e) {
			if (e.traversalKind === "Allows") {
				e.return(this.compiledCondition);
				return;
			}
			e.initializeErrorCount(), e.if(`${this.compiledNegation} && ctx.currentErrorCount === errorCount`, () => e.line(`ctx.errorFromNodeContext(${this.compiledErrorContext})`));
		}
		reduceJsonSchema(e, t) {
			return t.fallback.predicate({
				code: "predicate",
				base: e,
				predicate: this.predicate
			});
		}
	}
}, fc = {
	implementation: R({
		kind: "divisor",
		collapsibleKey: "rule",
		keys: { rule: { parse: (e) => Number.isInteger(e) ? e : M(pc(e)) } },
		normalize: (e) => typeof e == "number" ? { rule: e } : e,
		hasAssociatedError: !0,
		defaults: { description: (e) => e.rule === 1 ? "an integer" : e.rule === 2 ? "even" : `a multiple of ${e.rule}` },
		intersections: { divisor: (e, t, n) => n.$.node("divisor", { rule: Math.abs(e.rule * t.rule / mc(e.rule, t.rule)) }) },
		obviatesBasisDescription: !0
	}),
	Node: class extends ec {
		traverseAllows = (e) => e % this.rule === 0;
		compiledCondition = `data % ${this.rule} === 0`;
		compiledNegation = `data % ${this.rule} !== 0`;
		impliedBasis = I.intrinsic.number.internal;
		expression = `% ${this.rule}`;
		reduceJsonSchema(e) {
			return e.type = "integer", this.rule === 1 || (e.multipleOf = this.rule), e;
		}
	}
}, pc = (e) => `divisor must be an integer (was ${e})`, mc = (e, t) => {
	let n, r = e, i = t;
	for (; i !== 0;) n = i, i = r % i, r = n;
	return r;
}, hc = class extends ec {
	boundOperandKind = wc[this.kind];
	compiledActual = this.boundOperandKind === "value" ? "data" : this.boundOperandKind === "length" ? "data.length" : "data.valueOf()";
	comparator = Tc(this.kind, this.exclusive);
	numericLimit = this.rule.valueOf();
	expression = `${this.comparator} ${this.rule}`;
	compiledCondition = `${this.compiledActual} ${this.comparator} ${this.numericLimit}`;
	compiledNegation = `${this.compiledActual} ${gc[this.comparator]} ${this.numericLimit}`;
	stringLimit = this.boundOperandKind === "date" ? Ec(this.numericLimit) : `${this.numericLimit}`;
	limitKind = this.comparator[0] === "<" ? "upper" : "lower";
	isStricterThan(e) {
		return (this.limitKind === "upper" ? this.numericLimit < e.numericLimit : this.numericLimit > e.numericLimit) || this.numericLimit === e.numericLimit && this.exclusive === !0 && !e.exclusive;
	}
	overlapsRange(e) {
		return !(this.isStricterThan(e) || this.numericLimit === e.numericLimit && (this.exclusive || e.exclusive));
	}
	overlapIsUnit(e) {
		return this.numericLimit === e.numericLimit && !this.exclusive && !e.exclusive;
	}
}, gc = {
	"<": ">=",
	"<=": ">",
	">": "<=",
	">=": "<"
}, _c = {
	min: "max",
	minLength: "maxLength",
	after: "before"
}, vc = { parse: (e) => e || void 0 }, yc = (e) => (t) => {
	if (typeof t == "number") return { rule: t };
	let { exclusive: n, ...r } = t;
	return n ? {
		...r,
		rule: e === "minLength" ? r.rule + 1 : r.rule - 1
	} : r;
}, bc = (e) => (t) => {
	if (typeof t == "number" || typeof t == "string" || t instanceof Date) return { rule: t };
	let { exclusive: n, ...r } = t;
	if (!n) return r;
	let i = typeof r.rule == "number" ? r.rule : typeof r.rule == "string" ? new Date(r.rule).valueOf() : r.rule.valueOf();
	return n ? {
		...r,
		rule: e === "after" ? i + 1 : i - 1
	} : r;
}, xc = (e) => typeof e == "string" || typeof e == "number" ? new Date(e) : e, Sc = (e, t) => `${e} bound must be a positive integer (was ${t})`, Cc = (e) => (t) => ((!Number.isInteger(t) || t < 0) && M(Sc(e, t)), t), wc = {
	min: "value",
	max: "value",
	minLength: "length",
	maxLength: "length",
	after: "date",
	before: "date"
}, Tc = (e, t) => `${pa(e, _c) ? ">" : "<"}${t ? "" : "="}`, Ec = (e) => typeof e == "string" ? e : new Date(e).toLocaleString(), Dc = (e) => `Bounded expression ${e} must be exactly one of number, string, Array, or Date`, Oc = {
	implementation: R({
		kind: "after",
		collapsibleKey: "rule",
		hasAssociatedError: !0,
		keys: { rule: {
			parse: xc,
			serialize: (e) => e.toISOString()
		} },
		normalize: bc("after"),
		defaults: {
			description: (e) => `${e.collapsibleLimitString} or later`,
			actual: Io
		},
		intersections: { after: (e, t) => e.isStricterThan(t) ? e : t }
	}),
	Node: class extends hc {
		impliedBasis = I.intrinsic.Date.internal;
		collapsibleLimitString = Io(this.rule);
		traverseAllows = (e) => e >= this.rule;
		reduceJsonSchema(e, t) {
			return t.fallback.date({
				code: "date",
				base: e,
				after: this.rule
			});
		}
	}
}, kc = {
	implementation: R({
		kind: "before",
		collapsibleKey: "rule",
		hasAssociatedError: !0,
		keys: { rule: {
			parse: xc,
			serialize: (e) => e.toISOString()
		} },
		normalize: bc("before"),
		defaults: {
			description: (e) => `${e.collapsibleLimitString} or earlier`,
			actual: Io
		},
		intersections: {
			before: (e, t) => e.isStricterThan(t) ? e : t,
			after: (e, t, n) => e.overlapsRange(t) ? e.overlapIsUnit(t) ? n.$.node("unit", { unit: e.rule }) : null : B.init("range", e, t)
		}
	}),
	Node: class extends hc {
		collapsibleLimitString = Io(this.rule);
		traverseAllows = (e) => e <= this.rule;
		impliedBasis = I.intrinsic.Date.internal;
		reduceJsonSchema(e, t) {
			return t.fallback.date({
				code: "date",
				base: e,
				before: this.rule
			});
		}
	}
}, Ac = {
	implementation: R({
		kind: "exactLength",
		collapsibleKey: "rule",
		keys: { rule: { parse: Cc("exactLength") } },
		normalize: (e) => typeof e == "number" ? { rule: e } : e,
		hasAssociatedError: !0,
		defaults: {
			description: (e) => `exactly length ${e.rule}`,
			actual: (e) => `${e.length}`
		},
		intersections: {
			exactLength: (e, t, n) => B.init("unit", n.$.node("unit", { unit: e.rule }), n.$.node("unit", { unit: t.rule }), { path: ["length"] }),
			minLength: (e, t) => e.rule >= t.rule ? e : B.init("range", e, t),
			maxLength: (e, t) => e.rule <= t.rule ? e : B.init("range", e, t)
		}
	}),
	Node: class extends ec {
		traverseAllows = (e) => e.length === this.rule;
		compiledCondition = `data.length === ${this.rule}`;
		compiledNegation = `data.length !== ${this.rule}`;
		impliedBasis = I.intrinsic.lengthBoundable.internal;
		expression = `== ${this.rule}`;
		reduceJsonSchema(e) {
			switch (e.type) {
				case "string": return e.minLength = this.rule, e.maxLength = this.rule, e;
				case "array": return e.minItems = this.rule, e.maxItems = this.rule, e;
				default: return z.throwInternalOperandError("exactLength", e);
			}
		}
	}
}, jc = {
	implementation: R({
		kind: "max",
		collapsibleKey: "rule",
		hasAssociatedError: !0,
		keys: {
			rule: {},
			exclusive: vc
		},
		normalize: (e) => typeof e == "number" ? { rule: e } : e,
		defaults: { description: (e) => e.rule === 0 ? e.exclusive ? "negative" : "non-positive" : `${e.exclusive ? "less than" : "at most"} ${e.rule}` },
		intersections: {
			max: (e, t) => e.isStricterThan(t) ? e : t,
			min: (e, t, n) => e.overlapsRange(t) ? e.overlapIsUnit(t) ? n.$.node("unit", { unit: e.rule }) : null : B.init("range", e, t)
		},
		obviatesBasisDescription: !0
	}),
	Node: class extends hc {
		impliedBasis = I.intrinsic.number.internal;
		traverseAllows = this.exclusive ? (e) => e < this.rule : (e) => e <= this.rule;
		reduceJsonSchema(e) {
			return this.exclusive ? e.exclusiveMaximum = this.rule : e.maximum = this.rule, e;
		}
	}
}, Mc = {
	implementation: R({
		kind: "maxLength",
		collapsibleKey: "rule",
		hasAssociatedError: !0,
		keys: { rule: { parse: Cc("maxLength") } },
		reduce: (e, t) => e.rule === 0 ? t.node("exactLength", e) : void 0,
		normalize: yc("maxLength"),
		defaults: {
			description: (e) => `at most length ${e.rule}`,
			actual: (e) => `${e.length}`
		},
		intersections: {
			maxLength: (e, t) => e.isStricterThan(t) ? e : t,
			minLength: (e, t, n) => e.overlapsRange(t) ? e.overlapIsUnit(t) ? n.$.node("exactLength", { rule: e.rule }) : null : B.init("range", e, t)
		}
	}),
	Node: class extends hc {
		impliedBasis = I.intrinsic.lengthBoundable.internal;
		traverseAllows = (e) => e.length <= this.rule;
		reduceJsonSchema(e) {
			switch (e.type) {
				case "string": return e.maxLength = this.rule, e;
				case "array": return e.maxItems = this.rule, e;
				default: return z.throwInternalOperandError("maxLength", e);
			}
		}
	}
}, Nc = {
	implementation: R({
		kind: "min",
		collapsibleKey: "rule",
		hasAssociatedError: !0,
		keys: {
			rule: {},
			exclusive: vc
		},
		normalize: (e) => typeof e == "number" ? { rule: e } : e,
		defaults: { description: (e) => e.rule === 0 ? e.exclusive ? "positive" : "non-negative" : `${e.exclusive ? "more than" : "at least"} ${e.rule}` },
		intersections: { min: (e, t) => e.isStricterThan(t) ? e : t },
		obviatesBasisDescription: !0
	}),
	Node: class extends hc {
		impliedBasis = I.intrinsic.number.internal;
		traverseAllows = this.exclusive ? (e) => e > this.rule : (e) => e >= this.rule;
		reduceJsonSchema(e) {
			return this.exclusive ? e.exclusiveMinimum = this.rule : e.minimum = this.rule, e;
		}
	}
}, Pc = {
	implementation: R({
		kind: "minLength",
		collapsibleKey: "rule",
		hasAssociatedError: !0,
		keys: { rule: { parse: Cc("minLength") } },
		reduce: (e) => e.rule === 0 ? I.intrinsic.unknown : void 0,
		normalize: yc("minLength"),
		defaults: {
			description: (e) => e.rule === 1 ? "non-empty" : `at least length ${e.rule}`,
			actual: (e) => e.length === 0 ? "" : `${e.length}`
		},
		intersections: { minLength: (e, t) => e.isStricterThan(t) ? e : t }
	}),
	Node: class extends hc {
		impliedBasis = I.intrinsic.lengthBoundable.internal;
		traverseAllows = (e) => e.length >= this.rule;
		reduceJsonSchema(e) {
			switch (e.type) {
				case "string": return e.minLength = this.rule, e;
				case "array": return e.minItems = this.rule, e;
				default: return z.throwInternalOperandError("minLength", e);
			}
		}
	}
}, Fc = {
	min: Nc.implementation,
	max: jc.implementation,
	minLength: Pc.implementation,
	maxLength: Mc.implementation,
	exactLength: Ac.implementation,
	after: Oc.implementation,
	before: kc.implementation
}, Ic = {
	min: Nc.Node,
	max: jc.Node,
	minLength: Pc.Node,
	maxLength: Mc.Node,
	exactLength: Ac.Node,
	after: Oc.Node,
	before: kc.Node
}, Lc = {
	implementation: R({
		kind: "pattern",
		collapsibleKey: "rule",
		keys: {
			rule: {},
			flags: {}
		},
		normalize: (e) => typeof e == "string" ? { rule: e } : e instanceof RegExp ? e.flags ? {
			rule: e.source,
			flags: e.flags
		} : { rule: e.source } : e,
		obviatesBasisDescription: !0,
		obviatesBasisExpression: !0,
		hasAssociatedError: !0,
		intersectionIsOpen: !0,
		defaults: { description: (e) => `matched by ${e.rule}` },
		intersections: { pattern: () => null }
	}),
	Node: class extends ec {
		instance = new RegExp(this.rule, this.flags);
		expression = `${this.instance}`;
		traverseAllows = this.instance.test.bind(this.instance);
		compiledCondition = `${this.expression}.test(data)`;
		compiledNegation = `!${this.compiledCondition}`;
		impliedBasis = I.intrinsic.string.internal;
		reduceJsonSchema(e, t) {
			return e.pattern ? t.fallback.patternIntersection({
				code: "patternIntersection",
				base: e,
				pattern: this.rule
			}) : (e.pattern = this.rule, e);
		}
	}
}, Rc = (e, t) => {
	let n = zc(e);
	return t && !t.includes(n) ? M(`Root of kind ${n} should be one of ${t}`) : n;
}, zc = (e) => {
	if (L(e, "root")) return e.kind;
	if (typeof e == "string") return e[0] === "$" ? "alias" : e in oa ? "domain" : "proto";
	if (typeof e == "function") return "proto";
	if (typeof e != "object" || !e) return M(Bc(e));
	if ("morphs" in e) return "morph";
	if ("branches" in e || P(e)) return "union";
	if ("unit" in e) return "unit";
	if ("reference" in e) return "alias";
	let t = Object.keys(e);
	return t.length === 0 || t.some((e) => e in ps) ? "intersection" : "proto" in e ? "proto" : "domain" in e ? "domain" : M(Bc(e));
}, Bc = (e) => `${F(e)} is not a valid type schema`, Vc = {}, Hc = (e) => P(e) ? e.map((e) => e.collapsibleJson) : e.collapsibleJson, Uc = {};
I.nodesByRegisteredId = Uc;
var Wc = (e) => (Vc[e] ??= 0, `${e}${++Vc[e]}`), Gc = (e) => {
	let t = Au[e.kind], n = t.applyConfig?.(e.def, e.$.resolvedConfig) ?? e.def, r = {}, { meta: i, ...a } = n, o = i === void 0 ? {} : typeof i == "string" ? { description: i } : i, s = fa(a).sort(([e], [t]) => gs(e) ? gs(t) ? _s(e) - _s(t) : 1 : gs(t) || e < t ? -1 : 1).filter(([e, t]) => {
		if (e.startsWith("meta.")) {
			let n = e.slice(5);
			return o[n] = t, !1;
		}
		return !0;
	});
	for (let n of s) {
		let i = n[0], a = t.keys[i];
		if (!a) return M(`Key ${i} is not valid on ${e.kind} schema`);
		let o = a.parse ? a.parse(n[1], e) : n[1];
		o !== wa && (o !== void 0 || a.preserveUndefined) && (r[i] = o);
	}
	if (t.reduce && !e.prereduced) {
		let n = t.reduce(r, e.$);
		if (n) return n instanceof B ? n.throw() : Jc(n, o);
	}
	return Kc({
		id: e.id,
		kind: e.kind,
		inner: r,
		meta: o,
		$: e.$
	});
}, Kc = ({ id: e, kind: t, inner: n, meta: r, $: i, ignoreCache: a }) => {
	let o = Au[t], s = fa(n), c = [], l = {};
	for (let [e, t] of s) {
		let n = o.keys[e], r = n.serialize ?? (n.child ? Hc : ys);
		if (l[e] = r(t), n.child === !0) {
			let e = t;
			P(e) ? c.push(...e) : c.push(e);
		} else typeof n.child == "function" && c.push(...n.child(t));
	}
	o.finalizeInnerJson && (l = o.finalizeInnerJson(l));
	let u = { ...l }, d = {};
	ba(r) || (d = N(r, (e, t) => [e, e === "examples" ? t : ys(t)]), u.meta = Yc(d, "description", !0)), l = Yc(l, o.collapsibleKey, !1);
	let f = JSON.stringify({
		kind: t,
		...l
	});
	u = Yc(u, o.collapsibleKey, !1);
	let p = Yc(u, o.collapsibleKey, !0), m = JSON.stringify({
		kind: t,
		...u
	});
	if (i.nodesByHash[m] && !a) return i.nodesByHash[m];
	let h = {
		id: e,
		kind: t,
		impl: o,
		inner: n,
		innerEntries: s,
		innerJson: l,
		innerHash: f,
		meta: r,
		metaJson: d,
		json: u,
		hash: m,
		collapsibleJson: p,
		children: c
	};
	if (t !== "intersection") for (let e in n) e !== "in" && e !== "out" && (h[e] = n[e]);
	let g = new ju[t](h, i);
	return i.nodesByHash[m] = g;
}, qc = (e, t) => e.id === t ? e : (as(Uc[t]) && j(`Unexpected attempt to overwrite node id ${t}`), Kc({
	id: t,
	kind: e.kind,
	inner: e.inner,
	meta: e.meta,
	$: e.$,
	ignoreCache: !0
})), Jc = (e, t, n) => (n && as(Uc[n]) && j(`Unexpected attempt to overwrite node id ${n}`), Kc({
	id: n ?? Wc(t.alias ?? e.kind),
	kind: e.kind,
	inner: e.inner,
	meta: t,
	$: e.$
})), Yc = (e, t, n) => {
	let r = Object.keys(e);
	if (r.length === 1 && r[0] === t) {
		let r = e[t];
		if (n || ia(r, "object") && (Object.keys(r).length === 1 || Array.isArray(r))) return r;
	}
	return e;
}, Xc = (e, t, n) => {
	if (e.key !== t.key) return null;
	let r = e.key, i = V(e.value, t.value, n), a = e.required || t.required ? "required" : "optional";
	if (i instanceof B) if (a === "optional") i = I.intrinsic.never.internal;
	else return i.withPrefixKey(e.key, e.required && t.required ? "required" : "optional");
	if (a === "required") return n.$.node("required", {
		key: r,
		value: i
	});
	let o = e.hasDefault() ? t.hasDefault() ? e.default === t.default ? e.default : M(Qc(e.default, t.default)) : e.default : t.hasDefault() ? t.default : wa;
	return n.$.node("optional", {
		key: r,
		value: i,
		default: o
	});
}, Zc = class extends $s {
	required = this.kind === "required";
	optional = this.kind === "optional";
	impliedBasis = I.intrinsic.object.internal;
	serializedKey = Qo(this.key);
	compiledKey = typeof this.key == "string" ? this.key : this.serializedKey;
	flatRefs = A(this.value.flatRefs.map((e) => zs([this.key, ...e.path], e.node)), zs([this.key], this.value));
	_transform(e, t) {
		t.path.push(this.key);
		let n = super._transform(e, t);
		return t.path.pop(), n;
	}
	hasDefault() {
		return "default" in this.inner;
	}
	traverseAllows = (e, t) => this.key in e ? Ms(this.key, () => this.value.traverseAllows(e[this.key], t), t) : this.optional;
	traverseApply = (e, t) => {
		this.key in e ? Ms(this.key, () => this.value.traverseApply(e[this.key], t), t) : this.hasKind("required") && t.errorFromNodeContext(this.errorContext);
	};
	compile(e) {
		e.if(`${this.serializedKey} in data`, () => e.traverseKey(this.serializedKey, `data${e.prop(this.key)}`, this.value)), this.hasKind("required") && e.else(() => e.traversalKind === "Apply" ? e.line(`ctx.errorFromNodeContext(${this.compiledErrorContext})`) : e.return(!1)), e.traversalKind === "Allows" && e.return(!0);
	}
}, Qc = (e, t) => `Invalid intersection of default values ${F(e)} & ${F(t)}`, $c = {
	implementation: R({
		kind: "optional",
		hasAssociatedError: !1,
		intersectionIsOpen: !0,
		keys: {
			key: {},
			value: {
				child: !0,
				parse: (e, t) => t.$.parseSchema(e)
			},
			default: { preserveUndefined: !0 }
		},
		normalize: (e) => e,
		reduce: (e, t) => {
			if (t.resolvedConfig.exactOptionalPropertyTypes === !1 && !e.value.allows(void 0)) return t.node("optional", {
				...e,
				value: e.value.or(U.undefined)
			}, { prereduced: !0 });
		},
		defaults: { description: (e) => `${e.compiledKey}?: ${e.value.description}` },
		intersections: { optional: Xc }
	}),
	Node: class extends Zc {
		constructor(...e) {
			super(...e), "default" in this.inner && rl(this.value, this.inner.default, this.key);
		}
		get rawIn() {
			let e = super.rawIn;
			return this.hasDefault() ? this.$.node("optional", ya(e.inner, { default: !0 }), { prereduced: !0 }) : e;
		}
		get outProp() {
			if (!this.hasDefault()) return this;
			let { default: e, ...t } = this.inner;
			return this.cacheGetter("outProp", this.$.node("required", t, { prereduced: !0 }));
		}
		expression = this.hasDefault() ? `${this.compiledKey}: ${this.value.expression} = ${F(this.inner.default)}` : `${this.compiledKey}?: ${this.value.expression}`;
		defaultValueMorph = tl(this);
		defaultValueMorphRef = this.defaultValueMorph && Xo(this.defaultValueMorph);
	}
}, el = {}, tl = (e) => {
	if (!e.hasDefault()) return;
	let t = `{${e.compiledKey}: ${e.value.id} = ${ys(e.default)}}`;
	return el[t] ??= nl(e.key, e.value, e.default);
}, nl = (e, t, n) => {
	if (typeof n == "function") return t.includesTransform ? (r, i) => (Ms(e, () => t(r[e] = n(), i), i), r) : (t) => (t[e] = n(), t);
	let r = t.includesTransform ? t.assert(n) : n;
	return ia(r, "object") ? (r, i) => (Ms(e, () => t(r[e] = n, i), i), r) : (t) => (t[e] = r, t);
}, rl = (e, t, n) => {
	let r = Ha(t);
	ia(t, "object") && !r && M(il(n));
	let i = e.in(r ? t() : t);
	return i instanceof Os && (n === null && M(`Default ${i.summary}`), M(`Default for ${i.transform((e) => e.transform((e) => ({
		...e,
		prefixPath: [n]
	}))).summary}`)), t;
}, il = (e) => `Non-primitive default ${e === null ? "" : typeof e == "number" ? `for value at [${e}] ` : `for ${Qo(e)} `}must be specified as a function like () => ({my: 'object'})`, al = class extends Ns {
	constructor(e, t) {
		super(e, t), Object.defineProperty(this, is, {
			value: "root",
			enumerable: !1
		});
	}
	get rawIn() {
		return super.rawIn;
	}
	get rawOut() {
		return super.rawOut;
	}
	get internal() {
		return this;
	}
	get "~standard"() {
		return {
			vendor: "arktype",
			version: 1,
			validate: (e) => {
				let t = this(e);
				return t instanceof Os ? t : { value: t };
			},
			jsonSchema: {
				input: (e) => this.rawIn.toJsonSchema({
					target: ll(e.target),
					...e.libraryOptions
				}),
				output: (e) => this.rawOut.toJsonSchema({
					target: ll(e.target),
					...e.libraryOptions
				})
			}
		};
	}
	as() {
		return this;
	}
	brand(e) {
		return e === "" ? M(ol) : this;
	}
	readonly() {
		return this;
	}
	branches = this.hasKind("union") ? this.inner.branches : [this];
	distribute(e, t) {
		let n = this.branches.map(e);
		return t?.(n) ?? n;
	}
	get shortDescription() {
		return this.meta.description ?? this.defaultShortDescription;
	}
	toJsonSchema(e = {}) {
		let t = Cs(this.$.resolvedConfig.toJsonSchema, e);
		t.useRefs ||= this.isCyclic;
		let n = typeof t.dialect == "string" ? { $schema: t.dialect } : {};
		if (Object.assign(n, this.toJsonSchemaRecurse(t)), t.useRefs) {
			let e = N(this.references, (e, n) => n.isRoot() && !n.alwaysExpandJsonSchema ? [n.id, n.toResolvedJsonSchema(t)] : []);
			t.target === "draft-07" ? Object.assign(n, { definitions: e }) : n.$defs = e;
		}
		return n;
	}
	toJsonSchemaRecurse(e) {
		return e.useRefs && !this.alwaysExpandJsonSchema ? { $ref: `#/${e.target === "draft-07" ? "definitions" : "$defs"}/${this.id}` } : this.toResolvedJsonSchema(e);
	}
	get alwaysExpandJsonSchema() {
		return this.isBasis() || this.kind === "alias" || this.hasKind("union") && this.isBoolean;
	}
	toResolvedJsonSchema(e) {
		let t = this.innerToJsonSchema(e);
		return Object.assign(t, this.metaJson);
	}
	intersect(e) {
		let t = this.$.parseDefinition(e), n = this.rawIntersect(t);
		return n instanceof B ? n : this.$.finalize(n);
	}
	rawIntersect(e) {
		return qs(this, e, this.$);
	}
	toNeverIfDisjoint() {
		return this;
	}
	and(e) {
		let t = this.intersect(e);
		return t instanceof B ? t.throw() : t;
	}
	rawAnd(e) {
		let t = this.rawIntersect(e);
		return t instanceof B ? t.throw() : t;
	}
	or(e) {
		let t = this.$.parseDefinition(e);
		return this.$.finalize(this.rawOr(t));
	}
	rawOr(e) {
		let t = [...this.branches, ...e.branches];
		return this.$.node("union", t);
	}
	map(e) {
		return this.$.schema(this.applyStructuralOperation("map", [e]));
	}
	pick(...e) {
		return this.$.schema(this.applyStructuralOperation("pick", e));
	}
	omit(...e) {
		return this.$.schema(this.applyStructuralOperation("omit", e));
	}
	required() {
		return this.$.schema(this.applyStructuralOperation("required", []));
	}
	partial() {
		return this.$.schema(this.applyStructuralOperation("partial", []));
	}
	_keyof;
	keyof() {
		if (this._keyof) return this._keyof;
		let e = this.applyStructuralOperation("keyof", []).reduce((e, t) => e.intersect(t).toNeverIfDisjoint(), I.intrinsic.unknown.internal);
		return e.branches.length === 0 && M(Gs(`keyof ${this.expression}`)), this._keyof = this.$.finalize(e);
	}
	get props() {
		return this.branches.length === 1 ? [...this.applyStructuralOperation("props", [])[0]] : M(pl(this.expression));
	}
	merge(e) {
		let t = this.$.parseDefinition(e);
		return this.$.schema(t.distribute((e) => this.applyStructuralOperation("merge", [fl(e) ?? M(ml("merge", e.expression))])));
	}
	applyStructuralOperation(e, t) {
		return this.distribute((n) => {
			if (n.equals(I.intrinsic.object) && e !== "merge") return n;
			let r = fl(n);
			if (r || M(ml(e, n.expression)), e === "keyof") return r.keyof();
			if (e === "get") return r.get(...t);
			if (e === "props") return r.props;
			let i = e === "required" ? "require" : e === "partial" ? "optionalize" : e;
			return this.$.node("intersection", {
				domain: "object",
				structure: r[i](...t)
			});
		});
	}
	get(...e) {
		return e[0] === void 0 ? this : this.$.schema(this.applyStructuralOperation("get", e));
	}
	extract(e) {
		let t = this.$.parseDefinition(e);
		return this.$.schema(this.branches.filter((e) => e.extends(t)));
	}
	exclude(e) {
		let t = this.$.parseDefinition(e);
		return this.$.schema(this.branches.filter((e) => !e.extends(t)));
	}
	array() {
		return this.$.schema(this.isUnknown() ? { proto: Array } : {
			proto: Array,
			sequence: this
		}, { prereduced: !0 });
	}
	overlaps(e) {
		return !(this.intersect(e) instanceof B);
	}
	extends(e) {
		if (this.isNever()) return !0;
		let t = this.intersect(e);
		return !(t instanceof B) && this.equals(t);
	}
	ifExtends(e) {
		return this.extends(e) ? this : void 0;
	}
	subsumes(e) {
		return this.$.parseDefinition(e).extends(this);
	}
	configure(e, t = "shallow") {
		return this.configureReferences(e, t);
	}
	describe(e, t = "shallow") {
		return this.configure({ description: e }, t);
	}
	optional() {
		return [this, "?"];
	}
	default(e) {
		return rl(this, e, null), [
			this,
			"=",
			e
		];
	}
	from(e) {
		return this.assert(e);
	}
	_pipe(...e) {
		let t = e.reduce((e, t) => e.rawPipeOnce(t), this);
		return this.$.finalize(t);
	}
	tryPipe(...e) {
		let t = e.reduce((e, t) => e.rawPipeOnce(L(t, "root") ? t : ((e, n) => {
			try {
				return t(e, n);
			} catch (e) {
				return n.error({
					code: "predicate",
					predicate: t,
					actual: `aborted due to error:\n    ${e}\n`
				});
			}
		})), this);
		return this.$.finalize(t);
	}
	pipe = Object.assign(this._pipe.bind(this), { try: this.tryPipe.bind(this) });
	to(e) {
		return this.$.finalize(this.toNode(this.$.parseDefinition(e)));
	}
	toNode(e) {
		let t = Js(this, e, this.$);
		return t instanceof B ? t.throw() : t;
	}
	rawPipeOnce(e) {
		return L(e, "root") ? this.toNode(e) : this.distribute((t) => t.hasKind("morph") ? this.$.node("morph", {
			in: t.inner.in,
			morphs: [...t.morphs, e]
		}) : this.$.node("morph", {
			in: t,
			morphs: [e]
		}), this.$.parseSchema);
	}
	narrow(e) {
		return this.constrainOut("predicate", e);
	}
	constrain(e, t) {
		return this._constrain("root", e, t);
	}
	constrainIn(e, t) {
		return this._constrain("in", e, t);
	}
	constrainOut(e, t) {
		return this._constrain("out", e, t);
	}
	_constrain(e, t, n) {
		let r = this.$.node(t, n);
		if (r.isRoot()) return r.isUnknown() ? this : j(`Unexpected constraint node ${r}`);
		let i = e === "root" ? this : e === "in" ? this.rawIn : this.rawOut;
		if (i.hasKind("morph") || r.impliedBasis && !i.extends(r.impliedBasis)) return ac(t, r.impliedBasis, this);
		let a = this.$.node("intersection", { [r.kind]: r }), o = e === "out" ? Js(this, a, this.$) : qs(this, a, this.$);
		return o instanceof B && o.throw(), this.$.finalize(o);
	}
	onUndeclaredKey(e) {
		let t = typeof e == "string" ? e : e.rule, n = typeof e == "string" ? !1 : e.deep;
		return this.$.finalize(this.transform((e, n) => e === "structure" ? t === "ignore" ? ya(n, { undeclared: 1 }) : {
			...n,
			undeclared: t
		} : n, n ? void 0 : { shouldTransform: (e) => !Zi(ss, e.kind) }));
	}
	hasEqualMorphs(e) {
		return !this.includesTransform && !e.includesTransform ? !0 : !(!ra(this.shallowMorphs, e.shallowMorphs) || !ra(this.flatMorphs, e.flatMorphs, { isEqual: (e, t) => e.propString === t.propString && (e.node.hasKind("morph") && t.node.hasKind("morph") ? e.node.hasEqualMorphs(t.node) : e.node.hasKind("intersection") && t.node.hasKind("intersection") ? e.node.structure?.structuralMorphRef === t.node.structure?.structuralMorphRef : !1) }));
	}
	onDeepUndeclaredKey(e) {
		return this.onUndeclaredKey({
			rule: e,
			deep: !0
		});
	}
	filter(e) {
		return this.constrainIn("predicate", e);
	}
	divisibleBy(e) {
		return this.constrain("divisor", e);
	}
	matching(e) {
		return this.constrain("pattern", e);
	}
	atLeast(e) {
		return this.constrain("min", e);
	}
	atMost(e) {
		return this.constrain("max", e);
	}
	moreThan(e) {
		return this.constrain("min", ul(e));
	}
	lessThan(e) {
		return this.constrain("max", ul(e));
	}
	atLeastLength(e) {
		return this.constrain("minLength", e);
	}
	atMostLength(e) {
		return this.constrain("maxLength", e);
	}
	moreThanLength(e) {
		return this.constrain("minLength", ul(e));
	}
	lessThanLength(e) {
		return this.constrain("maxLength", ul(e));
	}
	exactlyLength(e) {
		return this.constrain("exactLength", e);
	}
	atOrAfter(e) {
		return this.constrain("after", e);
	}
	atOrBefore(e) {
		return this.constrain("before", e);
	}
	laterThan(e) {
		return this.constrain("after", ul(e));
	}
	earlierThan(e) {
		return this.constrain("before", ul(e));
	}
}, ol = "Expected a non-empty brand name after #", sl = ["draft-2020-12", "draft-07"], cl = (e) => `JSONSchema target '${e}' is not supported (must be ${sl.map((e) => `"${e}"`).join(" or ")})`, ll = (e) => (Zi(sl, e) || M(cl(e)), e), ul = (e) => typeof e == "object" && !(e instanceof Date) ? {
	...e,
	exclusive: !0
} : {
	rule: e,
	exclusive: !0
}, dl = (e, t) => L(t, "root") ? L(e, "root") ? e.extends(t) : t.allows(e) : L(e, "root") ? e.hasUnit(t) : t === e, fl = (e) => e.hasKind("morph") ? null : e.hasKind("intersection") ? e.inner.structure ?? (e.basis?.domain === "object" ? e.$.bindReference(I.intrinsic.emptyStructure) : null) : e.isBasis() && e.domain === "object" ? e.$.bindReference(I.intrinsic.emptyStructure) : null, pl = (e) => `Props cannot be extracted from a union. Use .distribute to extract props from each branch instead. Received:
${e}`, ml = (e, t) => `${e} operand must be an object (was ${t})`, hl = (e, t) => N(vs(e), (e, n) => [n, t]), gl = (e) => typeof e == "string" ? { reference: e } : e, _l = (e) => e instanceof B ? I.intrinsic.never.internal : e, vl = R({
	kind: "alias",
	hasAssociatedError: !1,
	collapsibleKey: "reference",
	keys: {
		reference: { serialize: (e) => e.startsWith("$") ? e : `$ark.${e}` },
		resolve: {}
	},
	normalize: gl,
	defaults: { description: (e) => e.reference },
	intersections: {
		alias: (e, t, n) => n.$.lazilyResolve(() => _l(V(e.resolution, t.resolution, n)), `${e.reference}${n.pipe ? "=>" : "&"}${t.reference}`),
		...hl("alias", (e, t, n) => t.isUnknown() ? e : t.isNever() ? t : t.isBasis() && !t.overlaps(I.intrinsic.object) ? B.init("assignability", I.intrinsic.object, t) : n.$.lazilyResolve(() => _l(V(e.resolution, t, n)), `${e.reference}${n.pipe ? "=>" : "&"}${t.id}`))
	}
}), yl = class extends al {
	expression = this.reference;
	structure = void 0;
	get resolution() {
		let e = this._resolve();
		return Uc[this.id] = e;
	}
	_resolve() {
		if (this.resolve) return this.resolve();
		if (this.reference[0] === "$") return this.$.resolveRoot(this.reference.slice(1));
		let e = Uc[this.reference], t = [];
		for (; L(e, "context");) {
			if (t.includes(e.id)) return M(bl(e.id, t));
			t.push(e.id), e = Uc[e.id];
		}
		return L(e, "root") ? e : j(`Unexpected resolution for reference ${this.reference}
Seen: [${t.join("->")}] 
Resolution: ${F(e)}`);
	}
	get resolutionId() {
		if (this.reference.includes("&") || this.reference.includes("=>")) return this.resolution.id;
		if (this.reference[0] !== "$") return this.reference;
		let e = this.reference.slice(1), t = this.$.resolutions[e];
		return typeof t == "string" ? t : L(t, "root") ? t.id : j(`Unexpected resolution for reference ${this.reference}: ${F(t)}`);
	}
	get defaultShortDescription() {
		return oa.object;
	}
	innerToJsonSchema(e) {
		return this.resolution.toJsonSchemaRecurse(e);
	}
	traverseAllows = (e, t) => {
		let n = t.seen[this.reference];
		return n?.includes(e) ? !0 : (t.seen[this.reference] = A(n, e), this.resolution.traverseAllows(e, t));
	};
	traverseApply = (e, t) => {
		let n = t.seen[this.reference];
		n?.includes(e) || (t.seen[this.reference] = A(n, e), this.resolution.traverseApply(e, t));
	};
	compile(e) {
		let t = this.resolutionId;
		e.if(`ctx.seen.${t} && ctx.seen.${t}.includes(data)`, () => e.return(!0)), e.if(`!ctx.seen.${t}`, () => e.line(`ctx.seen.${t} = []`)), e.line(`ctx.seen.${t}.push(data)`), e.return(e.invoke(t));
	}
}, bl = (e, t) => `Alias '${e}' has a shallow resolution cycle: ${[...t, e].join("->")}`, xl = {
	implementation: vl,
	Node: yl
}, Sl = class extends al {
	traverseApply = (e, t) => {
		this.traverseAllows(e, t) || t.errorFromNodeContext(this.errorContext);
	};
	get errorContext() {
		return {
			code: this.kind,
			description: this.description,
			meta: this.meta,
			...this.inner
		};
	}
	get compiledErrorContext() {
		return bs(this.errorContext);
	}
	compile(e) {
		e.traversalKind === "Allows" ? e.return(this.compiledCondition) : e.if(this.compiledNegation, () => e.line(`ctx.errorFromNodeContext(${this.compiledErrorContext})`));
	}
}, Cl = {
	implementation: R({
		kind: "domain",
		hasAssociatedError: !0,
		collapsibleKey: "domain",
		keys: {
			domain: {},
			numberAllowsNaN: {}
		},
		normalize: (e) => typeof e == "string" ? { domain: e } : ma(e, "numberAllowsNaN") && e.domain !== "number" ? M(Cl.writeBadAllowNanMessage(e.domain)) : e,
		applyConfig: (e, t) => e.numberAllowsNaN === void 0 && e.domain === "number" && t.numberAllowsNaN ? {
			...e,
			numberAllowsNaN: !0
		} : e,
		defaults: {
			description: (e) => oa[e.domain],
			actual: (e) => Number.isNaN(e) ? "NaN" : oa[aa(e)]
		},
		intersections: { domain: (e, t) => e.domain === "number" && t.domain === "number" ? e.numberAllowsNaN ? t : e : B.init("domain", e, t) }
	}),
	Node: class extends Sl {
		requiresNaNCheck = this.domain === "number" && !this.numberAllowsNaN;
		traverseAllows = this.requiresNaNCheck ? (e) => typeof e == "number" && !Number.isNaN(e) : (e) => aa(e) === this.domain;
		compiledCondition = this.domain === "object" ? "((typeof data === \"object\" && data !== null) || typeof data === \"function\")" : `typeof data === "${this.domain}"${this.requiresNaNCheck ? " && !Number.isNaN(data)" : ""}`;
		compiledNegation = this.domain === "object" ? "((typeof data !== \"object\" || data === null) && typeof data !== \"function\")" : `typeof data !== "${this.domain}"${this.requiresNaNCheck ? " || Number.isNaN(data)" : ""}`;
		expression = this.numberAllowsNaN ? "number | NaN" : this.domain;
		get nestableExpression() {
			return this.numberAllowsNaN ? `(${this.expression})` : this.expression;
		}
		get defaultShortDescription() {
			return oa[this.domain];
		}
		innerToJsonSchema(e) {
			return this.domain === "bigint" || this.domain === "symbol" ? e.fallback.domain({
				code: "domain",
				base: {},
				domain: this.domain
			}) : { type: this.domain };
		}
	},
	writeBadAllowNanMessage: (e) => `numberAllowsNaN may only be specified with domain "number" (was ${e})`
}, wl = {
	implementation: R({
		kind: "intersection",
		hasAssociatedError: !0,
		normalize: (e) => {
			if (as(e)) return e;
			let { structure: t, ...n } = e, r = !!t, i = t ?? {}, a = N(n, (e, t) => pa(e, ms) ? (r && M(`Flattened structure key ${e} cannot be specified alongside a root 'structure' key.`), i[e] = t, []) : [e, t]);
			return (L(i, "constraint") || !ba(i)) && (a.structure = i), a;
		},
		finalizeInnerJson: ({ structure: e, ...t }) => ia(e, "object") ? {
			...e,
			...t
		} : t,
		keys: {
			domain: {
				child: !0,
				parse: (e, t) => t.$.node("domain", e)
			},
			proto: {
				child: !0,
				parse: (e, t) => t.$.node("proto", e)
			},
			structure: {
				child: !0,
				parse: (e, t) => t.$.node("structure", e),
				serialize: (e) => {
					if (!e.sequence?.minLength) return e.collapsibleJson;
					let { sequence: t, ...n } = e.collapsibleJson, { minVariadicLength: r, ...i } = t, a = i.variadic && Object.keys(i).length === 1 ? i.variadic : i;
					return {
						...n,
						sequence: a
					};
				}
			},
			divisor: {
				child: !0,
				parse: tc("divisor")
			},
			max: {
				child: !0,
				parse: tc("max")
			},
			min: {
				child: !0,
				parse: tc("min")
			},
			maxLength: {
				child: !0,
				parse: tc("maxLength")
			},
			minLength: {
				child: !0,
				parse: tc("minLength")
			},
			exactLength: {
				child: !0,
				parse: tc("exactLength")
			},
			before: {
				child: !0,
				parse: tc("before")
			},
			after: {
				child: !0,
				parse: tc("after")
			},
			pattern: {
				child: !0,
				parse: tc("pattern")
			},
			predicate: {
				child: !0,
				parse: tc("predicate")
			}
		},
		reduce: (e, t) => El({}, e, {
			$: t,
			invert: !1,
			pipe: !1
		}),
		defaults: {
			description: (e) => {
				if (e.children.length === 0) return "unknown";
				if (e.structure) return e.structure.description;
				let t = [];
				if (e.basis && !e.prestructurals.some((e) => e.impl.obviatesBasisDescription) && t.push(e.basis.description), e.prestructurals.length) {
					let n = e.prestructurals.slice().sort((e, t) => e.kind === "min" && t.kind === "max" ? -1 : 0).map((e) => e.description);
					t.push(...n);
				}
				return e.inner.predicate && t.push(...e.inner.predicate.map((e) => e.description)), t.join(" and ");
			},
			expected: (e) => `  ◦ ${e.errors.map((e) => e.expected).join("\n  ◦ ")}`,
			problem: (e) => `(${e.actual}) must be...\n${e.expected}`
		},
		intersections: {
			intersection: (e, t, n) => El(e.inner, t.inner, n),
			...hl("intersection", (e, t, n) => {
				if (e.children.length === 0) return t;
				let { domain: r, proto: i, ...a } = e.inner, o = i ?? r, s = o ? V(o, t, n) : t;
				return s instanceof B ? s : e?.basis?.equals(s) ? e : e.$.node("intersection", {
					...a,
					[s.kind]: s
				}, { prereduced: !0 });
			})
		}
	}),
	Node: class extends al {
		basis = this.inner.domain ?? this.inner.proto ?? null;
		prestructurals = [];
		refinements = this.children.filter((e) => e.isRefinement() ? (Zi(cs, e.kind) && this.prestructurals.push(e), !0) : !1);
		structure = this.inner.structure;
		expression = Tl(this);
		get shallowMorphs() {
			return this.inner.structure?.structuralMorph ? [this.inner.structure.structuralMorph] : [];
		}
		get defaultShortDescription() {
			return this.basis?.defaultShortDescription ?? "present";
		}
		innerToJsonSchema(e) {
			return this.children.reduce((t, n) => n.isBasis() ? n.toJsonSchemaRecurse(e) : n.reduceJsonSchema(t, e), {});
		}
		traverseAllows = (e, t) => this.children.every((n) => n.traverseAllows(e, t));
		traverseApply = (e, t) => {
			let n = t.currentErrorCount;
			if (!(this.basis && (this.basis.traverseApply(e, t), t.currentErrorCount > n))) {
				if (this.prestructurals.length) {
					for (let r = 0; r < this.prestructurals.length - 1; r++) if (this.prestructurals[r].traverseApply(e, t), t.failFast && t.currentErrorCount > n) return;
					if (this.prestructurals[this.prestructurals.length - 1].traverseApply(e, t), t.currentErrorCount > n) return;
				}
				if (!(this.structure && (this.structure.traverseApply(e, t), t.currentErrorCount > n)) && this.inner.predicate) {
					for (let r = 0; r < this.inner.predicate.length - 1; r++) if (this.inner.predicate[r].traverseApply(e, t), t.failFast && t.currentErrorCount > n) return;
					this.inner.predicate[this.inner.predicate.length - 1].traverseApply(e, t);
				}
			}
		};
		compile(e) {
			if (e.traversalKind === "Allows") {
				for (let t of this.children) e.check(t);
				e.return(!0);
				return;
			}
			if (e.initializeErrorCount(), this.basis && (e.check(this.basis), this.children.length > 1 && e.returnIfFail()), this.prestructurals.length) {
				for (let t = 0; t < this.prestructurals.length - 1; t++) e.check(this.prestructurals[t]), e.returnIfFailFast();
				e.check(this.prestructurals[this.prestructurals.length - 1]), (this.structure || this.inner.predicate) && e.returnIfFail();
			}
			if (this.structure && (e.check(this.structure), this.inner.predicate && e.returnIfFail()), this.inner.predicate) {
				for (let t = 0; t < this.inner.predicate.length - 1; t++) e.check(this.inner.predicate[t]), e.returnIfFail();
				e.check(this.inner.predicate[this.inner.predicate.length - 1]);
			}
		}
	}
}, Tl = (e) => {
	if (e.structure?.expression) return e.structure.expression;
	let t = e.basis && !e.prestructurals.some((e) => e.impl.obviatesBasisExpression) ? e.basis.nestableExpression : "", n = e.prestructurals.map((e) => e.expression).join(" & "), r = `${t}${t ? " " : ""}${n}`;
	return r === "Array == 0" ? "[]" : r || "unknown";
}, El = (e, t, n) => {
	let r = {}, i = e.proto ?? e.domain, a = t.proto ?? t.domain, o = i ? a ? V(i, a, n) : i : a;
	return o instanceof B ? o : (o && (r[o.kind] = o), nc({
		kind: "intersection",
		baseInner: r,
		l: rc(e),
		r: rc(t),
		roots: [],
		ctx: n
	}));
}, Dl = {
	implementation: R({
		kind: "morph",
		hasAssociatedError: !1,
		keys: {
			in: {
				child: !0,
				parse: (e, t) => t.$.parseSchema(e)
			},
			morphs: {
				parse: Ji,
				serialize: (e) => e.map((e) => L(e, "root") ? e.json : Xo(e))
			},
			declaredIn: {
				child: !1,
				serialize: (e) => e.json
			},
			declaredOut: {
				child: !1,
				serialize: (e) => e.json
			}
		},
		normalize: (e) => e,
		defaults: { description: (e) => `a morph from ${e.rawIn.description} to ${e.rawOut?.description ?? "unknown"}` },
		intersections: {
			morph: (e, t, n) => {
				if (!e.hasEqualMorphs(t)) return M(Ol(e.expression, t.expression));
				let r = V(e.rawIn, t.rawIn, n);
				if (r instanceof B) return r;
				let i = { morphs: e.morphs };
				if (e.declaredIn || t.declaredIn) {
					let r = V(e.rawIn, t.rawIn, n);
					if (r instanceof B) return r.throw();
					i.declaredIn = r;
				}
				if (e.declaredOut || t.declaredOut) {
					let r = V(e.rawOut, t.rawOut, n);
					if (r instanceof B) return r.throw();
					i.declaredOut = r;
				}
				return r.distribute((e) => n.$.node("morph", {
					...i,
					in: e
				}), n.$.parseSchema);
			},
			...hl("morph", (e, t, n) => {
				let r = e.inner.in ? V(e.inner.in, t, n) : t;
				return r instanceof B ? r : r.equals(e.inner.in) ? e : n.$.node("morph", {
					...e.inner,
					in: r
				});
			})
		}
	}),
	Node: class extends al {
		serializedMorphs = this.morphs.map(Xo);
		compiledMorphs = `[${this.serializedMorphs}]`;
		lastMorph = this.inner.morphs[this.inner.morphs.length - 1];
		lastMorphIfNode = L(this.lastMorph, "root") ? this.lastMorph : void 0;
		introspectableIn = this.inner.in;
		introspectableOut = this.lastMorphIfNode ? Object.assign(this.referencesById, this.lastMorphIfNode.referencesById) && this.lastMorphIfNode.rawOut : void 0;
		get shallowMorphs() {
			return Array.isArray(this.inner.in?.shallowMorphs) ? [...this.inner.in.shallowMorphs, ...this.morphs] : this.morphs;
		}
		get rawIn() {
			return this.declaredIn ?? this.inner.in?.rawIn ?? I.intrinsic.unknown.internal;
		}
		get rawOut() {
			return this.declaredOut ?? this.introspectableOut ?? I.intrinsic.unknown.internal;
		}
		declareIn(e) {
			return this.$.node("morph", {
				...this.inner,
				declaredIn: e
			});
		}
		declareOut(e) {
			return this.$.node("morph", {
				...this.inner,
				declaredOut: e
			});
		}
		expression = `(In: ${this.rawIn.expression}) => ${this.lastMorphIfNode ? "To" : "Out"}<${this.rawOut.expression}>`;
		get defaultShortDescription() {
			return this.rawIn.meta.description ?? this.rawIn.defaultShortDescription;
		}
		innerToJsonSchema(e) {
			return e.fallback.morph({
				code: "morph",
				base: this.rawIn.toJsonSchemaRecurse(e),
				out: this.introspectableOut?.toJsonSchemaRecurse(e) ?? null
			});
		}
		compile(e) {
			if (e.traversalKind === "Allows") {
				if (!this.introspectableIn) return;
				e.return(e.invoke(this.introspectableIn));
				return;
			}
			this.introspectableIn && e.line(e.invoke(this.introspectableIn)), e.line(`ctx.queueMorphs(${this.compiledMorphs})`);
		}
		traverseAllows = (e, t) => !this.introspectableIn || this.introspectableIn.traverseAllows(e, t);
		traverseApply = (e, t) => {
			this.introspectableIn && this.introspectableIn.traverseApply(e, t), t.queueMorphs(this.morphs);
		};
		hasEqualMorphs(e) {
			return ra(this.morphs, e.morphs, { isEqual: (e, t) => e === t || L(e, "root") && L(t, "root") && e.equals(t) });
		}
	}
}, Ol = (e, t) => `The intersection of distinct morphs at a single path is indeterminate:
Left: ${e}
Right: ${t}`, kl = {
	implementation: R({
		kind: "proto",
		hasAssociatedError: !0,
		collapsibleKey: "proto",
		keys: {
			proto: { serialize: (e) => La(e) ?? ys(e) },
			dateAllowsInvalid: {}
		},
		normalize: (e) => {
			let t = typeof e == "string" ? { proto: Aa[e] } : typeof e == "function" ? as(e) ? e : { proto: e } : typeof e.proto == "string" ? {
				...e,
				proto: Aa[e.proto]
			} : e;
			return typeof t.proto != "function" && M(kl.writeInvalidSchemaMessage(t.proto)), ma(t, "dateAllowsInvalid") && t.proto !== Date && M(kl.writeBadInvalidDateMessage(t.proto)), t;
		},
		applyConfig: (e, t) => e.dateAllowsInvalid === void 0 && e.proto === Date && t.dateAllowsInvalid ? {
			...e,
			dateAllowsInvalid: !0
		} : e,
		defaults: {
			description: (e) => e.builtinName ? Ia[e.builtinName] : `an instance of ${e.proto.name}`,
			actual: (e) => e instanceof Date && e.toString() === "Invalid Date" ? "an invalid Date" : Ma(e)
		},
		intersections: {
			proto: (e, t) => e.proto === Date && t.proto === Date ? e.dateAllowsInvalid ? t : e : Ra(e.proto, t.proto) ? e : Ra(t.proto, e.proto) ? t : B.init("proto", e, t),
			domain: (e, t) => t.domain === "object" ? e : B.init("domain", I.intrinsic.object.internal, t)
		}
	}),
	Node: class extends Sl {
		builtinName = La(this.proto);
		serializedConstructor = this.json.proto;
		requiresInvalidDateCheck = this.proto === Date && !this.dateAllowsInvalid;
		traverseAllows = this.requiresInvalidDateCheck ? (e) => e instanceof Date && e.toString() !== "Invalid Date" : (e) => e instanceof this.proto;
		compiledCondition = `data instanceof ${this.serializedConstructor}${this.requiresInvalidDateCheck ? " && data.toString() !== \"Invalid Date\"" : ""}`;
		compiledNegation = `!(${this.compiledCondition})`;
		innerToJsonSchema(e) {
			switch (this.builtinName) {
				case "Array": return { type: "array" };
				case "Date": return e.fallback.date?.({
					code: "date",
					base: {}
				}) ?? e.fallback.proto({
					code: "proto",
					base: {},
					proto: this.proto
				});
				default: return e.fallback.proto({
					code: "proto",
					base: {},
					proto: this.proto
				});
			}
		}
		expression = this.dateAllowsInvalid ? "Date | InvalidDate" : this.proto.name;
		get nestableExpression() {
			return this.dateAllowsInvalid ? `(${this.expression})` : this.expression;
		}
		domain = "object";
		get defaultShortDescription() {
			return this.description;
		}
	},
	writeBadInvalidDateMessage: (e) => `dateAllowsInvalid may only be specified with constructor Date (was ${e.name})`,
	writeInvalidSchemaMessage: (e) => `instanceOf operand must be a function (was ${aa(e)})`
}, Al = R({
	kind: "union",
	hasAssociatedError: !0,
	collapsibleKey: "branches",
	keys: {
		ordered: {},
		branches: {
			child: !0,
			parse: (e, t) => {
				let n = [];
				for (let r of e) {
					let e = L(r, "root") ? r.branches : t.$.parseSchema(r).branches;
					for (let r of e) if (r.hasKind("morph")) {
						let e = n.findIndex((e) => e.hasKind("morph") && e.hasEqualMorphs(r));
						if (e === -1) n.push(r);
						else {
							let i = n[e];
							n[e] = t.$.node("morph", {
								...i.inner,
								in: i.rawIn.rawOr(r.rawIn)
							});
						}
					} else n.push(r);
				}
				return t.def.ordered || n.sort((e, t) => e.hash < t.hash ? -1 : 1), n;
			}
		}
	},
	normalize: (e) => P(e) ? { branches: e } : e,
	reduce: (e, t) => {
		let n = Gl(e);
		if (n.length === 1) return n[0];
		if (n.length !== e.branches.length) return t.node("union", {
			...e,
			branches: n
		}, { prereduced: !0 });
	},
	defaults: {
		description: (e) => e.distribute((e) => e.description, Ul),
		expected: (e) => {
			let t = na(e.errors, "propString");
			return Ul(Object.entries(t).map(([e, t]) => {
				let n = [];
				for (let e of t) ta(n, e.expected);
				let r = Ul(n), i = t.every((e) => e.actual === t[0].actual) ? t[0].actual : F(t[0].data);
				return `${e && `${e} `}must be ${r}${i && ` (was ${i})`}`;
			}));
		},
		problem: (e) => e.expected,
		message: (e) => e.problem[0] === "[" ? `value at ${e.problem}` : e.problem
	},
	intersections: {
		union: (e, t, n) => {
			if (e.isNever !== t.isNever) return B.init("presence", e, t);
			let r;
			return e.ordered ? (t.ordered && M(Yl(e.expression, t.expression)), r = Wl(t.branches, e.branches, n), r instanceof B && r.invert()) : r = Wl(e.branches, t.branches, n), r instanceof B ? r : n.$.parseSchema(e.ordered || t.ordered ? {
				branches: r,
				ordered: !0
			} : { branches: r });
		},
		...hl("union", (e, t, n) => {
			let r = Wl(e.branches, [t], n);
			return r instanceof B ? r : r.length === 1 ? r[0] : n.$.parseSchema(e.ordered ? {
				branches: r,
				ordered: !0
			} : { branches: r });
		})
	}
}), jl = class extends al {
	isBoolean = this.branches.length === 2 && this.branches[0].hasUnit(!1) && this.branches[1].hasUnit(!0);
	get branchGroups() {
		let e = [], t = -1;
		for (let n of this.branches) {
			if (n.hasKind("unit") && n.domain === "boolean") {
				t === -1 ? (t = e.length, e.push(n)) : e[t] = I.intrinsic.boolean;
				continue;
			}
			e.push(n);
		}
		return e;
	}
	unitBranches = this.branches.filter((e) => e.rawIn.hasKind("unit"));
	discriminant = this.discriminate();
	discriminantJson = this.discriminant ? Bl(this.discriminant) : null;
	expression = this.distribute((e) => e.nestableExpression, Hl);
	createBranchedOptimisticRootApply() {
		return (e, t) => {
			let n = this.traverseOptimistic(e);
			if (n !== wa) return n;
			let r = new js(e, this.$.resolvedConfig);
			return this.traverseApply(e, r), r.finalize(t);
		};
	}
	get shallowMorphs() {
		return this.branches.reduce((e, t) => ta(e, t.shallowMorphs), []);
	}
	get defaultShortDescription() {
		return this.distribute((e) => e.defaultShortDescription, Ul);
	}
	innerToJsonSchema(e) {
		if (this.branchGroups.length === 1 && this.branchGroups[0].equals(I.intrinsic.boolean)) return { type: "boolean" };
		let t = this.branchGroups.map((t) => t.toJsonSchemaRecurse(e));
		return t.every((e) => Object.keys(e).length === 1 && ma(e, "const")) ? { enum: t.map((e) => e.const) } : { anyOf: t };
	}
	traverseAllows = (e, t) => this.branches.some((n) => n.traverseAllows(e, t));
	traverseApply = (e, t) => {
		let n = [];
		for (let r = 0; r < this.branches.length; r++) {
			if (t.pushBranch(), this.branches[r].traverseApply(e, t), !t.hasError()) return this.branches[r].includesTransform ? t.queuedMorphs.push(...t.popBranch().queuedMorphs) : t.popBranch();
			n.push(t.popBranch().error);
		}
		t.errorFromNodeContext({
			code: "union",
			errors: n,
			meta: this.meta
		});
	};
	traverseOptimistic = (e) => {
		for (let t = 0; t < this.branches.length; t++) {
			let n = this.branches[t];
			if (n.traverseAllows(e)) return n.contextFreeMorph ? n.contextFreeMorph(e) : e;
		}
		return wa;
	};
	compile(e) {
		if (!this.discriminant || this.unitBranches.length === this.branches.length && this.branches.length === 2) return this.compileIndiscriminable(e);
		let t = this.discriminant.optionallyChainedPropString;
		this.discriminant.kind === "domain" && (t = `typeof ${t} === "object" ? ${t} === null ? "null" : "object" : typeof ${t} === "function" ? "object" : typeof ${t}`);
		let n = this.discriminant.cases, r = Object.keys(n), { optimistic: i } = e;
		if (e.optimistic = !1, e.block(`switch(${t})`, () => {
			for (let t in n) {
				let r = n[t], a = t === "default" ? t : `case ${t}`, o;
				o = r === !0 ? i ? "data" : "true" : i ? r.rootApplyStrategy === "branchedOptimistic" ? e.invoke(r, { kind: "Optimistic" }) : r.contextFreeMorph ? `${e.invoke(r)} ? ${Xo(r.contextFreeMorph)}(data) : "${wa}"` : `${e.invoke(r)} ? data : "${wa}"` : e.invoke(r), e.line(`${a}: return ${o}`);
			}
			return e;
		}), e.traversalKind === "Allows") {
			e.return(i ? `"${wa}"` : !1);
			return;
		}
		let a = Ul(this.discriminant.kind === "domain" ? r.map((e) => {
			let t = e.slice(1, -1);
			return t === "function" ? oa.object : oa[t];
		}) : r), o = this.discriminant.path.map((e) => typeof e == "symbol" ? Xo(e) : JSON.stringify(e)), s = JSON.stringify(a), c = this.discriminant.kind === "domain" ? `${Ll}[${t}]` : `${Rl}(${t})`;
		e.line(`ctx.errorFromNodeContext({
	code: "predicate",
	expected: ${s},
	actual: ${c},
	relativePath: [${o}],
	meta: ${this.compiledMeta}
})`);
	}
	compileIndiscriminable(e) {
		if (e.traversalKind === "Apply") {
			e.const("errors", "[]");
			for (let t of this.branches) e.line("ctx.pushBranch()").line(e.invoke(t)).if("!ctx.hasError()", () => e.return(t.includesTransform ? "ctx.queuedMorphs.push(...ctx.popBranch().queuedMorphs)" : "ctx.popBranch()")).line("errors.push(ctx.popBranch().error)");
			e.line(`ctx.errorFromNodeContext({ code: "union", errors, meta: ${this.compiledMeta} })`);
		} else {
			let { optimistic: t } = e;
			e.optimistic = !1;
			for (let n of this.branches) e.if(`${e.invoke(n)}`, () => e.return(t ? n.contextFreeMorph ? `${Xo(n.contextFreeMorph)}(data)` : "data" : !0));
			e.return(t ? `"${wa}"` : !1);
		}
	}
	get nestableExpression() {
		return this.isBoolean ? "boolean" : `(${this.expression})`;
	}
	discriminate() {
		if (this.branches.length < 2 || this.isCyclic) return null;
		if (this.unitBranches.length === this.branches.length) return {
			kind: "unit",
			path: [],
			optionallyChainedPropString: "data",
			cases: N(this.unitBranches, (e, t) => [`${t.rawIn.serializedValue}`, t.hasKind("morph") ? t : !0])
		};
		let e = [];
		for (let t = 0; t < this.branches.length - 1; t++) {
			let n = this.branches[t];
			for (let r = t + 1; r < this.branches.length; r++) {
				let i = this.branches[r], a = qs(n.rawIn, i.rawIn, n.$);
				if (a instanceof B) for (let n of a) {
					if (!n.kind || n.optional) continue;
					let i, a;
					if (n.kind === "domain") {
						let e = n.l, t = n.r;
						i = `"${typeof e == "string" ? e : e.domain}"`, a = `"${typeof t == "string" ? t : t.domain}"`;
					} else if (n.kind === "unit") i = n.l.serializedValue, a = n.r.serializedValue;
					else continue;
					let o = e.find((e) => ra(e.path, n.path) && e.kind === n.kind);
					o ? (o.cases[i] ? o.cases[i].branchIndices = ta(o.cases[i].branchIndices, t) : o.cases[i] ??= {
						branchIndices: [t],
						condition: n.l
					}, o.cases[a] ? o.cases[a].branchIndices = ta(o.cases[a].branchIndices, r) : o.cases[a] ??= {
						branchIndices: [r],
						condition: n.r
					}) : e.push({
						kind: n.kind,
						cases: {
							[i]: {
								branchIndices: [t],
								condition: n.l
							},
							[a]: {
								branchIndices: [r],
								condition: n.r
							}
						},
						path: n.path
					});
				}
			}
		}
		let t = this.ordered ? Pl(e, this.branches) : e;
		if (!t.length) return null;
		let n = Ml(t, this), r = {};
		for (let e in n.best.cases) {
			let t = Nl(n, e);
			if (t === null) {
				r[e] = !0;
				continue;
			}
			if (t.length === this.branches.length) return null;
			this.ordered && t.sort((e, t) => e.originalIndex - t.originalIndex);
			let i = t.map((e) => e.branch), a = i.length === 1 ? i[0] : this.$.node("union", this.ordered ? {
				branches: i,
				ordered: !0
			} : i);
			Object.assign(this.referencesById, a.referencesById), r[e] = a;
		}
		if (n.defaultEntries.length) {
			let e = n.defaultEntries.map((e) => e.branch);
			r.default = this.$.node("union", this.ordered ? {
				branches: e,
				ordered: !0
			} : e, { prereduced: !0 }), Object.assign(this.referencesById, r.default.referencesById);
		}
		return Object.assign(n.location, { cases: r });
	}
}, Ml = (e, t) => {
	let n = e.sort((e, t) => e.path.length === t.path.length ? Object.keys(t.cases).length - Object.keys(e.cases).length : e.path.length - t.path.length)[0];
	return {
		best: n,
		location: {
			kind: n.kind,
			path: n.path,
			optionallyChainedPropString: Il(n.path)
		},
		defaultEntries: t.branches.map((e, t) => ({
			originalIndex: t,
			branch: e
		})),
		node: t
	};
}, Nl = (e, t) => {
	let n = e.best.cases[t], r = Fl(n.condition, e.location.path, e.node.$), i = [], a = [];
	for (let t = 0; t < e.defaultEntries.length; t++) {
		let o = e.defaultEntries[t];
		if (n.branchIndices.includes(o.originalIndex)) {
			let t = ql(e.node.branches[o.originalIndex], e.location);
			t === null ? i = null : i?.push({
				originalIndex: o.originalIndex,
				branch: t
			});
		} else if (o.branch.hasKind("alias") && r.hasKind("domain") && r.domain === "object") i?.push(o);
		else {
			if (o.branch.rawIn.overlaps(r)) {
				let t = ql(o.branch, e.location);
				i?.push({
					originalIndex: o.originalIndex,
					branch: t
				});
			}
			a.push(o);
		}
	}
	return e.defaultEntries = a, i;
}, Pl = (e, t) => e.filter((e) => {
	let n = Object.values(e.cases).map((e) => e.branchIndices);
	for (let e = 0; e < n.length - 1; e++) {
		let r = n[e];
		for (let i = e + 1; i < n.length; i++) {
			let e = n[i];
			for (let n of r) for (let r of e) if (n > r && t[n].overlaps(t[r])) return !1;
		}
	}
	return !0;
}), Fl = (e, t, n) => {
	let r = e === "undefined" ? n.node("unit", { unit: void 0 }) : e === "null" ? n.node("unit", { unit: null }) : e === "boolean" ? n.units([!0, !1]) : e;
	for (let e = t.length - 1; e >= 0; e--) {
		let i = t[e];
		r = n.node("intersection", typeof i == "number" ? {
			proto: "Array",
			sequence: [...Qi(i).map((e) => ({})), r]
		} : {
			domain: "object",
			required: [{
				key: i,
				value: r
			}]
		});
	}
	return r;
}, Il = (e) => e.reduce((e, t) => e + $o(t, !0), "data"), Ll = Xo(sa), Rl = Xo(F), zl = {
	implementation: Al,
	Node: jl
}, Bl = (e) => ({
	kind: e.kind,
	path: e.path.map((e) => typeof e == "string" ? e : Qo(e)),
	cases: N(e.cases, (e, t) => [e, t === !0 ? t : t.hasKind("union") && t.discriminantJson ? t.discriminantJson : t.json])
}), Vl = {
	delimiter: " | ",
	finalDelimiter: " | "
}, Hl = (e) => Ul(e, Vl), Ul = (e, t) => {
	let n = t?.delimiter ?? ", ", r = t?.finalDelimiter ?? " or ";
	if (e.length === 0) return "never";
	if (e.length === 1) return e[0];
	if (e.length === 2 && e[0] === "false" && e[1] === "true" || e[0] === "true" && e[1] === "false") return "boolean";
	let i = {}, a = e.filter((e) => i[e] ? !1 : i[e] = !0), o = a.pop();
	return `${a.join(n)}${a.length ? r : ""}${o}`;
}, Wl = (e, t, n) => {
	let r = t.map(() => []);
	for (let i = 0; i < e.length; i++) {
		let a = {};
		for (let o = 0; o < t.length; o++) {
			if (r[o] === null) continue;
			if (e[i].equals(t[o])) {
				r[o] = null, a = {};
				break;
			}
			let s = V(e[i], t[o], n);
			if (!(s instanceof B)) {
				if (s.equals(e[i])) {
					r[o].push(e[i]), a = {};
					break;
				}
				s.equals(t[o]) ? r[o] = null : a[o] = s;
			}
		}
		for (let e in a) r[e][i] = a[e];
	}
	let i = r.flatMap((e, n) => e?.flatMap((e) => e.branches) ?? t[n]);
	return i.length === 0 ? B.init("union", e, t) : i;
}, Gl = ({ branches: e, ordered: t }) => {
	if (e.length < 2) return e;
	let n = e.map(() => !0);
	for (let r = 0; r < e.length; r++) for (let i = r + 1; i < e.length && n[r] && n[i]; i++) {
		if (e[r].equals(e[i])) {
			n[i] = !1;
			continue;
		}
		let a = qs(e[r].rawIn, e[i].rawIn, e[0].$);
		a instanceof B || (t || Kl(e[r], e[i]), a.equals(e[r].rawIn) ? n[r] = !!t : a.equals(e[i].rawIn) && (n[i] = !1));
	}
	return e.filter((e, t) => n[t]);
}, Kl = (e, t) => {
	!e.includesTransform && !t.includesTransform || (ra(e.shallowMorphs, t.shallowMorphs) || M(Jl(e.expression, t.expression)), ra(e.flatMorphs, t.flatMorphs, { isEqual: (e, t) => e.propString === t.propString && (e.node.hasKind("morph") && t.node.hasKind("morph") ? e.node.hasEqualMorphs(t.node) : e.node.hasKind("intersection") && t.node.hasKind("intersection") ? e.node.structure?.structuralMorphRef === t.node.structure?.structuralMorphRef : !1) }) || M(Jl(e.expression, t.expression)));
}, ql = (e, t) => e.transform((e, t) => e === "domain" || e === "unit" ? null : t, { shouldTransform: (e, n) => {
	let r = Il(n.path);
	return t.optionallyChainedPropString.startsWith(r) ? e.hasKind("domain") && e.domain === "object" || (e.hasKind("domain") || t.kind === "unit") && r === t.optionallyChainedPropString ? !0 : e.children.length !== 0 && e.kind !== "index" : !1;
} }), Jl = (e, t) => `An unordered union of a type including a morph and a type with overlapping input is indeterminate:
Left: ${e}
Right: ${t}`, Yl = (e, t) => `The intersection of two ordered unions is indeterminate:
Left: ${e}
Right: ${t}`, Xl = {
	implementation: R({
		kind: "unit",
		hasAssociatedError: !0,
		keys: { unit: {
			preserveUndefined: !0,
			serialize: (e) => e instanceof Date ? e.toISOString() : ys(e)
		} },
		normalize: (e) => e,
		defaults: {
			description: (e) => F(e.unit),
			problem: ({ expected: e, actual: t }) => `${e === t ? `must be reference equal to ${e} (serialized to the same value)` : `must be ${e} (was ${t})`}`
		},
		intersections: {
			unit: (e, t) => B.init("unit", e, t),
			...hl("unit", (e, t) => {
				if (t.allows(e.unit)) return e;
				let n = t.hasKind("intersection") ? t.basis : t;
				if (n) {
					let t = n.hasKind("domain") ? n : I.intrinsic.object;
					if (e.domain !== t.domain) {
						let n = e.domain === "undefined" || e.domain === "null" || e.domain === "boolean" ? e.domain : I.intrinsic[e.domain];
						return B.init("domain", n, t);
					}
				}
				return B.init("assignability", e, t.hasKind("intersection") ? t.children.find((t) => !t.allows(e.unit)) : t);
			})
		}
	}),
	Node: class extends Sl {
		compiledValue = this.json.unit;
		serializedValue = typeof this.unit == "string" || this.unit instanceof Date ? JSON.stringify(this.compiledValue) : `${this.compiledValue}`;
		compiledCondition = Zl(this.unit, this.serializedValue);
		compiledNegation = Zl(this.unit, this.serializedValue, "negated");
		expression = F(this.unit);
		domain = aa(this.unit);
		get defaultShortDescription() {
			return this.domain === "object" ? oa.object : this.description;
		}
		innerToJsonSchema(e) {
			return this.unit === null ? { type: "null" } : I.intrinsic.jsonPrimitive.allows(this.unit) ? { const: this.unit } : e.fallback.unit({
				code: "unit",
				base: {},
				unit: this.unit
			});
		}
		traverseAllows = this.unit instanceof Date ? (e) => e instanceof Date && e.toISOString() === this.compiledValue : Number.isNaN(this.unit) ? (e) => Number.isNaN(e) : (e) => e === this.unit;
	}
}, Zl = (e, t, n) => {
	if (e instanceof Date) {
		let e = `data instanceof Date && data.toISOString() === ${t}`;
		return n ? `!(${e})` : e;
	}
	return Number.isNaN(e) ? `${n ? "!" : ""}Number.isNaN(data)` : `data ${n ? "!" : "="}== ${t}`;
}, Ql = {
	implementation: R({
		kind: "index",
		hasAssociatedError: !1,
		intersectionIsOpen: !0,
		keys: {
			signature: {
				child: !0,
				parse: (e, t) => {
					let n = t.$.parseSchema(e);
					if (!n.extends(I.intrinsic.key)) return M(eu(n.expression));
					let r = n.branches.filter((e) => e.hasKind("unit"));
					return r.length ? M($l(r.map((e) => F(e.unit)))) : n;
				}
			},
			value: {
				child: !0,
				parse: (e, t) => t.$.parseSchema(e)
			}
		},
		normalize: (e) => e,
		defaults: { description: (e) => `[${e.signature.expression}]: ${e.value.description}` },
		intersections: { index: (e, t, n) => {
			if (e.signature.equals(t.signature)) {
				let r = V(e.value, t.value, n), i = r instanceof B ? I.intrinsic.never.internal : r;
				return n.$.node("index", {
					signature: e.signature,
					value: i
				});
			}
			return e.signature.extends(t.signature) && e.value.subsumes(t.value) ? t : t.signature.extends(e.signature) && t.value.subsumes(e.value) ? e : null;
		} }
	}),
	Node: class extends $s {
		impliedBasis = I.intrinsic.object.internal;
		expression = `[${this.signature.expression}]: ${this.value.expression}`;
		flatRefs = A(this.value.flatRefs.map((e) => zs([this.signature, ...e.path], e.node)), zs([this.signature], this.value));
		traverseAllows = (e, t) => xa(e).every((e) => this.signature.traverseAllows(e[0], t) ? Ms(e[0], () => this.value.traverseAllows(e[1], t), t) : !0);
		traverseApply = (e, t) => {
			for (let n of xa(e)) this.signature.traverseAllows(n[0], t) && Ms(n[0], () => this.value.traverseApply(n[1], t), t);
		};
		_transform(e, t) {
			t.path.push(this.signature);
			let n = super._transform(e, t);
			return t.path.pop(), n;
		}
		compile() {}
	}
}, $l = (e) => `Index keys ${e.join(", ")} should be specified as named props.`, eu = (e) => `Indexed key definition '${e}' must be a string or symbol`, tu = {
	implementation: R({
		kind: "required",
		hasAssociatedError: !0,
		intersectionIsOpen: !0,
		keys: {
			key: {},
			value: {
				child: !0,
				parse: (e, t) => t.$.parseSchema(e)
			}
		},
		normalize: (e) => e,
		defaults: {
			description: (e) => `${e.compiledKey}: ${e.value.description}`,
			expected: (e) => e.missingValueDescription,
			actual: () => "missing"
		},
		intersections: {
			required: Xc,
			optional: Xc
		}
	}),
	Node: class extends Zc {
		expression = `${this.compiledKey}: ${this.value.expression}`;
		errorContext = Object.freeze({
			code: "required",
			missingValueDescription: this.value.defaultShortDescription,
			relativePath: [this.key],
			meta: this.meta
		});
		compiledErrorContext = bs(this.errorContext);
	}
}, nu = R({
	kind: "sequence",
	hasAssociatedError: !1,
	collapsibleKey: "variadic",
	keys: {
		prefix: {
			child: !0,
			parse: (e, t) => {
				if (e.length !== 0) return e.map((e) => t.$.parseSchema(e));
			}
		},
		optionals: {
			child: !0,
			parse: (e, t) => {
				if (e.length !== 0) return e.map((e) => t.$.parseSchema(e));
			}
		},
		defaultables: {
			child: (e) => e.map((e) => e[0]),
			parse: (e, t) => {
				if (e.length !== 0) return e.map((e) => {
					let n = t.$.parseSchema(e[0]);
					return rl(n, e[1], null), [n, e[1]];
				});
			},
			serialize: (e) => e.map((e) => [e[0].collapsibleJson, ys(e[1])]),
			reduceIo: (e, t, n) => {
				if (e === "in") {
					t.optionals = n.map((e) => e[0].rawIn);
					return;
				}
				t.prefix = n.map((e) => e[0].rawOut);
			}
		},
		variadic: {
			child: !0,
			parse: (e, t) => t.$.parseSchema(e, t)
		},
		minVariadicLength: { parse: (e) => e === 0 ? void 0 : e },
		postfix: {
			child: !0,
			parse: (e, t) => {
				if (e.length !== 0) return e.map((e) => t.$.parseSchema(e));
			}
		}
	},
	normalize: (e) => {
		if (typeof e == "string") return { variadic: e };
		if ("variadic" in e || "prefix" in e || "defaultables" in e || "optionals" in e || "postfix" in e || "minVariadicLength" in e) {
			if (e.postfix?.length) {
				if (!e.variadic) return M(uu);
				if (e.optionals?.length || e.defaultables?.length) return M(lu);
			}
			return e.minVariadicLength && !e.variadic ? M("minVariadicLength may not be specified without a variadic element") : e;
		}
		return { variadic: e };
	},
	reduce: (e, t) => {
		let n = e.minVariadicLength ?? 0, r = e.prefix?.slice() ?? [], i = e.defaultables?.slice() ?? [], a = e.optionals?.slice() ?? [], o = e.postfix?.slice() ?? [];
		if (e.variadic) {
			for (; a[a.length - 1]?.equals(e.variadic);) a.pop();
			if (a.length === 0 && i.length === 0) for (; r[r.length - 1]?.equals(e.variadic);) r.pop(), n++;
			for (; o[0]?.equals(e.variadic);) o.shift(), n++;
		} else a.length === 0 && i.length === 0 && r.push(...o.splice(0));
		if (n !== e.minVariadicLength || e.prefix && e.prefix.length !== r.length) return t.node("sequence", {
			...e,
			prefix: r,
			defaultables: i,
			optionals: a,
			postfix: o,
			minVariadicLength: n
		}, { prereduced: !0 });
	},
	defaults: { description: (e) => e.isVariadicOnly ? `${e.variadic.nestableExpression}[]` : `[${e.tuple.map((e) => e.kind === "defaultables" ? `${e.node.nestableExpression} = ${F(e.default)}` : e.kind === "optionals" ? `${e.node.nestableExpression}?` : e.kind === "variadic" ? `...${e.node.nestableExpression}[]` : e.node.expression).join(", ")}]` },
	intersections: { sequence: (e, t, n) => {
		let r = du({
			l: e.tuple,
			r: t.tuple,
			disjoint: new B(),
			result: [],
			fixedVariants: [],
			ctx: n
		}), i = r.disjoint.length === 0 ? [r, ...r.fixedVariants] : r.fixedVariants;
		return i.length === 0 ? r.disjoint : i.length === 1 ? n.$.node("sequence", cu(i[0].result)) : n.$.node("union", i.map((e) => ({
			proto: Array,
			sequence: cu(e.result)
		})));
	} }
}), ru = class extends $s {
	impliedBasis = I.intrinsic.Array.internal;
	tuple = su(this.inner);
	prefixLength = this.prefix?.length ?? 0;
	defaultablesLength = this.defaultables?.length ?? 0;
	optionalsLength = this.optionals?.length ?? 0;
	postfixLength = this.postfix?.length ?? 0;
	defaultablesAndOptionals = [];
	prevariadic = this.tuple.filter((e) => e.kind === "defaultables" || e.kind === "optionals" ? (this.defaultablesAndOptionals.push(e.node), !0) : e.kind === "prefix");
	variadicOrPostfix = $i(this.variadic && [this.variadic], this.postfix);
	flatRefs = this.addFlatRefs();
	addFlatRefs() {
		return Vs(this.flatRefs, this.prevariadic.flatMap((e, t) => A(e.node.flatRefs.map((e) => zs([`${t}`, ...e.path], e.node)), zs([`${t}`], e.node)))), Vs(this.flatRefs, this.variadicOrPostfix.flatMap((e) => A(e.flatRefs.map((e) => zs([I.intrinsic.nonNegativeIntegerString.internal, ...e.path], e.node)), zs([I.intrinsic.nonNegativeIntegerString.internal], e)))), this.flatRefs;
	}
	isVariadicOnly = this.prevariadic.length + this.postfixLength === 0;
	minVariadicLength = this.inner.minVariadicLength ?? 0;
	minLength = this.prefixLength + this.minVariadicLength + this.postfixLength;
	minLengthNode = this.minLength === 0 ? null : this.$.node("minLength", this.minLength);
	maxLength = this.variadic ? null : this.tuple.length;
	maxLengthNode = this.maxLength === null ? null : this.$.node("maxLength", this.maxLength);
	impliedSiblings = this.minLengthNode ? this.maxLengthNode ? [this.minLengthNode, this.maxLengthNode] : [this.minLengthNode] : this.maxLengthNode ? [this.maxLengthNode] : [];
	defaultValueMorphs = au(this);
	defaultValueMorphsReference = this.defaultValueMorphs.length ? Xo(this.defaultValueMorphs) : void 0;
	elementAtIndex(e, t) {
		if (t < this.prevariadic.length) return this.tuple[t];
		let n = e.length - this.postfixLength;
		return t >= n ? {
			kind: "postfix",
			node: this.postfix[t - n]
		} : {
			kind: "variadic",
			node: this.variadic ?? j(`Unexpected attempt to access index ${t} on ${this}`)
		};
	}
	traverseAllows = (e, t) => {
		for (let n = 0; n < e.length; n++) if (!this.elementAtIndex(e, n).node.traverseAllows(e[n], t)) return !1;
		return !0;
	};
	traverseApply = (e, t) => {
		let n = 0;
		for (; n < e.length; n++) Ms(n, () => this.elementAtIndex(e, n).node.traverseApply(e[n], t), t);
	};
	get element() {
		return this.cacheGetter("element", this.$.node("union", this.children));
	}
	compile(e) {
		if (this.prefix) for (let [t, n] of this.prefix.entries()) e.traverseKey(`${t}`, `data[${t}]`, n);
		for (let [t, n] of this.defaultablesAndOptionals.entries()) {
			let r = `${t + this.prefixLength}`;
			e.if(`${r} >= data.length`, () => e.traversalKind === "Allows" ? e.return(!0) : e.return()), e.traverseKey(r, `data[${r}]`, n);
		}
		if (this.variadic && (this.postfix && e.const("firstPostfixIndex", `data.length${this.postfix ? `- ${this.postfix.length}` : ""}`), e.for(`i < ${this.postfix ? "firstPostfixIndex" : "data.length"}`, () => e.traverseKey("i", "data[i]", this.variadic), this.prevariadic.length), this.postfix)) for (let [t, n] of this.postfix.entries()) {
			let r = `firstPostfixIndex + ${t}`;
			e.traverseKey(r, `data[${r}]`, n);
		}
		e.traversalKind === "Allows" && e.return(!0);
	}
	_transform(e, t) {
		t.path.push(I.intrinsic.nonNegativeIntegerString.internal);
		let n = super._transform(e, t);
		return t.path.pop(), n;
	}
	expression = this.description;
	reduceJsonSchema(e, t) {
		let n = t.target === "draft-07";
		if (this.prevariadic.length) {
			let r = this.prevariadic.map((e) => {
				let n = e.node.toJsonSchemaRecurse(t);
				if (e.kind === "defaultables") {
					let r = typeof e.default == "function" ? e.default() : e.default;
					n.default = I.intrinsic.jsonData.allows(r) ? r : t.fallback.defaultValue({
						code: "defaultValue",
						base: n,
						value: r
					});
				}
				return n;
			});
			n ? e.items = r : e.prefixItems = r;
		}
		if (this.minLength && (e.minItems = this.minLength), this.variadic) {
			let r = this.variadic.toJsonSchemaRecurse(t);
			if (n && this.prevariadic.length ? e.additionalItems = r : e.items = r, this.maxLength && (e.maxItems = this.maxLength), this.postfix) {
				let n = this.postfix.map((e) => e.toJsonSchemaRecurse(t));
				e = t.fallback.arrayPostfix({
					code: "arrayPostfix",
					base: e,
					elements: n
				});
			}
		} else n ? e.additionalItems = !1 : e.items = !1, delete e.maxItems;
		return e;
	}
}, iu = {}, au = (e) => {
	if (!e.defaultables) return [];
	let t = [], n = "[", r = e.prefixLength + e.defaultablesLength - 1;
	for (let i = e.prefixLength; i <= r; i++) {
		let [r, a] = e.defaultables[i - e.prefixLength];
		t.push(nl(i, r, a)), n += `${i}: ${r.id} = ${ys(a)}, `;
	}
	return n += "]", iu[n] ??= t;
}, ou = {
	implementation: nu,
	Node: ru
}, su = (e) => {
	let t = [];
	if (e.prefix) for (let n of e.prefix) t.push({
		kind: "prefix",
		node: n
	});
	if (e.defaultables) for (let [n, r] of e.defaultables) t.push({
		kind: "defaultables",
		node: n,
		default: r
	});
	if (e.optionals) for (let n of e.optionals) t.push({
		kind: "optionals",
		node: n
	});
	if (e.variadic && t.push({
		kind: "variadic",
		node: e.variadic
	}), e.postfix) for (let n of e.postfix) t.push({
		kind: "postfix",
		node: n
	});
	return t;
}, cu = (e) => e.reduce((e, t) => (t.kind === "variadic" ? e.variadic = t.node : t.kind === "defaultables" ? e.defaultables = A(e.defaultables, [[t.node, t.default]]) : e[t.kind] = A(e[t.kind], t.node), e), {}), lu = "A postfix required element cannot follow an optional or defaultable element", uu = "A postfix element requires a variadic element", du = (e) => {
	let [t, ...n] = e.l, [r, ...i] = e.r;
	if (!t || !r) return e;
	let a = n[n.length - 1]?.kind === "postfix", o = i[i.length - 1]?.kind === "postfix", s = t.kind === "prefix" || r.kind === "prefix" ? "prefix" : t.kind === "postfix" || r.kind === "postfix" ? "postfix" : t.kind === "variadic" && r.kind === "variadic" ? "variadic" : a || o ? "prefix" : t.kind === "defaultables" || r.kind === "defaultables" ? "defaultables" : "optionals";
	if (t.kind === "prefix" && r.kind === "variadic" && o) {
		let t = du({
			...e,
			fixedVariants: [],
			r: i.map((e) => ({
				...e,
				kind: "prefix"
			}))
		});
		t.disjoint.length === 0 && e.fixedVariants.push(t);
	} else if (r.kind === "prefix" && t.kind === "variadic" && a) {
		let t = du({
			...e,
			fixedVariants: [],
			l: n.map((e) => ({
				...e,
				kind: "prefix"
			}))
		});
		t.disjoint.length === 0 && e.fixedVariants.push(t);
	}
	let c = V(t.node, r.node, e.ctx);
	if (c instanceof B) if (s === "prefix" || s === "postfix") e.disjoint.push(...c.withPrefixKey(s === "prefix" ? e.result.length : `-${n.length + 1}`, fu(t) && fu(r) ? "required" : "optional")), e.result = [...e.result, {
		kind: s,
		node: I.intrinsic.never.internal
	}];
	else if (s === "optionals" || s === "defaultables") return e;
	else return du({
		...e,
		fixedVariants: [],
		l: n.map((e) => ({
			...e,
			kind: "prefix"
		})),
		r: n.map((e) => ({
			...e,
			kind: "prefix"
		}))
	});
	else s === "defaultables" ? (t.kind === "defaultables" && r.kind === "defaultables" && t.default !== r.default && M(Qc(t.default, r.default)), e.result = [...e.result, {
		kind: s,
		node: c,
		default: t.kind === "defaultables" ? t.default : r.kind === "defaultables" ? r.default : j(`Unexpected defaultable intersection from ${t.kind} and ${r.kind} elements.`)
	}]) : e.result = [...e.result, {
		kind: s,
		node: c
	}];
	let l = e.l.length, u = e.r.length;
	return (t.kind !== "variadic" || l >= u && (r.kind === "variadic" || u === 1)) && (e.l = n), (r.kind !== "variadic" || u >= l && (t.kind === "variadic" || l === 1)) && (e.r = i), du(e);
}, fu = (e) => e.kind === "prefix" || e.kind === "postfix", pu = (e) => (t) => {
	if (t.props.length || t.index) {
		let n = t.index?.map((t) => t[e]) ?? [];
		for (let r of t.props) n.push(r[e]);
		t.undeclared && n.push(`+ (undeclared): ${t.undeclared}`);
		let r = `{ ${n.join(", ")} }`;
		return t.sequence ? `${r} & ${t.sequence.description}` : r;
	}
	return t.sequence?.description ?? "{}";
}, mu = pu("description"), hu = pu("expression"), gu = (e, t, n) => {
	let r = e.required ? "required" : "optional";
	if (!t.signature.allows(e.key)) return null;
	let i = qs(e.value, t.value, n);
	return i instanceof B ? r === "optional" ? n.node("optional", {
		key: e.key,
		value: I.intrinsic.never.internal
	}) : i.withPrefixKey(e.key, e.kind) : null;
}, _u = R({
	kind: "structure",
	hasAssociatedError: !1,
	normalize: (e) => e,
	applyConfig: (e, t) => !e.undeclared && t.onUndeclaredKey !== "ignore" ? {
		...e,
		undeclared: t.onUndeclaredKey
	} : e,
	keys: {
		required: {
			child: !0,
			parse: tc("required"),
			reduceIo: (e, t, n) => {
				t.required = A(t.required, n.map((t) => e === "in" ? t.rawIn : t.rawOut));
			}
		},
		optional: {
			child: !0,
			parse: tc("optional"),
			reduceIo: (e, t, n) => {
				if (e === "in") {
					t.optional = n.map((e) => e.rawIn);
					return;
				}
				for (let e of n) t[e.outProp.kind] = A(t[e.outProp.kind], e.outProp.rawOut);
			}
		},
		index: {
			child: !0,
			parse: tc("index")
		},
		sequence: {
			child: !0,
			parse: tc("sequence")
		},
		undeclared: {
			parse: (e) => e === "ignore" ? void 0 : e,
			reduceIo: (e, t, n) => {
				if (n === "reject") {
					t.undeclared = "reject";
					return;
				}
				e === "in" ? delete t.undeclared : t.undeclared = "reject";
			}
		}
	},
	defaults: { description: mu },
	intersections: { structure: (e, t, n) => {
		let r = { ...e.inner }, i = { ...t.inner }, a = new B();
		if (e.undeclared) {
			let r = e.keyof();
			for (let e of t.requiredKeys) r.allows(e) || a.add("presence", I.intrinsic.never.internal, t.propsByKey[e].value, { path: [e] });
			i.optional &&= i.optional.filter((e) => r.allows(e.key)), i.index &&= i.index.flatMap((e) => {
				if (e.signature.extends(r)) return e;
				let t = qs(r, e.signature, n.$);
				if (t instanceof B) return [];
				let a = Eu(t, e.value, n.$);
				return a.required && (i.required = $i(i.required, a.required)), a.optional && (i.optional = $i(i.optional, a.optional)), a.index ?? [];
			});
		}
		if (t.undeclared) {
			let i = t.keyof();
			for (let t of e.requiredKeys) i.allows(t) || a.add("presence", e.propsByKey[t].value, I.intrinsic.never.internal, { path: [t] });
			r.optional &&= r.optional.filter((e) => i.allows(e.key)), r.index &&= r.index.flatMap((e) => {
				if (e.signature.extends(i)) return e;
				let t = qs(i, e.signature, n.$);
				if (t instanceof B) return [];
				let a = Eu(t, e.value, n.$);
				return a.required && (r.required = $i(r.required, a.required)), a.optional && (r.optional = $i(r.optional, a.optional)), a.index ?? [];
			});
		}
		let o = {};
		(e.undeclared || t.undeclared) && (o.undeclared = e.undeclared === "reject" || t.undeclared === "reject" ? "reject" : "delete");
		let s = nc({
			kind: "structure",
			baseInner: o,
			l: rc(r),
			r: rc(i),
			roots: [],
			ctx: n
		});
		return s instanceof B && a.push(...s), a.length ? a : s;
	} },
	reduce: (e, t) => {
		if (!e.required && !e.optional) return;
		let n = {}, r = !1, i = e.optional ? [...e.optional] : [];
		if (e.required) for (let r = 0; r < e.required.length; r++) {
			let i = e.required[r];
			if (i.key in n && M(ku(i.key)), n[i.key] = !0, e.index) for (let n of e.index) {
				let e = gu(i, n, t);
				if (e instanceof B) return e;
			}
		}
		if (e.optional) for (let a = 0; a < e.optional.length; a++) {
			let o = e.optional[a];
			if (o.key in n && M(ku(o.key)), n[o.key] = !0, e.index) for (let n of e.index) {
				let e = gu(o, n, t);
				if (e instanceof B) return e;
				e !== null && (i[a] = e, r = !0);
			}
		}
		if (r) return t.node("structure", {
			...e,
			optional: i
		}, { prereduced: !0 });
	}
}), vu = class extends $s {
	impliedBasis = I.intrinsic.object.internal;
	impliedSiblings = this.children.flatMap((e) => e.impliedSiblings ?? []);
	props = $i(this.required, this.optional);
	propsByKey = N(this.props, (e, t) => [t.key, t]);
	propsByKeyReference = Xo(this.propsByKey);
	expression = hu(this);
	requiredKeys = this.required?.map((e) => e.key) ?? [];
	optionalKeys = this.optional?.map((e) => e.key) ?? [];
	literalKeys = [...this.requiredKeys, ...this.optionalKeys];
	_keyof;
	keyof() {
		if (this._keyof) return this._keyof;
		let e = this.$.units(this.literalKeys).branches;
		if (this.index) for (let { signature: t } of this.index) e = e.concat(t.branches);
		return this._keyof = this.$.node("union", e);
	}
	map(e) {
		return this.$.node("structure", this.props.flatMap(e).reduce((e, t) => {
			let n = this.propsByKey[t.key];
			if (as(t)) return t.kind !== "required" && t.kind !== "optional" ? M(`Map result must have kind "required" or "optional" (was ${t.kind})`) : (e[t.kind] = A(e[t.kind], t), e);
			let r = t.kind ?? n?.kind ?? "required", i = N(t, (e, t) => e in $c.implementation.keys ? [e, t] : []);
			return e[r] = A(e[r], this.$.node(r, i)), e;
		}, {}));
	}
	assertHasKeys(e) {
		let t = e.filter((e) => !dl(e, this.keyof()));
		if (t.length) return M(Ou(this.expression, t));
	}
	get(e, ...t) {
		let n, r = !1, i = wu(e);
		if ((typeof i == "string" || typeof i == "symbol") && this.propsByKey[i] && (n = this.propsByKey[i].value, r = this.propsByKey[i].required), this.index) for (let e of this.index) dl(i, e.signature) && (n = n?.and(e.value) ?? e.value);
		if (this.sequence && dl(i, I.intrinsic.nonNegativeIntegerString)) if (L(i, "root")) this.sequence.variadic && (n = n?.and(this.sequence.element) ?? this.sequence.element);
		else {
			let e = Number.parseInt(i);
			if (e < this.sequence.prevariadic.length) {
				let t = this.sequence.prevariadic[e].node;
				n = n?.and(t) ?? t, r ||= e < this.sequence.prefixLength;
			} else if (this.sequence.variadic) {
				let e = this.$.node("union", this.sequence.variadicOrPostfix);
				n = n?.and(e) ?? e;
			}
		}
		if (!n) return this.sequence?.variadic && L(i, "root") && i.extends(I.intrinsic.number) ? M(Tu(i.expression, this.sequence.expression)) : M(Ou(this.expression, [i]));
		let a = n.get(...t);
		return r ? a : a.or(I.intrinsic.undefined);
	}
	pick(...e) {
		return this.assertHasKeys(e), this.$.node("structure", this.filterKeys("pick", e));
	}
	omit(...e) {
		return this.assertHasKeys(e), this.$.node("structure", this.filterKeys("omit", e));
	}
	optionalize() {
		let { required: e, ...t } = this.inner;
		return this.$.node("structure", {
			...t,
			optional: this.props.map((e) => e.hasKind("required") ? this.$.node("optional", e.inner) : e)
		});
	}
	require() {
		let { optional: e, ...t } = this.inner;
		return this.$.node("structure", {
			...t,
			required: this.props.map((e) => e.hasKind("optional") ? {
				key: e.key,
				value: e.value
			} : e)
		});
	}
	merge(e) {
		let t = this.filterKeys("omit", [e.keyof()]);
		return e.required && (t.required = A(t.required, e.required)), e.optional && (t.optional = A(t.optional, e.optional)), e.index && (t.index = A(t.index, e.index)), e.sequence && (t.sequence = e.sequence), e.undeclared ? t.undeclared = e.undeclared : delete t.undeclared, this.$.node("structure", t);
	}
	filterKeys(e, t) {
		let n = rs(this.inner), r = (n) => {
			let r = t.some((e) => dl(n, e));
			return e === "pick" ? r : !r;
		};
		return n.required &&= n.required.filter((e) => r(e.key)), n.optional &&= n.optional.filter((e) => r(e.key)), n.index &&= n.index.filter((e) => r(e.signature)), n;
	}
	traverseAllows = (e, t) => this._traverse("Allows", e, t);
	traverseApply = (e, t) => this._traverse("Apply", e, t);
	_traverse = (e, t, n) => {
		let r = n?.currentErrorCount ?? 0;
		for (let i = 0; i < this.props.length; i++) if (e === "Allows") {
			if (!this.props[i].traverseAllows(t, n)) return !1;
		} else if (this.props[i].traverseApply(t, n), n.failFast && n.currentErrorCount > r) return !1;
		if (this.sequence) {
			if (e === "Allows") {
				if (!this.sequence.traverseAllows(t, n)) return !1;
			} else if (this.sequence.traverseApply(t, n), n.failFast && n.currentErrorCount > r) return !1;
		}
		if (this.index || this.undeclared === "reject") {
			let i = Object.keys(t);
			i.push(...Object.getOwnPropertySymbols(t));
			for (let a = 0; a < i.length; a++) {
				let o = i[a];
				if (this.index) {
					for (let i of this.index) if (i.signature.traverseAllows(o, n)) {
						if (e === "Allows") {
							if (!Ms(o, () => i.value.traverseAllows(t[o], n), n)) return !1;
						} else if (Ms(o, () => i.value.traverseApply(t[o], n), n), n.failFast && n.currentErrorCount > r) return !1;
					}
				}
				if (this.undeclared === "reject" && !this.declaresKey(o) && (e === "Allows" || (n.errorFromNodeContext({
					code: "predicate",
					expected: "removed",
					actual: "",
					relativePath: [o],
					meta: this.meta
				}), n.failFast))) return !1;
			}
		}
		return this.structuralMorph && n && !n.hasError() && n.queueMorphs([this.structuralMorph]), !0;
	};
	get defaultable() {
		return this.cacheGetter("defaultable", this.optional?.filter((e) => e.hasDefault()) ?? []);
	}
	declaresKey = (e) => e in this.propsByKey || this.index?.some((t) => t.signature.allows(e)) || this.sequence !== void 0 && I.intrinsic.nonNegativeIntegerString.allows(e);
	_compileDeclaresKey(e) {
		let t = [];
		if (this.props.length && t.push(`k in ${this.propsByKeyReference}`), this.index) for (let n of this.index) t.push(e.invoke(n.signature, {
			kind: "Allows",
			arg: "k"
		}));
		return this.sequence && t.push("$ark.intrinsic.nonNegativeIntegerString.allows(k)"), t.join(" || ") || "false";
	}
	get structuralMorph() {
		return this.cacheGetter("structuralMorph", xu(this));
	}
	structuralMorphRef = this.structuralMorph && Xo(this.structuralMorph);
	compile(e) {
		e.traversalKind === "Apply" && e.initializeErrorCount();
		for (let t of this.props) e.check(t), e.traversalKind === "Apply" && e.returnIfFailFast();
		if (this.sequence && (e.check(this.sequence), e.traversalKind === "Apply" && e.returnIfFailFast()), (this.index || this.undeclared === "reject") && (e.const("keys", "Object.keys(data)"), e.line("keys.push(...Object.getOwnPropertySymbols(data))"), e.for("i < keys.length", () => this.compileExhaustiveEntry(e))), e.traversalKind === "Allows") return e.return(!0);
		this.structuralMorphRef && e.if("ctx && !ctx.hasError()", () => (e.line("ctx.queueMorphs(["), Su(e, this), e.line("])")));
	}
	compileExhaustiveEntry(e) {
		if (e.const("k", "keys[i]"), this.index) for (let t of this.index) e.if(`${e.invoke(t.signature, {
			arg: "k",
			kind: "Allows"
		})}`, () => e.traverseKey("k", "data[k]", t.value));
		return this.undeclared === "reject" && e.if(`!(${this._compileDeclaresKey(e)})`, () => e.traversalKind === "Allows" ? e.return(!1) : e.line(`ctx.errorFromNodeContext({ code: "predicate", expected: "removed", actual: "", relativePath: [k], meta: ${this.compiledMeta} })`).if("ctx.failFast", () => e.return())), e;
	}
	reduceJsonSchema(e, t) {
		switch (e.type) {
			case "object": return this.reduceObjectJsonSchema(e, t);
			case "array":
				let n = this.sequence?.reduceJsonSchema(e, t) ?? e;
				return this.props.length || this.index ? t.fallback.arrayObject({
					code: "arrayObject",
					base: n,
					object: this.reduceObjectJsonSchema({ type: "object" }, t)
				}) : n;
			default: return z.throwInternalOperandError("structure", e);
		}
	}
	reduceObjectJsonSchema(e, t) {
		if (this.props.length) {
			e.properties = {};
			for (let n of this.props) {
				let r = n.value.toJsonSchemaRecurse(t);
				if (typeof n.key == "symbol") {
					t.fallback.symbolKey({
						code: "symbolKey",
						base: e,
						key: n.key,
						value: r,
						optional: n.optional
					});
					continue;
				}
				if (n.hasDefault()) {
					let e = typeof n.default == "function" ? n.default() : n.default;
					r.default = I.intrinsic.jsonData.allows(e) ? e : t.fallback.defaultValue({
						code: "defaultValue",
						base: r,
						value: e
					});
				}
				e.properties[n.key] = r;
			}
			this.requiredKeys.length && e.properties && (e.required = this.requiredKeys.filter((t) => typeof t == "string" && t in e.properties));
		}
		if (this.index) for (let n of this.index) {
			let r = n.value.toJsonSchemaRecurse(t);
			if (n.signature.equals(I.intrinsic.string)) {
				e.additionalProperties = r;
				continue;
			}
			for (let i of n.signature.branches) {
				if (!i.extends(I.intrinsic.string)) {
					e = t.fallback.symbolKey({
						code: "symbolKey",
						base: e,
						key: null,
						value: r,
						optional: !1
					});
					continue;
				}
				let n = { type: "string" };
				if (i.hasKind("morph") && (n = t.fallback.morph({
					code: "morph",
					base: i.rawIn.toJsonSchemaRecurse(t),
					out: i.rawOut.toJsonSchemaRecurse(t)
				})), !i.hasKind("intersection")) return j(`Unexpected index branch kind ${i.kind}.`);
				let { pattern: a } = i.inner;
				if (a) {
					let i = Object.assign(n, { pattern: a[0].rule });
					for (let e = 1; e < a.length; e++) n = t.fallback.patternIntersection({
						code: "patternIntersection",
						base: i,
						pattern: a[e].rule
					});
					e.patternProperties ??= {}, e.patternProperties[i.pattern] = r;
				}
			}
		}
		return this.undeclared && !e.additionalProperties && (e.additionalProperties = !1), e;
	}
}, yu = {}, bu = (e) => {
	let t = "";
	for (let n = 0; n < e.defaultable.length; n++) t += e.defaultable[n].defaultValueMorphRef;
	if (e.sequence?.defaultValueMorphsReference && (t += e.sequence?.defaultValueMorphsReference), e.undeclared === "delete") {
		if (t += "delete !(", e.required) for (let n of e.required) t += n.compiledKey + " | ";
		if (e.optional) for (let n of e.optional) t += n.compiledKey + " | ";
		if (e.index) for (let n of e.index) t += n.signature.id + " | ";
		if (e.sequence) if (e.sequence.maxLength === null) t += U.nonNegativeIntegerString.id;
		else for (let n = 0; n < e.sequence.tuple.length; n++) t += n + " | ";
		t += ")";
	}
	return t;
}, xu = (e) => {
	let t = bu(e);
	return t ? yu[t] ? yu[t] : yu[t] = (t, n) => {
		for (let r = 0; r < e.defaultable.length; r++) e.defaultable[r].key in t || e.defaultable[r].defaultValueMorph(t, n);
		if (e.sequence?.defaultables) for (let r = t.length - e.sequence.prefixLength; r < e.sequence.defaultables.length; r++) e.sequence.defaultValueMorphs[r](t, n);
		if (e.undeclared === "delete") for (let n in t) e.declaresKey(n) || delete t[n];
		return t;
	} : void 0;
}, Su = (e, t) => {
	let n = `(data${t.defaultable.some((e) => e.defaultValueMorph.length === 2) || t.sequence?.defaultValueMorphs.some((e) => e.length === 2) ? ", ctx" : ""})`;
	return e.block(`${n} => `, (e) => {
		for (let r = 0; r < t.defaultable.length; r++) {
			let { serializedKey: i, defaultValueMorphRef: a } = t.defaultable[r];
			e.if(`!(${i} in data)`, (e) => e.line(`${a}${n}`));
		}
		return t.sequence?.defaultables && e.for(`i < ${t.sequence.defaultables.length}`, (e) => e.set("data[i]", 5), `data.length - ${t.sequence.prefixLength}`), t.undeclared === "delete" && e.forIn("data", (e) => e.if(`!(${t._compileDeclaresKey(e)})`, (e) => e.line("delete data[k]"))), e.return("data");
	});
}, Cu = {
	implementation: _u,
	Node: vu
}, wu = (e) => (L(e, "root") && e.hasKind("unit") && (e = e.unit), typeof e == "number" && (e = `${e}`), e), Tu = (e, t) => `${e} is not allowed as an array index on ${t}. Use the 'nonNegativeIntegerString' keyword instead.`, Eu = (e, t, n) => {
	let [r, i] = Yi(e.branches, (e) => e.hasKind("unit"));
	if (!r.length) return { index: n.node("index", {
		signature: e,
		value: t
	}) };
	let a = {};
	for (let e of r) {
		let r = n.node("required", {
			key: e.unit,
			value: t
		});
		a[r.kind] = A(a[r.kind], r);
	}
	return i.length && (a.index = n.node("index", {
		signature: i,
		value: t
	})), a;
}, Du = (e) => L(e, "root") ? e.expression : F(e), Ou = (e, t) => `Key${t.length === 1 ? "" : "s"} ${t.map(Du).join(", ")} ${t.length === 1 ? "does" : "do"} not exist on ${e}`, ku = (e) => `Duplicate key ${Qo(e)}`, Au = {
	...Fc,
	alias: xl.implementation,
	domain: Cl.implementation,
	unit: Xl.implementation,
	proto: kl.implementation,
	union: zl.implementation,
	morph: Dl.implementation,
	intersection: wl.implementation,
	divisor: fc.implementation,
	pattern: Lc.implementation,
	predicate: dc.implementation,
	required: tu.implementation,
	optional: $c.implementation,
	index: Ql.implementation,
	sequence: ou.implementation,
	structure: Cu.implementation
};
I.defaultConfig = Ca(Object.assign(N(Au, (e, t) => [e, t.defaults]), {
	jitless: Ga(),
	clone: za,
	onUndeclaredKey: "ignore",
	exactOptionalPropertyTypes: !0,
	numberAllowsNaN: !1,
	dateAllowsInvalid: !1,
	onFail: null,
	keywords: {},
	toJsonSchema: z.defaultConfig
})), I.resolvedConfig = xs(I.defaultConfig, I.config);
var ju = {
	...Ic,
	alias: xl.Node,
	domain: Cl.Node,
	unit: Xl.Node,
	proto: kl.Node,
	union: zl.Node,
	morph: Dl.Node,
	intersection: wl.Node,
	divisor: fc.Node,
	pattern: Lc.Node,
	predicate: dc.Node,
	required: tu.Node,
	optional: $c.Node,
	index: Ql.Node,
	sequence: ou.Node,
	structure: Cu.Node
}, Mu = class extends ha {
	get [is]() {
		return "module";
	}
}, Nu = (e, t) => new Mu(N(e, (e, n) => [e, L(n, "module") ? Nu(n, t) : t.bindReference(n)])), Pu = (e) => P(e) ? e : "branches" in e && P(e.branches) ? e.branches : void 0, Fu = (e, t) => M(`Node of kind ${t} is not valid as a ${e} definition`), Iu = (e) => `#${e} duplicates public alias ${e}`, Lu = {};
I.ambient ??= {};
var Ru, zu = "function $", Bu = (e) => Vu(e, Hu(e)), Vu = (e, t) => {
	let n = t.write(zu, 4), r = t.compile()();
	for (let t of e) t.precompilation ||= (t.traverseAllows = r[`${t.id}Allows`].bind(r), t.isRoot() && !t.allowsRequiresContext && (t.allows = t.traverseAllows), t.traverseApply = r[`${t.id}Apply`].bind(r), r[`${t.id}Optimistic`] && (t.traverseOptimistic = r[`${t.id}Optimistic`].bind(r)), n);
}, Hu = (e) => new Zo().return(e.reduce((e, t) => {
	let n = new ns({ kind: "Allows" }).indent();
	t.compile(n);
	let r = n.write(`${t.id}Allows`), i = new ns({ kind: "Apply" }).indent();
	t.compile(i);
	let a = `${e}${r},\n${i.write(`${t.id}Apply`)},\n`;
	if (!t.hasKind("union")) return a;
	let o = new ns({
		kind: "Allows",
		optimistic: !0
	}).indent();
	return t.compile(o), `${a}${o.write(`${t.id}Optimistic`)},\n`;
}, "{\n") + "}"), Uu = class {
	config;
	resolvedConfig;
	name;
	get [is]() {
		return "scope";
	}
	referencesById = {};
	references = [];
	resolutions = {};
	exportedNames = [];
	aliases = {};
	resolved = !1;
	nodesByHash = {};
	intrinsic;
	constructor(e, t) {
		this.config = xs(I.config, t), this.resolvedConfig = xs(I.resolvedConfig, t), this.name = this.resolvedConfig.name ?? `anonymousScope${Object.keys(Lu).length}`, this.name in Lu && M(`A Scope already named ${this.name} already exists`), Lu[this.name] = this;
		let n = Object.entries(e).map((e) => this.preparseOwnAliasEntry(...e));
		for (let [e, t] of n) {
			let n = e;
			if (e[0] === "#" ? (n = e.slice(1), n in this.aliases && M(Iu(n)), this.aliases[n] = t) : (n in this.aliases && M(Iu(e)), this.aliases[n] = t, this.exportedNames.push(n)), !L(t, "module") && !L(t, "generic") && !Ha(t)) {
				let e = this.preparseOwnDefinitionFormat(t, { alias: n });
				this.resolutions[n] = L(e, "root") ? this.bindReference(e) : this.createParseContext(e).id;
			}
		}
		Ru ??= this.node("union", { branches: [
			"string",
			"number",
			"object",
			"bigint",
			"symbol",
			{ unit: !0 },
			{ unit: !1 },
			{ unit: void 0 },
			{ unit: null }
		] }, { prereduced: !0 }), this.nodesByHash[Ru.hash] = this.node("intersection", {}, { prereduced: !0 }), this.intrinsic = I.intrinsic ? N(I.intrinsic, (e, t) => e.startsWith("json") ? [] : [e, this.bindReference(t)]) : {};
	}
	cacheGetter(e, t) {
		return Object.defineProperty(this, e, { value: t }), t;
	}
	get internal() {
		return this;
	}
	_json;
	get json() {
		return this._json || this.export(), this._json;
	}
	defineSchema(e) {
		return e;
	}
	generic = (...e) => {
		let t = this;
		return (n, r) => new lc(e, r ? new cc(n) : n, t, t, r ?? null);
	};
	units = (e, t) => {
		let n = [];
		for (let t of e) n.includes(t) || n.push(t);
		let r = n.map((e) => this.node("unit", { unit: e }, t));
		return this.node("union", r, {
			...t,
			prereduced: !0
		});
	};
	lazyResolutions = [];
	lazilyResolve(e, t) {
		let n = this.node("alias", {
			reference: t ?? "synthetic",
			resolve: e
		}, { prereduced: !0 });
		return this.resolved || this.lazyResolutions.push(n), n;
	}
	schema = (e, t) => this.finalize(this.parseSchema(e, t));
	parseSchema = (e, t) => this.node(Rc(e), e, t);
	preparseNode(e, t, n) {
		let r = typeof e == "string" ? e : Rc(t, e);
		if (as(t) && t.kind === r) return t;
		if (r === "alias" && !n?.prereduced) {
			let { reference: e } = xl.implementation.normalize(t, this);
			if (e.startsWith("$")) {
				let n = this.resolveRoot(e.slice(1));
				t = n, r = n.kind;
			}
		} else if (r === "union" && ia(t, "object")) {
			let e = Pu(t);
			e?.length === 1 && (t = e[0], r = Rc(t));
		}
		if (as(t) && t.kind === r) return t;
		let i = Au[r].normalize?.(t, this) ?? t;
		return as(i) ? i.kind === r ? i : Fu(r, i.kind) : {
			...n,
			$: this,
			kind: r,
			def: i,
			prefix: n.alias ?? r
		};
	}
	bindReference(e) {
		let t;
		return t = as(e) ? e.$ === this ? e : new e.constructor(e.attachments, this) : e.$ === this ? e : new lc(e.params, e.bodyDef, e.$, this, e.hkt), this.resolved || Object.assign(this.referencesById, t.referencesById), t;
	}
	resolveRoot(e) {
		return this.maybeResolveRoot(e) ?? M(Zu(e));
	}
	maybeResolveRoot(e) {
		let t = this.maybeResolve(e);
		if (!L(t, "generic")) return t;
	}
	maybeResolveSubalias(e) {
		return qu(this.aliases, e) ?? qu(this.ambient, e);
	}
	get ambient() {
		return I.ambient;
	}
	maybeResolve(e) {
		let t = this.resolutions[e];
		if (t) {
			if (typeof t != "string") return this.bindReference(t);
			let n = Uc[t];
			if (L(n, "root")) return this.resolutions[e] = n;
			if (L(n, "context")) {
				if (n.phase === "resolving") return this.node("alias", { reference: `$${e}` }, { prereduced: !0 });
				if (n.phase === "resolved") return j(`Unexpected resolved context for was uncached by its scope: ${F(n)}`);
				n.phase = "resolving";
				let t = this.bindReference(this.parseOwnDefinitionFormat(n.def, n));
				return n.phase = "resolved", Uc[t.id] = t, Uc[n.id] = t, this.resolutions[e] = t;
			}
			return j(`Unexpected nodesById entry for ${t}: ${F(n)}`);
		}
		let n = this.aliases[e] ?? this.ambient?.[e];
		return n ? (n = this.normalizeRootScopeValue(n), L(n, "generic") ? this.resolutions[e] = this.bindReference(n) : L(n, "module") ? (n.root || M($u(e)), this.resolutions[e] = this.bindReference(n.root)) : this.resolutions[e] = this.parse(n, { alias: e })) : this.maybeResolveSubalias(e);
	}
	createParseContext(e) {
		let t = e.id ?? Wc(e.prefix);
		return Uc[t] = Object.assign(e, {
			[is]: "context",
			$: this,
			id: t,
			phase: "unresolved"
		});
	}
	traversal(e) {
		return new js(e, this.resolvedConfig);
	}
	import(...e) {
		return new Mu(N(this.export(...e), (e, t) => [`#${e}`, t]));
	}
	precompilation;
	_exportedResolutions;
	_exports;
	export(...e) {
		if (!this._exports) {
			this._exports = {};
			for (let e of this.exportedNames) {
				let t = this.aliases[e];
				this._exports[e] = L(t, "module") ? Nu(t, this) : Gu(this.maybeResolve(e));
			}
			for (let e of this.lazyResolutions) e.resolution;
			if (this._exportedResolutions = Xu(this, this._exports), this._json = Ku(this._exportedResolutions), Object.assign(this.resolutions, this._exportedResolutions), this.references = Object.values(this.referencesById), !this.resolvedConfig.jitless) {
				let e = Hu(this.references);
				this.precompilation = e.write(zu, 4), Vu(this.references, e);
			}
			this.resolved = !0;
		}
		return new Mu(N(e.length ? e : this.exportedNames, (e, t) => [t, this._exports[t]]));
	}
	resolve(e) {
		return this.export()[e];
	}
	node = (e, t, n = {}) => {
		let r = this.preparseNode(e, t, n);
		if (as(r)) return this.bindReference(r);
		let i = this.createParseContext(r), a = Gc(i), o = this.bindReference(a);
		return Uc[i.id] = o;
	};
	parse = (e, t = {}) => this.finalize(this.parseDefinition(e, t));
	parseDefinition(e, t = {}) {
		if (L(e, "root")) return this.bindReference(e);
		let n = this.preparseOwnDefinitionFormat(e, t);
		if (L(n, "root")) return this.bindReference(n);
		let r = this.createParseContext(n);
		Uc[r.id] = r;
		let i = this.bindReference(this.parseOwnDefinitionFormat(e, r));
		return i.isCyclic && (i = qc(i, r.id)), Uc[r.id] = i, i;
	}
	finalize(e) {
		return Gu(e), !e.precompilation && !this.resolvedConfig.jitless && Bu(e.references), e;
	}
}, Wu = class extends Uu {
	parseOwnDefinitionFormat(e, t) {
		return Gc(t);
	}
	preparseOwnDefinitionFormat(e, t) {
		return this.preparseNode(Rc(e), e, t);
	}
	preparseOwnAliasEntry(e, t) {
		return [e, t];
	}
	normalizeRootScopeValue(e) {
		return e;
	}
}, Gu = (e) => {
	let t = e.references.filter((e) => e.hasKind("alias"));
	for (let n of t) {
		Object.assign(n.referencesById, n.resolution.referencesById);
		for (let t of e.references) n.id in t.referencesById && Object.assign(t.referencesById, n.referencesById);
	}
	return e;
}, Ku = (e) => N(e, (e, t) => [e, L(t, "root") || L(t, "generic") ? t.json : L(t, "module") ? Ku(t) : j(`Unexpected resolution ${F(t)}`)]), qu = (e, t) => {
	let n = t.indexOf(".");
	if (n === -1) return;
	let r = t.slice(0, n), i = e[r];
	if (i === void 0) return;
	if (!L(i, "module")) return M(Qu(r));
	let a = t.slice(n + 1), o = i[a];
	if (o === void 0) return qu(i, a);
	if (L(o, "root") || L(o, "generic")) return o;
	if (L(o, "module")) return o.root ?? M($u(t));
	j(`Unexpected resolution for alias '${t}': ${F(o)}`);
}, Ju = (e, t) => new Wu(e, t), Yu = new Wu({}), Xu = (e, t) => {
	let n = {};
	for (let r in t) {
		let i = t[r];
		if (L(i, "module")) {
			let t = N(Xu(e, i), (e, t) => [`${r}.${e}`, t]);
			Object.assign(n, t);
		} else L(i, "root") || L(i, "generic") ? n[r] = i : j(`Unexpected scope resolution ${F(i)}`);
	}
	return n;
}, Zu = (e) => `'${e}' is unresolvable`, Qu = (e) => `'${e}' must reference a module to be accessed using dot syntax`, $u = (e) => `Reference to submodule '${e}' must specify an alias`;
Yu.export();
var H = Yu.schema, ed = Yu.node;
Yu.defineSchema;
var td = Yu.generic, nd = "^(?:0|[1-9]\\d*)$";
Xo(new RegExp(nd));
//#endregion
//#region ../../node_modules/.pnpm/@ark+schema@0.56.0/node_modules/@ark/schema/out/intrinsic.js
var rd = Ju({
	bigint: "bigint",
	boolean: [{ unit: !1 }, { unit: !0 }],
	false: { unit: !1 },
	never: [],
	null: { unit: null },
	number: "number",
	object: "object",
	string: "string",
	symbol: "symbol",
	true: { unit: !0 },
	unknown: {},
	undefined: { unit: void 0 },
	Array,
	Date
}, { prereducedAliases: !0 }).export();
I.intrinsic = { ...rd };
var id = Ju({
	integer: {
		domain: "number",
		divisor: 1
	},
	lengthBoundable: ["string", Array],
	key: ["string", "symbol"],
	nonNegativeIntegerString: {
		domain: "string",
		pattern: nd
	}
}, { prereducedAliases: !0 }).export();
Object.assign(I.intrinsic, id);
var ad = Ju({
	jsonPrimitive: [
		"string",
		"number",
		{ unit: !0 },
		{ unit: !1 },
		{ unit: null }
	],
	jsonObject: {
		domain: "object",
		index: {
			signature: "string",
			value: "$jsonData"
		}
	},
	jsonData: ["$jsonPrimitive", "$jsonObject"]
}, { prereducedAliases: !0 }).export(), U = {
	...rd,
	...id,
	...ad,
	emptyStructure: ed("structure", {}, { prereduced: !0 })
};
I.intrinsic = { ...U };
//#endregion
//#region ../../node_modules/.pnpm/arkregex@0.0.5/node_modules/arkregex/out/regex.js
var od = ((e, t) => new RegExp(e, t));
Object.assign(od, { as: od });
//#endregion
//#region ../../node_modules/.pnpm/arktype@2.2.0/node_modules/arktype/out/parser/shift/operand/date.js
var sd = (e) => typeof e == "string" && e[0] === "d" && (e[1] === "'" || e[1] === "\"") && e[e.length - 1] === e[1], cd = (e) => e.toString() !== "Invalid Date", ld = (e) => e.slice(2, -1), ud = (e) => `'${e}' could not be parsed by the Date constructor`, dd = (e, t) => fd(e, t), fd = (e, t) => {
	let n = new Date(e);
	if (cd(n)) return n;
	let r = bo(e);
	if (r !== void 0) {
		let e = new Date(r);
		if (cd(e)) return e;
	}
	return t ? M(t === !0 ? ud(e) : t) : void 0;
}, pd = H({
	proto: "Array",
	sequence: "string",
	required: {
		key: "groups",
		value: ["object", { unit: void 0 }]
	}
}), md = (e, t) => {
	let n = e.scanner.shiftUntilEscapable(bd[yd[t]]);
	if (e.scanner.lookahead === "") return e.error(Sd(n, t));
	if (e.scanner.shift(), t in vd) {
		let r;
		try {
			r = new RegExp(n);
		} catch (e) {
			M(String(e));
		}
		e.root = e.ctx.$.node("intersection", {
			domain: "string",
			pattern: n
		}, { prereduced: !0 }), t === "x/" && (e.root = e.ctx.$.node("morph", {
			in: e.root,
			morphs: (e) => r.exec(e),
			declaredOut: pd
		}));
	} else if (pa(t, hd)) e.root = e.ctx.$.node("unit", { unit: n });
	else {
		let t = dd(n, ud(n));
		e.root = e.ctx.$.node("unit", {
			meta: n,
			unit: t
		});
	}
}, hd = {
	"'": 1,
	"\"": 1
}, gd = {
	"/": 1,
	"'": 1,
	"\"": 1
}, _d = {
	"d'": "'",
	"d\"": "\"",
	"'": "'",
	"\"": "\""
}, vd = {
	"/": "/",
	"x/": "/"
}, yd = {
	..._d,
	...vd
}, bd = {
	"'": (e) => e.lookahead === "'",
	"\"": (e) => e.lookahead === "\"",
	"/": (e) => e.lookahead === "/"
}, xd = {
	"\"": "double-quote",
	"'": "single-quote",
	"/": "forward slash"
}, Sd = (e, t) => `${t}${e} requires a closing ${xd[yd[t]]}`, Cd = (e) => `Private type references should not include '#'. Use '${e}' instead.`, wd = "Optional definitions like 'string?' are only valid as properties in an object or tuple", Td = "Defaultable definitions like 'number = 0' are only valid as properties in an object or tuple", Ed = {
	"<": 1,
	">": 1,
	"=": 1,
	"|": 1,
	"&": 1,
	")": 1,
	"[": 1,
	"%": 1,
	",": 1,
	":": 1,
	"?": 1,
	"#": 1,
	...$a
}, Dd = (e, t) => e === ">" ? t[0] === "=" ? t[1] === "=" : t.trimStart() === "" || pa(t.trimStart()[0], Ed) : e === "=" ? t[0] !== "=" : e === "," || e === "?", Od = (e, t, n) => kd(e, t, n, []), kd = (e, t, n, r) => {
	let i = n.parseUntilFinalizer();
	return r.push(i.root), i.finalizer === ">" ? r.length === t.params.length ? r : n.error(Ad(e, t.names, r.map((e) => e.expression))) : i.finalizer === "," ? kd(e, t, n, r) : i.error(Go(">"));
}, Ad = (e, t, n) => `${e}<${t.join(", ")}> requires exactly ${t.length} args (got ${n.length}${n.length === 0 ? "" : `: ${n.join(", ")}`})`, jd = (e) => {
	let t = e.scanner.shiftUntilLookahead(Ed);
	t === "keyof" ? e.addPrefix("keyof") : e.root = Nd(e, t);
}, Md = (e, t, n) => (n.scanner.shiftUntilNonWhitespace(), n.scanner.shift() === "<" ? t(...Od(e, t, n)) : n.error(Ad(e, t.names, []))), Nd = (e, t) => Pd(e, t) ?? Fd(e, t) ?? e.error(t === "" ? e.scanner.lookahead === "#" ? Cd(e.shiftedBy(1).scanner.shiftUntilLookahead(Ed)) : Id(e) : Zu(t)), Pd = (e, t) => {
	if (e.ctx.args?.[t]) {
		let n = e.ctx.args[t];
		return typeof n == "string" ? e.ctx.$.node("alias", { reference: n }, { prereduced: !0 }) : n;
	}
	let n = e.ctx.$.maybeResolve(t);
	if (L(n, "root")) return n;
	if (n !== void 0) return L(n, "generic") ? Md(t, n, e) : M(`Unexpected resolution ${F(n)}`);
}, Fd = (e, t) => {
	let n = xo(t);
	if (n !== void 0) return e.ctx.$.node("unit", { unit: n });
	let r = wo(t);
	if (r !== void 0) return e.ctx.$.node("unit", { unit: r });
}, Id = (e) => {
	let t = e.previousOperator();
	return t ? Ld(t, e.scanner.unscanned) : Rd(e.scanner.unscanned);
}, Ld = (e, t = "") => `Token '${e}' requires a right operand${t ? ` before '${t}'` : ""}`, Rd = (e) => `Expected an expression${e ? ` before '${e}'` : ""}`, zd = (e) => e.scanner.lookahead === "" ? e.error(Id(e)) : e.scanner.lookahead === "(" ? e.shiftedBy(1).reduceGroupOpen() : e.scanner.lookaheadIsIn(gd) ? md(e, e.scanner.shift()) : e.scanner.lookaheadIsIn($a) ? zd(e.shiftedBy(1)) : e.scanner.lookahead === "d" ? e.scanner.nextLookahead in hd ? md(e, `${e.scanner.shift()}${e.scanner.shift()}`) : jd(e) : e.scanner.lookahead === "x" && e.scanner.nextLookahead === "/" ? e.shiftedBy(2) && md(e, "x/") : jd(e), Bd = {
	">": !0,
	">=": !0
}, Vd = {
	"<": !0,
	"<=": !0
}, Hd = {
	"<": ">",
	">": "<",
	"<=": ">=",
	">=": "<=",
	"==": "=="
}, Ud = (e, t) => `Left bounds are only valid when paired with right bounds (try ...${t}${e})`, Wd = (e) => `Left-bounded expressions must specify their limits using < or <= (was ${e})`, Gd = (e, t, n, r) => `An expression may have at most one left bound (parsed ${e}${Hd[t]}, ${n}${Hd[r]})`, Kd = (e, t) => {
	let n = Jd(e, t);
	if (e.root.hasKind("unit")) {
		if (typeof e.root.unit == "number") {
			e.reduceLeftBound(e.root.unit, n), e.unsetRoot();
			return;
		}
		if (e.root.unit instanceof Date) {
			let t = `d'${e.root.description ?? e.root.unit.toISOString()}'`;
			e.unsetRoot(), e.reduceLeftBound(t, n);
			return;
		}
	}
	return Zd(e, n);
}, qd = {
	"<": 1,
	">": 1,
	"=": 1
}, Jd = (e, t) => e.scanner.lookaheadIs("=") ? `${t}${e.scanner.shift()}` : t, Yd = (e, t, n, r) => n.extends(I.intrinsic.number) ? typeof t == "number" ? e === "==" ? ["min", "max"] : e[0] === ">" ? ["min"] : ["max"] : M(Qd(e, t, r)) : n.extends(I.intrinsic.lengthBoundable) ? typeof t == "number" ? e === "==" ? ["exactLength"] : e[0] === ">" ? ["minLength"] : ["maxLength"] : M(Qd(e, t, r)) : n.extends(I.intrinsic.Date) ? e === "==" ? ["after", "before"] : e[0] === ">" ? ["after"] : ["before"] : M(Dc(n.expression)), Xd = (e) => ({
	rule: sd(e.limit) ? ld(e.limit) : e.limit,
	exclusive: e.comparator.length === 1
}), Zd = (e, t) => {
	let n = e.unsetRoot(), r = e.scanner.location;
	e.parseOperand();
	let i = e.unsetRoot(), a = e.scanner.sliceChars(r, e.scanner.location);
	if (e.root = n, !i.hasKind("unit") || typeof i.unit != "number" && !(i.unit instanceof Date)) return e.error(Qd(t, a, "right"));
	let o = i.unit, s = t.length === 1, c = Yd(t, typeof o == "number" ? o : a, n, "right");
	for (let n of c) e.constrainRoot(n, t === "==" ? { rule: o } : {
		rule: o,
		exclusive: s
	});
	if (!e.branches.leftBound) return;
	if (!pa(t, Vd)) return e.error(Wd(t));
	let l = Yd(e.branches.leftBound.comparator, e.branches.leftBound.limit, n, "left");
	e.constrainRoot(l[0], Xd(e.branches.leftBound)), e.branches.leftBound = null;
}, Qd = (e, t, n) => `Comparator ${n === "left" ? Hd[e] : e} must be ${n === "left" ? "preceded" : "followed"} by a corresponding literal (was ${t})`, $d = (e) => {
	e.scanner.shiftUntilNonWhitespace();
	let t = e.scanner.shiftUntilLookahead(Ed);
	e.root = e.root.brand(t);
}, ef = (e) => {
	e.scanner.shiftUntilNonWhitespace();
	let t = e.scanner.shiftUntilLookahead(Ed), n = So(t, { errorOnFail: tf(t) });
	n === 0 && e.error(tf(0)), e.root = e.root.constrain("divisor", n);
}, tf = (e) => `% operator must be followed by a non-zero integer literal (was ${e})`, nf = (e) => {
	let t = e.scanner.shift();
	return t === "" ? e.finalize("") : t === "[" ? e.scanner.shift() === "]" ? e.setRoot(e.root.array()) : e.error(af) : t === "|" ? e.scanner.lookahead === ">" ? e.shiftedBy(1).pushRootToBranch("|>") : e.pushRootToBranch(t) : t === "&" ? e.pushRootToBranch(t) : t === ")" ? e.finalizeGroup() : Dd(t, e.scanner.unscanned) ? e.finalize(t) : pa(t, qd) ? Kd(e, t) : t === "%" ? ef(e) : t === "#" ? $d(e) : t in $a ? nf(e) : e.error(rf(t));
}, rf = (e, t = "") => `'${e}' is not allowed here${t && ` (should be ${t})`}`, af = "Missing expected ']'", of = (e) => {
	let t = e.unsetRoot();
	e.parseOperand();
	let n = e.unsetRoot();
	return n.hasKind("unit") ? [
		t,
		"=",
		n.unit instanceof Date ? () => new Date(n.unit) : n.unit
	] : e.error(sf(n.expression));
}, sf = (e) => `Default value '${e}' must be a literal value`, cf = (e, t) => {
	let n = t.$.maybeResolveRoot(e);
	if (n) return n;
	if (e.endsWith("[]")) {
		let n = t.$.maybeResolveRoot(e.slice(0, -2));
		if (n) return n.array();
	}
	let r = new ff(new Uo(e), t), i = lf(r);
	return r.finalizer === ">" && M(rf(">")), i;
}, lf = (e) => {
	e.parseOperand();
	let t = uf(e).root;
	return t ? (e.finalizer === "=" ? t = of(e) : e.finalizer === "?" && (t = [t, "?"]), e.scanner.shiftUntilNonWhitespace(), e.scanner.lookahead && M(rf(e.scanner.lookahead)), t) : j(`Root was unexpectedly unset after parsing string '${e.scanner.scanned}'`);
}, uf = (e) => {
	for (; e.finalizer === void 0;) df(e);
	return e;
}, df = (e) => e.hasRoot() ? e.parseOperator() : e.parseOperand(), ff = class e {
	root;
	branches = {
		prefixes: [],
		leftBound: null,
		intersection: null,
		union: null,
		pipe: null
	};
	finalizer;
	groups = [];
	scanner;
	ctx;
	constructor(e, t) {
		this.scanner = e, this.ctx = t;
	}
	error(e) {
		return M(e);
	}
	hasRoot() {
		return this.root !== void 0;
	}
	setRoot(e) {
		this.root = e;
	}
	unsetRoot() {
		let e = this.root;
		return this.root = void 0, e;
	}
	constrainRoot(...e) {
		this.root = this.root.constrain(e[0], e[1]);
	}
	finalize(e) {
		if (this.groups.length) return this.error(Go(")"));
		this.finalizeBranches(), this.finalizer = e;
	}
	reduceLeftBound(e, t) {
		let n = Hd[t];
		if (!pa(n, Bd)) return this.error(Wd(t));
		if (this.branches.leftBound) return this.error(Gd(this.branches.leftBound.limit, this.branches.leftBound.comparator, e, n));
		this.branches.leftBound = {
			comparator: n,
			limit: e
		};
	}
	finalizeBranches() {
		if (this.assertRangeUnset(), this.branches.pipe) {
			this.pushRootToBranch("|>"), this.root = this.branches.pipe;
			return;
		}
		if (this.branches.union) {
			this.pushRootToBranch("|"), this.root = this.branches.union;
			return;
		}
		if (this.branches.intersection) {
			this.pushRootToBranch("&"), this.root = this.branches.intersection;
			return;
		}
		this.applyPrefixes();
	}
	finalizeGroup() {
		this.finalizeBranches();
		let e = this.groups.pop();
		if (!e) return this.error(Wo(")", this.scanner.unscanned));
		this.branches = e;
	}
	addPrefix(e) {
		this.branches.prefixes.push(e);
	}
	applyPrefixes() {
		for (; this.branches.prefixes.length;) {
			let e = this.branches.prefixes.pop();
			this.root = e === "keyof" ? this.root.keyof() : j(`Unexpected prefix '${e}'`);
		}
	}
	pushRootToBranch(e) {
		this.assertRangeUnset(), this.applyPrefixes();
		let t = this.root;
		this.root = void 0, this.branches.intersection = this.branches.intersection?.rawAnd(t) ?? t, e !== "&" && (this.branches.union = this.branches.union?.rawOr(this.branches.intersection) ?? this.branches.intersection, this.branches.intersection = null, e !== "|" && (this.branches.pipe = this.branches.pipe?.rawPipeOnce(this.branches.union) ?? this.branches.union, this.branches.union = null));
	}
	parseUntilFinalizer() {
		return uf(new e(this.scanner, this.ctx));
	}
	parseOperator() {
		return nf(this);
	}
	parseOperand() {
		return zd(this);
	}
	assertRangeUnset() {
		if (this.branches.leftBound) return this.error(Ud(this.branches.leftBound.limit, this.branches.leftBound.comparator));
	}
	reduceGroupOpen() {
		this.groups.push(this.branches), this.branches = {
			prefixes: [],
			leftBound: null,
			union: null,
			intersection: null,
			pipe: null
		};
	}
	previousOperator() {
		return this.branches.leftBound?.comparator ?? this.branches.prefixes[this.branches.prefixes.length - 1] ?? (this.branches.intersection ? "&" : this.branches.union ? "|" : this.branches.pipe ? "|>" : void 0);
	}
	shiftedBy(e) {
		return this.scanner.jumpForward(e), this;
	}
}, pf = "An empty string is not a valid generic parameter name", mf = (e, t, n) => {
	e.shiftUntilNonWhitespace();
	let r = e.shiftUntilLookahead(Ed);
	return r === "" ? e.lookahead === "" && t.length ? t : M(pf) : (e.shiftUntilNonWhitespace(), gf(e, r, t, n));
}, hf = "extends ", gf = (e, t, n, r) => {
	if (e.shiftUntilNonWhitespace(), e.unscanned.startsWith(hf)) e.jumpForward(8);
	else return e.lookahead === "," && e.shift(), n.push(t), mf(e, n, r);
	let i = uf(new ff(e, r));
	return n.push([t, i.root]), mf(e, n, r);
}, _f = class extends Wa {
	constructor(e) {
		let t = {
			$: e,
			raw: e.fn
		};
		super((...t) => {
			let n = t.indexOf(":"), r = n === -1 ? t.length - 1 : n - 1, i = t.slice(0, r + 1), a = e.parse(i).assertHasKind("intersection"), o = e.intrinsic.unknown;
			if (n !== -1) {
				if (n !== t.length - 2) return M(yf);
				o = e.parse(t[n + 1]);
			}
			return (e) => new vf(e, a, o);
		}, { attach: t });
	}
}, vf = class extends Wa {
	raw;
	params;
	returns;
	expression;
	constructor(e, t, n) {
		let r = `typed ${e.name}`, i = { [r]: (...r) => {
			let i = e(...t.assert(r));
			return n.assert(i);
		} }[r];
		super(i), this.raw = e, this.params = t, this.returns = n;
		let a = t.expression;
		a[0] === "[" && a[a.length - 1] === "]" ? a = a.slice(1, -1) : a.endsWith("[]") && (a = `...${a}`), this.expression = `(${a}) => ${n?.expression ?? "unknown"}`;
	}
}, yf = "\":\" must be followed by exactly one return type e.g:\nfn(\"string\", \":\", \"number\")(s => s.length)", bf = class extends Wa {
	$;
	constructor(e) {
		super((...t) => new xf(e)(...t), { bind: e }), this.$ = e;
	}
	in(e) {
		return new xf(this.$, e === void 0 ? void 0 : this.$.parse(e));
	}
	at(e, t) {
		return new xf(this.$).at(e, t);
	}
	case(e, t) {
		return new xf(this.$).case(e, t);
	}
}, xf = class extends Wa {
	$;
	in;
	key;
	branches = [];
	constructor(e, t) {
		super((e) => this.caseEntries(Object.entries(e).map(([e, t]) => e === "default" ? [e, t] : [this.$.parse(e), t]))), this.$ = e, this.in = t;
	}
	at(e, t) {
		return this.key && M(wf), this.branches.length && M(Cf), this.key = e, t ? this.match(t) : this;
	}
	case(e, t) {
		return this.caseEntry(this.$.parse(e), t);
	}
	caseEntry(e, t) {
		let n = (this.key ? this.$.parse({ [this.key]: e }) : e).pipe(t);
		return this.branches.push(n), this;
	}
	match(e) {
		return this(e);
	}
	strings(e) {
		return this.caseEntries(Object.entries(e).map(([e, t]) => e === "default" ? [e, t] : [this.$.node("unit", { unit: e }), t]));
	}
	caseEntries(e) {
		for (let t = 0; t < e.length; t++) {
			let [n, r] = e[t];
			if (n === "default") return t !== e.length - 1 && M("default may only be specified as the last key of a switch definition"), this.default(r);
			if (typeof r != "function") return M(`Value for case "${n}" must be a function (was ${aa(r)})`);
			this.caseEntry(n, r);
		}
		return this;
	}
	default(e) {
		typeof e == "function" && this.case(U.unknown, e);
		let t = {
			branches: this.branches,
			ordered: !0
		};
		(e === "never" || e === "assert") && (t.meta = { onFail: Sf });
		let n = this.$.node("union", t);
		if (!this.in) return this.$.finalize(n);
		let r = this.in.pipe(n);
		return (e === "never" || e === "assert") && (r = r.configureReferences({ onFail: Sf }, "self")), this.$.finalize(r);
	}
}, Sf = (e) => e.throw(), Cf = "A key matcher must be specified before the first case i.e. match.at('foo') or match.in<object>().at('bar')", wf = "At most one key matcher may be specified per expression", Tf = (e, t) => {
	if (P(e)) {
		if (e[1] === "=") return [
			t.$.parseOwnDefinitionFormat(e[0], t),
			"=",
			e[2]
		];
		if (e[1] === "?") return [t.$.parseOwnDefinitionFormat(e[0], t), "?"];
	}
	return cp(e, t);
}, Ef = "Only required keys may make their values optional, e.g. { [mySymbol]: ['number', '?'] }", Df = "Only required keys may specify default values, e.g. { value: 'number = 0' }", Of = (e, t) => {
	let n, r = {}, i = xa(e);
	for (let [e, a] of i) {
		let i = Mf(e);
		if (i.kind === "spread") {
			if (!ba(r)) return M(jf);
			let e = t.$.parseOwnDefinitionFormat(a, t);
			if (e.equals(U.object)) continue;
			if (!e.hasKind("intersection") || !e.basis?.equals(U.object)) return M(Nf(e.expression));
			n = e.structure;
			continue;
		}
		if (i.kind === "undeclared") {
			a !== "reject" && a !== "delete" && a !== "ignore" && M(Af(a)), r.undeclared = a;
			continue;
		}
		let o = Tf(a, t), s = i;
		if (i.kind === "required") {
			P(o) ? kf(r, "optional", o[1] === "=" ? {
				key: i.normalized,
				value: o[0],
				default: o[2]
			} : {
				key: i.normalized,
				value: o[0]
			}, t) : kf(r, "required", {
				key: i.normalized,
				value: o
			}, t);
			continue;
		}
		if (P(o) && (o[1] === "?" && M(Ef), o[1] === "=" && M(Df)), i.kind === "optional") {
			kf(r, "optional", {
				key: i.normalized,
				value: o
			}, t);
			continue;
		}
		let c = Eu(t.$.parseOwnDefinitionFormat(s.normalized, t), o, t.$);
		c.index && (r.index = A(r.index, c.index)), c.required && (r.required = A(r.required, c.required));
	}
	let a = t.$.node("structure", r);
	return t.$.parseSchema({
		domain: "object",
		structure: n?.merge(a) ?? a
	});
}, kf = (e, t, n, r) => {
	e[t] = A(e[t], r.$.node(t, n));
}, Af = (e) => `Value of '+' key must be 'reject', 'delete', or 'ignore' (was ${F(e)})`, jf = "Spread operator may only be used as the first key in an object", Mf = (e) => typeof e == "symbol" ? {
	kind: "required",
	normalized: e
} : e[e.length - 1] === "?" ? e[e.length - 2] === "\\" ? {
	kind: "required",
	normalized: `${e.slice(0, -2)}?`
} : {
	kind: "optional",
	normalized: e.slice(0, -1)
} : e[0] === "[" && e[e.length - 1] === "]" ? {
	kind: "index",
	normalized: e.slice(1, -1)
} : e[0] === "\\" && e[1] === "[" && e[e.length - 1] === "]" ? {
	kind: "required",
	normalized: e.slice(1)
} : e === "..." ? { kind: "spread" } : e === "+" ? { kind: "undeclared" } : {
	kind: "required",
	normalized: e === "\\..." ? "..." : e === "\\+" ? "+" : e
}, Nf = (e) => `Spread operand must resolve to an object literal type (was ${e})`, Pf = (e, t) => Jf(e) ? qf[e[0]](e, t) : Kf(e) ? Gf[e[1]](e, t) : null, Ff = (e, t) => t.$.parseOwnDefinitionFormat(e[1], t).keyof(), If = (e, t) => {
	if (e[2] === void 0) return M(Ld(e[1], ""));
	let n = t.$.parseOwnDefinitionFormat(e[0], t), r = t.$.parseOwnDefinitionFormat(e[2], t);
	if (e[1] === "|") return t.$.node("union", { branches: [n, r] });
	let i = e[1] === "&" ? qs(n, r, t.$) : Js(n, r, t.$);
	return i instanceof B ? i.throw() : i;
}, Lf = (e, t) => t.$.parseOwnDefinitionFormat(e[0], t).array(), Rf = (e, t) => typeof e[2] == "function" ? t.$.parseOwnDefinitionFormat(e[0], t).pipe(e[2]) : M(zf("=>", e[2])), zf = (e, t) => `${e === ":" ? "Narrow" : "Morph"} expression requires a function following '${e}' (was ${typeof t})`, Bf = (e, t) => typeof e[2] == "function" ? t.$.parseOwnDefinitionFormat(e[0], t).constrain("predicate", e[2]) : M(zf(":", e[2])), Vf = (e, t) => t.$.parseOwnDefinitionFormat(e[0], t).configure(e[2], e[3]), Hf = (e) => e, Uf = Hf({
	"[]": Lf,
	"?": () => M(wd)
}), Wf = Hf({
	"|": If,
	"&": If,
	":": Bf,
	"=>": Rf,
	"|>": If,
	"@": Vf,
	"=": () => M(Td)
}), Gf = {
	...Uf,
	...Wf
}, Kf = (e) => Gf[e[1]] !== void 0, qf = ((e) => e)({
	keyof: Ff,
	instanceof: (e, t) => {
		if (typeof e[1] != "function") return M(Yf(Ma(e[1])));
		let n = e.slice(1).map((e) => typeof e == "function" ? t.$.node("proto", { proto: e }) : M(Yf(Ma(e))));
		return n.length === 1 ? n[0] : t.$.node("union", { branches: n });
	},
	"===": (e, t) => t.$.units(e.slice(1))
}), Jf = (e) => qf[e[0]] !== void 0, Yf = (e) => `Expected a constructor following 'instanceof' operator (was ${e})`, Xf = (e, t) => {
	let n = [{}], r = 0;
	for (; r < e.length;) {
		let i = !1;
		e[r] === "..." && r < e.length - 1 && (i = !0, r++);
		let a = Tf(e[r], t), [o, s, c] = P(a) ? a : [a];
		if (r++, i) {
			if (!o.extends(I.intrinsic.Array)) return M(np(o.expression));
			n = n.flatMap((e) => o.distribute((t) => tp(rs(e), t)));
		} else n = n.map((e) => s === "?" ? Qf(e, o) : s === "=" ? $f(e, o, c) : Zf(e, o));
	}
	return t.$.parseSchema(n.map((e) => ba(e) ? {
		proto: Array,
		exactLength: 0
	} : {
		proto: Array,
		sequence: e
	}));
}, Zf = (e, t) => e.defaultables || e.optionals ? M(e.variadic ? lu : ip) : (e.variadic ? e.postfix = A(e.postfix, t) : e.prefix = A(e.prefix, t), e), Qf = (e, t) => e.variadic ? M(ap) : (e.optionals = A(e.optionals, t), e), $f = (e, t, n) => e.variadic ? M(ap) : e.optionals ? M(op) : (e.defaultables = A(e.defaultables, [[t, n]]), e), ep = (e, t) => (e.postfix && M(rp), e.variadic ? e.variadic.equals(t) || M(rp) : e.variadic = t.internal, e), tp = (e, t) => {
	let n = t.select({
		method: "find",
		kind: "sequence"
	});
	if (!n) return ep(e, I.intrinsic.unknown);
	if (n.prefix) for (let t of n.prefix) Zf(e, t);
	if (n.optionals) for (let t of n.optionals) Qf(e, t);
	if (n.variadic && ep(e, n.variadic), n.postfix) for (let t of n.postfix) Zf(e, t);
	return e;
}, np = (e) => `Spread element must be an array (was ${e})`, rp = "A tuple may have at most one variadic element", ip = "A required element may not follow an optional element", ap = "An optional element may not follow a variadic element", op = "A defaultable element may not follow an optional element without a default", sp = {}, cp = (e, t) => {
	if (typeof e == "string") {
		if (t.args && Object.keys(t.args).some((t) => e.includes(t))) return cf(e, t);
		let n = sp[t.$.name] ??= {};
		return n[e] ??= cf(e, t);
	}
	return ia(e, "object") ? lp(e, t) : M(fp(aa(e)));
}, lp = (e, t) => {
	let n = ja(e);
	switch (n) {
		case void 0: return L(e, "root") ? e : "~standard" in e ? up(e, t) : Of(e, t);
		case "Array": return dp(e, t);
		case "RegExp": return t.$.node("intersection", {
			domain: "string",
			pattern: e
		}, { prereduced: !0 });
		case "Function": {
			let t = Ha(e) ? e() : e;
			return L(t, "root") ? t : M(fp("Function"));
		}
		default: return M(fp(n ?? F(e)));
	}
}, up = (e, t) => t.$.intrinsic.unknown.pipe((t, n) => {
	let r = e["~standard"].validate(t);
	if (!r.issues) return r.value;
	for (let { message: e, path: t } of r.issues) t && t.length ? n.error({
		problem: Ya(e),
		relativePath: t.map((e) => typeof e == "object" ? e.key : e)
	}) : n.error({ message: e });
}), dp = (e, t) => Pf(e, t) ?? Xf(e, t), fp = (e) => `Type definitions must be strings or objects (was ${e})`, pp = class extends Wa {
	constructor(e) {
		let t = Object.assign({
			errors: Os,
			hkt: Ka,
			$: e,
			raw: e.parse,
			module: e.constructor.module,
			scope: e.constructor.scope,
			declare: e.declare,
			define: e.define,
			match: e.match,
			generic: e.generic,
			schema: e.schema,
			keywords: e.ambient,
			unit: e.unit,
			enumerated: e.enumerated,
			instanceOf: e.instanceOf,
			valueOf: e.valueOf,
			or: e.or,
			and: e.and,
			merge: e.merge,
			pipe: e.pipe,
			fn: e.fn
		}, e.ambientAttachments);
		super((...t) => {
			if (t.length === 1) return e.parse(t[0]);
			if (t.length === 2 && typeof t[0] == "string" && t[0][0] === "<" && t[0][t[0].length - 1] === ">") {
				let n = t[0].slice(1, -1);
				return new lc(e.parseGenericParams(n, {}), t[1], e, e, null);
			}
			return e.parse(t);
		}, { attach: t });
	}
}, mp = I, hp = class e extends Uu {
	get ambientAttachments() {
		if (mp.typeAttachments) return this.cacheGetter("ambientAttachments", N(mp.typeAttachments, (e, t) => [e, this.bindReference(t)]));
	}
	preparseOwnAliasEntry(e, t) {
		let n = e.indexOf("<");
		if (n === -1) {
			if (L(t, "module") || L(t, "generic")) return [e, t];
			let n = this.name === "ark" ? e : e === "root" ? this.name : `${this.name}.${e}`, r = this.resolvedConfig.keywords?.[n];
			return r && (t = [
				t,
				"@",
				r
			]), [e, t];
		}
		e[e.length - 1] !== ">" && M("'>' must be the last character of a generic declaration in a scope");
		let r = e.slice(0, n), i = e.slice(n + 1, -1);
		return [r, () => sc(this.parseGenericParams(i, { alias: r }), t, this)];
	}
	parseGenericParams(e, t) {
		return mf(new Uo(e), [], this.createParseContext({
			...t,
			def: e,
			prefix: "generic"
		}));
	}
	normalizeRootScopeValue(e) {
		return Ha(e) && !L(e, "generic") ? e() : e;
	}
	preparseOwnDefinitionFormat(e, t) {
		return {
			...t,
			def: e,
			prefix: t.alias ?? "type"
		};
	}
	parseOwnDefinitionFormat(e, t) {
		!(t.alias && t.alias in this.aliases) && !t.args && (t.args = { this: t.id });
		let n = cp(e, t);
		if (P(n)) {
			if (n[1] === "=") return M(Td);
			if (n[1] === "?") return M(wd);
		}
		return n;
	}
	unit = (e) => this.units([e]);
	valueOf = (e) => this.units(Ta(e));
	enumerated = (...e) => this.units(e);
	instanceOf = (e) => this.node("proto", { proto: e }, { prereduced: !0 });
	or = (...e) => this.schema(e.map((e) => this.parse(e)));
	and = (...e) => e.reduce((e, t) => e.and(this.parse(t)), this.intrinsic.unknown);
	merge = (...e) => e.reduce((e, t) => e.merge(this.parse(t)), this.intrinsic.object);
	pipe = (...e) => this.intrinsic.unknown.pipe(...e);
	fn = new _f(this);
	match = new bf(this);
	declare = () => ({ type: this.type });
	define(e) {
		return e;
	}
	type = new pp(this);
	static scope = ((t, n = {}) => new e(t, n));
	static module = ((e, t = {}) => this.scope(e, t).export());
}, gp = Object.assign(hp.scope, { define: (e) => e }), W = hp, _p = class extends Ka {
	description = "merge an object's properties onto another like `Merge(User, { isAdmin: \"true\" })`";
}, vp = td(["base", U.object], ["props", U.object])((e) => e.base.merge(e.props), _p), yp = W.module({
	Key: U.key,
	Merge: vp
}), bp = class extends Ka {}, xp = td("element")((e) => {
	let t = e.element.exclude(U.Array), n = t.array();
	return t.rawOr(n).pipe(Ji).distribute((e) => e.assertHasKind("morph").declareOut(n), H);
}, bp), Sp = W.module({
	root: U.Array,
	readonly: "root",
	index: U.nonNegativeIntegerString,
	liftFrom: xp
}, { name: "Array" }), Cp = H(["string", To.FileConstructor]), wp = H({
	meta: "an object representing parsed form data",
	domain: "object",
	index: {
		signature: "string",
		value: Cp.rawOr(Cp.array())
	}
}), Tp = W.module({
	root: ["instanceof", FormData],
	value: Cp,
	parsed: wp,
	parse: H({
		in: FormData,
		morphs: (e) => {
			let t = {};
			for (let [n, r] of e) if (n in t) {
				let e = t[n];
				typeof e == "string" || e instanceof To.FileConstructor ? t[n] = [e, r] : e.push(r);
			} else t[n] = r;
			return t;
		},
		declaredOut: wp
	})
}, { name: "FormData" }), Ep = W.module({
	Int8: ["instanceof", Int8Array],
	Uint8: ["instanceof", Uint8Array],
	Uint8Clamped: ["instanceof", Uint8ClampedArray],
	Int16: ["instanceof", Int16Array],
	Uint16: ["instanceof", Uint16Array],
	Int32: ["instanceof", Int32Array],
	Uint32: ["instanceof", Uint32Array],
	Float32: ["instanceof", Float32Array],
	Float64: ["instanceof", Float64Array],
	BigInt64: ["instanceof", BigInt64Array],
	BigUint64: ["instanceof", BigUint64Array]
}, { name: "TypedArray" }), Dp = {
	Boolean: 1,
	Number: 1,
	String: 1
}, Op = W.module({
	...N({
		...Ea,
		...Oa
	}, (e, t) => e in Dp ? [] : [e, ["instanceof", t]]),
	Array: Sp,
	TypedArray: Ep,
	FormData: Tp
}), kp = H({
	domain: {
		domain: "number",
		meta: "a number representing a Unix timestamp"
	},
	divisor: {
		rule: 1,
		meta: "an integer representing a Unix timestamp"
	},
	min: {
		rule: -864e13,
		meta: "a Unix timestamp after -8640000000000000"
	},
	max: {
		rule: 864e13,
		meta: "a Unix timestamp before 8640000000000000"
	},
	meta: "an integer representing a safe Unix timestamp"
}), Ap = H({
	domain: "number",
	divisor: 1
}), jp = W.module({
	root: U.number,
	integer: Ap,
	epoch: kp,
	safe: H({
		domain: {
			domain: "number",
			numberAllowsNaN: !1
		},
		min: -(2 ** 53 - 1),
		max: 2 ** 53 - 1
	}),
	NaN: ["===", NaN],
	Infinity: ["===", Infinity],
	NegativeInfinity: ["===", -Infinity]
}, { name: "number" }), G = (e, t, n) => {
	let r = {
		domain: "string",
		pattern: {
			rule: e.source,
			flags: e.flags,
			meta: t
		}
	};
	return n && (r.meta = { format: n }), ed("intersection", r);
}, Mp = G(uo, "a well-formed integer string"), Np = W.module({
	root: Mp,
	parse: H({
		in: Mp,
		morphs: (e, t) => {
			let n = Number.parseInt(e);
			return Number.isSafeInteger(n) ? n : t.error("an integer in the range Number.MIN_SAFE_INTEGER to Number.MAX_SAFE_INTEGER");
		},
		declaredOut: U.integer
	})
}, { name: "string.integer" }), Pp = G(/^[\dA-Fa-f]+$/, "hex characters only"), Fp = W.module({
	root: G(/^(?:[\d+/A-Za-z]{4})*(?:[\d+/A-Za-z]{2}==|[\d+/A-Za-z]{3}=)?$/, "base64-encoded"),
	url: G(/^(?:[\w-]{4})*(?:[\w-]{2}(?:==|%3D%3D)?|[\w-]{3}(?:=|%3D)?)?$/, "base64url-encoded")
}, { name: "string.base64" }), Ip = G(/^[A-Z].*$/, "capitalized"), Lp = W.module({
	root: H({
		in: "string",
		morphs: (e) => e.charAt(0).toUpperCase() + e.slice(1),
		declaredOut: Ip
	}),
	preformatted: Ip
}, { name: "string.capitalize" }), Rp = H({
	domain: "string",
	pattern: {
		meta: "a credit card number",
		rule: "^(?:4\\d{12}(?:\\d{3,6})?|5[1-5]\\d{14}|(222[1-9]|22[3-9]\\d|2[3-6]\\d{2}|27[01]\\d|2720)\\d{12}|6(?:011|5\\d\\d)\\d{12,15}|3[47]\\d{13}|3(?:0[0-5]|[68]\\d)\\d{11}|(?:2131|1800|35\\d{3})\\d{11}|6[27]\\d{14}|^(81\\d{14,17}))$"
	},
	predicate: {
		meta: "a credit card number",
		predicate: (e) => {
			let t = e.replace(/[ -]+/g, ""), n = 0, r, i, a = !1;
			for (let e = t.length - 1; e >= 0; e--) r = t.substring(e, e + 1), i = Number.parseInt(r, 10), a ? (i *= 2, n += i >= 10 ? i % 10 + 1 : i) : n += i, a = !a;
			return !!(n % 10 == 0 && t);
		}
	}
}), zp = /^([+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))(T((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([,.]\d+(?!:))?)?(\17[0-5]\d([,.]\d+)?)?([Zz]|([+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, Bp = H({
	domain: "string",
	predicate: {
		meta: "a parsable date",
		predicate: (e) => !Number.isNaN(new Date(e).valueOf())
	}
}).assertHasKind("intersection"), Vp = Np.root.internal.narrow((e, t) => {
	let n = Number.parseInt(e), r = jp.epoch(n);
	return r instanceof Os ? (t.errors.merge(r), !1) : !0;
}).configure({ description: "an integer string representing a safe Unix timestamp" }, "self").assertHasKind("intersection"), Hp = W.module({
	root: Vp,
	parse: H({
		in: Vp,
		morphs: (e) => new Date(e),
		declaredOut: U.Date
	})
}, { name: "string.date.epoch" }), Up = G(zp, "an ISO 8601 (YYYY-MM-DDTHH:mm:ss.sssZ) date").internal.assertHasKind("intersection"), Wp = W.module({
	root: Up,
	parse: H({
		in: Up,
		morphs: (e) => new Date(e),
		declaredOut: U.Date
	})
}, { name: "string.date.iso" }), Gp = W.module({
	root: Bp,
	parse: H({
		declaredIn: Bp,
		in: "string",
		morphs: (e, t) => {
			let n = new Date(e);
			return Number.isNaN(n.valueOf()) ? t.error("a parsable date") : n;
		},
		declaredOut: U.Date
	}),
	iso: Wp,
	epoch: Hp
}, { name: "string.date" }), Kp = G(/^[\w%+.-]+@[\d.A-Za-z-]+\.[A-Za-z]{2,}$/, "an email address", "email"), qp = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])", Jp = `(${qp}[.]){3}${qp}`, Yp = RegExp(`^${Jp}$`), K = "(?:[0-9a-fA-F]{1,4})", Xp = RegExp(`^((?:${K}:){7}(?:${K}|:)|(?:${K}:){6}(?:${Jp}|:${K}|:)|(?:${K}:){5}(?::${Jp}|(:${K}){1,2}|:)|(?:${K}:){4}(?:(:${K}){0,1}:${Jp}|(:${K}){1,3}|:)|(?:${K}:){3}(?:(:${K}){0,2}:${Jp}|(:${K}){1,4}|:)|(?:${K}:){2}(?:(:${K}){0,3}:${Jp}|(:${K}){1,5}|:)|(?:${K}:){1}(?:(:${K}){0,4}:${Jp}|(:${K}){1,6}|:)|(?::((?::${K}){0,5}:${Jp}|(?::${K}){1,7}|:)))(%[0-9a-zA-Z.]{1,})?\$`), Zp = W.module({
	root: [
		"v4 | v6",
		"@",
		"an IP address"
	],
	v4: G(Yp, "an IPv4 address", "ipv4"),
	v6: G(Xp, "an IPv6 address", "ipv6")
}, { name: "string.ip" }), Qp = "a JSON string", $p = (e) => {
	if (!(e instanceof SyntaxError)) throw e;
	return `must be ${Qp} (${e})`;
}, em = H({
	meta: Qp,
	domain: "string",
	predicate: {
		meta: Qp,
		predicate: (e, t) => {
			try {
				return JSON.parse(e), !0;
			} catch (e) {
				return t.reject({
					code: "predicate",
					expected: Qp,
					problem: $p(e)
				});
			}
		}
	}
}), tm = W.module({
	root: em,
	parse: H({
		meta: "safe JSON string parser",
		in: "string",
		morphs: (e, t) => {
			if (e.length === 0) return t.error({
				code: "predicate",
				expected: Qp,
				actual: "empty"
			});
			try {
				return JSON.parse(e);
			} catch (e) {
				return t.error({
					code: "predicate",
					expected: Qp,
					problem: $p(e)
				});
			}
		},
		declaredOut: U.jsonObject
	})
}, { name: "string.json" }), nm = G(/^[a-z]*$/, "only lowercase letters"), rm = W.module({
	root: H({
		in: "string",
		morphs: (e) => e.toLowerCase(),
		declaredOut: nm
	}),
	preformatted: nm
}, { name: "string.lower" }), im = [
	"NFC",
	"NFD",
	"NFKC",
	"NFKD"
], am = N(im, (e, t) => [t, H({
	domain: "string",
	predicate: (e) => e.normalize(t) === e,
	meta: `${t}-normalized unicode`
})]), om = N(im, (e, t) => [t, H({
	in: "string",
	morphs: (e) => e.normalize(t),
	declaredOut: am[t]
})]), sm = W.module({
	root: om.NFC,
	preformatted: am.NFC
}, { name: "string.normalize.NFC" }), cm = W.module({
	root: om.NFD,
	preformatted: am.NFD
}, { name: "string.normalize.NFD" }), lm = W.module({
	root: om.NFKC,
	preformatted: am.NFKC
}, { name: "string.normalize.NFKC" }), um = W.module({
	root: om.NFKD,
	preformatted: am.NFKD
}, { name: "string.normalize.NFKD" }), dm = W.module({
	root: "NFC",
	NFC: sm,
	NFD: cm,
	NFKC: lm,
	NFKD: um
}, { name: "string.normalize" }), fm = G(so, "a well-formed numeric string"), pm = W.module({
	root: fm,
	parse: H({
		in: fm,
		morphs: (e) => Number.parseFloat(e),
		declaredOut: U.number
	})
}, { name: "string.numeric" }), mm = "a regex pattern", hm = H({
	domain: "string",
	predicate: {
		meta: mm,
		predicate: (e, t) => {
			try {
				return new RegExp(e), !0;
			} catch (e) {
				return t.reject({
					code: "predicate",
					expected: mm,
					problem: String(e)
				});
			}
		}
	},
	meta: { format: "regex" }
}), gm = G(/^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[A-Za-z-][\dA-Za-z-]*)(?:\.(?:0|[1-9]\d*|\d*[A-Za-z-][\dA-Za-z-]*))*))?(?:\+([\dA-Za-z-]+(?:\.[\dA-Za-z-]+)*))?$/, "a semantic version (see https://semver.org/)"), _m = G(/^\S.*\S$|^\S?$/, "trimmed"), vm = W.module({
	root: H({
		in: "string",
		morphs: (e) => e.trim(),
		declaredOut: _m
	}),
	preformatted: _m
}, { name: "string.trim" }), ym = G(/^[A-Z]*$/, "only uppercase letters"), bm = W.module({
	root: H({
		in: "string",
		morphs: (e) => e.toUpperCase(),
		declaredOut: ym
	}),
	preformatted: ym
}, { name: "string.upper" }), xm = H({
	domain: "string",
	predicate: {
		meta: "a URL string",
		predicate: (e) => URL.canParse(e)
	},
	meta: { format: "uri" }
}), Sm = W.module({
	root: xm,
	parse: H({
		declaredIn: xm,
		in: "string",
		morphs: (e, t) => {
			try {
				return new URL(e);
			} catch {
				return t.error("a URL string");
			}
		},
		declaredOut: H(URL)
	})
}, { name: "string.url" }), Cm = W.module({
	root: [
		"versioned | nil | max",
		"@",
		{
			description: "a UUID",
			format: "uuid"
		}
	],
	"#nil": "'00000000-0000-0000-0000-000000000000'",
	"#max": "'ffffffff-ffff-ffff-ffff-ffffffffffff'",
	"#versioned": /[\da-f]{8}-[\da-f]{4}-[1-8][\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}/i,
	v1: G(/^[\da-f]{8}-[\da-f]{4}-1[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i, "a UUIDv1"),
	v2: G(/^[\da-f]{8}-[\da-f]{4}-2[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i, "a UUIDv2"),
	v3: G(/^[\da-f]{8}-[\da-f]{4}-3[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i, "a UUIDv3"),
	v4: G(/^[\da-f]{8}-[\da-f]{4}-4[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i, "a UUIDv4"),
	v5: G(/^[\da-f]{8}-[\da-f]{4}-5[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i, "a UUIDv5"),
	v6: G(/^[\da-f]{8}-[\da-f]{4}-6[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i, "a UUIDv6"),
	v7: G(/^[\da-f]{8}-[\da-f]{4}-7[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i, "a UUIDv7"),
	v8: G(/^[\da-f]{8}-[\da-f]{4}-8[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i, "a UUIDv8")
}, { name: "string.uuid" }), wm = W.module({
	root: U.string,
	alpha: G(/^[A-Za-z]*$/, "only letters"),
	alphanumeric: G(/^[\dA-Za-z]*$/, "only letters and digits 0-9"),
	hex: Pp,
	base64: Fp,
	capitalize: Lp,
	creditCard: Rp,
	date: Gp,
	digits: G(/^\d*$/, "only digits 0-9"),
	email: Kp,
	integer: Np,
	ip: Zp,
	json: tm,
	lower: rm,
	normalize: dm,
	numeric: pm,
	regex: hm,
	semver: gm,
	trim: vm,
	upper: bm,
	url: Sm,
	uuid: Cm
}, { name: "string" }), Tm = W.module({
	bigint: U.bigint,
	boolean: U.boolean,
	false: U.false,
	never: U.never,
	null: U.null,
	number: U.number,
	object: U.object,
	string: U.string,
	symbol: U.symbol,
	true: U.true,
	unknown: U.unknown,
	undefined: U.undefined
}), Em = W.module({
	root: U.unknown,
	any: U.unknown
}, { name: "unknown" }), Dm = W.module({
	root: U.jsonObject,
	stringify: ed("morph", {
		in: U.jsonObject,
		morphs: (e) => JSON.stringify(e),
		declaredOut: U.string
	})
}, { name: "object.json" }), Om = W.module({
	root: U.object,
	json: Dm
}, { name: "object" }), km = class extends Ka {
	description = "instantiate an object from an index signature and corresponding value type like `Record(\"string\", \"number\")`";
}, Am = td(["K", U.key], "V")((e) => ({
	domain: "object",
	index: {
		signature: e.K,
		value: e.V
	}
}), km), jm = class extends Ka {
	description = "pick a set of properties from an object like `Pick(User, \"name | age\")`";
}, Mm = td(["T", U.object], ["K", U.key])((e) => e.T.pick(e.K), jm), Nm = class extends Ka {
	description = "omit a set of properties from an object like `Omit(User, \"age\")`";
}, Pm = td(["T", U.object], ["K", U.key])((e) => e.T.omit(e.K), Nm), Fm = class extends Ka {
	description = "make all named properties of an object optional like `Partial(User)`";
}, Im = td(["T", U.object])((e) => e.T.partial(), Fm), Lm = class extends Ka {
	description = "make all named properties of an object required like `Required(User)`";
}, Rm = td(["T", U.object])((e) => e.T.required(), Lm), zm = class extends Ka {
	description = "exclude branches of a union like `Exclude(\"boolean\", \"true\")`";
}, Bm = td("T", "U")((e) => e.T.exclude(e.U), zm), Vm = class extends Ka {
	description = "extract branches of a union like `Extract(\"0 | false | 1\", \"number\")`";
}, Hm = td("T", "U")((e) => e.T.extract(e.U), Vm), Um = W.module({
	Exclude: Bm,
	Extract: Hm,
	Omit: Pm,
	Partial: Im,
	Pick: Mm,
	Record: Am,
	Required: Rm
}), Wm = gp({
	...Tm,
	...Um,
	...Op,
	...yp,
	string: wm,
	number: jp,
	object: Om,
	unknown: Em
}, {
	prereducedAliases: !0,
	name: "ark"
}), q = Wm.export();
Object.assign(mp.ambient, q), mp.typeAttachments = {
	string: q.string.root,
	number: q.number.root,
	bigint: q.bigint,
	boolean: q.boolean,
	symbol: q.symbol,
	undefined: q.undefined,
	null: q.null,
	object: q.object.root,
	unknown: q.unknown.root,
	false: q.false,
	true: q.true,
	never: q.never,
	arrayIndex: q.Array.index,
	Key: q.Key,
	Record: q.Record,
	Array: q.Array.root,
	Date: q.Date
};
var Gm = Object.assign(Wm.type, mp.typeAttachments);
Wm.match, Wm.fn, Wm.generic, Wm.schema, Wm.define, Wm.declare;
//#endregion
//#region src/oauth/google.tsx
var Km = Gm({
	code: "string?",
	provider_access_token: "string?",
	provider_refresh_token: "string?",
	access_token: "string?",
	refresh_token: "string?",
	expires_at: "string.date.iso.parse"
}), qm = "QUIRKY_QUAIL_GOOGLE_OAUTH_REDIRECT_HASH";
function Jm() {
	let e = sessionStorage.getItem(qm);
	if (!e) return null;
	try {
		let t = Km(JSON.parse(e));
		return t instanceof Gm.errors ? (console.error("🚀 - getOauthRedirectData - result.summary:", t.summary), null) : t;
	} catch (t) {
		return console.error("🚀 - getOauthRedirectData JSON.parse fail - e:", t, e), null;
	}
}
function Ym() {
	let e = ki();
	return t.useCallback(async (t, n, r) => {
		console.log("🚀 Starting OAuth token processing", window.location.hash);
		try {
			console.log("Successfully retrieved user:", t);
			let i = new URLSearchParams(window.location.hash.substring(1));
			console.log("🚀 - returnReact.useCallback - params:", i);
			let a = i.get("expires_in"), o = /* @__PURE__ */ new Date();
			o.setSeconds(o.getSeconds() + parseInt(a || "3600", 10));
			let s = await e.auth.getSession().then((e) => e?.data?.session);
			if (!s) throw console.error("No supabase session found"), Error("No supabase session found");
			let { provider_token: c, provider_refresh_token: l, expires_at: u } = s, d = /* @__PURE__ */ new Date((u ?? 3600) * 1e3);
			if (!l) {
				n({
					status: "error",
					error: "No access token found in URL"
				});
				return;
			}
			if (!c) {
				n({
					status: "error",
					error: "No expiration"
				});
				return;
			}
			n({ status: "processing" }), console.log("🚀 - google.tsx:115 - skipping save refresh tokens", {
				provider: "google",
				provider_access_token: c,
				provider_refresh_token: l,
				provider_access_token_expires_at: d
			});
			let f = await r?.({
				profileId: t ?? "",
				provider: "google",
				provider_access_token: c,
				provider_refresh_token: l,
				provider_access_token_expires_at: d
			});
			console.log("🚀 - google.tsx:96 - useProcessOauthToken - result:", f), n({ status: "success" }), Xm();
		} catch (e) {
			console.error("Unexpected error in processOAuthToken:", e), n({
				status: "error",
				error: `An unexpected error occurred: ${e instanceof Error ? e.message : "Unknown error"}`
			});
		}
	}, [e]);
}
function Xm() {
	sessionStorage.removeItem(qm);
}
function Zm() {
	i(() => {
		let e = window.location.hash;
		if (!e) return;
		let t = new URLSearchParams(e.replace("#", "")), n = t.get("access_token"), r = t.get("code"), i = t.get("refresh_token"), a = t.get("expires_in"), o = Km({
			code: r,
			refresh_token: i,
			expires_at: qi(/* @__PURE__ */ new Date(), { seconds: a ? parseInt(a, 10) : 3600 }),
			access_token: n
		});
		if (o instanceof Gm.errors) {
			console.error("🚀 - getOauthRedirectData - result.summary:", o.summary);
			return;
		}
		sessionStorage.setItem(qm, JSON.stringify(o));
	}, []);
}
function Qm({ children: e }) {
	return Zm(), /* @__PURE__ */ s(o, { children: e }, void 0, !1);
}
//#endregion
//#region src/mapped-dates.ts
function $m(e) {
	let t = {};
	for (let n in e) e.hasOwnProperty(n) && (n.endsWith("_at") || n.endsWith("_dt") ? t[n] = e[n] ? new Date(e[n]) : e[n] : t[n] = e[n]);
	return t;
}
function eh(e) {
	let t = {};
	for (let n in e) t[n] = e[n] instanceof Date ? e[n].toISOString() : e[n];
	return t;
}
//#endregion
//#region src/metrics.ts
var th = 20, nh = 1e4;
function rh({ send: e, batchSize: t = th, flushIntervalMs: n = nh }) {
	let r = [], i = async () => {
		if (r.length === 0) return;
		let t = r;
		r = [], console.debug("[metrics] flush", {
			count: t.length,
			batch: t
		});
		try {
			await e(t), console.debug("[metrics] flush ok", { count: t.length });
		} catch (e) {
			console.warn("[metrics] flush failed", e, { droppedCount: t.length });
		}
	}, a = typeof setInterval == "function" && n > 0 ? setInterval(() => void i(), n) : void 0, o = () => {
		document.visibilityState === "hidden" && i();
	}, s = () => void i();
	return typeof document < "u" && document.addEventListener("visibilitychange", o), typeof window < "u" && window.addEventListener("pagehide", s), {
		record: (e) => {
			console.debug("[metrics] record", e), r.push(e), r.length >= t && i();
		},
		flush: i,
		dispose: () => {
			a && clearInterval(a), typeof document < "u" && document.removeEventListener("visibilitychange", o), typeof window < "u" && window.removeEventListener("pagehide", s), i();
		}
	};
}
//#endregion
//#region src/metrics-context.tsx
var ih = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-common/src/metrics-context.tsx", ah = n(null);
function oh({ collector: e, children: t }) {
	return /* @__PURE__ */ s(ah.Provider, {
		value: e,
		children: t
	}, void 0, !1, {
		fileName: ih,
		lineNumber: 14,
		columnNumber: 5
	}, this);
}
function sh() {
	return r(ah);
}
//#endregion
//#region src/type-helpers.ts
function ch(e, t) {
	if (typeof e == "object" && e && t in e) {
		let n = e[t];
		if (typeof n == "string") return n;
	}
}
//#endregion
//#region ../../node_modules/.pnpm/@0no-co+graphql.web@1.2.0_graphql@16.12.0/node_modules/@0no-co/graphql.web/dist/graphql.web.mjs
var lh = {
	NAME: "Name",
	DOCUMENT: "Document",
	OPERATION_DEFINITION: "OperationDefinition",
	VARIABLE_DEFINITION: "VariableDefinition",
	SELECTION_SET: "SelectionSet",
	FIELD: "Field",
	ARGUMENT: "Argument",
	FRAGMENT_SPREAD: "FragmentSpread",
	INLINE_FRAGMENT: "InlineFragment",
	FRAGMENT_DEFINITION: "FragmentDefinition",
	VARIABLE: "Variable",
	INT: "IntValue",
	FLOAT: "FloatValue",
	STRING: "StringValue",
	BOOLEAN: "BooleanValue",
	NULL: "NullValue",
	ENUM: "EnumValue",
	LIST: "ListValue",
	OBJECT: "ObjectValue",
	OBJECT_FIELD: "ObjectField",
	DIRECTIVE: "Directive",
	NAMED_TYPE: "NamedType",
	LIST_TYPE: "ListType",
	NON_NULL_TYPE: "NonNullType"
}, uh = class extends Error {
	constructor(e, t, n, r, i, a, o) {
		super(e), this.name = "GraphQLError", this.message = e, i && (this.path = i), t && (this.nodes = Array.isArray(t) ? t : [t]), n && (this.source = n), r && (this.positions = r), a && (this.originalError = a);
		var s = o;
		if (!s && a) {
			var c = a.extensions;
			c && typeof c == "object" && (s = c);
		}
		this.extensions = s || {};
	}
	toJSON() {
		return {
			...this,
			message: this.message
		};
	}
	toString() {
		return this.message;
	}
	get [Symbol.toStringTag]() {
		return "GraphQLError";
	}
}, J, Y;
function dh(e) {
	return new uh(`Syntax Error: Unexpected token at ${Y} in ${e}`);
}
function fh(e) {
	if (e.lastIndex = Y, e.test(J)) return J.slice(Y, Y = e.lastIndex);
}
var ph = / +(?=[^\s])/y;
function mh(e) {
	for (var t = e.split("\n"), n = "", r = 0, i = 0, a = t.length - 1, o = 0; o < t.length; o++) ph.lastIndex = 0, ph.test(t[o]) && (o && (!r || ph.lastIndex < r) && (r = ph.lastIndex), i ||= o, a = o);
	for (var s = i; s <= a; s++) s !== i && (n += "\n"), n += t[s].slice(r).replace(/\\"""/g, "\"\"\"");
	return n;
}
function X() {
	for (var e = 0 | J.charCodeAt(Y++); e === 9 || e === 10 || e === 13 || e === 32 || e === 35 || e === 44 || e === 65279; e = 0 | J.charCodeAt(Y++)) if (e === 35) for (; (e = 0 | J.charCodeAt(Y++)) && e !== 10 && e !== 13;);
	Y--;
}
function hh() {
	for (var e = Y, t = 0 | J.charCodeAt(Y++); t >= 48 && t <= 57 || t >= 65 && t <= 90 || t === 95 || t >= 97 && t <= 122; t = 0 | J.charCodeAt(Y++));
	if (e === Y - 1) throw dh("Name");
	var n = J.slice(e, --Y);
	return X(), n;
}
function gh() {
	return {
		kind: "Name",
		value: hh()
	};
}
var _h = /(?:"""|(?:[\s\S]*?[^\\])""")/y, vh = /(?:(?:\.\d+)?[eE][+-]?\d+|\.\d+)/y;
function yh(e) {
	var t;
	switch (J.charCodeAt(Y)) {
		case 91:
			Y++, X();
			for (var n = []; J.charCodeAt(Y) !== 93;) n.push(yh(e));
			return Y++, X(), {
				kind: "ListValue",
				values: n
			};
		case 123:
			Y++, X();
			for (var r = []; J.charCodeAt(Y) !== 125;) {
				var i = gh();
				if (J.charCodeAt(Y++) !== 58) throw dh("ObjectField");
				X(), r.push({
					kind: "ObjectField",
					name: i,
					value: yh(e)
				});
			}
			return Y++, X(), {
				kind: "ObjectValue",
				fields: r
			};
		case 36:
			if (e) throw dh("Variable");
			return Y++, {
				kind: "Variable",
				name: gh()
			};
		case 34: if (J.charCodeAt(Y + 1) === 34 && J.charCodeAt(Y + 2) === 34) {
			if (Y += 3, (t = fh(_h)) == null) throw dh("StringValue");
			return X(), {
				kind: "StringValue",
				value: mh(t.slice(0, -3)),
				block: !0
			};
		} else {
			var a = Y, o;
			Y++;
			var s = !1;
			for (o = 0 | J.charCodeAt(Y++); o === 92 && (Y++, s = !0) || o !== 10 && o !== 13 && o !== 34 && o; o = 0 | J.charCodeAt(Y++));
			if (o !== 34) throw dh("StringValue");
			return t = J.slice(a, Y), X(), {
				kind: "StringValue",
				value: s ? JSON.parse(t) : t.slice(1, -1),
				block: !1
			};
		}
		case 45:
		case 48:
		case 49:
		case 50:
		case 51:
		case 52:
		case 53:
		case 54:
		case 55:
		case 56:
		case 57:
			for (var c = Y++, l; (l = 0 | J.charCodeAt(Y++)) >= 48 && l <= 57;);
			var u = J.slice(c, --Y);
			if ((l = J.charCodeAt(Y)) === 46 || l === 69 || l === 101) {
				if ((t = fh(vh)) == null) throw dh("FloatValue");
				return X(), {
					kind: "FloatValue",
					value: u + t
				};
			} else return X(), {
				kind: "IntValue",
				value: u
			};
		case 110:
			if (J.charCodeAt(Y + 1) === 117 && J.charCodeAt(Y + 2) === 108 && J.charCodeAt(Y + 3) === 108) return Y += 4, X(), { kind: "NullValue" };
			break;
		case 116:
			if (J.charCodeAt(Y + 1) === 114 && J.charCodeAt(Y + 2) === 117 && J.charCodeAt(Y + 3) === 101) return Y += 4, X(), {
				kind: "BooleanValue",
				value: !0
			};
			break;
		case 102:
			if (J.charCodeAt(Y + 1) === 97 && J.charCodeAt(Y + 2) === 108 && J.charCodeAt(Y + 3) === 115 && J.charCodeAt(Y + 4) === 101) return Y += 5, X(), {
				kind: "BooleanValue",
				value: !1
			};
			break;
	}
	return {
		kind: "EnumValue",
		value: hh()
	};
}
function bh(e) {
	if (J.charCodeAt(Y) === 40) {
		var t = [];
		Y++, X();
		do {
			var n = gh();
			if (J.charCodeAt(Y++) !== 58) throw dh("Argument");
			X(), t.push({
				kind: "Argument",
				name: n,
				value: yh(e)
			});
		} while (J.charCodeAt(Y) !== 41);
		return Y++, X(), t;
	}
}
function xh(e) {
	if (J.charCodeAt(Y) === 64) {
		var t = [];
		do
			Y++, t.push({
				kind: "Directive",
				name: gh(),
				arguments: bh(e)
			});
		while (J.charCodeAt(Y) === 64);
		return t;
	}
}
function Sh() {
	for (var e = 0; J.charCodeAt(Y) === 91;) e++, Y++, X();
	var t = {
		kind: "NamedType",
		name: gh()
	};
	do
		if (J.charCodeAt(Y) === 33 && (Y++, X(), t = {
			kind: "NonNullType",
			type: t
		}), e) {
			if (J.charCodeAt(Y++) !== 93) throw dh("NamedType");
			X(), t = {
				kind: "ListType",
				type: t
			};
		}
	while (e--);
	return t;
}
function Ch() {
	if (J.charCodeAt(Y++) !== 123) throw dh("SelectionSet");
	return X(), wh();
}
function wh() {
	var e = [];
	do
		if (J.charCodeAt(Y) === 46) {
			if (J.charCodeAt(++Y) !== 46 || J.charCodeAt(++Y) !== 46) throw dh("SelectionSet");
			switch (Y++, X(), J.charCodeAt(Y)) {
				case 64:
					e.push({
						kind: "InlineFragment",
						typeCondition: void 0,
						directives: xh(!1),
						selectionSet: Ch()
					});
					break;
				case 111:
					J.charCodeAt(Y + 1) === 110 ? (Y += 2, X(), e.push({
						kind: "InlineFragment",
						typeCondition: {
							kind: "NamedType",
							name: gh()
						},
						directives: xh(!1),
						selectionSet: Ch()
					})) : e.push({
						kind: "FragmentSpread",
						name: gh(),
						directives: xh(!1)
					});
					break;
				case 123:
					Y++, X(), e.push({
						kind: "InlineFragment",
						typeCondition: void 0,
						directives: void 0,
						selectionSet: wh()
					});
					break;
				default: e.push({
					kind: "FragmentSpread",
					name: gh(),
					directives: xh(!1)
				});
			}
		} else {
			var t = gh(), n = void 0;
			J.charCodeAt(Y) === 58 && (Y++, X(), n = t, t = gh());
			var r = bh(!1), i = xh(!1), a = void 0;
			J.charCodeAt(Y) === 123 && (Y++, X(), a = wh()), e.push({
				kind: "Field",
				alias: n,
				name: t,
				arguments: r,
				directives: i,
				selectionSet: a
			});
		}
	while (J.charCodeAt(Y) !== 125);
	return Y++, X(), {
		kind: "SelectionSet",
		selections: e
	};
}
function Th() {
	if (X(), J.charCodeAt(Y) === 40) {
		var e = [];
		Y++, X();
		do {
			var t = void 0;
			if (J.charCodeAt(Y) === 34 && (t = yh(!0)), J.charCodeAt(Y++) !== 36) throw dh("Variable");
			var n = gh();
			if (J.charCodeAt(Y++) !== 58) throw dh("VariableDefinition");
			X();
			var r = Sh(), i = void 0;
			J.charCodeAt(Y) === 61 && (Y++, X(), i = yh(!0)), X();
			var a = {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: n
				},
				type: r,
				defaultValue: i,
				directives: xh(!0)
			};
			t && (a.description = t), e.push(a);
		} while (J.charCodeAt(Y) !== 41);
		return Y++, X(), e;
	}
}
function Eh(e) {
	var t = gh();
	if (J.charCodeAt(Y++) !== 111 || J.charCodeAt(Y++) !== 110) throw dh("FragmentDefinition");
	X();
	var n = {
		kind: "FragmentDefinition",
		name: t,
		typeCondition: {
			kind: "NamedType",
			name: gh()
		},
		directives: xh(!1),
		selectionSet: Ch()
	};
	return e && (n.description = e), n;
}
function Dh() {
	var e = [];
	do {
		var t = void 0;
		if (J.charCodeAt(Y) === 34 && (t = yh(!0)), J.charCodeAt(Y) === 123) {
			if (t) throw dh("Document");
			Y++, X(), e.push({
				kind: "OperationDefinition",
				operation: "query",
				name: void 0,
				variableDefinitions: void 0,
				directives: void 0,
				selectionSet: wh()
			});
		} else {
			var n = hh();
			switch (n) {
				case "fragment":
					e.push(Eh(t));
					break;
				case "query":
				case "mutation":
				case "subscription":
					var r, i = void 0;
					(r = J.charCodeAt(Y)) !== 40 && r !== 64 && r !== 123 && (i = gh());
					var a = {
						kind: "OperationDefinition",
						operation: n,
						name: i,
						variableDefinitions: Th(),
						directives: xh(!1),
						selectionSet: Ch()
					};
					t && (a.description = t), e.push(a);
					break;
				default: throw dh("Document");
			}
		}
	} while (Y < J.length);
	return e;
}
function Oh(e, t) {
	return J = e.body ? e.body : e, Y = 0, X(), t && t.noLocation ? {
		kind: "Document",
		definitions: Dh()
	} : {
		kind: "Document",
		definitions: Dh(),
		loc: {
			start: 0,
			end: J.length,
			startToken: void 0,
			endToken: void 0,
			source: {
				body: J,
				name: "graphql.web",
				locationOffset: {
					line: 1,
					column: 1
				}
			}
		}
	};
}
function kh(e, t, n) {
	for (var r = "", i = 0; i < e.length; i++) i && (r += t), r += n(e[i]);
	return r;
}
function Ah(e) {
	return JSON.stringify(e);
}
function jh(e) {
	return "\"\"\"\n" + e.replace(/"""/g, "\\\"\"\"") + "\n\"\"\"";
}
var Mh = "\n", Z = {
	OperationDefinition(e) {
		var t = "";
		e.description && (t += Z.StringValue(e.description) + "\n"), t += e.operation, e.name && (t += " " + e.name.value), e.variableDefinitions && e.variableDefinitions.length && (e.name || (t += " "), t += "(" + kh(e.variableDefinitions, ", ", Z.VariableDefinition) + ")"), e.directives && e.directives.length && (t += " " + kh(e.directives, " ", Z.Directive));
		var n = Z.SelectionSet(e.selectionSet);
		return t === "query" ? n : t + " " + n;
	},
	VariableDefinition(e) {
		var t = "";
		return e.description && (t += Z.StringValue(e.description) + " "), t += Z.Variable(e.variable) + ": " + Nh(e.type), e.defaultValue && (t += " = " + Nh(e.defaultValue)), e.directives && e.directives.length && (t += " " + kh(e.directives, " ", Z.Directive)), t;
	},
	Field(e) {
		var t = e.alias ? e.alias.value + ": " + e.name.value : e.name.value;
		if (e.arguments && e.arguments.length) {
			var n = kh(e.arguments, ", ", Z.Argument);
			t.length + n.length + 2 > 80 ? t += "(" + (Mh += "  ") + kh(e.arguments, Mh, Z.Argument) + (Mh = Mh.slice(0, -2)) + ")" : t += "(" + n + ")";
		}
		return e.directives && e.directives.length && (t += " " + kh(e.directives, " ", Z.Directive)), e.selectionSet && e.selectionSet.selections.length && (t += " " + Z.SelectionSet(e.selectionSet)), t;
	},
	StringValue(e) {
		return e.block ? jh(e.value).replace(/\n/g, Mh) : Ah(e.value);
	},
	BooleanValue: (e) => "" + e.value,
	NullValue: (e) => "null",
	IntValue: (e) => e.value,
	FloatValue: (e) => e.value,
	EnumValue: (e) => e.value,
	Name: (e) => e.value,
	Variable: (e) => "$" + e.name.value,
	ListValue: (e) => "[" + kh(e.values, ", ", Nh) + "]",
	ObjectValue: (e) => "{" + kh(e.fields, ", ", Z.ObjectField) + "}",
	ObjectField: (e) => e.name.value + ": " + Nh(e.value),
	Document(e) {
		return !e.definitions || !e.definitions.length ? "" : kh(e.definitions, "\n\n", Nh);
	},
	SelectionSet: (e) => "{" + (Mh += "  ") + kh(e.selections, Mh, Nh) + (Mh = Mh.slice(0, -2)) + "}",
	Argument: (e) => e.name.value + ": " + Nh(e.value),
	FragmentSpread(e) {
		var t = "..." + e.name.value;
		return e.directives && e.directives.length && (t += " " + kh(e.directives, " ", Z.Directive)), t;
	},
	InlineFragment(e) {
		var t = "...";
		return e.typeCondition && (t += " on " + e.typeCondition.name.value), e.directives && e.directives.length && (t += " " + kh(e.directives, " ", Z.Directive)), t += " " + Z.SelectionSet(e.selectionSet);
	},
	FragmentDefinition(e) {
		var t = "";
		return e.description && (t += Z.StringValue(e.description) + "\n"), t += "fragment " + e.name.value, t += " on " + e.typeCondition.name.value, e.directives && e.directives.length && (t += " " + kh(e.directives, " ", Z.Directive)), t + " " + Z.SelectionSet(e.selectionSet);
	},
	Directive(e) {
		var t = "@" + e.name.value;
		return e.arguments && e.arguments.length && (t += "(" + kh(e.arguments, ", ", Z.Argument) + ")"), t;
	},
	NamedType: (e) => e.name.value,
	ListType: (e) => "[" + Nh(e.type) + "]",
	NonNullType: (e) => Nh(e.type) + "!"
}, Nh = (e) => Z[e.kind](e);
function Ph(e) {
	return Mh = "\n", Z[e.kind] ? Z[e.kind](e) : "";
}
function Fh(e, t) {
	switch (e.kind) {
		case "NullValue": return null;
		case "IntValue": return parseInt(e.value, 10);
		case "FloatValue": return parseFloat(e.value);
		case "StringValue":
		case "EnumValue":
		case "BooleanValue": return e.value;
		case "ListValue":
			for (var n = [], r = 0, i = e.values.length; r < i; r++) n.push(Fh(e.values[r], t));
			return n;
		case "ObjectValue":
			for (var a = Object.create(null), o = 0, s = e.fields.length; o < s; o++) {
				var c = e.fields[o];
				a[c.name.value] = Fh(c.value, t);
			}
			return a;
		case "Variable": return t && t[e.name.value];
	}
}
//#endregion
//#region ../../node_modules/.pnpm/wonka@6.3.5/node_modules/wonka/dist/wonka.mjs
var Ih = () => {}, Lh = Ih;
function Rh(e) {
	return {
		tag: 0,
		0: e
	};
}
function zh(e) {
	return {
		tag: 1,
		0: e
	};
}
var Bh = () => typeof Symbol == "function" && Symbol.asyncIterator || "@@asyncIterator", Vh = (e) => e;
function Hh(e) {
	return (t) => (n) => {
		var r = Lh;
		t(((t) => {
			t === 0 ? n(0) : t.tag === 0 ? (r = t[0], n(t)) : e(t[0]) ? n(t) : r(0);
		}));
	};
}
function Uh(e) {
	return (t) => (n) => t(((t) => {
		t === 0 || t.tag === 0 ? n(t) : n(zh(e(t[0])));
	}));
}
function Wh(e) {
	return (t) => (n) => {
		var r = [], i = Lh, a = !1, o = !1;
		t(((t) => {
			o || (t === 0 ? (o = !0, r.length || n(0)) : t.tag === 0 ? i = t[0] : (a = !1, (function(e) {
				var t = Lh;
				e(((e) => {
					if (e === 0) {
						if (r.length) {
							var s = r.indexOf(t);
							s > -1 && (r = r.slice()).splice(s, 1), r.length || (o ? n(0) : a || (a = !0, i(0)));
						}
					} else e.tag === 0 ? (r.push(t = e[0]), t(0)) : r.length && (n(e), t(0));
				}));
			})(e(t[0])), a || (a = !0, i(0))));
		})), n(Rh(((e) => {
			if (e === 1) {
				o || (o = !0, i(1));
				for (var t = 0, n = r, s = r.length; t < s; t++) n[t](1);
				r.length = 0;
			} else {
				!o && !a ? (a = !0, i(0)) : a = !1;
				for (var c = 0, l = r, u = r.length; c < u; c++) l[c](0);
			}
		})));
	};
}
function Gh(e) {
	return Wh(Vh)(e);
}
function Kh(e) {
	return Gh(ig(e));
}
function qh(e) {
	return (t) => (n) => {
		var r = !1;
		t(((t) => {
			if (!r) if (t === 0) r = !0, n(0), e();
			else if (t.tag === 0) {
				var i = t[0];
				n(Rh(((t) => {
					t === 1 ? (r = !0, i(1), e()) : i(t);
				})));
			} else n(t);
		}));
	};
}
function Jh(e) {
	return (t) => (n) => {
		var r = !1;
		t(((t) => {
			if (!r) if (t === 0) r = !0, n(0);
			else if (t.tag === 0) {
				var i = t[0];
				n(Rh(((e) => {
					e === 1 && (r = !0), i(e);
				})));
			} else e(t[0]), n(t);
		}));
	};
}
function Yh(e) {
	return (t) => (n) => t(((t) => {
		t === 0 ? n(0) : t.tag === 0 ? (n(t), e()) : n(t);
	}));
}
function Xh(e) {
	var t = [], n = Lh, r = !1;
	return (i) => {
		t.push(i), t.length === 1 && e(((e) => {
			if (e === 0) {
				for (var i = 0, a = t, o = t.length; i < o; i++) a[i](0);
				t.length = 0;
			} else if (e.tag === 0) n = e[0];
			else {
				r = !1;
				for (var s = 0, c = t, l = t.length; s < l; s++) c[s](e);
			}
		})), i(Rh(((e) => {
			if (e === 1) {
				var a = t.indexOf(i);
				a > -1 && (t = t.slice()).splice(a, 1), t.length || n(1);
			} else r || (r = !0, n(0));
		})));
	};
}
function Zh(e) {
	return (t) => (n) => {
		var r = Lh, i = Lh, a = !1, o = !1, s = !1, c = !1;
		t(((t) => {
			c || (t === 0 ? (c = !0, s || n(0)) : t.tag === 0 ? r = t[0] : (s && (i(1), i = Lh), a ? a = !1 : (a = !0, r(0)), (function(e) {
				s = !0, e(((e) => {
					s && (e === 0 ? (s = !1, c ? n(0) : a || (a = !0, r(0))) : e.tag === 0 ? (o = !1, (i = e[0])(0)) : (n(e), o ? o = !1 : i(0)));
				}));
			})(e(t[0]))));
		})), n(Rh(((e) => {
			e === 1 ? (c || (c = !0, r(1)), s && (s = !1, i(1))) : (!c && !a && (a = !0, r(0)), s && !o && (o = !0, i(0)));
		})));
	};
}
function Qh(e) {
	return (t) => (n) => {
		var r = Lh, i = !1, a = 0;
		t(((t) => {
			i || (t === 0 ? (i = !0, n(0)) : t.tag === 0 ? e <= 0 ? (i = !0, n(0), t[0](1)) : r = t[0] : a++ < e ? (n(t), !i && a >= e && (i = !0, n(0), r(1))) : n(t));
		})), n(Rh(((t) => {
			t === 1 && !i ? (i = !0, r(1)) : t === 0 && !i && a < e && r(0);
		})));
	};
}
function $h(e) {
	return (t) => (n) => {
		var r = Lh, i = Lh, a = !1;
		t(((t) => {
			a || (t === 0 ? (a = !0, i(1), n(0)) : t.tag === 0 ? (r = t[0], e(((e) => {
				e === 0 || (e.tag === 0 ? (i = e[0])(0) : (a = !0, i(1), r(1), n(0)));
			}))) : n(t));
		})), n(Rh(((e) => {
			e === 1 && !a ? (a = !0, r(1), i(1)) : a || r(0);
		})));
	};
}
function eg(e, t) {
	return (n) => (r) => {
		var i = Lh, a = !1;
		n(((n) => {
			a || (n === 0 ? (a = !0, r(0)) : n.tag === 0 ? (i = n[0], r(n)) : e(n[0]) ? r(n) : (a = !0, t && r(n), r(0), i(1)));
		}));
	};
}
function tg(e) {
	return (t) => e()(t);
}
function ng(e) {
	return (t) => {
		var n = e[Bh()] && e[Bh()]() || e, r = !1, i = !1, a = !1, o;
		t(Rh((async (e) => {
			if (e === 1) r = !0, n.return && n.return();
			else if (i) a = !0;
			else {
				for (a = i = !0; a && !r;) if ((o = await n.next()).done) r = !0, n.return && await n.return(), t(0);
				else try {
					a = !1, t(zh(o.value));
				} catch (e) {
					if (n.throw) (r = !!(await n.throw(e)).done) && t(0);
					else throw e;
				}
				i = !1;
			}
		})));
	};
}
function rg(e) {
	return e[Symbol.asyncIterator] ? ng(e) : (t) => {
		var n = e[Symbol.iterator](), r = !1, i = !1, a = !1, o;
		t(Rh(((e) => {
			if (e === 1) r = !0, n.return && n.return();
			else if (i) a = !0;
			else {
				for (a = i = !0; a && !r;) if ((o = n.next()).done) r = !0, n.return && n.return(), t(0);
				else try {
					a = !1, t(zh(o.value));
				} catch (e) {
					if (n.throw) (r = !!n.throw(e).done) && t(0);
					else throw e;
				}
				i = !1;
			}
		})));
	};
}
var ig = rg;
function ag(e) {
	return (t) => {
		var n = !1;
		t(Rh(((r) => {
			r === 1 ? n = !0 : n || (n = !0, t(zh(e)), t(0));
		})));
	};
}
function og(e) {
	return (t) => {
		var n = !1, r = e({
			next(e) {
				n || t(zh(e));
			},
			complete() {
				n || (n = !0, t(0));
			}
		});
		t(Rh(((e) => {
			e === 1 && !n && (n = !0, r());
		})));
	};
}
function sg() {
	var e, t;
	return {
		source: Xh(og(((n) => (e = n.next, t = n.complete, Ih)))),
		next(t) {
			e && e(t);
		},
		complete() {
			t && t();
		}
	};
}
var cg = (e) => {
	var t = !1;
	e(Rh(((n) => {
		n === 1 ? t = !0 : t || (t = !0, e(0));
	})));
};
function lg(e) {
	return og(((t) => (e.then(((e) => {
		Promise.resolve(e).then((() => {
			t.next(e), t.complete();
		}));
	})), Ih)));
}
function ug(e) {
	return (t) => {
		var n = Lh, r = !1;
		return t(((t) => {
			t === 0 ? r = !0 : t.tag === 0 ? (n = t[0])(0) : r || (e(t[0]), n(0));
		})), { unsubscribe() {
			r || (r = !0, n(1));
		} };
	};
}
function dg(e) {
	ug(((e) => {}))(e);
}
function fg(e) {
	return new Promise(((t) => {
		var n = Lh, r;
		e(((e) => {
			e === 0 ? Promise.resolve(r).then(t) : e.tag === 0 ? (n = e[0])(0) : (r = e[0], n(0));
		}));
	}));
}
//#endregion
//#region ../../node_modules/.pnpm/@urql+core@5.2.0_graphql@16.12.0/node_modules/@urql/core/dist/urql-core-chunk.mjs
var pg = (e) => e && typeof e.message == "string" && (e.extensions || e.name === "GraphQLError") ? e : typeof e == "object" && typeof e.message == "string" ? new uh(e.message, e.nodes, e.source, e.positions, e.path, e, e.extensions || {}) : new uh(e), mg = class extends Error {
	constructor(e) {
		var t = (e.graphQLErrors || []).map(pg), n = ((e, t) => {
			var n = "";
			if (e) return `[Network] ${e.message}`;
			if (t) for (var r = 0, i = t.length; r < i; r++) n && (n += "\n"), n += `[GraphQL] ${t[r].message}`;
			return n;
		})(e.networkError, t);
		super(n), this.name = "CombinedError", this.message = n, this.graphQLErrors = t, this.networkError = e.networkError, this.response = e.response;
	}
	toString() {
		return this.message;
	}
}, hg = (e, t) => {
	for (var n = 0 | (t || 5381), r = 0, i = 0 | e.length; r < i; r++) n = (n << 5) + n + e.charCodeAt(r);
	return n;
}, gg = /* @__PURE__ */ new Set(), _g = /* @__PURE__ */ new WeakMap(), vg = (e, t) => {
	if (e === null || gg.has(e)) return "null";
	if (typeof e != "object") return JSON.stringify(e) || "";
	if (e.toJSON) return vg(e.toJSON(), t);
	if (Array.isArray(e)) {
		for (var n = "[", r = 0, i = e.length; r < i; r++) n.length > 1 && (n += ","), n += vg(e[r], t) || "null";
		return n += "]";
	} else if (!t && (Sg !== xg && e instanceof Sg || Cg !== xg && e instanceof Cg)) return "null";
	var a = Object.keys(e).sort();
	if (!a.length && e.constructor && Object.getPrototypeOf(e).constructor !== Object.prototype.constructor) {
		var o = _g.get(e) || Math.random().toString(36).slice(2);
		return _g.set(e, o), vg({ __key: o }, t);
	}
	gg.add(e);
	for (var s = "{", c = 0, l = a.length; c < l; c++) {
		var u = vg(e[a[c]], t);
		u && (s.length > 1 && (s += ","), s += vg(a[c], t) + ":" + u);
	}
	return gg.delete(e), s += "}";
}, yg = (e, t, n) => {
	if (!(typeof n != "object" || !n || n.toJSON || gg.has(n))) if (Array.isArray(n)) for (var r = 0, i = n.length; r < i; r++) yg(e, `${t}.${r}`, n[r]);
	else if (n instanceof Sg || n instanceof Cg) e.set(t, n);
	else for (var a in gg.add(n), n) yg(e, `${t}.${a}`, n[a]);
}, bg = (e, t) => (gg.clear(), vg(e, t || !1)), xg = class {}, Sg = typeof File < "u" ? File : xg, Cg = typeof Blob < "u" ? Blob : xg, wg = /("{3}[\s\S]*"{3}|"(?:\\.|[^"])*")/g, Tg = /(?:#[^\n\r]+)?(?:[\r\n]+|$)/g, Eg = (e, t) => t % 2 == 0 ? e.replace(Tg, "\n") : e, Dg = (e) => e.split(wg).map(Eg).join("").trim(), Og = /* @__PURE__ */ new Map(), kg = /* @__PURE__ */ new Map(), Ag = (e) => {
	var t;
	return typeof e == "string" ? t = Dg(e) : e.loc && kg.get(e.__key) === e ? t = e.loc.source.body : (t = Og.get(e) || Dg(Ph(e)), Og.set(e, t)), typeof e != "string" && !e.loc && (e.loc = {
		start: 0,
		end: t.length,
		source: {
			body: t,
			name: "gql",
			locationOffset: {
				line: 1,
				column: 1
			}
		}
	}), t;
}, jg = (e) => {
	var t;
	if (e.documentId) t = hg(e.documentId);
	else if (t = hg(Ag(e)), e.definitions) {
		var n = Pg(e);
		n && (t = hg(`\n# ${n}`, t));
	}
	return t;
}, Mg = (e) => {
	var t, n;
	return typeof e == "string" ? (t = jg(e), n = kg.get(t) || Oh(e, { noLocation: !0 })) : (t = e.__key || jg(e), n = kg.get(t) || e), n.loc || Ag(n), n.__key = t, kg.set(t, n), n;
}, Ng = (e, t, n) => {
	var r = t || {}, i = Mg(e), a = bg(r, !0), o = i.__key;
	return a !== "{}" && (o = hg(a, o)), {
		key: o,
		query: i,
		variables: r,
		extensions: n
	};
}, Pg = (e) => {
	for (var t = 0, n = e.definitions.length; t < n; t++) {
		var r = e.definitions[t];
		if (r.kind === lh.OPERATION_DEFINITION) return r.name ? r.name.value : void 0;
	}
}, Fg = (e) => {
	for (var t = 0, n = e.definitions.length; t < n; t++) {
		var r = e.definitions[t];
		if (r.kind === lh.OPERATION_DEFINITION) return r.operation;
	}
}, Ig = (e, t, n) => {
	if (!("data" in t || "errors" in t && Array.isArray(t.errors))) throw Error("No Content");
	var r = e.kind === "subscription";
	return {
		operation: e,
		data: t.data,
		error: Array.isArray(t.errors) ? new mg({
			graphQLErrors: t.errors,
			response: n
		}) : void 0,
		extensions: t.extensions ? { ...t.extensions } : void 0,
		hasNext: t.hasNext == null ? r : t.hasNext,
		stale: !1
	};
}, Lg = (e, t) => {
	if (typeof e == "object" && e) {
		if (Array.isArray(e)) {
			e = [...e];
			for (var n = 0, r = t.length; n < r; n++) e[n] = Lg(e[n], t[n]);
			return e;
		}
		if (!e.constructor || e.constructor === Object) {
			for (var i in e = { ...e }, t) e[i] = Lg(e[i], t[i]);
			return e;
		}
	}
	return t;
}, Rg = (e, t, n, r) => {
	var i = e.error ? e.error.graphQLErrors : [], a = !!e.extensions || !!(t.payload || t).extensions, o = {
		...e.extensions,
		...(t.payload || t).extensions
	}, s = t.incremental;
	"path" in t && (s = [t]);
	var c = { data: e.data };
	if (s) for (var l = function() {
		var e = s[u];
		Array.isArray(e.errors) && i.push(...e.errors), e.extensions && (Object.assign(o, e.extensions), a = !0);
		var t = "data", n = c, l = [];
		if (e.path) l = e.path;
		else if (r) {
			var d = r.find(((t) => t.id === e.id));
			l = e.subPath ? [...d.path, ...e.subPath] : d.path;
		}
		for (var f = 0, p = l.length; f < p; t = l[f++]) n = n[t] = Array.isArray(n[t]) ? [...n[t]] : { ...n[t] };
		if (e.items) for (var m = +t >= 0 ? t : 0, h = 0, g = e.items.length; h < g; h++) n[m + h] = Lg(n[m + h], e.items[h]);
		else e.data !== void 0 && (n[t] = Lg(n[t], e.data));
	}, u = 0, d = s.length; u < d; u++) l();
	else c.data = (t.payload || t).data || e.data, i = t.errors || t.payload && t.payload.errors || i;
	return {
		operation: e.operation,
		data: c.data,
		error: i.length ? new mg({
			graphQLErrors: i,
			response: n
		}) : void 0,
		extensions: a ? o : void 0,
		hasNext: t.hasNext == null ? e.hasNext : t.hasNext,
		stale: !1
	};
}, zg = (e, t, n) => ({
	operation: e,
	data: void 0,
	error: new mg({
		networkError: t,
		response: n
	}),
	extensions: void 0,
	hasNext: !1,
	stale: !1
});
function Bg(e) {
	var t = {
		query: void 0,
		documentId: void 0,
		operationName: Pg(e.query),
		variables: e.variables || void 0,
		extensions: e.extensions
	};
	return "documentId" in e.query && e.query.documentId && (!e.query.definitions || !e.query.definitions.length) ? t.documentId = e.query.documentId : (!e.extensions || !e.extensions.persistedQuery || e.extensions.persistedQuery.miss) && (t.query = Ag(e.query)), t;
}
var Vg = (e, t) => {
	var n = e.kind === "query" && e.context.preferGetMethod;
	if (!n || !t) return e.context.url;
	var r = Hg(e.context.url);
	for (var i in t) {
		var a = t[i];
		a && r[1].set(i, typeof a == "object" ? bg(a) : a);
	}
	var o = r.join("?");
	return o.length > 2047 && n !== "force" ? (e.context.preferGetMethod = !1, e.context.url) : o;
}, Hg = (e) => {
	var t = e.indexOf("?");
	return t > -1 ? [e.slice(0, t), new URLSearchParams(e.slice(t + 1))] : [e, new URLSearchParams()];
}, Ug = (e, t) => {
	if (t && !(e.kind === "query" && e.context.preferGetMethod)) {
		var n = bg(t), r = ((e) => {
			var t = /* @__PURE__ */ new Map();
			return (Sg !== xg || Cg !== xg) && (gg.clear(), yg(t, "variables", e)), t;
		})(t.variables);
		if (r.size) {
			var i = new FormData();
			i.append("operations", n), i.append("map", bg({ ...[...r.keys()].map(((e) => [e])) }));
			var a = 0;
			for (var o of r.values()) i.append("" + a++, o);
			return i;
		}
		return n;
	}
}, Wg = (e, t) => {
	var n = { accept: e.kind === "subscription" ? "text/event-stream, multipart/mixed" : "application/graphql-response+json, application/graphql+json, application/json, text/event-stream, multipart/mixed" }, r = (typeof e.context.fetchOptions == "function" ? e.context.fetchOptions() : e.context.fetchOptions) || {};
	if (r.headers) if (((e) => "has" in e && !Object.keys(e).length)(r.headers)) r.headers.forEach(((e, t) => {
		n[t] = e;
	}));
	else if (Array.isArray(r.headers)) r.headers.forEach(((e, t) => {
		Array.isArray(e) ? n[e[0]] ? n[e[0]] = `${n[e[0]]},${e[1]}` : n[e[0]] = e[1] : n[t] = e;
	}));
	else for (var i in r.headers) n[i.toLowerCase()] = r.headers[i];
	var a = Ug(e, t);
	return typeof a == "string" && !n["content-type"] && (n["content-type"] = "application/json"), {
		...r,
		method: a ? "POST" : "GET",
		body: a,
		headers: n
	};
}, Gg = /boundary="?([^=";]+)"?/i, Kg = /data: ?([^\n]+)/;
async function* qg(e) {
	if (e.body[Symbol.asyncIterator]) for await (var t of e.body) yield t;
	else {
		var n = e.body.getReader(), r;
		try {
			for (; !(r = await n.read()).done;) yield r.value;
		} finally {
			n.cancel();
		}
	}
}
async function* Jg(e, t) {
	var n = typeof TextDecoder < "u" ? new TextDecoder() : null, r = "", i;
	for await (var a of e) for (r += a.constructor.name === "Buffer" ? a.toString() : n.decode(a, { stream: !0 }); (i = r.indexOf(t)) > -1;) yield r.slice(0, i), r = r.slice(i + t.length);
}
async function* Yg(e, t, n) {
	var r = !0, i = null, a;
	try {
		yield await Promise.resolve();
		var o = (a = await (e.context.fetch || fetch)(t, n)).headers.get("Content-Type") || "", s = /multipart\/mixed/i.test(o) ? async function* (e, t) {
			var n = e.match(Gg), r = "--" + (n ? n[1] : "-"), i = !0, a;
			for await (var o of Jg(qg(t), "\r\n" + r)) {
				if (i) {
					i = !1;
					var s = o.indexOf(r);
					if (s > -1) o = o.slice(s + r.length);
					else continue;
				}
				try {
					yield a = JSON.parse(o.slice(o.indexOf("\r\n\r\n") + 4));
				} catch (e) {
					if (!a) throw e;
				}
				if (a && !1 === a.hasNext) break;
			}
			a && !1 !== a.hasNext && (yield { hasNext: !1 });
		}(o, a) : /text\/event-stream/i.test(o) ? async function* (e) {
			var t;
			for await (var n of Jg(qg(e), "\n\n")) {
				var r = n.match(Kg);
				if (r) {
					var i = r[1];
					try {
						yield t = JSON.parse(i);
					} catch (e) {
						if (!t) throw e;
					}
					if (t && !1 === t.hasNext) break;
				}
			}
			t && !1 !== t.hasNext && (yield { hasNext: !1 });
		}(a) : /text\//i.test(o) ? async function* (e) {
			var t = await e.text();
			try {
				var n = JSON.parse(t);
				process.env.NODE_ENV !== "production" && console.warn("Found response with content-type \"text/plain\" but it had a valid \"application/json\" response."), yield n;
			} catch {
				throw Error(t);
			}
		}(a) : async function* (e) {
			yield JSON.parse(await e.text());
		}(a), c;
		for await (var l of s) l.pending && !i ? c = l.pending : l.pending && (c = [...c, ...l.pending]), i = i ? Rg(i, l, a, c) : Ig(e, l, a), r = !1, yield i, r = !0;
		i || (yield i = Ig(e, {}, a));
	} catch (t) {
		if (!r) throw t;
		yield zg(e, a && (a.status < 200 || a.status >= 300) && a.statusText ? Error(a.statusText) : t, a);
	}
}
function Xg(e, t, n) {
	var r;
	return typeof AbortController < "u" && (n.signal = (r = new AbortController()).signal), qh((() => {
		r && r.abort();
	}))(Hh(((e) => !!e))(ng(Yg(e, t, n))));
}
//#endregion
//#region ../../node_modules/.pnpm/@urql+core@5.2.0_graphql@16.12.0/node_modules/@urql/core/dist/urql-core.mjs
var Zg = (e) => {
	if ("definitions" in e) {
		for (var t = [], n = 0, r = e.definitions.length; n < r; n++) {
			var i = Zg(e.definitions[n]);
			t.push(i);
		}
		return {
			...e,
			definitions: t
		};
	}
	if ("directives" in e && e.directives && e.directives.length) {
		for (var a = [], o = {}, s = 0, c = e.directives.length; s < c; s++) {
			var l = e.directives[s], u = l.name.value;
			u[0] === "_" ? u = u.slice(1) : a.push(l), o[u] = l;
		}
		e = {
			...e,
			directives: a,
			_directives: o
		};
	}
	if ("selectionSet" in e) {
		var d = [], f = e.kind === lh.OPERATION_DEFINITION;
		if (e.selectionSet) {
			for (var p = 0, m = e.selectionSet.selections.length; p < m; p++) {
				var h = e.selectionSet.selections[p];
				f ||= h.kind === lh.FIELD && h.name.value === "__typename" && !h.alias;
				var g = Zg(h);
				d.push(g);
			}
			return f || d.push({
				kind: lh.FIELD,
				name: {
					kind: lh.NAME,
					value: "__typename"
				},
				_generated: !0
			}), {
				...e,
				selectionSet: {
					...e.selectionSet,
					selections: d
				}
			};
		}
	}
	return e;
}, Qg = /* @__PURE__ */ new Map(), $g = (e) => {
	var t = Mg(e), n = Qg.get(t.__key);
	return n || (Qg.set(t.__key, n = Zg(t)), Object.defineProperty(n, "__key", {
		value: t.__key,
		enumerable: !1
	})), n;
};
function e_(e) {
	var t = (t) => e(t);
	return t.toPromise = () => fg(Qh(1)(Hh(((e) => !e.stale && !e.hasNext))(t))), t.then = (e, n) => t.toPromise().then(e, n), t.subscribe = (e) => ug(e)(t), t;
}
function t_(e, t, n) {
	return {
		...t,
		kind: e,
		context: t.context ? {
			...t.context,
			...n
		} : n || t.context
	};
}
var n_ = () => {}, r_ = ({ forward: e, dispatchDebug: t }) => (n) => Kh([Wh(((e) => {
	var r = Bg(e), i = Vg(e, r), a = Wg(e, r);
	process.env.NODE_ENV !== "production" && t({
		type: "fetchRequest",
		message: "A fetch request is being executed.",
		operation: e,
		data: {
			url: i,
			fetchOptions: a
		},
		source: "fetchExchange"
	});
	var o = $h(Hh(((t) => t.kind === "teardown" && t.key === e.key))(n))(Xg(e, i, a));
	return process.env.NODE_ENV === "production" ? o : Jh(((n) => {
		var r = n.data ? void 0 : n.error;
		process.env.NODE_ENV !== "production" && t({
			type: r ? "fetchError" : "fetchSuccess",
			message: `A ${r ? "failed" : "successful"} fetch response has been returned.`,
			operation: e,
			data: {
				url: i,
				fetchOptions: a,
				value: r || n
			},
			source: "fetchExchange"
		});
	}))(o);
}))(Hh(((e) => e.kind !== "teardown" && (e.kind !== "subscription" || !!e.context.fetchSubscriptions)))(n)), e(Hh(((e) => e.kind === "teardown" || e.kind === "subscription" && !e.context.fetchSubscriptions))(n))]), i_ = (e) => ({ client: t, forward: n, dispatchDebug: r }) => e.reduceRight(((e, n) => {
	var i = !1;
	return n({
		client: t,
		forward(t) {
			if (process.env.NODE_ENV !== "production") {
				if (i) throw Error("forward() must only be called once in each Exchange.");
				i = !0;
			}
			return Xh(e(Xh(t)));
		},
		dispatchDebug(e) {
			process.env.NODE_ENV !== "production" && r({
				timestamp: Date.now(),
				source: n.name,
				...e
			});
		}
	});
}), n), a_ = ({ onOperation: e, onResult: t, onError: n }) => ({ forward: r }) => (i) => Wh(((e) => {
	n && e.error && n(e.error, e.operation);
	var r = t && t(e) || e;
	return "then" in r ? lg(r) : ag(r);
}))(r(Wh(((t) => {
	var n = e && e(t) || t;
	return "then" in n ? lg(n) : ag(n);
}))(i))), o_ = ({ dispatchDebug: e }) => (t) => (process.env.NODE_ENV !== "production" && (t = Jh(((t) => {
	if (t.kind !== "teardown" && process.env.NODE_ENV !== "production") {
		var n = `No exchange has handled operations of kind "${t.kind}". Check whether you've added an exchange responsible for these operations.`;
		process.env.NODE_ENV !== "production" && e({
			type: "fallbackCatch",
			message: n,
			operation: t,
			source: "fallbackExchange"
		}), console.warn(n);
	}
}))(t)), Hh(((e) => !1))(t)), s_ = function e(t) {
	if (process.env.NODE_ENV !== "production" && !t.url) throw Error("You are creating an urql-client without a url.");
	var n = 0, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set(), o = [], s = {
		url: t.url,
		fetchSubscriptions: t.fetchSubscriptions,
		fetchOptions: t.fetchOptions,
		fetch: t.fetch,
		preferGetMethod: t.preferGetMethod,
		requestPolicy: t.requestPolicy || "cache-first"
	}, c = sg();
	function l(e) {
		(e.kind === "mutation" || e.kind === "teardown" || !a.has(e.key)) && (e.kind === "teardown" ? a.delete(e.key) : e.kind !== "mutation" && a.add(e.key), c.next(e));
	}
	var u = !1;
	function d(e) {
		if (e && l(e), !u) {
			for (u = !0; u && (e = o.shift());) l(e);
			u = !1;
		}
	}
	var f = (e) => {
		var t = $h(Hh(((t) => t.kind === "teardown" && t.key === e.key))(c.source))(Hh(((t) => t.operation.kind === e.kind && t.operation.key === e.key && (!t.operation.context._instance || t.operation.context._instance === e.context._instance)))(v));
		return t = e.kind === "query" ? Zh(((t) => {
			var n = ag(t);
			return t.stale || t.hasNext ? n : Kh([n, Uh((() => (t.stale = !0, t)))(Qh(1)(Hh(((t) => t.key === e.key))(c.source)))]);
		}))(t) : eg(((e) => !!e.hasNext), !0)(t), t = e.kind === "mutation" ? Yh((() => {
			l(e);
		}))(t) : qh((() => {
			a.delete(e.key), r.delete(e.key), i.delete(e.key), u = !1;
			for (var t = o.length - 1; t >= 0; t--) o[t].key === e.key && o.splice(t, 1);
			l(t_("teardown", e, e.context));
		}))(Jh(((t) => {
			if (t.stale) if (!t.hasNext) a.delete(e.key);
			else for (var n = 0; n < o.length; n++) {
				var i = o[n];
				if (i.key === t.operation.key) {
					a.delete(i.key);
					break;
				}
			}
			else t.hasNext || a.delete(e.key);
			r.set(e.key, t);
		}))(t)), Xh(t);
	}, p = this instanceof e ? this : Object.create(e.prototype), m = Object.assign(p, {
		suspense: !!t.suspense,
		operations$: c.source,
		reexecuteOperation(e) {
			if (e.kind === "teardown") d(e);
			else if (e.kind === "mutation") o.push(e), Promise.resolve().then(d);
			else if (i.has(e.key)) {
				for (var t = !1, n = 0; n < o.length; n++) o[n].key === e.key && (o[n] = e, t = !0);
				t || a.has(e.key) && e.context.requestPolicy !== "network-only" ? (a.delete(e.key), Promise.resolve().then(d)) : (o.push(e), Promise.resolve().then(d));
			}
		},
		createRequestOperation(e, t, r) {
			r ||= {};
			var i;
			if (process.env.NODE_ENV !== "production" && e !== "teardown" && (i = Fg(t.query)) !== e) throw Error(`Expected operation of type "${e}" but found "${i}"`);
			return t_(e, t, {
				_instance: e === "mutation" ? n = n + 1 | 0 : void 0,
				...s,
				...r,
				requestPolicy: r.requestPolicy || s.requestPolicy,
				suspense: r.suspense || !1 !== r.suspense && m.suspense
			});
		},
		executeRequestOperation(e) {
			return e.kind === "mutation" ? e_(f(e)) : e_(tg((() => {
				var t = i.get(e.key);
				t || i.set(e.key, t = f(e)), t = Yh((() => {
					d(e);
				}))(t);
				var n = r.get(e.key);
				return e.kind === "query" && n && (n.stale || n.hasNext) ? Zh(ag)(Kh([t, Hh(((t) => t === r.get(e.key)))(ag(n))])) : t;
			})));
		},
		executeQuery(e, t) {
			var n = m.createRequestOperation("query", e, t);
			return m.executeRequestOperation(n);
		},
		executeSubscription(e, t) {
			var n = m.createRequestOperation("subscription", e, t);
			return m.executeRequestOperation(n);
		},
		executeMutation(e, t) {
			var n = m.createRequestOperation("mutation", e, t);
			return m.executeRequestOperation(n);
		},
		readQuery(e, t, n) {
			var r = null;
			return ug(((e) => {
				r = e;
			}))(m.query(e, t, n)).unsubscribe(), r;
		},
		query: (e, t, n) => m.executeQuery(Ng(e, t), n),
		subscription: (e, t, n) => m.executeSubscription(Ng(e, t), n),
		mutation: (e, t, n) => m.executeMutation(Ng(e, t), n)
	}), h = n_;
	if (process.env.NODE_ENV !== "production") {
		var { next: g, source: _ } = sg();
		m.subscribeToDebugTarget = (e) => ug(e)(_), h = g;
	}
	var v = Xh(i_(t.exchanges)({
		client: m,
		dispatchDebug: h,
		forward: o_({ dispatchDebug: h })
	})(c.source));
	return dg(v), m;
}, c_ = "\nhttps://bit.ly/2XbVrpR#", l_ = /* @__PURE__ */ new Set(), u_ = [], d_ = () => u_.pop(), f_ = (e, t) => {
	var n = "";
	t.kind === lh.INLINE_FRAGMENT ? n = e ? `Inline Fragment on "${e}"` : "Inline Fragment" : t.kind === lh.OPERATION_DEFINITION ? n = `${t.name ? `"${t.name.value}"` : "Unnamed"} ${t.operation}` : t.kind === lh.FRAGMENT_DEFINITION && (n = `"${t.name.value}" Fragment`), n && u_.push(n);
}, p_ = () => u_.length ? "\n(Caused At: " + u_.join(", ") + ")" : "";
function m_(e, t, n) {
	if (!e) {
		var r = t || "Minfied Error #" + n + "\n";
		process.env.NODE_ENV !== "production" && (r += p_());
		var i = Error(r + c_ + n);
		throw i.name = "Graphcache Error", i;
	}
}
function Q(e, t, n) {
	l_.has(e) || (n ? n("warn", e + p_() + c_ + t) : console.warn(e + p_() + c_ + t), l_.add(e));
}
var h_ = {}, g_ = (e) => e._directives || h_, __ = (e) => e.name.value, v_ = (e) => e.typeCondition.name.value, y_ = (e) => e.alias ? e.alias.value : e.name.value, b_ = [], x_ = (e) => e.selectionSet ? e.selectionSet.selections : b_, S_ = (e) => e.typeCondition ? e.typeCondition.name.value : null, C_ = (e, t) => {
	var n = null;
	if (e.arguments) for (var r = 0, i = e.arguments.length; r < i; r++) {
		var a = e.arguments[r], o = Fh(a.value, t);
		o != null && (n ||= {}, n[__(a)] = o);
	}
	return n;
}, w_ = (e, t) => {
	if (!(!t || !e.variableDefinitions)) {
		for (var n = {}, r = 0, i = e.variableDefinitions.length; r < i; r++) {
			var a = __(e.variableDefinitions[r].variable);
			n[a] = t[a];
		}
		return n;
	}
}, T_ = (e, t) => {
	var n = {};
	if (!t) return n;
	if (e.variableDefinitions) for (var r = 0, i = e.variableDefinitions.length; r < i; r++) {
		var a = e.variableDefinitions[r], o = __(a.variable);
		n[o] = t[o] === void 0 && a.defaultValue ? Fh(a.defaultValue, t) : t[o];
	}
	for (var s in t) s in n || (n[s] = t[s]);
	return n;
};
function E_(e) {
	for (var t = 0; t < e.definitions.length; t++) if (e.definitions[t].kind === lh.OPERATION_DEFINITION) return e.definitions[t];
	m_(!1, process.env.NODE_ENV === "production" ? "" : "Invalid GraphQL document: All GraphQL documents must contain an OperationDefinitionnode for a query, subscription, or mutation.", 1);
}
var D_ = (e) => {
	for (var t = {}, n = 0; n < e.definitions.length; n++) {
		var r = e.definitions[n];
		r.kind === lh.FRAGMENT_DEFINITION && (t[__(r)] = r);
	}
	return t;
}, O_ = (e, t) => {
	var n = g_(e);
	if (n.include || n.skip) for (var r in n) {
		var i = n[r];
		if (i && (r === "include" || r === "skip") && i.arguments && i.arguments[0] && __(i.arguments[0]) === "if") {
			var a = Fh(i.arguments[0].value, t);
			return r === "include" ? !!a : !a;
		}
	}
	return !0;
}, k_ = (e, t) => {
	var { defer: n } = g_(e);
	if (n) {
		for (var r of n.arguments || []) if (__(r) === "if") return !!Fh(r.value, t);
		return !0;
	}
	return !1;
}, A_ = (e) => {
	var { optional: t, required: n } = g_(e);
	if (n) return !1;
	if (t) return !0;
}, j_ = "__", M_ = (e, t, n, r) => {
	var i = I_(e, t, n, r);
	return !!i && i.type.kind !== "NON_NULL";
}, N_ = (e, t, n, r) => {
	var i = I_(e, t, n, r);
	if (!i) return !1;
	var a = i.type.kind === "NON_NULL" ? i.type.ofType : i.type;
	return a.kind === "LIST" && a.ofType.kind !== "NON_NULL";
}, P_ = (e, t, n, r) => n.indexOf(j_) === 0 || t.indexOf(j_) === 0 || !!I_(e, t, n, r), F_ = (e, t, n) => {
	if (!n) return !1;
	var r = S_(t);
	return !r || n === r ? !0 : e.types.has(r) && e.types.get(r).kind === "OBJECT" ? r === n : ((function(e, t) {
		m_(e.types.has(t) && (e.types.get(t).kind === "INTERFACE" || e.types.get(t).kind === "UNION"), process.env.NODE_ENV === "production" ? "" : "Invalid Abstract type: The type `" + t + "` is not an Interface or Union type in the defined schema, but a fragment in the GraphQL document is using it as a type condition.", 5);
	})(e, r), L_(e, n), e.isSubType(r, n));
}, I_ = (e, t, n, r) => {
	if (!(n.indexOf(j_) === 0 || t.indexOf(j_) === 0)) {
		L_(e, t);
		var i = e.types.get(t).fields()[n];
		return process.env.NODE_ENV !== "production" && (i || Q("Invalid field: The field `" + n + "` does not exist on `" + t + "`, but the GraphQL document expects it to exist.\nTraversal will continue, however this may lead to undefined behavior!", 4, r)), i;
	}
};
function L_(e, t) {
	m_(e.types.has(t) && e.types.get(t).kind === "OBJECT", process.env.NODE_ENV === "production" ? "" : "Invalid Object type: The type `" + t + "` is not an object in the defined schema, but the GraphQL document is traversing it.", 3);
}
function R_(e, t) {
	process.env.NODE_ENV !== "production" && Q(`Invalid resolver: \`${e}\` is not in the defined schema, but the \`resolvers\` option is referencing it.`, 23, t);
}
function z_(e, t, n) {
	process.env.NODE_ENV !== "production" && Q(`Invalid resolver: \`${e}\` does not match to a concrete type in the schema, but the \`resolvers\` option is referencing it. Implement the resolver for the types that ${t === "UNION" ? "make up the union" : "implement the interface"} instead.`, 26, n);
}
var B_ = (e, t) => t ? `${e}(${bg(t)})` : e, V_ = (e, t) => `${e}.${t}`, H_ = (e) => {
	var t = e.indexOf("(");
	return t > -1 ? {
		fieldKey: e,
		fieldName: e.slice(0, t),
		arguments: JSON.parse(e.slice(t + 1, -1))
	} : {
		fieldKey: e,
		fieldName: e,
		arguments: null
	};
}, U_ = (e) => {
	var t = e.indexOf(".");
	return {
		entityKey: e.slice(0, t).replace(/%2e/g, "."),
		fieldKey: e.slice(t + 1)
	};
}, W_ = null, G_ = null, $ = null, K_ = null, q_ = null, J_ = null, Y_ = !1, X_ = !1;
function Z_(e, t) {
	var n;
	if (e) {
		if (W_.has(e)) return e;
		n = G_.get(e);
	}
	return n ??= t ? [] : {}, e && G_.set(e, n), W_.add(n), n;
}
var Q_ = (e) => !!e && W_.has(e), $_ = (e, t, n, r, i) => {
	W_ = /* @__PURE__ */ new WeakSet(), G_ = /* @__PURE__ */ new WeakMap(), q_ = e, $ = t, J_ = /* @__PURE__ */ new Set(), X_ = !!r, Y_ = !!i, process.env.NODE_ENV !== "production" && (u_.length = 0), n ? q_ === "read" ? K_ = n : r || t.hydrating || t.optimisticOrder.length > 1 ? (!r && !t.commutativeKeys.has(n) ? yv(t, n) : r && (t.optimisticOrder.indexOf(n) !== -1 && !t.commutativeKeys.has(n) && t.optimisticOrder.splice(t.optimisticOrder.indexOf(n), 1), t.commutativeKeys.delete(n)), K_ = n, bv(t, n)) : (K_ = null, Sv(t, n)) : K_ = null;
}, ev = () => {
	process.env.NODE_ENV !== "production" && nv();
	var e = $, t = K_;
	if (X_ = !1, K_ = null, !e.hydrating && t && e.optimisticOrder.indexOf(t) > -1) for (var n = e.optimisticOrder.length; --n >= 0 && e.dirtyKeys.has(e.optimisticOrder[n]) && e.commutativeKeys.has(e.optimisticOrder[n]);) Cv(e.optimisticOrder[n]);
	W_ = null, G_ = null, q_ = null, $ = null, J_ = null, process.env.NODE_ENV !== "production" && (u_.length = 0), process.env.NODE_ENV !== "test" && !e.defer && (e.storage || !e.optimisticOrder.length) && (e.defer = !0, setTimeout((() => {
		$_("read", e, null), uv(), Tv(), ev(), e.defer = !1;
	})));
}, tv = (e, t, n) => {
	t && !n && e.deferredKeys.delete(t), $_("write", e, t, n), ev();
}, nv = () => (m_(J_ !== null, process.env.NODE_ENV === "production" ? "" : "Invalid Cache call: The cache may only be accessed or mutated duringoperations like write or query, or as part of its resolvers, updaters, or optimistic configs.", 2), J_), rv = /* @__PURE__ */ new Set(), iv = (e, t, n, r) => {
	process.env.NODE_ENV !== "production" && m_(q_ !== "read", process.env.NODE_ENV === "production" ? "" : "Invalid Cache write: You may not write to the cache during cache reads.  Accesses to `cache.writeFragment`, `cache.updateQuery`, and `cache.link` may  not be made inside `resolvers` for instance.", 27);
	var i = K_ ? e.optimistic.get(K_) : e.base, a = i.get(t);
	a === void 0 && i.set(t, a = Object.create(null)), r === void 0 && !K_ ? delete a[n] : a[n] = r;
}, av = (e, t, n) => {
	for (var r, i = !X_ && q_ === "read" && K_ && $.commutativeKeys.has(K_), a = 0, o = $.optimisticOrder.length; a < o; a++) {
		var s = $.optimisticOrder[a], c = e.optimistic.get(s);
		if (i &&= s !== K_, c && (!i || !$.commutativeKeys.has(s)) && (!X_ || q_ === "write" || $.commutativeKeys.has(s)) && (r = c.get(t)) !== void 0 && n in r) return r[n];
	}
	return (r = e.base.get(t)) === void 0 ? void 0 : r[n];
};
function ov(e) {
	return $.refCount.get(e) || 0;
}
var sv = (e, t) => {
	if (Array.isArray(e)) for (var n = 0, r = e.length; n < r; n++) sv(e[n], t);
	else typeof e == "string" && ((e, t) => {
		var n = ov(e), r = n + t > 0 ? n + t : 0;
		$.refCount.set(e, r), r ? !n && r && $.gc.delete(e) : $.gc.add(e);
	})(e, t);
}, cv = (e, t, n) => {
	if (n !== void 0) for (var r in n) t.has(r) || (e.push(H_(r)), t.add(r));
}, lv = (e, t, n, r) => {
	cv(e, t, r.base.get(n));
	for (var i = 0, a = $.optimisticOrder.length; i < a; i++) {
		var o = r.optimistic.get($.optimisticOrder[i]);
		o !== void 0 && cv(e, t, o.get(n));
	}
}, uv = () => {
	if (!$.optimisticOrder.length) {
		for (var e of $.gc.keys()) if ($.gc.delete(e), !(ov(e) > 0)) {
			var t = $.records.base.get(e);
			$.refCount.delete(e), $.records.base.delete(e);
			var n = t && t.__typename;
			if (n) {
				var r = $.types.get(n);
				r && r.delete(e);
			}
			var i = $.links.base.get(e);
			if (i) for (var a in $.links.base.delete(e), i) sv(i[a], -1);
		}
	}
}, dv = (e, t) => {
	e === $.queryRootKey ? t !== void 0 && t !== "__typename" && J_.add(V_(e, t)) : J_.add(e);
}, fv = (e, t) => {
	!X_ && $.storage && $.persist.add(((e, t) => `${e.replace(/\./g, "%2e")}.${t}`)(e, t));
}, pv = (e, t) => (q_ === "read" && dv(e, t), av($.records, e, t)), mv = (e, t) => (q_ === "read" && dv(e, t), av($.links, e, t)), hv = (e, t) => {
	var n = $.abstractToConcreteMap.get(e);
	if (n) n.add(t);
	else {
		var r = /* @__PURE__ */ new Set();
		r.add(t), $.abstractToConcreteMap.set(e, r);
	}
}, gv = (e, t, n) => {
	Ev(av($.records, e, t), n) || (dv(e, t), fv(e, t)), iv($.records, e, t, n);
}, _v = (e, t) => pv(e, t) !== void 0 || mv(e, t) !== void 0, vv = (e, t, n) => {
	var r = K_ ? $.links.optimistic.get(K_) : $.links.base;
	if (!K_) {
		var i = r && r.get(e);
		sv(i && i[t], -1), sv(n, 1);
	}
	Ev(av($.links, e, t), n) || (dv(e, t), fv(e, t)), iv($.links, e, t, n);
}, yv = (e, t, n) => {
	var r = e.optimisticOrder.indexOf(t);
	if (r > -1 && e.optimisticOrder.splice(r, 1), n) for (e.deferredKeys.add(t), r = r > -1 ? r : 0; r < e.optimisticOrder.length && !e.deferredKeys.has(e.optimisticOrder[r]) && (!e.dirtyKeys.has(e.optimisticOrder[r]) || !e.commutativeKeys.has(e.optimisticOrder[r])); r++);
	else e.deferredKeys.delete(t), r > -1 && !e.commutativeKeys.has(t) && xv(e, t), r = 0;
	e.optimisticOrder.splice(r, 0, t), e.commutativeKeys.add(t);
}, bv = (e, t) => {
	e.optimisticOrder.indexOf(t) === -1 && e.optimisticOrder.unshift(t), e.dirtyKeys.has(t) || (e.dirtyKeys.add(t), e.links.optimistic.set(t, /* @__PURE__ */ new Map()), e.records.optimistic.set(t, /* @__PURE__ */ new Map()));
}, xv = (e, t) => {
	e.dirtyKeys.has(t) && (e.dirtyKeys.delete(t), e.records.optimistic.delete(t), e.links.optimistic.delete(t), e.deferredKeys.delete(t));
}, Sv = (e, t) => {
	var n = e.optimisticOrder.indexOf(t);
	n > -1 && (e.optimisticOrder.splice(n, 1), e.commutativeKeys.delete(t)), xv(e, t);
}, Cv = (e) => {
	var t = J_;
	J_ = /* @__PURE__ */ new Set(), q_ = "write";
	var n = $.links.optimistic.get(e);
	if (n) for (var r of n.entries()) {
		var i = r[0], a = r[1];
		for (var o in a) vv(i, o, a[o]);
	}
	var s = $.records.optimistic.get(e);
	if (s) for (var c of s.entries()) {
		var l = c[0], u = c[1];
		for (var d in u) gv(l, d, u[d]);
	}
	J_ = t, Sv($, e);
}, wv = (e) => {
	var { links: t, records: n } = $, r = [], i = /* @__PURE__ */ new Set();
	return dv(e), lv(r, i, e, t), lv(r, i, e, n), r;
}, Tv = () => {
	if ($.storage) {
		X_ = !0, q_ = "read";
		var e = {};
		for (var t of $.persist.keys()) {
			var { entityKey: n, fieldKey: r } = U_(t), i = void 0;
			(i = mv(n, r)) === void 0 ? (i = pv(n, r)) === void 0 ? e[t] = void 0 : e[t] = bg(i) : e[t] = `:${bg(i)}`;
		}
		X_ = !1, $.storage.writeData(e), $.persist.clear();
	}
};
function Ev(e, t) {
	return typeof e != typeof t || e !== t ? !1 : Array.isArray(e) && Array.isArray(t) ? e.length === t.length ? !e.some(((e, n) => e !== t[n])) : !1 : !0;
}
var Dv = null, Ov = !1, kv = void 0, Av = (e) => e.__internal.path.length > 0 && e.__internal.errorMap ? e.__internal.errorMap[e.__internal.path.join(".")] : void 0, jv = (e, t, n, r, i, a) => {
	var o = {
		store: e,
		variables: t,
		fragments: n,
		parent: { __typename: r },
		parentTypeName: r,
		parentKey: i,
		parentFieldKey: "",
		fieldName: "",
		error: void 0,
		partial: !1,
		hasNext: !1,
		optimistic: X_,
		__internal: {
			path: [],
			errorMap: void 0
		}
	};
	if (a && a.graphQLErrors) for (var s = 0; s < a.graphQLErrors.length; s++) {
		var c = a.graphQLErrors[s];
		c.path && c.path.length && (o.__internal.errorMap || (o.__internal.errorMap = Object.create(null)), o.__internal.errorMap[c.path.join(".")] = c);
	}
	return o;
}, Mv = (e, t, n, r, i, a) => {
	Dv = e, e.parent = t, e.parentTypeName = n, e.parentKey = r, e.parentFieldKey = i, e.fieldName = a, e.error = Av(e);
}, Nv = (e, t, n, r, i) => {
	if (!t) return !1;
	var a = S_(e);
	return !a || t === a ? !0 : (process.env.NODE_ENV !== "production" && Q("Heuristic Fragment Matching: A fragment is trying to match against the `" + t + "` type, but the type condition is `" + a + "`. Since GraphQL allows for interfaces `" + a + "` may be an interface.\nA schema needs to be defined for this match to be deterministic, otherwise the fragment will be matched heuristically!", 16, i), !x_(e).some(((e) => e.kind === lh.FIELD ? !_v(n, B_(__(e), C_(e, r))) : !1)));
}, Pv = class {
	constructor(e, t, n, r, i, a) {
		this.typename = e, this.entityKey = t, this.ctx = a, this.stack = [{
			selectionSet: i,
			index: 0,
			defer: n,
			optional: r
		}];
	}
	next() {
		for (; this.stack.length > 0;) {
			for (var e = this.stack[this.stack.length - 1]; e.index < e.selectionSet.length;) {
				var t = e.selectionSet[e.index++];
				if (O_(t, this.ctx.variables)) {
					if (t.kind !== lh.FIELD) {
						var n = t.kind === lh.INLINE_FRAGMENT ? t : this.ctx.fragments[__(t)];
						if (n) {
							var r = !n.typeCondition || (this.ctx.store.schema ? F_(this.ctx.store.schema, n, this.typename) : q_ === "read" && Fv(n.typeCondition.name.value, this.typename) || Nv(n, this.typename, this.entityKey, this.ctx.variables, this.ctx.store.logger));
							if (r || q_ === "write" && !this.ctx.store.schema) {
								process.env.NODE_ENV !== "production" && f_(this.typename, n);
								var i = A_(t);
								r && n.typeCondition && this.typename !== n.typeCondition.name.value && hv(n.typeCondition.name.value, this.typename), this.stack.push(e = {
									selectionSet: x_(n),
									index: 0,
									defer: e.defer || k_(t, this.ctx.variables),
									optional: i === void 0 ? e.optional : i
								});
							}
						}
					} else if (q_ === "write" || !t._generated) return Ov = e.defer, kv = e.optional, t;
				}
			}
			this.stack.pop(), process.env.NODE_ENV !== "production" && d_();
		}
	}
}, Fv = (e, t) => {
	if (!t) return !1;
	if (e === t) return !0;
	if (((e) => $.types.has(e))(e)) return !1;
	var n = ((e) => $.abstractToConcreteMap.get(e) || rv)(e);
	return n.size && n.has(t);
}, Iv = (e) => e ?? null, Lv = (e, t) => {
	if (!t) return t || null;
	if (Array.isArray(t)) {
		for (var n = Array(t.length), r = 0, i = n.length; r < i; r++) n[r] = Lv(e, t[r]);
		return n;
	}
	var a = e.keyOfEntity(t);
	return process.env.NODE_ENV !== "production" && !a && t && typeof t == "object" && Q("Can't generate a key for link(...) item.\nYou have to pass an `id` or `_id` field or create a custom `keys` config for `" + t.__typename + "`.", 12, e.logger), a;
}, Rv = (e, t, n, r) => {
	var i = $g(t.query), a = E_(i), o = e.rootFields[a.operation], s = x_(a), c = jv(e, T_(a, t.variables), D_(i), o, o, r);
	process.env.NODE_ENV !== "production" && f_(o, a);
	var l = o === c.store.rootFields.query ? Hv(c, o, s, n || Z_()) : zv(c, o, s, n || Z_());
	return process.env.NODE_ENV !== "production" && (d_(), nv()), {
		dependencies: J_,
		partial: c.partial || !l,
		hasNext: c.hasNext,
		data: l || null
	};
}, zv = (e, t, n, r) => {
	if (typeof (e.store.rootNames[t] ? t : r.__typename) != "string") return r;
	for (var i = new Pv(t, t, !1, void 0, n, e), a, o = Y_, s = Z_(r); a = i.next();) {
		var c = y_(a), l = r[c];
		e.__internal.path.push(c);
		var u = void 0;
		u = a.selectionSet && l !== null ? Bv(e, x_(a), Iv(l)) : l, o ||= u !== l, u !== void 0 && (s[c] = u), e.__internal.path.pop();
	}
	return o ? s : r;
}, Bv = (e, t, n) => {
	if (Array.isArray(n)) {
		for (var r = Array(n.length), i = Y_, a = 0, o = n.length; a < o; a++) e.__internal.path.push(a), r[a] = Bv(e, t, n[a]), i ||= r[a] !== n[a], e.__internal.path.pop();
		return i ? r : n;
	} else if (n === null) return null;
	var s = e.store.keyOfEntity(n);
	return s === null ? zv(e, n.__typename, t, n) : Hv(e, s, t, n) || null;
};
function Vv(e, t, n, r) {
	var i = r.store.resolvers[t], a = i && i[n], o;
	for (var s in e) {
		var c = e[s];
		if (c && s !== "include" && s !== "skip" && r.store.directives[s]) {
			if (o = r.store.directives[s](C_(c, r.variables)), process.env.NODE_ENV === "production") return o;
			break;
		}
	}
	return process.env.NODE_ENV !== "production" && a && o && Q(`A resolver and directive is being used at "${t}.${n}" simultaneously. Only the directive will apply.`, 28, r.store.logger), o || a;
}
var Hv = (e, t, n, r, i) => {
	var { store: a } = e, o = t === a.rootFields.query, s = i && a.keyOfEntity(i) || t;
	process.env.NODE_ENV !== "production" && !o && e.store.rootNames[s] && Q("Invalid root traversal: A selection was being read on `" + s + "` which is an uncached root type.\nThe `" + e.store.rootFields.mutation + "` and `" + e.store.rootFields.subscription + "` types are special Operation Root Types and cannot be read back from the cache.", 25, a.logger);
	var c = o ? t : pv(s, "__typename") || i && i.__typename;
	if (typeof c == "string") {
		if (i && c !== i.__typename) {
			process.env.NODE_ENV !== "production" && Q("Invalid resolver data: The resolver at `" + s + "` returned an invalid typename that could not be reconciled with the cache.", 8, a.logger);
			return;
		}
		for (var l = new Pv(c, s, !1, void 0, n, e), u = !1, d = !1, f = Y_, p, m = e.partial, h = Z_(r); (p = l.next()) !== void 0;) {
			var g = __(p), _ = C_(p, e.variables), v = y_(p), ee = g_(p), te = Vv(ee, c, g, e), ne = B_(g, _), re = V_(s, ne), ie = pv(s, ne), ae = i ? i[g] : void 0;
			process.env.NODE_ENV !== "production" && a.schema && c && P_(a.schema, c, g, e.store.logger), e.__internal.path.push(v);
			var y = void 0;
			if (g === "__typename") y = c;
			else if (ae !== void 0 && p.selectionSet === void 0) y = ae;
			else if (q_ === "read" && te) {
				var oe = h;
				if (p.selectionSet === void 0 && ie !== void 0 && (oe = {
					...h,
					[v]: ie,
					[g]: ie
				}), Mv(e, oe, c, s, ne, g), y = te(oe, _ || {}, a, e), p.selectionSet && (y = Uv(e, c, g, re, x_(p), h[v] === void 0 ? r[v] : h[v], y, Q_(r))), a.schema && y === null && !M_(a.schema, c, g, e.store.logger)) return;
			} else if (!p.selectionSet) y = ie;
			else if (ae !== void 0) y = Uv(e, c, g, re, x_(p), h[v] === void 0 ? r[v] : h[v], ae, Q_(r));
			else {
				var se = mv(s, ne);
				se === void 0 ? typeof ie == "object" && ie && (y = ie) : y = Wv(e, se, c, g, x_(p), h[v] === void 0 ? r[v] : h[v], Q_(r));
			}
			if (!Ov && y === void 0 && (ee.optional || kv && !ee.required || Av(e) || !ee.required && a.schema && M_(a.schema, c, g, e.store.logger)) ? (e.partial = !0, y = null) : y === null && (ee.required || !1 === kv) ? (e.store.logger && process.env.NODE_ENV !== "production" && q_ === "read" && e.store.logger("debug", `Got value "null" for required field "${g}"${_ ? ` with args ${JSON.stringify(_)}` : ""} on entity "${s}"`), y = void 0) : u ||= g !== "__typename", e.__internal.path.pop(), f ||= y !== r[v], y !== void 0) h[v] = y;
			else if (Ov) d = !0;
			else {
				e.store.logger && process.env.NODE_ENV !== "production" && q_ === "read" && e.store.logger("debug", `No value for field "${g}"${_ ? ` with args ${JSON.stringify(_)}` : ""} on entity "${s}"`), e.partial = m;
				return;
			}
		}
		return e.partial = e.partial || m, e.hasNext = e.hasNext || d, o && e.partial && !u ? void 0 : f ? h : r;
	}
}, Uv = (e, t, n, r, i, a, o, s) => {
	if (Array.isArray(o)) {
		for (var { store: c } = e, l = c.schema ? N_(c.schema, t, n, e.store.logger) : !1, u = e.partial, d = Z_(a, !0), f = Y_ || !Array.isArray(a) || o.length !== a.length, p = 0, m = o.length; p < m; p++) {
			e.__internal.path.push(p);
			var h = Uv(e, t, n, V_(r, `${p}`), i, a?.[p], o[p], s);
			if (e.__internal.path.pop(), h === void 0 && !l) {
				e.partial = u;
				return;
			} else e.partial = e.partial || h === void 0 && l, d[p] = h ?? null, f ||= d[p] !== a[p];
		}
		return f ? d : a;
	} else if (o == null) return o;
	else if (s && a === null) return null;
	else if (Gv(o)) {
		var g = a || Z_(a);
		return typeof o == "string" ? Hv(e, o, i, g) : Hv(e, r, i, g, o);
	} else {
		process.env.NODE_ENV !== "production" && Q("Invalid resolver value: The field at `" + r + "` is a scalar (number, boolean, etc), but the GraphQL query expects a selection set for this field.", 9, e.store.logger);
		return;
	}
}, Wv = (e, t, n, r, i, a, o) => {
	if (Array.isArray(t)) {
		for (var { store: s } = e, c = s.schema ? N_(s.schema, n, r, e.store.logger) : !1, l = Z_(a, !0), u = e.partial, d = Y_ || !Array.isArray(a) || t.length !== a.length, f = 0, p = t.length; f < p; f++) {
			e.__internal.path.push(f);
			var m = Wv(e, t[f], n, r, i, a?.[f], o);
			if (e.__internal.path.pop(), m === void 0 && !c) {
				e.partial = u;
				return;
			} else e.partial = e.partial || m === void 0 && c, l[f] = m || null, d ||= l[f] !== a[f];
		}
		return d ? l : a;
	} else if (t === null || a === null && o) return null;
	return Hv(e, t, i, a || Z_(a));
}, Gv = (e) => typeof e == "string" || typeof e == "object" && typeof e.__typename == "string", Kv = (e, t, n) => {
	for (var r = t ? [{ fieldKey: B_(t, n) }] : wv(e), i = 0, a = r.length; i < a; i++) {
		var { fieldKey: o } = r[i];
		mv(e, o) === void 0 ? gv(e, o, void 0) : vv(e, o, void 0);
	}
}, qv = (e, t) => {
	for (var n of ((e) => $.types.get(e) || rv)(e)) t.includes(n) || Kv(n);
}, Jv = (e, t, n, r) => {
	process.env.NODE_ENV !== "production" && nv();
	var i = $g(t.query), a = E_(i), o = {
		data: n || Z_(),
		dependencies: J_
	}, s = e.rootFields[a.operation], c = jv(e, T_(a, t.variables), D_(i), s, s, r);
	return process.env.NODE_ENV !== "production" && f_(s, a), Yv(c, s, x_(a), o.data), process.env.NODE_ENV !== "production" && d_(), o;
}, Yv = (e, t, n, r) => {
	var i = e.store.rootNames[t] || "query", a = !!e.store.rootNames[t], o = a ? t : r.__typename;
	if (!o && t && e.optimistic && (o = pv(t, "__typename")), o) !a && t && (gv(t, "__typename", o), ((e, t) => {
		var n = $.types.get(e);
		if (n) n.add(t);
		else {
			var r = /* @__PURE__ */ new Set();
			r.add(t), $.types.set(e, r);
		}
	})(o, t));
	else {
		process.env.NODE_ENV !== "production" && Q("Couldn't find __typename when writing.\nIf you're writing to the cache manually have to pass a `__typename` property on each entity in your data.", 14, e.store.logger);
		return;
	}
	for (var s = e.store.updates[o], c = new Pv(o, t || o, !1, void 0, n, e), l; l = c.next();) {
		var u = __(l), d = C_(l, e.variables), f = B_(u, d), p = y_(l), m = r[e.optimistic ? u : p];
		if (!(u === "__typename" || m === void 0 && (Ov || e.optimistic && i === "query"))) {
			process.env.NODE_ENV !== "production" && e.store.schema && o && u !== "__typename" && P_(e.store.schema, o, u, e.store.logger), e.__internal.path.push(p);
			var h = void 0;
			if (e.optimistic && i === "mutation") {
				if (!(h = e.store.optimisticMutations[u])) continue;
			} else e.optimistic && typeof m == "function" && (h = m);
			if (h && (Mv(e, r, o, t || o, f, u), m = Iv(h(d || {}, e.store, e))), m === void 0) {
				process.env.NODE_ENV !== "production" && (!t || !_v(t, f) || e.optimistic && !pv(t, "__typename")) && process.env.NODE_ENV !== "production" && Q("Invalid undefined: The field at `" + f + "` is `undefined`, but the GraphQL query expects a " + (l.selectionSet === void 0 ? "scalar (number, boolean, etc)" : "selection set") + " for this field.", 13, e.store.logger);
				continue;
			}
			if (l.selectionSet) if (t && i === "query") {
				var g = V_(t, f), _ = Zv(e, x_(l), Iv(m), g, e.optimistic ? mv(t || o, f) : void 0);
				vv(t || o, f, _);
			} else Zv(e, x_(l), Iv(m));
			else t && i === "query" && gv(t || o, f, m !== null || !Av(e) ? m : void 0);
			var v = s && s[u];
			if (v) Mv(e, r, o, t || o, f, u), r[u] = m, v(r, d || {}, e.store, e);
			else if (o === e.store.rootFields.mutation && !e.optimistic) {
				if (m && Array.isArray(m)) for (var ee = m.map(((t) => e.store.keyOfEntity(t) || "")), te = 0, ne = m.length; te < ne; te++) {
					var re = ee[te];
					if (re && m[te].__typename) {
						var ie = pv(re, "__typename"), ae = ov(re);
						ie && !ae && qv(m[te].__typename, ee);
					}
				}
				else if (m && typeof m == "object") {
					var y = e.store.keyOfEntity(m);
					if (y) {
						var oe = pv(y, "__typename"), se = ov(y);
						(!oe || !se) && m.__typename && qv(m.__typename, [y]);
					}
				}
			}
			e.__internal.path.pop();
		}
	}
}, Xv = /^__|PageInfo|(Connection|Edge)$/, Zv = (e, t, n, r, i) => {
	if (Array.isArray(n)) {
		for (var a = Array(n.length), o = 0, s = n.length; o < s; o++) {
			e.__internal.path.push(o);
			var c = r ? V_(r, `${o}`) : void 0;
			a[o] = Zv(e, t, n[o], c, i?.[o]), e.__internal.path.pop();
		}
		return a;
	} else if (n === null) return Av(e) ? void 0 : null;
	var l = e.store.keyOfEntity(n) || (typeof i == "string" ? i : null), u = n.__typename;
	process.env.NODE_ENV !== "production" && r && !e.store.keys[n.__typename] && l === null && typeof u == "string" && !Xv.test(u) && Q("Invalid key: The GraphQL query at the field at `" + r + "` has a selection set, but no key could be generated for the data at this field.\nYou have to request `id` or `_id` fields for all selection sets or create a custom `keys` config for `" + u + "`.\nEntities without keys will be embedded directly on the parent entity. If this is intentional, create a `keys` config for `" + u + "` that always returns null.", 15, e.store.logger);
	var d = l || r;
	return Yv(e, d, t, n), d || null;
}, Qv = class {
	constructor(e) {
		e ||= {}, this.logger = e.logger, this.resolvers = e.resolvers || {}, this.directives = e.directives || {}, this.optimisticMutations = e.optimistic || {}, this.keys = e.keys || {}, this.globalIDs = Array.isArray(e.globalIDs) ? new Set(e.globalIDs) : !!e.globalIDs;
		var t = "Query", n = "Mutation", r = "Subscription";
		if (e.schema) {
			var i = (({ __schema: e }) => {
				var t = /* @__PURE__ */ new Map(), n = (e) => {
					var t;
					return () => {
						if (!t) {
							t = {};
							for (var n = 0; n < e.length; n++) t[e[n].name] = e[n];
						}
						return t;
					};
				}, r = (e) => {
					switch (e.kind) {
						case "OBJECT":
						case "INTERFACE": return {
							name: e.name,
							kind: e.kind,
							interfaces: n(e.interfaces || []),
							fields: n(e.fields.map(((e) => ({
								name: e.name,
								type: e.type,
								args: n(e.args)
							}))))
						};
						case "UNION": return {
							name: e.name,
							kind: e.kind,
							types: n(e.possibleTypes || [])
						};
					}
				}, i = {
					query: e.queryType ? e.queryType.name : null,
					mutation: e.mutationType ? e.mutationType.name : null,
					subscription: e.subscriptionType ? e.subscriptionType.name : null,
					types: void 0,
					isSubType(e, n) {
						var r = t.get(e), i = t.get(n);
						return !r || !i ? !1 : r.kind === "UNION" ? !!r.types()[n] : r.kind !== "OBJECT" && i.kind === "OBJECT" ? !!i.interfaces()[e] : e === n;
					}
				};
				if (e.types) {
					i.types = t;
					for (var a = 0; a < e.types.length; a++) {
						var o = e.types[a];
						if (o && o.name) {
							var s = r(o);
							s && t.set(o.name, s);
						}
					}
				}
				return i;
			})(e.schema);
			t = i.query || t, n = i.mutation || n, r = i.subscription || r, i.types && (this.schema = i);
		}
		this.updates = e.updates || {}, this.rootFields = {
			query: t,
			mutation: n,
			subscription: r
		}, this.rootNames = {
			[t]: "query",
			[n]: "mutation",
			[r]: "subscription"
		}, this.data = (a = t, {
			hydrating: !1,
			defer: !1,
			gc: /* @__PURE__ */ new Set(),
			types: /* @__PURE__ */ new Map(),
			persist: /* @__PURE__ */ new Set(),
			queryRootKey: a,
			refCount: /* @__PURE__ */ new Map(),
			links: {
				optimistic: /* @__PURE__ */ new Map(),
				base: /* @__PURE__ */ new Map()
			},
			abstractToConcreteMap: /* @__PURE__ */ new Map(),
			records: {
				optimistic: /* @__PURE__ */ new Map(),
				base: /* @__PURE__ */ new Map()
			},
			deferredKeys: /* @__PURE__ */ new Set(),
			commutativeKeys: /* @__PURE__ */ new Set(),
			dirtyKeys: /* @__PURE__ */ new Set(),
			optimisticOrder: [],
			storage: null
		});
		var a;
		this.schema && process.env.NODE_ENV !== "production" && ((function(e, t, n) {
			if (process.env.NODE_ENV !== "production") for (var r in t) process.env.NODE_ENV !== "production" && (e.types.has(r) || Q("Invalid Object type: The type `" + r + "` is not an object in the defined schema, but the `keys` option is referencing it.", 20, n));
		})(this.schema, this.keys, this.logger), (function(e, t, n) {
			if (process.env.NODE_ENV !== "production") {
				for (var r in t) if (t[r]) {
					if (!e.types.has(r)) {
						var i = "";
						return r === "Mutation" && e.mutation && e.mutation !== "Mutation" ? i += "\nMaybe your config should reference `" + e.mutation + "`?" : r === "Subscription" && e.subscription && e.subscription !== "Subscription" && (i += "\nMaybe your config should reference `" + e.subscription + "`?"), process.env.NODE_ENV === "production" ? void 0 : Q("Invalid updates type: The type `" + r + "` is not an object in the defined schema, but the `updates` config is referencing it." + i, 21, n);
					}
					var a = e.types.get(r).fields();
					for (var o in t[r]) process.env.NODE_ENV !== "production" && (a[o] || Q("Invalid updates field: `" + o + "` on `" + r + "` is not in the defined schema, but the `updates` config is referencing it.", 22, n));
				}
			}
		})(this.schema, this.updates, this.logger), (function(e, t, n) {
			if (process.env.NODE_ENV !== "production") for (var r in t) if (r === "Query") if (e.query) {
				var i = e.types.get(e.query).fields();
				for (var a in t.Query || {}) i[a] || R_("Query." + a, n);
			} else R_("Query", n);
			else if (!e.types.has(r)) R_(r, n);
			else if (e.types.get(r).kind === "INTERFACE" || e.types.get(r).kind === "UNION") z_(r, e.types.get(r).kind, n);
			else {
				var o = e.types.get(r).fields();
				for (var s in t[r] || {}) o[s] || R_(r + "." + s, n);
			}
		})(this.schema, this.resolvers, this.logger), (function(e, t, n) {
			if (process.env.NODE_ENV !== "production" && e.mutation) {
				var r = e.types.get(e.mutation).fields();
				for (var i in t) process.env.NODE_ENV !== "production" && (r[i] || Q(`Invalid optimistic mutation field: \`${i}\` is not a mutation field in the defined schema, but the \`optimistic\` option is referencing it.`, 24, n));
			}
		})(this.schema, this.optimisticMutations, this.logger));
	}
	keyOfField(e, t) {
		return B_(e, t);
	}
	keyOfEntity(e) {
		if (Dv && e === Dv.parent) return Dv.parentKey;
		if (e == null || typeof e == "string") return e || null;
		if (!e.__typename) return null;
		if (this.rootNames[e.__typename]) return e.__typename;
		var t = null;
		this.keys[e.__typename] ? t = this.keys[e.__typename](e) || null : e.id == null ? e._id != null && (t = `${e._id}`) : t = `${e.id}`;
		var n = e.__typename;
		return !0 === this.globalIDs || this.globalIDs && this.globalIDs.has(n) || !t ? t : `${n}:${t}`;
	}
	resolve(e, t, n) {
		var r = this.keyOfEntity(e);
		if (r) {
			var i = B_(t, n), a = pv(r, i);
			if (a !== void 0) return a;
			var o = mv(r, i);
			return o !== void 0 && (o = Lv(this, o)), o;
		}
	}
	invalidate(e, t, n) {
		var r = this.keyOfEntity(e);
		e && typeof e == "string" && !t && !n && !this.resolve(e, "__typename") ? qv(e, []) : (m_(r, process.env.NODE_ENV === "production" ? "" : "Can't generate a key for invalidate(...).\nYou have to pass an id or _id field or create a custom `keys` field for `" + (typeof e == "object" ? e.__typename : e + "`."), 19), Kv(r, t, n));
	}
	inspectFields(e) {
		var t = this.keyOfEntity(e);
		return t ? wv(t) : [];
	}
	updateQuery(e, t) {
		var n = Ng(e.query, e.variables), r = t(this.readQuery(n));
		r !== null && Jv(this, n, r, void 0);
	}
	readQuery(e) {
		var t = Ng(e.query, e.variables);
		return Rv(this, t, void 0, void 0).data;
	}
	readFragment(e, t, n, r) {
		return ((e, t, n, r, i) => {
			var a = D_(t), o;
			if (i) {
				if (!(o = a[i])) return process.env.NODE_ENV !== "production" && Q("readFragment(...) was called with a fragment name that does not exist.\nYou provided " + i + " but could only find " + Object.keys(a).join(", ") + ".", 6, e.logger), null;
			} else if (!(o = a[Object.keys(a)[0]])) return process.env.NODE_ENV !== "production" && Q("readFragment(...) was called with an empty fragment.\nYou have to call it with at least one fragment in your GraphQL document.", 6, e.logger), null;
			var s = v_(o);
			typeof n != "string" && !n.__typename && (n.__typename = s);
			var c = e.keyOfEntity(n);
			if (!c) return process.env.NODE_ENV !== "production" && Q("Can't generate a key for readFragment(...).\nYou have to pass an `id` or `_id` field or create a custom `keys` config for `" + s + "`.", 7, e.logger), null;
			process.env.NODE_ENV !== "production" && f_(s, o);
			var l = Hv(jv(e, r || {}, a, s, c, void 0), c, x_(o), Z_()) || null;
			return process.env.NODE_ENV !== "production" && d_(), l;
		})(this, $g(e), t, n, r);
	}
	writeFragment(e, t, n, r) {
		((e, t, n, r, i) => {
			var a = D_(t), o;
			if (i) {
				if (!(o = a[i])) return process.env.NODE_ENV !== "production" && Q("writeFragment(...) was called with a fragment name that does not exist.\nYou provided " + i + " but could only find " + Object.keys(a).join(", ") + ".", 11, e.logger), null;
			} else if (!(o = a[Object.keys(a)[0]])) return process.env.NODE_ENV !== "production" && Q("writeFragment(...) was called with an empty fragment.\nYou have to call it with at least one fragment in your GraphQL document.", 11, e.logger), null;
			var s = v_(o), c = {
				__typename: s,
				...n
			}, l = e.keyOfEntity(c);
			if (!l) return process.env.NODE_ENV === "production" ? void 0 : Q("Can't generate a key for writeFragment(...) data.\nYou have to pass an `id` or `_id` field or create a custom `keys` config for `" + s + "`.", 12, e.logger);
			process.env.NODE_ENV !== "production" && f_(s, o), Yv(jv(e, r || {}, a, s, l, void 0), l, x_(o), c), process.env.NODE_ENV !== "production" && d_();
		})(this, $g(e), t, n, r);
	}
	link(e, t, ...n) {
		var r = n.length === 2 ? n[0] : null, i = n.length === 2 ? n[1] : n[0], a = this.keyOfEntity(e);
		a && vv(a, B_(t, r), Lv(this, i));
	}
}, $v = (e, t) => t_(e.kind, e, {
	...e.context,
	meta: {
		...e.context.meta,
		...t
	}
}), ey = (e, t) => t_(e.kind, e, {
	...e.context,
	requestPolicy: t
}), ty = (e) => ({ forward: t, client: n, dispatchDebug: r }) => {
	var i = new Qv(e);
	e && e.storage && (i.data.hydrating = !0, e.storage.readData().then(((t) => {
		((e, t, n) => {
			for (var r in $_("write", e, null), n) {
				var i = n[r];
				if (i !== void 0) {
					var { entityKey: a, fieldKey: o } = U_(r);
					i[0] === ":" ? mv(a, o) === void 0 && vv(a, o, JSON.parse(i.slice(1))) : pv(a, o) === void 0 && gv(a, o, JSON.parse(i));
				}
			}
			e.storage = t, e.hydrating = !1, ev();
		})(i.data, e.storage, t), e.storage.onCacheHydrated && e.storage.onCacheHydrated();
	})));
	var a = /* @__PURE__ */ new Map(), o = [], s = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Set(), p = /* @__PURE__ */ new Set(), m = (e) => {
		for (var t of e.values()) if (l.has(t)) return !0;
		return !1;
	}, h = (e, t) => {
		if (t) for (var n of t.values()) {
			var r = d.get(n);
			if (r) for (var i of r.values()) e.add(i);
		}
	}, g = (e, t, r) => {
		for (var i of t.values()) if (i !== e.key) {
			var a = s.get(i);
			if (a) {
				e.kind === "query" && p.add(i);
				var o = "cache-first";
				u.has(i) && (u.delete(i), o = "cache-and-network"), n.reexecuteOperation(ey(a, o));
			}
		}
		if (!r) {
			var c = f;
			f = p, e.kind === "query" && f.add(e.key), (p = c).clear();
		}
	}, _ = (e) => {
		var t = !1;
		if (e.kind === "query") yv(i.data, e.key), s.set(e.key, e);
		else if (e.kind === "teardown") return s.delete(e.key), c.delete(e.key), f.delete(e.key), tv(i.data, e.key), e;
		else if (e.kind === "mutation" && e.context.requestPolicy !== "network-only") {
			s.set(e.key, e), $_("write", i.data, e.key, !0, !1);
			var { dependencies: n } = Jv(i, e, void 0, void 0);
			if (ev(), n.size) {
				for (var r of n.values()) l.add(r);
				a.set(e.key, n);
				var o = /* @__PURE__ */ new Set();
				h(o, n), g(e, o, !0), t = !0;
			}
		}
		return t_(e.kind, {
			key: e.key,
			query: $g(e.query),
			variables: e.variables ? w_(E_(e.query), e.variables) : e.variables
		}, {
			...e.context,
			optimistic: t
		});
	}, v = (e, t) => {
		for (var n of t.values()) {
			var r = d.get(n);
			r || d.set(n, r = /* @__PURE__ */ new Set()), r.add(e.key);
		}
	}, ee = (e) => {
		$_("read", i.data, void 0, !1, !1);
		var t = Rv(i, e, c.get(e.key), void 0);
		ev();
		var n = t.data ? !t.partial && !t.hasNext ? "hit" : "partial" : "miss";
		return c.set(e.key, t.data), s.set(e.key, e), v(e, t.dependencies), {
			outcome: n,
			operation: e,
			data: t.data,
			dependencies: t.dependencies,
			hasNext: t.hasNext
		};
	}, te = (e, t) => {
		var n = s.get(e.operation.key) || e.operation;
		n.kind === "mutation" && (h(t, a.get(n.key)), a.delete(n.key)), (n.kind === "subscription" || e.hasNext) && yv(i.data, n.key, !0);
		var r, o = e.data;
		if (o) {
			$_("write", i.data, n.key, !1, !1);
			var l = Jv(i, n, o, e.error).dependencies;
			ev(), h(t, l);
			var u = n.kind === "query" ? c.get(n.key) : null;
			$_("read", i.data, n.key, !1, u !== o);
			var d = Rv(i, n, u || o, e.error);
			ev(), o = d.data, n.kind === "query" && (h(t, r = d.dependencies), c.set(n.key, o));
		} else tv(i.data, n.key);
		return r && v(e.operation, r), {
			operation: n,
			data: o,
			error: e.error,
			extensions: e.extensions,
			hasNext: e.hasNext,
			stale: e.stale
		};
	};
	return (e) => {
		var c = Xh(Uh(ee)(Hh(((e) => e.kind === "query" && e.context.requestPolicy !== "network-only"))(e))), d = Hh(((e) => e.kind !== "query" || e.context.requestPolicy === "network-only"))(e), p = Uh(((e) => (process.env.NODE_ENV !== "production" && r({
			type: "cacheMiss",
			message: "The result could not be retrieved from the cache",
			operation: e.operation,
			source: "cacheExchange"
		}), $v(e.operation, { cacheOutcome: "miss" }))))(Hh(((e) => e.outcome === "miss" && e.operation.context.requestPolicy !== "cache-only" && !m(e.dependencies) && !f.has(e.operation.key)))(c)), h = Uh(((e) => {
			var { requestPolicy: t } = e.operation.context, a = t !== "cache-only" && (e.hasNext || t === "cache-and-network" || t === "cache-first" && e.outcome === "partial" && !f.has(e.operation.key)), o = t !== "cache-only" && (a || e.outcome === "partial" && f.has(e.operation.key) && ((c = i.data).commutativeKeys.has(l = e.operation.key) || c.optimisticOrder.indexOf(l) > -1)), c, l, d = {
				operation: $v(e.operation, { cacheOutcome: e.outcome }),
				data: e.data,
				error: e.error,
				extensions: e.extensions,
				stale: o && !e.hasNext,
				hasNext: a && e.hasNext
			};
			return a && (m(e.dependencies) ? t === "cache-and-network" && u.add(e.operation.key) : n.reexecuteOperation(ey(s.get(e.operation.key) || e.operation, "network-only"))), process.env.NODE_ENV !== "production" && r({
				type: "cacheHit",
				message: "A requested operation was found and returned from the cache.",
				operation: e.operation,
				data: { value: d },
				source: "cacheExchange"
			}), d;
		}))(Hh(((e) => e.outcome !== "miss" || e.operation.context.requestPolicy === "cache-only"))(c)), v = t(Uh(_)(Kh([d, p])));
		return Kh([
			Uh(((e) => {
				var t = /* @__PURE__ */ new Set(), n = te(e, t);
				return g(e.operation, t, !1), n;
			}))(Hh(((e) => !a.has(e.operation.key)))(v)),
			Wh(((e) => {
				if (o.push(e) < a.size) return cg;
				for (var t = 0; t < o.length; t++) yv(i.data, o[t].operation.key);
				l.clear();
				for (var n = [], r = /* @__PURE__ */ new Set(), s; s = o.shift();) n.push(te(s, r));
				return g(e.operation, r, !1), ig(n);
			}))(Hh(((e) => a.has(e.operation.key)))(v)),
			h
		]);
	};
};
//#endregion
//#region src/urql-client.tsx
function ny() {
	let { signOut: e } = Li();
	return async function(t, n) {
		let r = n && "body" in n ? JSON.parse(n.body?.toString() ?? "{}").operationName ?? "_missing_op_name_" : "_missing_op_name_", i = await fetch(`${t}?op=${r}`, n), a = await i.clone().json();
		return a?.errors?.[0]?.extensions?.code === "invalid-jwt" && (console.debug("🚀 - file: gql-request-client-provider.tsx:22 - fetchWithOpName - resJson invalid jwt", a), e()), i;
	};
}
function ry(e, n) {
	let r = Li(), i = ny();
	return t.useMemo(() => new s_({
		url: e,
		exchanges: [
			ty({
				resolvers: n?.customScalarResolvers,
				updates: {
					Mutation: n?.mutationUpdates ?? {},
					Query: n?.queryUpdates ?? {}
				},
				...n?.cacheExchangeOptions
			}),
			a_({ onResult: (e) => {
				e.error && n?.onError && n.onError(e.error, e.operation);
			} }),
			r_
		],
		fetchOptions: () => r?.jwt ? { headers: { Authorization: `Bearer ${r.jwt}` } } : {},
		fetch: i
	}), [e, r.jwt]);
}
//#endregion
export { Ii as AuthProvider, bi as EnvProvider, Qm as GoogleOuathCatcher, oh as MetricsProvider, ji as SupabaseProvider, Xm as clearOauthTokenAndExpiresIn, rh as createMetricsCollector, Jm as getOauthRedirectData, $m as mapDateFields, ch as stringProp, eh as unmapDateFields, Li as useAuth, ry as useAuthorizedUrqlClient, xi as useEnv, Si as useEnvOptional, Ti as useIsDev, Ei as useIsProd, sh as useMetricsOptional, wi as useMkUrl, Ci as useOrigin, Ym as useProcessOauthToken, Zm as useSetOauthToken, Ri as useSignInWithEmailPassword, zi as useSignInWithOtpInitiate, ki as useSupabase, Mi as useSupabaseUser, Ni as useUserId };

//# sourceMappingURL=index.js.map